/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

/** AIIntegration represents an integration with an AI/LLM provider */
export type AiIntegration = {
  __typename?: "AIIntegration";
  /** AI integration actions the current user is allowed to perform on this integration. */
  allowedActions: Array<Action>;
  /**
   * Custom base URL for self-hosted OpenAI-compatible / Anthropic / Google
   * gateways (e.g. LiteLLM). Empty means use the provider default.
   * Not used for Bedrock integrations.
   */
  baseURL: Maybe<Scalars["String"]["output"]>;
  /** Optional description of the integration. */
  description: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether the integration can be used for LLM calls. Disabled integrations
   * remain visible and editable but are rejected by the AI provider proxy.
   * Spacelift-provided integrations read as disabled while the account has
   * Spacelift Intelligence off. Turning it on restores the account's last
   * choice for each one.
   */
  enabled: Scalars["Boolean"]["output"];
  /** The unique ID for managing the integration within Spacelift. */
  id: Scalars["ID"]["output"];
  /** Indicates this is a Spacelift-managed integration that is read-only and visible to all accounts. */
  isSpaceliftProvided: Scalars["Boolean"]["output"];
  /** User-defined labels set on the integration. */
  labels: Array<Scalars["String"]["output"]>;
  /**
   * Models available on this integration with display names. For Bedrock
   * integrations, names are resolved live from AWS, which may fail or return
   * fewer entries than `models`.
   */
  modelDetails: Array<AiModel>;
  /**
   * Models explicitly pinned on this integration. Null means the integration
   * follows the provider's default model list; modelDetails reports what that
   * resolves to. For Bedrock integrations this is never null: it lists the
   * inference profile IDs stored on the integration, with no live AWS lookup.
   */
  models: Maybe<Array<Scalars["String"]["output"]>>;
  /** The friendly name of the integration. */
  name: Scalars["String"]["output"];
  /** AI provider (Anthropic, OpenAI, Google, Bedrock). */
  provider: Scalars["String"]["output"];
  /** Provider-specific configuration. Concrete shape depends on the provider. */
  providerConfig: Maybe<AiProviderConfig>;
  /** ULID of the underlying provider integration (e.g. AWS integration for Bedrock). */
  providerIntegrationId: Maybe<Scalars["ID"]["output"]>;
  /** Friendly name of the underlying provider integration (e.g. AWS integration name for Bedrock). */
  providerIntegrationName: Maybe<Scalars["String"]["output"]>;
  /**
   * Details of the space this AI integration belongs to.
   * Null for Spacelift-provided integrations.
   */
  space: Maybe<Space>;
  /** Account-level AI token usage for the current budget window. */
  tokenUsage: AiIntegrationTokenUsage;
};

/** AIIntegrationTokenUsage represents account-level AI budget usage values. */
export type AiIntegrationTokenUsage = {
  __typename?: "AIIntegrationTokenUsage";
  /** Unix timestamp when the current budget window resets. */
  tokensResetAt: Maybe<Scalars["Int"]["output"]>;
  /** Total budget tokens available in the current window. */
  totalTokens: Scalars["Int"]["output"];
  /** Total budget tokens consumed in the current window. */
  usedTokens: Scalars["Int"]["output"];
};

/** AIModel represents a model available on an AI integration or provider. */
export type AiModel = {
  __typename?: "AIModel";
  /** Canonical model identifier (e.g. "claude-sonnet-4-6") or, for Bedrock integrations, the inference profile ID. */
  id: Scalars["String"]["output"];
  /** Human-readable display name for the model. */
  name: Scalars["String"]["output"];
};

/** AIProvider represents the available AI providers */
export type AiProvider = {
  __typename?: "AIProvider";
  /** Available models for this provider with display names. */
  modelDetails: Array<AiModel>;
  /** Available model identifiers for this provider. */
  models: Array<Scalars["String"]["output"]>;
  /** The AI provider */
  provider: Scalars["String"]["output"];
};

/** AIProviderConfig is the discriminated union of provider-specific configurations. */
export type AiProviderConfig = AwsBedrockConfig;

/**
 * AIProviderConfigInput wraps the per-provider config inputs. Exactly one
 * field should be set, matching the integration's provider.
 */
export type AiProviderConfigInput = {
  bedrock: InputMaybe<AwsBedrockConfigInput>;
};

export type ApiKeyInputOidc = {
  claimMappings: InputMaybe<ClaimMappingInput>;
  clientId: Scalars["String"]["input"];
  issuer: Scalars["String"]["input"];
  subjectExpression: Scalars["String"]["input"];
};

/** APIKeyType represents the type of an API key. */
export enum ApiKeyType {
  /**
   * API key that can dynamically generate tokens using an external,
   * OIDC-compliant identity provider.
   */
  Oidc = "OIDC",
  /** Classic API key with a secret. */
  Secret = "SECRET",
}

/** AWSBedrockConfig is the Bedrock-specific provider configuration. */
export type AwsBedrockConfig = {
  __typename?: "AWSBedrockConfig";
  /** Selected Bedrock inference profile IDs. */
  profiles: Array<Scalars["String"]["output"]>;
  /** AWS region the Bedrock requests are routed through. */
  region: Scalars["String"]["output"];
};

/** AWSBedrockConfigInput configures a Bedrock AI integration link. */
export type AwsBedrockConfigInput = {
  profiles: Array<Scalars["String"]["input"]>;
  region: Scalars["String"]["input"];
};

export type AwsRegion = {
  __typename?: "AWSRegion";
  id: Scalars["String"]["output"];
  /**
   * The place within that group, "Ireland" for eu-west-1. Not always a city,
   * which is how AWS itself labels them.
   */
  location: Scalars["String"]["output"];
  /** The geographic area AWS groups the region under, "Europe" for eu-west-1. */
  region: Scalars["String"]["output"];
};

export type AwsScanConfigSchema = {
  __typename?: "AWSScanConfigSchema";
  /** Every region a scan can be pointed at. China and GovCloud are not supported. */
  regions: Array<AwsRegion>;
};

/**
 * AWSScanSettings is the AWS provider's own configuration, which covers a single
 * region, so a scan spanning several regions holds one entry per region.
 */
export type AwsScanSettings = {
  __typename?: "AWSScanSettings";
  region: Scalars["String"]["output"];
};

export type AwsScanSettingsInput = {
  region: Scalars["String"]["input"];
};

/** AccountType represents the type of a GitHub account. */
export enum AccountType {
  /** Organization account. */
  Org = "ORG",
  /** Invalid "zero value" for the account type. */
  Unknown = "UNKNOWN",
  /** Individual user account. */
  User = "USER",
}

export type AccountUpdateDefaultWorkerPoolRunnerImagesResult = {
  __typename?: "AccountUpdateDefaultWorkerPoolRunnerImagesResult";
  privateWorkerPoolRunnerImage: Maybe<Scalars["String"]["output"]>;
  publicWorkerPoolRunnerImage: Maybe<Scalars["String"]["output"]>;
};

/** Action represents an action in Spacelift that can be performed by a user. */
export enum Action {
  AiIntegrationCreate = "AI_INTEGRATION_CREATE",
  AiIntegrationDelete = "AI_INTEGRATION_DELETE",
  AiIntegrationToggle = "AI_INTEGRATION_TOGGLE",
  AiIntegrationUpdate = "AI_INTEGRATION_UPDATE",
  ContextCreate = "CONTEXT_CREATE",
  ContextDelete = "CONTEXT_DELETE",
  ContextUpdate = "CONTEXT_UPDATE",
  CreateBlueprintsVersionedGroup = "CREATE_BLUEPRINTS_VERSIONED_GROUP",
  CreateBlueprintDeployment = "CREATE_BLUEPRINT_DEPLOYMENT",
  DeleteBlueprintsVersionedGroup = "DELETE_BLUEPRINTS_VERSIONED_GROUP",
  DeleteBlueprintDeployment = "DELETE_BLUEPRINT_DEPLOYMENT",
  DriftDetectionIntegrationCreate = "DRIFT_DETECTION_INTEGRATION_CREATE",
  DriftDetectionIntegrationDelete = "DRIFT_DETECTION_INTEGRATION_DELETE",
  DriftDetectionIntegrationUpdate = "DRIFT_DETECTION_INTEGRATION_UPDATE",
  IntentDependenciesAdd = "INTENT_DEPENDENCIES_ADD",
  IntentDependenciesRemove = "INTENT_DEPENDENCIES_REMOVE",
  IntentPolicyCreate = "INTENT_POLICY_CREATE",
  IntentPolicyDelete = "INTENT_POLICY_DELETE",
  IntentPolicyUpdate = "INTENT_POLICY_UPDATE",
  IntentProjectCloudIntegrationAttach = "INTENT_PROJECT_CLOUD_INTEGRATION_ATTACH",
  IntentProjectCloudIntegrationDetach = "INTENT_PROJECT_CLOUD_INTEGRATION_DETACH",
  IntentProjectConfigAdd = "INTENT_PROJECT_CONFIG_ADD",
  IntentProjectConfigDelete = "INTENT_PROJECT_CONFIG_DELETE",
  IntentProjectConfigUpdate = "INTENT_PROJECT_CONFIG_UPDATE",
  IntentProjectCreate = "INTENT_PROJECT_CREATE",
  IntentProjectDelete = "INTENT_PROJECT_DELETE",
  IntentProjectDisable = "INTENT_PROJECT_DISABLE",
  IntentProjectEnable = "INTENT_PROJECT_ENABLE",
  IntentProjectLock = "INTENT_PROJECT_LOCK",
  IntentProjectPolicyAttach = "INTENT_PROJECT_POLICY_ATTACH",
  IntentProjectPolicyDetach = "INTENT_PROJECT_POLICY_DETACH",
  IntentProjectUnlock = "INTENT_PROJECT_UNLOCK",
  IntentProjectUpdate = "INTENT_PROJECT_UPDATE",
  IntentResourceCreate = "INTENT_RESOURCE_CREATE",
  IntentResourceDelete = "INTENT_RESOURCE_DELETE",
  IntentResourceImport = "INTENT_RESOURCE_IMPORT",
  IntentResourceOperationReview = "INTENT_RESOURCE_OPERATION_REVIEW",
  IntentResourceRefresh = "INTENT_RESOURCE_REFRESH",
  IntentResourceResume = "INTENT_RESOURCE_RESUME",
  IntentResourceUpdate = "INTENT_RESOURCE_UPDATE",
  IntentStateEject = "INTENT_STATE_EJECT",
  IntentStateRead = "INTENT_STATE_READ",
  ModuleCreate = "MODULE_CREATE",
  ModuleDisable = "MODULE_DISABLE",
  ModuleEnable = "MODULE_ENABLE",
  ModuleMarkAsBad = "MODULE_MARK_AS_BAD",
  ModuleProposeLocalWorkspace = "MODULE_PROPOSE_LOCAL_WORKSPACE",
  ModulePublish = "MODULE_PUBLISH",
  ModuleTriggerVersion = "MODULE_TRIGGER_VERSION",
  ModuleUploadLocalWorkspace = "MODULE_UPLOAD_LOCAL_WORKSPACE",
  ModuleVersionDelete = "MODULE_VERSION_DELETE",
  RepoCreate = "REPO_CREATE",
  RepoDelete = "REPO_DELETE",
  RepoUpdate = "REPO_UPDATE",
  RevisionCreate = "REVISION_CREATE",
  RollbackBlueprintDeployment = "ROLLBACK_BLUEPRINT_DEPLOYMENT",
  RunCancel = "RUN_CANCEL",
  RunCancelBlocking = "RUN_CANCEL_BLOCKING",
  RunComment = "RUN_COMMENT",
  RunConfirm = "RUN_CONFIRM",
  RunDiscard = "RUN_DISCARD",
  RunKill = "RUN_KILL",
  RunKillBlocking = "RUN_KILL_BLOCKING",
  RunPrioritizeSet = "RUN_PRIORITIZE_SET",
  RunPromote = "RUN_PROMOTE",
  RunProposeLocalWorkspace = "RUN_PROPOSE_LOCAL_WORKSPACE",
  RunProposeWithOverrides = "RUN_PROPOSE_WITH_OVERRIDES",
  RunRetry = "RUN_RETRY",
  RunRetryBlocking = "RUN_RETRY_BLOCKING",
  RunReview = "RUN_REVIEW",
  RunStop = "RUN_STOP",
  RunStopBlocking = "RUN_STOP_BLOCKING",
  RunTargetedReplan = "RUN_TARGETED_REPLAN",
  RunTrigger = "RUN_TRIGGER",
  RunTriggerWithCustomRuntimeConfig = "RUN_TRIGGER_WITH_CUSTOM_RUNTIME_CONFIG",
  SpaceAdmin = "SPACE_ADMIN",
  SpaceRead = "SPACE_READ",
  SpaceShareModule = "SPACE_SHARE_MODULE",
  SpaceWrite = "SPACE_WRITE",
  StackAddConfig = "STACK_ADD_CONFIG",
  /** Disabled. Do not use. */
  StackAwsIntegrationAttach = "STACK_AWS_INTEGRATION_ATTACH",
  /** Disabled. Do not use. */
  StackAwsIntegrationDetach = "STACK_AWS_INTEGRATION_DETACH",
  /** Disabled. Do not use. */
  StackAwsIntegrationUpdate = "STACK_AWS_INTEGRATION_UPDATE",
  /** Disabled. Do not use. */
  StackAzureIntegrationAttach = "STACK_AZURE_INTEGRATION_ATTACH",
  /** Disabled. Do not use. */
  StackAzureIntegrationDetach = "STACK_AZURE_INTEGRATION_DETACH",
  /** Disabled. Do not use. */
  StackAzureIntegrationUpdate = "STACK_AZURE_INTEGRATION_UPDATE",
  /** Disabled. Do not use. */
  StackContextAttach = "STACK_CONTEXT_ATTACH",
  /** Disabled. Do not use. */
  StackContextDetach = "STACK_CONTEXT_DETACH",
  StackCreate = "STACK_CREATE",
  StackDelete = "STACK_DELETE",
  StackDeleteConfig = "STACK_DELETE_CONFIG",
  StackDisable = "STACK_DISABLE",
  StackEnable = "STACK_ENABLE",
  /** Disabled. Do not use. */
  StackGcpIntegrationCreate = "STACK_GCP_INTEGRATION_CREATE",
  /** Disabled. Do not use. */
  StackGcpIntegrationDelete = "STACK_GCP_INTEGRATION_DELETE",
  StackLock = "STACK_LOCK",
  StackManage = "STACK_MANAGE",
  StackManagedStateImport = "STACK_MANAGED_STATE_IMPORT",
  StackManagedStateRollback = "STACK_MANAGED_STATE_ROLLBACK",
  /** Disabled. Do not use. */
  StackPolicyAttach = "STACK_POLICY_ATTACH",
  /** Disabled. Do not use. */
  StackPolicyDetach = "STACK_POLICY_DETACH",
  StackReslug = "STACK_RESLUG",
  /** Disabled. Do not use. */
  StackRoleBindingCreate = "STACK_ROLE_BINDING_CREATE",
  /** Disabled. Do not use. */
  StackRoleBindingDelete = "STACK_ROLE_BINDING_DELETE",
  /** Disabled. Do not use. */
  StackRoleBindingUpdate = "STACK_ROLE_BINDING_UPDATE",
  StackScheduledDeleteCreate = "STACK_SCHEDULED_DELETE_CREATE",
  StackScheduledDeleteDelete = "STACK_SCHEDULED_DELETE_DELETE",
  StackScheduledDeleteUpdate = "STACK_SCHEDULED_DELETE_UPDATE",
  StackScheduledRunCreate = "STACK_SCHEDULED_RUN_CREATE",
  StackScheduledRunDelete = "STACK_SCHEDULED_RUN_DELETE",
  StackScheduledRunUpdate = "STACK_SCHEDULED_RUN_UPDATE",
  StackScheduledTaskCreate = "STACK_SCHEDULED_TASK_CREATE",
  StackScheduledTaskDelete = "STACK_SCHEDULED_TASK_DELETE",
  StackScheduledTaskUpdate = "STACK_SCHEDULED_TASK_UPDATE",
  StackSetCurrentCommit = "STACK_SET_CURRENT_COMMIT",
  StackSetStar = "STACK_SET_STAR",
  StackStateDownload = "STACK_STATE_DOWNLOAD",
  StackStateRead = "STACK_STATE_READ",
  StackSyncCommit = "STACK_SYNC_COMMIT",
  StackUnlock = "STACK_UNLOCK",
  StackUnlockForce = "STACK_UNLOCK_FORCE",
  StackUpdate = "STACK_UPDATE",
  StackUploadLocalWorkspace = "STACK_UPLOAD_LOCAL_WORKSPACE",
  /** Disabled. Do not use. */
  StackWebhookCreate = "STACK_WEBHOOK_CREATE",
  /** Disabled. Do not use. */
  StackWebhookDelete = "STACK_WEBHOOK_DELETE",
  /** Disabled. Do not use. */
  StackWebhookUpdate = "STACK_WEBHOOK_UPDATE",
  StackWorkspaceLock = "STACK_WORKSPACE_LOCK",
  StackWorkspaceUnlock = "STACK_WORKSPACE_UNLOCK",
  TaskCreate = "TASK_CREATE",
  TerraformProviderCreate = "TERRAFORM_PROVIDER_CREATE",
  TerraformProviderDelete = "TERRAFORM_PROVIDER_DELETE",
  TerraformProviderSetVisibility = "TERRAFORM_PROVIDER_SET_VISIBILITY",
  TerraformProviderUpdate = "TERRAFORM_PROVIDER_UPDATE",
  TerraformProviderVersionCreate = "TERRAFORM_PROVIDER_VERSION_CREATE",
  TerraformProviderVersionDelete = "TERRAFORM_PROVIDER_VERSION_DELETE",
  TerraformProviderVersionPublish = "TERRAFORM_PROVIDER_VERSION_PUBLISH",
  TerraformProviderVersionRegisterPlatform = "TERRAFORM_PROVIDER_VERSION_REGISTER_PLATFORM",
  TerraformProviderVersionRevoke = "TERRAFORM_PROVIDER_VERSION_REVOKE",
  TerraformProviderVersionUpdate = "TERRAFORM_PROVIDER_VERSION_UPDATE",
  TestBlueprintDeployment = "TEST_BLUEPRINT_DEPLOYMENT",
  UpdateBlueprintsVersionedGroup = "UPDATE_BLUEPRINTS_VERSIONED_GROUP",
  /** @deprecated Use UPGRADE_BLUEPRINT_DEPLOYMENT instead. */
  UpdateBlueprintDeployment = "UPDATE_BLUEPRINT_DEPLOYMENT",
  /** @deprecated Use UPGRADE_BLUEPRINT_DEPLOYMENT instead. */
  UpdateBlueprintDeploymentInputs = "UPDATE_BLUEPRINT_DEPLOYMENT_INPUTS",
  UpgradeBlueprintDeployment = "UPGRADE_BLUEPRINT_DEPLOYMENT",
  WorkerDrainSet = "WORKER_DRAIN_SET",
  WorkerPoolCreate = "WORKER_POOL_CREATE",
  WorkerPoolCycle = "WORKER_POOL_CYCLE",
  WorkerPoolDelete = "WORKER_POOL_DELETE",
  WorkerPoolReset = "WORKER_POOL_RESET",
  WorkerPoolUpdate = "WORKER_POOL_UPDATE",
}

/** Possible Ansible entity types. */
export type AnsibleEntity = AnsibleResource;

export type AnsibleHost = {
  __typename?: "AnsibleHost";
  architecture: Maybe<Scalars["String"]["output"]>;
  distribution: Maybe<Scalars["String"]["output"]>;
  distributionVersion: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  machineID: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** searchAnsibleTaskExecutions allows to search ansibleTaskExecutions of an ansibleHost. */
  searchAnsibleTaskExecutions: Maybe<SearchAnsibleTaskExecutionsOutput>;
  /** Information about fields available for searching AnsibleTaskExecution. */
  searchAnsibleTaskExecutionsSuggestions: Maybe<SearchSuggestionsOutput>;
  taskExecutions: Array<AnsibleTaskExecution>;
};

export type AnsibleHostSearchAnsibleTaskExecutionsArgs = {
  input: SearchInput;
};

export type AnsibleHostSearchAnsibleTaskExecutionsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type AnsibleHostsConnection = {
  __typename?: "AnsibleHostsConnection";
  cursor: Scalars["String"]["output"];
  node: AnsibleHost;
};

export type AnsiblePlaybook = {
  __typename?: "AnsiblePlaybook";
  name: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
};

/** Metadata for a Ansible resource. */
export type AnsibleResource = {
  __typename?: "AnsibleResource";
  /** Data of the Ansible resource. */
  data: Scalars["String"]["output"];
};

export type AnsibleRole = {
  __typename?: "AnsibleRole";
  name: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
};

export type AnsibleTask = {
  __typename?: "AnsibleTask";
  action: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  playbook: AnsiblePlaybook;
  resolvedAction: Scalars["String"]["output"];
  role: Maybe<AnsibleRole>;
  taskExecutions: Array<AnsibleTaskExecution>;
};

export type AnsibleTaskExecution = {
  __typename?: "AnsibleTaskExecution";
  /** Was task executed in check mode */
  checkMode: Scalars["Boolean"]["output"];
  /** Diff (if present) */
  diff: Scalars["String"]["output"];
  /** AnsibleHost on which AnsibleTask was executed */
  host: AnsibleHost;
  /** Run ID */
  runId: Scalars["ID"]["output"];
  /** Stack slug */
  stackId: Scalars["ID"]["output"];
  /** Execution AnsibleTaskStatus */
  status: AnsibleTaskStatus;
  /** Task output */
  stdout: Scalars["String"]["output"];
  /** Executed AnsibleTask */
  task: AnsibleTask;
  /** Timestamp of the task execution */
  timestamp: Scalars["Int"]["output"];
};

export type AnsibleTaskExecutionsConnection = {
  __typename?: "AnsibleTaskExecutionsConnection";
  cursor: Scalars["String"]["output"];
  node: AnsibleTaskExecution;
};

export enum AnsibleTaskStatus {
  Changed = "CHANGED",
  Failed = "FAILED",
  Ignored = "IGNORED",
  Ok = "OK",
  Rescued = "RESCUED",
  Skipped = "SKIPPED",
  Unreachable = "UNREACHABLE",
}

export type AnsibleTasksConnection = {
  __typename?: "AnsibleTasksConnection";
  cursor: Scalars["String"]["output"];
  node: AnsibleTask;
};

/** ApiKey represents a user-generated API key. */
export type ApiKey = {
  __typename?: "ApiKey";
  /** List of permissions given explicitly to this api key. */
  accessRules: Array<SpaceAccessRule>;
  /** Should tokens generated from this API key have admin permissions? */
  admin: Scalars["Boolean"]["output"];
  apiKeyRoleBindings: Array<ApiKeyRoleBinding>;
  /** Creation timestamp. */
  createdAt: Scalars["Int"]["output"];
  /** The creator of the API key. */
  creator: Scalars["String"]["output"];
  /** Indicates whether the API key is deleted. */
  deleted: Scalars["Boolean"]["output"];
  /** Free-form description of the API key. */
  description: Scalars["String"]["output"];
  /** Indicates whether the API key has been disabled. */
  disabled: Scalars["Boolean"]["output"];
  /** When the API key was disabled. Null while the key is active. */
  disabledAt: Maybe<Scalars["Int"]["output"]>;
  /** Who disabled the API key. Null while the key is active. */
  disabledReason: Maybe<ApiKeyDisabledReason>;
  expiresAt: Maybe<Scalars["Int"]["output"]>;
  /** Globally unique ID of the API key. */
  id: Scalars["ID"]["output"];
  /** Indicates whether the api key is a machine user. */
  isMachineUser: Scalars["Boolean"]["output"];
  /** Indicates whether the API key is personal, owned by a person rather than the organization. */
  isPersonal: Scalars["Boolean"]["output"];
  /** Last usage (token generation) timestamp, if any. */
  lastUsedAt: Maybe<Scalars["Int"]["output"]>;
  /** Human-readable name of this API key. */
  name: Scalars["String"]["output"];
  /** The OIDC settings for this API key. */
  oidcSettings: Maybe<ApiKeyOidcSettings>;
  /** Login of the user who owns the API key. Null for organization-level keys. */
  owner: Maybe<Scalars["String"]["output"]>;
  /**
   * API key secret - only visible when the key is created and not persisted on
   * Spacelift end. Make sure to save it!
   */
  secret: Maybe<Scalars["String"]["output"]>;
  /** Number of spaces api key was explicitly given permissions to. */
  spaceCount: Scalars["Int"]["output"];
  /** Number of teams this key "belongs to" */
  teamCount: Scalars["Int"]["output"];
  /**
   * List of teams this key "belongs to". This allows non-admin API keys to be
   * treated the same way as regular users by stack-level policies.
   */
  teams: Array<Scalars["String"]["output"]>;
  /** Type of the API key. */
  type: ApiKeyType;
};

/** ApiKeyDisabledReason says who disabled a personal API key. */
export enum ApiKeyDisabledReason {
  /** An account admin turned personal API keys off and disabled existing keys. */
  Account = "ACCOUNT",
  /** A root admin revoked the key. */
  Admin = "ADMIN",
  /** The owner was deprovisioned. */
  Deprovisioned = "DEPROVISIONED",
  /** The account moved to login policies. */
  Scheme = "SCHEME",
}

export type ApiKeyInput = {
  /** Access rules for api key. */
  accessRules: InputMaybe<Array<SpaceAccessRuleInput>>;
  admin: Scalars["Boolean"]["input"];
  description: InputMaybe<Scalars["String"]["input"]>;
  expiresAt: InputMaybe<Scalars["Int"]["input"]>;
  machine: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  oidc: InputMaybe<ApiKeyInputOidc>;
  roleBindings: InputMaybe<Array<RoleBindingInput>>;
  teams: Array<Scalars["String"]["input"]>;
};

/** ApiKeyOIDCSettings represents the OIDC settings for an API key. */
export type ApiKeyOidcSettings = {
  __typename?: "ApiKeyOIDCSettings";
  /**
   * Claim mappings for mapping IdP JWT claim keys to Spacelift claim keys.
   * For example, mapping "cognito_groups" to "groups" allows dynamic team
   * extraction from the OIDC token.
   */
  claimMapping: ClaimMapping;
  /** The OIDC client ID (audience). */
  clientId: Scalars["String"]["output"];
  /** The OIDC issuer URL. */
  issuer: Scalars["String"]["output"];
  /**
   * The regular expression against which the subject of the OIDC token will be
   * matched.
   */
  subjectExpression: Scalars["String"]["output"];
};

export type ApiKeyRoleBinding = {
  __typename?: "ApiKeyRoleBinding";
  apiKey: ApiKey;
  apiKeyID: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  role: Role;
  space: Space;
  /** @deprecated Use space field instead. */
  spaceID: Scalars["ID"]["output"];
};

export type ApiKeyRoleBindingBatchInput = {
  /** List of API key role bindings to create. */
  bindings: Array<ApiKeyRoleBindingInput>;
};

export type ApiKeyRoleBindingInput = {
  /** ID of the api key. */
  apiKeyID: Scalars["ID"]["input"];
  /** ID of the role. */
  roleID: Scalars["ID"]["input"];
  /** ID of the space. */
  spaceID: Scalars["ID"]["input"];
};

export type ApiKeySessionsWithAccessToSpaceEdge = {
  __typename?: "ApiKeySessionsWithAccessToSpaceEdge";
  cursor: Scalars["String"]["output"];
  node: ApiKeySessionsWithAccessToSpaceNode;
};

export type ApiKeySessionsWithAccessToSpaceNode = {
  __typename?: "ApiKeySessionsWithAccessToSpaceNode";
  apiKey: ApiKey;
  roles: Array<SessionSpaceAccessRoleGrant>;
  /** Number of live sessions of this key whose access reaches the queried space. */
  sessionCount: Scalars["Int"]["output"];
};

export type ApiKeySessionsWithAccessToSpaceOutput = {
  __typename?: "ApiKeySessionsWithAccessToSpaceOutput";
  edges: Array<ApiKeySessionsWithAccessToSpaceEdge>;
  pageInfo: PageInfo;
};

/** A role grant giving an API key access to a space, either directly or via an ancestor space. */
export type ApiKeySpaceAccessRoleGrant = {
  __typename?: "ApiKeySpaceAccessRoleGrant";
  /** True when the grant lives on an ancestor space rather than the queried space. */
  propagated: Scalars["Boolean"]["output"];
  role: Role;
  space: Space;
};

export type ApiKeyUpdateInput = {
  description: InputMaybe<Scalars["String"]["input"]>;
  name: InputMaybe<Scalars["String"]["input"]>;
  oidcClaimMappings: InputMaybe<ClaimMappingInput>;
  teams: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ApiKeyWithAccessToSpaceEdge = {
  __typename?: "ApiKeyWithAccessToSpaceEdge";
  cursor: Scalars["String"]["output"];
  node: ApiKeyWithAccessToSpaceNode;
};

export type ApiKeyWithAccessToSpaceNode = {
  __typename?: "ApiKeyWithAccessToSpaceNode";
  apiKey: ApiKey;
  roles: Array<ApiKeySpaceAccessRoleGrant>;
};

export type ApiKeysWithAccessToSpaceOutput = {
  __typename?: "ApiKeysWithAccessToSpaceOutput";
  edges: Array<ApiKeyWithAccessToSpaceEdge>;
  pageInfo: PageInfo;
};

export type AuditActor = {
  __typename?: "AuditActor";
  /**
   * Contains details of the Spacelift run that performed the action. Only populated for audit
   * entries created by runs in Administrative stacks.
   */
  run: Maybe<AuditRunActor>;
  /**
   * Username of the user / API key who created the entry. If the action was triggered by a
   * run on an administrative stack, this field will be set to `spacelift`, and the `run`
   * field will be populated.
   */
  username: Scalars["String"]["output"];
};

export type AuditRunActor = {
  __typename?: "AuditRunActor";
  /** The run ID. */
  id: Scalars["ID"]["output"];
  /** The ID of the run's stack. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailAiIntegrationMetadata = {
  __typename?: "AuditTrailAIIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailApiKeyMetadata = {
  __typename?: "AuditTrailAPIKeyMetadata";
  /** The ID of the API key. */
  id: Scalars["ID"]["output"];
};

export type AuditTrailApiKeyRoleBindingMetadata = {
  __typename?: "AuditTrailAPIKeyRoleBindingMetadata";
  /** The ULID of the API key. */
  apiKeyULID: Scalars["ID"]["output"];
  /** The ULID of the role. */
  roleULID: Scalars["ID"]["output"];
  /** The ULID of the space. */
  spaceULID: Scalars["ID"]["output"];
};

export type AuditTrailAwsIntegrationMetadata = {
  __typename?: "AuditTrailAWSIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailAccountMetadata = {
  __typename?: "AuditTrailAccountMetadata";
  /** The subdomain of the Spacelift account. */
  subdomain: Scalars["ID"]["output"];
};

export type AuditTrailAzureDevOpsRepoIntegrationMetadata = {
  __typename?: "AuditTrailAzureDevOpsRepoIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailAzureIntegrationMetadata = {
  __typename?: "AuditTrailAzureIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailBitbucketCloudIntegrationMetadata = {
  __typename?: "AuditTrailBitbucketCloudIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailBitbucketDatacenterIntegrationMetadata = {
  __typename?: "AuditTrailBitbucketDatacenterIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailBlobStorageIntegrationMetadata = {
  __typename?: "AuditTrailBlobStorageIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailBlueprintDeploymentMetadata = {
  __typename?: "AuditTrailBlueprintDeploymentMetadata";
  /** The ID of the deployment. */
  id: Scalars["ID"]["output"];
  /** The name of the deployment. */
  name: Scalars["String"]["output"];
};

export type AuditTrailBlueprintMetadata = {
  __typename?: "AuditTrailBlueprintMetadata";
  /** The ID of the blueprint. */
  id: Scalars["ID"]["output"];
  /** The name of the blueprint. */
  name: Scalars["String"]["output"];
};

export type AuditTrailBlueprintVersionedGroupMetadata = {
  __typename?: "AuditTrailBlueprintVersionedGroupMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailContextMetadata = {
  __typename?: "AuditTrailContextMetadata";
  /** The ID of the context. */
  id: Scalars["ID"]["output"];
  /** The name of the context. */
  name: Scalars["String"]["output"];
};

export type AuditTrailDriftDetectionIntegrationMetadata = {
  __typename?: "AuditTrailDriftDetectionIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The ID of the stack the integration is defined on. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailEntriesConnection = {
  __typename?: "AuditTrailEntriesConnection";
  cursor: Scalars["String"]["output"];
  node: AuditTrailEntry;
};

export type AuditTrailEntry = {
  __typename?: "AuditTrailEntry";
  /** The audit action. */
  action: Scalars["String"]["output"];
  /** The entity that performed the action being audited. */
  actor: AuditActor;
  /** The resource that was affected by the event. */
  affectedResource: AuditTrailResource;
  /** Body of the event */
  body: Maybe<Scalars["String"]["output"]>;
  /** CreatedAt is unix timestamp (in seconds) at which the entry was created */
  createdAt: Scalars["Int"]["output"];
  /** The type of the event which was triggered */
  eventType: AuditTrailEventType;
  /** AuditTrailEntry ID, used to identify an entry */
  id: Scalars["ID"]["output"];
  /** IdentityULID is the ULID of the identity that performed the action, if one is associated with it. */
  identityUlid: Maybe<Scalars["String"]["output"]>;
  /** OwnerLogin is the username of the person behind a personal API key session, null for every other actor. */
  ownerLogin: Maybe<Scalars["String"]["output"]>;
  /**
   * A resource that wasn't affected by the event, but is related to the affected resource. For
   * example a Blueprint that was used to create a stack. This is only populated for certain events.
   */
  relatedResource: Maybe<AuditTrailResource>;
  /** RemoteIP is the IP address of the user who triggered the event */
  remoteIP: Maybe<Scalars["String"]["output"]>;
  /** UpdatedAt is unix timestamp (in seconds) at which the entry was updated */
  updatedAt: Scalars["Int"]["output"];
};

export enum AuditTrailEventType {
  /** A new resource was created. */
  Create = "CREATE",
  /** An existing resource was deleted. */
  Delete = "DELETE",
  /** No changes were made - this audit entry is informational only. */
  None = "NONE",
  /** The event type is unknown. */
  Unknown = "UNKNOWN",
  /** An existing resource was updated. */
  Update = "UPDATE",
}

export type AuditTrailExternalIntegrationMetadata = {
  __typename?: "AuditTrailExternalIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailFlowsProjectRoleBindingMetadata = {
  __typename?: "AuditTrailFlowsProjectRoleBindingMetadata";
  /** The external Flows project UUID. */
  flowsProjectID: Scalars["ID"]["output"];
  /** The ULID of the role binding. */
  id: Scalars["ID"]["output"];
  /** The ULID of the role. */
  roleULID: Scalars["ID"]["output"];
  /** The slug of the space. */
  spaceID: Scalars["ID"]["output"];
};

export type AuditTrailGpgKeyMetadata = {
  __typename?: "AuditTrailGPGKeyMetadata";
  /** The ID of the key. */
  id: Scalars["ID"]["output"];
  /** The name of the key. */
  name: Scalars["String"]["output"];
};

export type AuditTrailGenericFormMetadata = {
  __typename?: "AuditTrailGenericFormMetadata";
  /** The name of the generic form. */
  name: Scalars["String"]["output"];
};

export type AuditTrailGithubAppInstallationMetadata = {
  __typename?: "AuditTrailGithubAppInstallationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
};

export type AuditTrailGithubEnterpriseIntegrationMetadata = {
  __typename?: "AuditTrailGithubEnterpriseIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailGitlabIntegrationMetadata = {
  __typename?: "AuditTrailGitlabIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailIdentityMetadata = {
  __typename?: "AuditTrailIdentityMetadata";
  /** The external username on the federation provider. */
  externalUsername: Scalars["String"]["output"];
  /** The ULID of the identity. */
  id: Scalars["ID"]["output"];
  /** The federation provider that was linked or unlinked. */
  provider: Scalars["String"]["output"];
};

export type AuditTrailIntentChatConversationMetadata = {
  __typename?: "AuditTrailIntentChatConversationMetadata";
  id: Scalars["ID"]["output"];
  name: Maybe<Scalars["String"]["output"]>;
};

export type AuditTrailIntentProjectMetadata = {
  __typename?: "AuditTrailIntentProjectMetadata";
  id: Scalars["ID"]["output"];
  name: Maybe<Scalars["String"]["output"]>;
};

export type AuditTrailLoginMetadata = {
  __typename?: "AuditTrailLoginMetadata";
  /** The username. */
  username: Scalars["String"]["output"];
};

export type AuditTrailModuleMetadata = {
  __typename?: "AuditTrailModuleMetadata";
  /** The ID of the module. */
  id: Scalars["ID"]["output"];
  /** The name of the module. */
  name: Scalars["String"]["output"];
};

export type AuditTrailNamedWebhooksIntegrationMetadata = {
  __typename?: "AuditTrailNamedWebhooksIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
  /** The name of the integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailOriginIntegrationMetadata = {
  __typename?: "AuditTrailOriginIntegrationMetadata";
  /** The ID of the integration. */
  id: Scalars["ID"]["output"];
};

export type AuditTrailPluginMetadata = {
  __typename?: "AuditTrailPluginMetadata";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type AuditTrailPluginTemplateMetadata = {
  __typename?: "AuditTrailPluginTemplateMetadata";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type AuditTrailPolicyMetadata = {
  __typename?: "AuditTrailPolicyMetadata";
  /** The ID of the policy. */
  id: Scalars["ID"]["output"];
  /** The name of the policy. */
  name: Scalars["String"]["output"];
};

export type AuditTrailRepoMetadata = {
  __typename?: "AuditTrailRepoMetadata";
  /** The ID (slug) of the Repo. */
  id: Scalars["ID"]["output"];
  /** The name of the Repo. */
  name: Scalars["String"]["output"];
};

export type AuditTrailResource = {
  __typename?: "AuditTrailResource";
  /** Contains additional information about the resource that has changed. This is primarily used to generate links to the resource in the Spacelift UI. */
  metadata: AuditTrailResourceMetadata;
  /** The ID of the resource, or null if the event affected multiple resources. */
  resourceId: Maybe<Scalars["String"]["output"]>;
  /** Resource type which was affected */
  resourceType: AuditTrailResourceType;
};

/**
 * AuditTrailResourceMetadata is a union of all the types of resource metadata that can be provided.
 * Each AuditTrailResourceType has a corresponding metadata type containing additional information
 * about that resource.
 */
export type AuditTrailResourceMetadata =
  | AuditTrailAiIntegrationMetadata
  | AuditTrailApiKeyMetadata
  | AuditTrailApiKeyRoleBindingMetadata
  | AuditTrailAwsIntegrationMetadata
  | AuditTrailAccountMetadata
  | AuditTrailAzureDevOpsRepoIntegrationMetadata
  | AuditTrailAzureIntegrationMetadata
  | AuditTrailBitbucketCloudIntegrationMetadata
  | AuditTrailBitbucketDatacenterIntegrationMetadata
  | AuditTrailBlobStorageIntegrationMetadata
  | AuditTrailBlueprintDeploymentMetadata
  | AuditTrailBlueprintMetadata
  | AuditTrailBlueprintVersionedGroupMetadata
  | AuditTrailContextMetadata
  | AuditTrailDriftDetectionIntegrationMetadata
  | AuditTrailExternalIntegrationMetadata
  | AuditTrailFlowsProjectRoleBindingMetadata
  | AuditTrailGpgKeyMetadata
  | AuditTrailGenericFormMetadata
  | AuditTrailGithubAppInstallationMetadata
  | AuditTrailGithubEnterpriseIntegrationMetadata
  | AuditTrailGitlabIntegrationMetadata
  | AuditTrailIdentityMetadata
  | AuditTrailIntentChatConversationMetadata
  | AuditTrailIntentProjectMetadata
  | AuditTrailLoginMetadata
  | AuditTrailModuleMetadata
  | AuditTrailNamedWebhooksIntegrationMetadata
  | AuditTrailOriginIntegrationMetadata
  | AuditTrailPluginMetadata
  | AuditTrailPluginTemplateMetadata
  | AuditTrailPolicyMetadata
  | AuditTrailRepoMetadata
  | AuditTrailRoleMetadata
  | AuditTrailRunMetadata
  | AuditTrailScanMetadata
  | AuditTrailScanRunMetadata
  | AuditTrailScheduledDeleteMetadata
  | AuditTrailScheduledRunMetadata
  | AuditTrailScheduledTaskMetadata
  | AuditTrailSecurityKeyMetadata
  | AuditTrailSessionMetadata
  | AuditTrailSpaceMetadata
  | AuditTrailStackDependencyMetadata
  | AuditTrailStackMetadata
  | AuditTrailStackRoleBindingMetadata
  | AuditTrailTaskMetadata
  | AuditTrailTerraformProviderMetadata
  | AuditTrailTerraformProviderVersionMetadata
  | AuditTrailUserGroupIntegrationMetadata
  | AuditTrailUserGroupMetadata
  | AuditTrailUserGroupRoleBindingMetadata
  | AuditTrailUserGuideMetadata
  | AuditTrailUserMetadata
  | AuditTrailUserRoleBindingMetadata
  | AuditTrailVersionMetadata
  | AuditTrailWebhookMetadata
  | AuditTrailWorkerMetadata
  | AuditTrailWorkerPoolMetadata;

export enum AuditTrailResourceType {
  Account = "ACCOUNT",
  AiIntegration = "AI_INTEGRATION",
  ApiKey = "API_KEY",
  ApiKeyRoleBinding = "API_KEY_ROLE_BINDING",
  AwsIntegration = "AWS_INTEGRATION",
  AzureDevopsRepoIntegration = "AZURE_DEVOPS_REPO_INTEGRATION",
  AzureIntegration = "AZURE_INTEGRATION",
  BitbucketCloudIntegration = "BITBUCKET_CLOUD_INTEGRATION",
  BitbucketDatacenterIntegration = "BITBUCKET_DATACENTER_INTEGRATION",
  BlobStorageIntegration = "BLOB_STORAGE_INTEGRATION",
  Blueprint = "BLUEPRINT",
  BlueprintDeployment = "BLUEPRINT_DEPLOYMENT",
  BlueprintVersionedGroup = "BLUEPRINT_VERSIONED_GROUP",
  Context = "CONTEXT",
  DriftDetectionIntegration = "DRIFT_DETECTION_INTEGRATION",
  ExternalIntegration = "EXTERNAL_INTEGRATION",
  FlowsProjectRoleBinding = "FLOWS_PROJECT_ROLE_BINDING",
  GenericForm = "GENERIC_FORM",
  GithubAppInstallation = "GITHUB_APP_INSTALLATION",
  GithubEnterpriseIntegration = "GITHUB_ENTERPRISE_INTEGRATION",
  GitlabIntegration = "GITLAB_INTEGRATION",
  GpgKey = "GPG_KEY",
  Identity = "IDENTITY",
  IntentChatConversation = "INTENT_CHAT_CONVERSATION",
  IntentProject = "INTENT_PROJECT",
  Login = "LOGIN",
  Module = "MODULE",
  NamedWebhooksIntegration = "NAMED_WEBHOOKS_INTEGRATION",
  Notification = "NOTIFICATION",
  OriginIntegration = "ORIGIN_INTEGRATION",
  Plugin = "PLUGIN",
  PluginTemplate = "PLUGIN_TEMPLATE",
  Policy = "POLICY",
  Repo = "REPO",
  Role = "ROLE",
  Run = "RUN",
  Scan = "SCAN",
  ScanRun = "SCAN_RUN",
  ScheduledDelete = "SCHEDULED_DELETE",
  ScheduledRun = "SCHEDULED_RUN",
  ScheduledTask = "SCHEDULED_TASK",
  SecurityKey = "SECURITY_KEY",
  Session = "SESSION",
  Space = "SPACE",
  Stack = "STACK",
  StackDependency = "STACK_DEPENDENCY",
  StackRoleBinding = "STACK_ROLE_BINDING",
  Task = "TASK",
  TerraformProvider = "TERRAFORM_PROVIDER",
  TerraformProviderVersion = "TERRAFORM_PROVIDER_VERSION",
  Unknown = "UNKNOWN",
  User = "USER",
  UserGroup = "USER_GROUP",
  UserGroupIntegration = "USER_GROUP_INTEGRATION",
  UserGroupRoleBinding = "USER_GROUP_ROLE_BINDING",
  UserGuide = "USER_GUIDE",
  UserRoleBinding = "USER_ROLE_BINDING",
  Version = "VERSION",
  Webhook = "WEBHOOK",
  Worker = "WORKER",
  WorkerPool = "WORKER_POOL",
}

export type AuditTrailRoleMetadata = {
  __typename?: "AuditTrailRoleMetadata";
  /** The ID of the role. */
  id: Scalars["ID"]["output"];
  /** The name of the role. */
  name: Scalars["String"]["output"];
  /** The slug of the role. */
  slug: Scalars["String"]["output"];
};

export type AuditTrailRunMetadata = {
  __typename?: "AuditTrailRunMetadata";
  /** The ID of the run. */
  id: Scalars["ID"]["output"];
  /** The stack ID of the run. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailScanMetadata = {
  __typename?: "AuditTrailScanMetadata";
  /** The ID of the scan. */
  id: Scalars["ID"]["output"];
  /** The name of the scan. */
  name: Scalars["String"]["output"];
};

export type AuditTrailScanRunMetadata = {
  __typename?: "AuditTrailScanRunMetadata";
  /** The ID of the scan run (ULID). */
  id: Scalars["ID"]["output"];
};

export type AuditTrailScheduledDeleteMetadata = {
  __typename?: "AuditTrailScheduledDeleteMetadata";
  /** The ID of the scheduled delete. */
  id: Scalars["ID"]["output"];
  /** The ID of the stack the schedule is defined on. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailScheduledRunMetadata = {
  __typename?: "AuditTrailScheduledRunMetadata";
  /** The ID of the scheduled run. */
  id: Scalars["ID"]["output"];
  /** The ID of the stack the schedule is defined on. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailScheduledTaskMetadata = {
  __typename?: "AuditTrailScheduledTaskMetadata";
  /** The ID of the scheduled task. */
  id: Scalars["ID"]["output"];
  /** The ID of the stack the schedule is defined on. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailSecurityKeyMetadata = {
  __typename?: "AuditTrailSecurityKeyMetadata";
  /** The ID of the security key. */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type AuditTrailSessionMetadata = {
  __typename?: "AuditTrailSessionMetadata";
  /** The ID of the session. */
  id: Scalars["ID"]["output"];
};

export type AuditTrailSpaceMetadata = {
  __typename?: "AuditTrailSpaceMetadata";
  /** The ID of the space. */
  id: Scalars["ID"]["output"];
  /** The name of the space. */
  name: Scalars["String"]["output"];
};

export type AuditTrailStackDependencyMetadata = {
  __typename?: "AuditTrailStackDependencyMetadata";
  /** The ID (slug) of the stack being depended on. */
  dependsOnStackId: Scalars["ID"]["output"];
  /** The name of the stack being depended on. */
  dependsOnStackName: Scalars["String"]["output"];
  /** The ID of the stack dependency. */
  id: Scalars["ID"]["output"];
  /** The ID (slug) of the stack that has the dependency. */
  stackId: Scalars["ID"]["output"];
  /** The name of the stack that has the dependency. */
  stackName: Scalars["String"]["output"];
};

export type AuditTrailStackMetadata = {
  __typename?: "AuditTrailStackMetadata";
  /** The ID of the stack. */
  id: Scalars["ID"]["output"];
  /** The name of the stack. */
  name: Scalars["String"]["output"];
};

export type AuditTrailStackRoleBindingMetadata = {
  __typename?: "AuditTrailStackRoleBindingMetadata";
  /** The ID of the stack role binding. */
  id: Scalars["ID"]["output"];
  /** The ULID of the role. */
  roleULID: Scalars["ID"]["output"];
  /** The ID of the space. */
  spaceID: Scalars["ID"]["output"];
  /** The ID of the stack. */
  stackID: Scalars["ID"]["output"];
  /** The name of the stack. */
  stackName: Scalars["String"]["output"];
};

export type AuditTrailTaskMetadata = {
  __typename?: "AuditTrailTaskMetadata";
  /** The ID of the task. */
  id: Scalars["ID"]["output"];
  /** The stack ID of the task. */
  stackId: Scalars["ID"]["output"];
};

export type AuditTrailTerraformProviderMetadata = {
  __typename?: "AuditTrailTerraformProviderMetadata";
  /** The Terraform provider type. */
  type: Scalars["String"]["output"];
};

export type AuditTrailTerraformProviderVersionMetadata = {
  __typename?: "AuditTrailTerraformProviderVersionMetadata";
  /** The ID of the version. */
  id: Scalars["ID"]["output"];
  /** The Terraform provider type. */
  type: Scalars["String"]["output"];
  /** The version number. */
  versionNumber: Scalars["String"]["output"];
};

export type AuditTrailUserGroupIntegrationMetadata = {
  __typename?: "AuditTrailUserGroupIntegrationMetadata";
  /** The ID of the group integration. */
  id: Scalars["ID"]["output"];
  /** The name of the group integration. */
  name: Scalars["String"]["output"];
};

export type AuditTrailUserGroupMetadata = {
  __typename?: "AuditTrailUserGroupMetadata";
  /** The ID of the group. */
  id: Scalars["ID"]["output"];
  /** The name of the group. */
  name: Scalars["String"]["output"];
};

export type AuditTrailUserGroupRoleBindingMetadata = {
  __typename?: "AuditTrailUserGroupRoleBindingMetadata";
  /** The ID of the user group role binding. */
  id: Scalars["ID"]["output"];
  /** The ULID of the role. */
  roleULID: Scalars["ID"]["output"];
  /** The ID of the space. */
  spaceID: Scalars["ID"]["output"];
  /** The ID of the user group. */
  userGroupID: Scalars["ID"]["output"];
  /** The name of the user group. */
  userGroupName: Scalars["String"]["output"];
};

export type AuditTrailUserGuideMetadata = {
  __typename?: "AuditTrailUserGuideMetadata";
  /** The ID of the user guide progress. */
  id: Scalars["ID"]["output"];
  /** The name of the user guide. */
  name: Scalars["String"]["output"];
  /** The status of the user guide progress. */
  status: UserGuideStatus;
};

export type AuditTrailUserMetadata = {
  __typename?: "AuditTrailUserMetadata";
  /** The user's username. */
  username: Scalars["String"]["output"];
};

export type AuditTrailUserRoleBindingMetadata = {
  __typename?: "AuditTrailUserRoleBindingMetadata";
  /** The ID of the user role binding. */
  id: Scalars["ID"]["output"];
  /** The ULID of the role. */
  roleULID: Scalars["ID"]["output"];
  /** The ID of the space. */
  spaceID: Scalars["ID"]["output"];
  /** The username of the user. */
  username: Scalars["String"]["output"];
};

export type AuditTrailVersionMetadata = {
  __typename?: "AuditTrailVersionMetadata";
  /** The ID of the version. */
  id: Scalars["ID"]["output"];
  /** The ID of the module. */
  moduleId: Scalars["ID"]["output"];
};

/** AuditTrailWebhook represents audit trail webhook configuration for the account. */
export type AuditTrailWebhook = {
  __typename?: "AuditTrailWebhook";
  /**
   * Custom headers is a list of header keys which are set for this webhook.
   * Only the keys are returned as values potentially have sensitive data.
   */
  customHeaders: Array<Scalars["String"]["output"]>;
  /**
   * Paginated list of audit trail deliveries. The optional opaque token is used
   * for pagination and should be copied from the previous WebhookDeliveries
   * response.
   */
  deliveries: Maybe<WebhookDeliveries>;
  /** Extended details of a single delivery. */
  deliveryDetails: Maybe<WebhookDeliveryDetails>;
  /** Enable or disable audit trail. */
  enabled: Scalars["Boolean"]["output"];
  /** User endpoint to send audit trail webhooks. */
  endpoint: Scalars["String"]["output"];
  /**
   * Controls whether the global webhooks should also receive run state change
   * notifications.
   */
  includeRuns: Scalars["Boolean"]["output"];
  retryOnFailure: Scalars["Boolean"]["output"];
  /**
   *  Secret used to validate incoming webhook.
   * @deprecated This property is no longer used.
   */
  secret: Scalars["String"]["output"];
};

/** AuditTrailWebhook represents audit trail webhook configuration for the account. */
export type AuditTrailWebhookDeliveriesArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

/** AuditTrailWebhook represents audit trail webhook configuration for the account. */
export type AuditTrailWebhookDeliveryDetailsArgs = {
  key: Scalars["String"]["input"];
};

export type AuditTrailWebhookDeleteHeadersInput = {
  customHeaderKeys: Array<Scalars["String"]["input"]>;
};

export type AuditTrailWebhookInput = {
  /** Map of key values strings, that will be passed as headers with audit trail call. */
  customHeaders: InputMaybe<StringMapInput>;
  /** Enable or disable audit trail. */
  enabled: Scalars["Boolean"]["input"];
  /** User endpoint to send audit trail webhooks. */
  endpoint: Scalars["String"]["input"];
  /**
   * Controls whether the global webhooks should also receive run state change
   * notifications.
   */
  includeRuns: InputMaybe<Scalars["Boolean"]["input"]>;
  retryOnFailure: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Secret used to validate incoming webhook. */
  secret: InputMaybe<Scalars["String"]["input"]>;
};

export type AuditTrailWebhookMetadata = {
  __typename?: "AuditTrailWebhookMetadata";
  /** The ID of the webhook. */
  id: Scalars["ID"]["output"];
  /** The ID of the module. Only populated for webhooks defined on modules. */
  moduleId: Maybe<Scalars["ID"]["output"]>;
  /** The ID of the stack. Only populated for webhooks defined on stacks. */
  stackId: Maybe<Scalars["ID"]["output"]>;
};

export type AuditTrailWebhookSetHeadersInput = {
  customHeaders: StringMapInput;
};

export type AuditTrailWorkerMetadata = {
  __typename?: "AuditTrailWorkerMetadata";
  /** The ID of the worker. */
  id: Scalars["ID"]["output"];
  /** The ID of the worker pool. */
  workerPoolId: Scalars["ID"]["output"];
};

export type AuditTrailWorkerPoolMetadata = {
  __typename?: "AuditTrailWorkerPoolMetadata";
  /** The ID of the worker pool. */
  id: Scalars["ID"]["output"];
  /** The name of the worker pool. */
  name: Scalars["String"]["output"];
};

export enum AuthorizationScheme {
  LoginPolicies = "LOGIN_POLICIES",
  ManagedUsers = "MANAGED_USERS",
}

/**
 * AutoattachmentTarget is a stack or module that is autoattached to an
 * entity that supports autoattachment.
 */
export type AutoattachmentTarget = {
  __typename?: "AutoattachmentTarget";
  /** The ID (slug) of the target. */
  id: Scalars["ID"]["output"];
  /** True if the target is a module. */
  isModule: Scalars["Boolean"]["output"];
  /** List of labels on the target. */
  labels: Array<Scalars["String"]["output"]>;
  /** Name of the target. */
  name: Scalars["String"]["output"];
  /** ID of the space to which the target belongs. */
  space: Scalars["ID"]["output"];
  /** Details of the space this autoattachment target belongs to. */
  spaceDetails: Space;
};

/** AutoattachmentTargets is the list of autoattached stacks and modules. */
export type AutoattachmentTargets = {
  __typename?: "AutoattachmentTargets";
  /** The total number of autoattachment targets. */
  count: Scalars["Int"]["output"];
  /** Top 100 results. */
  sample: Array<AutoattachmentTarget>;
};

export type AwarenessSourceSurvey = {
  __typename?: "AwarenessSourceSurvey";
  completed: Scalars["Boolean"]["output"];
  response: Maybe<Scalars["String"]["output"]>;
};

/**
 * AwsIntegration is an integration with AWS
 * that you can attach to your stack
 */
export type AwsIntegration = Notifiable & {
  __typename?: "AwsIntegration";
  /** The scans using this integration. */
  attachedScans: Array<AwsIntegrationScanAttachment>;
  /** Retrieve an individual stack attachment by its ID (slug). */
  attachedStack: Maybe<AwsIntegrationStackAttachment>;
  /** The stacks attached to this integration. */
  attachedStacks: Array<AwsIntegrationStackAttachment>;
  /** Enable support for autoattach labels */
  autoattachEnabled: Scalars["Boolean"]["output"];
  /** Duration in seconds for which the assumed role credentials should be valid. */
  durationSeconds: Maybe<Scalars["Int"]["output"]>;
  /** AWS external ID (only valid when generating credentials in private workers). */
  externalId: Scalars["String"]["output"];
  /** Generates the external ID that would be used for role assumption when attached to the specified stack. */
  externalIdForStack: Maybe<ExternalIdForStackResult>;
  /** AWS credentials will be generated in the private worker. */
  generateCredentialsInWorker: Scalars["Boolean"]["output"];
  /** Indicates whether any scans use this integration. */
  hasAttachedScans: Scalars["Boolean"]["output"];
  /** Indicates whether any stacks are attached to this policy, either directly or via auto-attachment. */
  hasAttachedStacks: Scalars["Boolean"]["output"];
  /** The unique ID for managing the integration within Spacelift. */
  id: Scalars["String"]["output"];
  /** User-defined labels set on the integration. */
  labels: Array<Scalars["String"]["output"]>;
  /**
   * Indicates that this integration was automatically created via the stackIntegrationAwsCreate mutation
   * and is bound to a single stack.
   */
  legacy: Scalars["Boolean"]["output"];
  /** The friendly name of the integration. */
  name: Scalars["String"]["output"];
  /** Number of the aws integration notifications. */
  notificationCount: Scalars["Int"]["output"];
  /** AWS region. */
  region: Maybe<Scalars["String"]["output"]>;
  /** AWS IAM role to assume. */
  roleArn: Scalars["String"]["output"];
  /** ID of the space this AwsIntegration belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this AWS integration belongs to. */
  spaceDetails: Space;
  /** Enable session tags when assuming the role */
  tagAssumeRole: Scalars["Boolean"]["output"];
};

/**
 * AwsIntegration is an integration with AWS
 * that you can attach to your stack
 */
export type AwsIntegrationAttachedStackArgs = {
  id: Scalars["ID"]["input"];
};

/**
 * AwsIntegration is an integration with AWS
 * that you can attach to your stack
 */
export type AwsIntegrationExternalIdForStackArgs = {
  read: Scalars["Boolean"]["input"];
  stackId: Scalars["ID"]["input"];
  write: Scalars["Boolean"]["input"];
};

/** AwsIntegrationIntentProjectAttachment represents the attachment of an AWS integration to an intent project. */
export type AwsIntegrationIntentProjectAttachment = {
  __typename?: "AwsIntegrationIntentProjectAttachment";
  /** The AWS integration attached to the intent project. */
  awsIntegration: AwsIntegration;
  /** AWS region where this attachment should be used. */
  awsRegion: Scalars["String"]["output"];
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** The intent project the AWS integration is attached to. */
  intentProject: IntentProject;
  /** True if this attachment is used for read operations. */
  read: Scalars["Boolean"]["output"];
  /** True if this attachment is used for write operations. */
  write: Scalars["Boolean"]["output"];
};

/** AwsIntegrationScanAttachment is a scan using the integration, viewed from the integration. */
export type AwsIntegrationScanAttachment = {
  __typename?: "AwsIntegrationScanAttachment";
  /** Slug of the scan. */
  scanId: Scalars["ID"]["output"];
  /** Name of the scan. */
  scanName: Scalars["String"]["output"];
  /** Details of the space the scan belongs to. */
  spaceDetails: Space;
};

/** AwsIntegrationStackAttachment is the stack attachment viewed from the integration. */
export type AwsIntegrationStackAttachment = {
  __typename?: "AwsIntegrationStackAttachment";
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** Whether the context is autoattached to the stack. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** True if the attached stack is type of Module. */
  isModule: Scalars["Boolean"]["output"];
  /** Whether the integration is used for read operations. */
  read: Scalars["Boolean"]["output"];
  /** Details of the space the attached stack belongs to. */
  spaceDetails: Space;
  /** Slug of the attached stack. */
  stackId: Scalars["ID"]["output"];
  /** Name of the attached stack. */
  stackName: Scalars["String"]["output"];
  /** Whether the integration is used for write operations. */
  write: Scalars["Boolean"]["output"];
};

export type AzureDevOpsRepoIntegration = {
  __typename?: "AzureDevOpsRepoIntegration";
  /** List of accessible Azure DevOps projects. Empty list means all projects are accessible. */
  accessibleProjects: Array<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** The API host where requests will be sent. */
  organizationURL: Scalars["String"]["output"];
  space: Maybe<Space>;
  useGitCheckout: Scalars["Boolean"]["output"];
  userFacingHost: Scalars["String"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
  /** Autogenerated password for Azure DevOps webhook integration */
  webhookPassword: Scalars["String"]["output"];
  webhookUrl: Scalars["String"]["output"];
};

/** AzureIntegration represents an integration with an Azure AD tenant. */
export type AzureIntegration = {
  __typename?: "AzureIntegration";
  /** Indicates whether admin consent has been performed for the AAD Application. */
  adminConsentProvided: Scalars["Boolean"]["output"];
  /** The URL to use to provide admin consent to the application in the customer's tenant. */
  adminConsentURL: Scalars["String"]["output"];
  /** The applicationId of the Azure AD application used by the integration. */
  applicationId: Scalars["String"]["output"];
  /** Retrieve an individual stack attachment by its ID (slug). */
  attachedStack: Maybe<AzureIntegrationStackAttachment>;
  /** The stacks attached to this integration. */
  attachedStacks: Array<AzureIntegrationStackAttachment>;
  /** Enable support for autoattach labels */
  autoattachEnabled: Scalars["Boolean"]["output"];
  /** Unix timestamp representing the integration creation. */
  createdAt: Scalars["Int"]["output"];
  /** The default subscription ID to use, if one isn't specified at the stack level. */
  defaultSubscriptionId: Maybe<Scalars["String"]["output"]>;
  /**
   * The display name for the application in Azure. This is automatically generated when the
   * integration is created, and cannot be changed without deleting and recreating the integration.
   */
  displayName: Scalars["String"]["output"];
  /** Indicates whether any stacks are attached to this policy, either directly or via auto-attachment. */
  hasAttachedStacks: Scalars["Boolean"]["output"];
  /** The unique ID for managing the integration within Spacelift. */
  id: Scalars["String"]["output"];
  /** User-defined labels set on the integration. */
  labels: Array<Scalars["String"]["output"]>;
  /** The friendly name of the integration. */
  name: Scalars["String"]["output"];
  /** The Azure AD object ID. */
  objectId: Scalars["String"]["output"];
  /**
   * The Object ID of the service principal in the customer's Azure AD tenant. This is only
   * populated after admin consent has been granted. Returns null if admin consent has not been
   * provided or if the service principal cannot be found.
   */
  servicePrincipalObjectId: Maybe<Scalars["String"]["output"]>;
  /** ID of the space this AzureIntegration belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this Azure integration belongs to. */
  spaceDetails: Space;
  /** The Azure AD tenant ID. */
  tenantId: Scalars["String"]["output"];
  /** Unix timestamp representing the last update to the integration. */
  updatedAt: Scalars["Int"]["output"];
};

/** AzureIntegration represents an integration with an Azure AD tenant. */
export type AzureIntegrationAttachedStackArgs = {
  id: Scalars["ID"]["input"];
};

/** AzureIntegrationStackAttachment is the stack attachment viewed from the integration. */
export type AzureIntegrationStackAttachment = {
  __typename?: "AzureIntegrationStackAttachment";
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** Whether the context is autoattached to the stack. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** True if the attached stack is type of Module. */
  isModule: Scalars["Boolean"]["output"];
  /** True if this attachment is used for read operations. */
  read: Scalars["Boolean"]["output"];
  /** Details of the space the attached stack belongs to. */
  spaceDetails: Space;
  /** Slug of the attached stack. */
  stackId: Scalars["ID"]["output"];
  /** Name of the attached stack. */
  stackName: Scalars["String"]["output"];
  /**
   * Contains the Azure subscription ID to use with this Stack. Overrides the defaultSubscriptionId
   * set at the account level.
   */
  subscriptionId: Maybe<Scalars["String"]["output"]>;
  /** True if this attachment is used for write operations. */
  write: Scalars["Boolean"]["output"];
};

/** BillableRunState represents a state that is billed. */
export enum BillableRunState {
  /** A worker is currently applying the run's changes. */
  Applying = "APPLYING",
  /**
   * The worker is currently performing a destroy operation on the managed
   * resources.
   */
  Destroying = "DESTROYING",
  /** The run's workspace is currently initializing on the worker. */
  Initializing = "INITIALIZING",
  /** The worker is currently performing the task requested by the user. */
  Performing = "PERFORMING",
  /** The worker is planning the run. */
  Planning = "PLANNING",
  /** The workspace is currently being prepared for the run. */
  Preparing = "PREPARING",
  /** The workspace is currently being prepared for the change deployment. */
  PreparingApply = "PREPARING_APPLY",
  /** The run is being prepared to be replanned. */
  PreparingReplan = "PREPARING_REPLAN",
}

/** BillingAddon represents an addon that can be bought along with the plan. */
export type BillingAddon = {
  __typename?: "BillingAddon";
  /** Monthly price of the addon in cents. */
  monthlyPrice: Scalars["Int"]["output"];
  /** Name of the addon. */
  name: BillingAddonType;
  /** Tiers that are eligible for buying the addon. */
  tiers: Array<BillingTier>;
  /** Yearly price of the addon in cents. */
  yearlyPrice: Scalars["Int"]["output"];
};

/**
 * BillingAddonType represents the addon types that are available to be subscribed to.
 * This only applies to the V4_STARTER tier.
 */
export enum BillingAddonType {
  AdditionalPublicWorker = "ADDITIONAL_PUBLIC_WORKER",
  UnlimitedSeats = "UNLIMITED_SEATS",
}

/**
 * BillingCycleInterval represents the billing cycle interval for a subscription.
 * This only applies to the V4_STARTER tier.
 */
export enum BillingCycleInterval {
  Monthly = "MONTHLY",
  Yearly = "YEARLY",
}

/** BillingInfo represents account billing details stored in Stripe */
export type BillingInfo = {
  __typename?: "BillingInfo";
  /** Billing address */
  address: Scalars["String"]["output"];
  /** Billing city */
  city: Scalars["String"]["output"];
  /** Company name */
  companyName: Scalars["String"]["output"];
  /** Country code (ISO 3166-1 alpha2) */
  country: Scalars["String"]["output"];
  /** Billing email */
  email: Scalars["String"]["output"];
  /** Full name of the billing contact */
  fullName: Scalars["String"]["output"];
  /** State (US-only) */
  state: Scalars["String"]["output"];
  /** Tax ID type (e.g., eu_vat, us_ein) */
  taxIDType: Maybe<Scalars["String"]["output"]>;
  /** Tax ID value */
  taxIDValue: Maybe<Scalars["String"]["output"]>;
  /** Zip code */
  zipCode: Scalars["String"]["output"];
};

/** BillingPlan represents a tier that can be bought. */
export type BillingPlan = {
  __typename?: "BillingPlan";
  /** Monthly price of the plan in cents. */
  monthlyPrice: Scalars["Int"]["output"];
  /** Tier of the plan */
  tier: BillingTier;
  /** Yearly price of the plan in cents. */
  yearlyPrice: Scalars["Int"]["output"];
};

export type BillingSubscription = {
  __typename?: "BillingSubscription";
  /** Addons of the subscription. */
  addons: Array<BillingSubscriptionAddon>;
  /** Price amount for the subscription. In cents. */
  billingAmount: Maybe<Scalars["Int"]["output"]>;
  /** Timestamp of start of the current billing cycle */
  billingCycleStart: Maybe<Scalars["Int"]["output"]>;
  /** Billing info provided by the user which is attached to each invoice by Stripe */
  billingInfo: Maybe<BillingInfo>;
  /** Interval of the subscription. One of "month" or "year". */
  billingInterval: Maybe<BillingCycleInterval>;
  /** Timestamp of the renewal date of the subscription */
  billingRenewalDate: Maybe<Scalars["Int"]["output"]>;
  /** isActive describes if the account has active (premium) subscription */
  isActive: Scalars["Boolean"]["output"];
  /** URL to Stripe-hosted portal which allows to manage subscription */
  selfServePortalUrl: Scalars["String"]["output"];
  /** Status of the subscription */
  status: StripeSubscriptionStatus;
};

export type BillingSubscriptionAddon = {
  __typename?: "BillingSubscriptionAddon";
  name: BillingAddonType;
};

/**
 * BillingTier represents a billing tier for a user. Please see https://spacelift.io/pricing for
 * more information about each tier.
 */
export enum BillingTier {
  /** Cloud billing tier. */
  Cloud = "CLOUD",
  /** Enterprise billing tier. */
  Enterprise = "ENTERPRISE",
  /** Free billing tier. */
  Free = "FREE",
  /** Cloud billing tier. */
  V3Cloud = "V3_CLOUD",
  /** Free billing tier. */
  V3Free = "V3_FREE",
  /** BUSINESS Billing tier. */
  V4Business = "V4_BUSINESS",
  /** BUSINESS Billing tier. */
  V4Enterprise = "V4_ENTERPRISE",
  /** Free Billing tier. */
  V4Free = "V4_FREE",
  /** Starter Billing tier. */
  V4Starter = "V4_STARTER",
  /** Starter Plus Billing tier. */
  V4StarterPlus = "V4_STARTER_PLUS",
  /** Business Billing tier (V5). */
  V5Business = "V5_BUSINESS",
  /** Enterprise Billing tier (V5). */
  V5Enterprise = "V5_ENTERPRISE",
  /** Enterprise Plus Billing tier (V5). */
  V5EnterprisePlus = "V5_ENTERPRISE_PLUS",
  /** Free Billing tier (V5). */
  V5Free = "V5_FREE",
  /** Starter Billing tier (V5). */
  V5Starter = "V5_STARTER",
  /** Starter Plus Billing tier (V5). */
  V5StarterPlus = "V5_STARTER_PLUS",
  /** Starter Plus 2 Billing tier (V5). */
  V5StarterPlus_2 = "V5_STARTER_PLUS_2",
  /** Strategic Billing tier (V5). */
  V5Strategic = "V5_STRATEGIC",
}

/** BillingTierFeature lists various features that are feature-gated by billing tier. */
export enum BillingTierFeature {
  AccessPolicies = "ACCESS_POLICIES",
  AccountAiControl = "ACCOUNT_AI_CONTROL",
  AdditionalPublicWorker = "ADDITIONAL_PUBLIC_WORKER",
  AdvancedScheduling = "ADVANCED_SCHEDULING",
  AggregatedVcsChecks = "AGGREGATED_VCS_CHECKS",
  ApiKeysOidc = "API_KEYS_OIDC",
  /** Indicates whether your account can use audit functionality, including audit webhooks. */
  Auditing = "AUDITING",
  /** @deprecated Use the AUDITING feature instead. */
  AuditWebhooks = "AUDIT_WEBHOOKS",
  BackstageIntegration = "BACKSTAGE_INTEGRATION",
  Blueprints = "BLUEPRINTS",
  CanUpdateSsoSaml = "CAN_UPDATE_SSO_SAML",
  CloudCredentialGeneration = "CLOUD_CREDENTIAL_GENERATION",
  CustomSsoSaml = "CUSTOM_SSO_SAML",
  DriftDetection = "DRIFT_DETECTION",
  Mfa = "MFA",
  MultipleVcs = "MULTIPLE_VCS",
  NotificationPolicies = "NOTIFICATION_POLICIES",
  OidcFederationTokenGeneration = "OIDC_FEDERATION_TOKEN_GENERATION",
  PrivateModuleSharing = "PRIVATE_MODULE_SHARING",
  PrivateVcs = "PRIVATE_VCS",
  PrivateWorkers = "PRIVATE_WORKERS",
  RunIgnoredTriggers = "RUN_IGNORED_TRIGGERS",
  RunStateChangeWebhooks = "RUN_STATE_CHANGE_WEBHOOKS",
  /** Indicates whether the account can use scans. */
  Scans = "SCANS",
  /** Indicates whether the account can use SCIM v2 provisioning APIs. */
  Scim = "SCIM",
  ServiceNowIntegration = "SERVICE_NOW_INTEGRATION",
  SpaceliftIntelligence = "SPACELIFT_INTELLIGENCE",
  TargetedReplan = "TARGETED_REPLAN",
  TerraformProviderVersions = "TERRAFORM_PROVIDER_VERSIONS",
  UnlimitedSeats = "UNLIMITED_SEATS",
  WorkflowPolicies = "WORKFLOW_POLICIES",
}

/** BitbucketCloudIntegration shows Bitbucket Cloud integration details. */
export type BitbucketCloudIntegration = {
  __typename?: "BitbucketCloudIntegration";
  description: Scalars["String"]["output"];
  /**  Email to be used for authentication. */
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  space: Maybe<Space>;
  /**
   * Indicates whether the integration should use git checkout. If false source code will be downloaded using the VCS API.
   * For Bitbucket Cloud this is always true because tarball download does not work with API Tokens.
   */
  useGitCheckout: Scalars["Boolean"]["output"];
  /**  Username to be used for authentication. */
  username: Scalars["String"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
  /** Secret for webhooks originating from Bitbucket repositories. */
  webhookSecret: Scalars["String"]["output"];
  webhookUrl: Scalars["String"]["output"];
};

export type BitbucketCloudIntegrationInput = {
  apiToken: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  email: Scalars["String"]["input"];
};

export type BitbucketCloudIntegrationUpdateInput = {
  apiToken: InputMaybe<Scalars["String"]["input"]>;
  customInput: InputMaybe<CustomVcsUpdateInput>;
  email: Scalars["String"]["input"];
};

/** BitbucketDatacenterIntegration shows Bitbucket Datacenter integration details. */
export type BitbucketDatacenterIntegration = {
  __typename?: "BitbucketDatacenterIntegration";
  /** The API host where requests will be sent. */
  apiHost: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  space: Maybe<Space>;
  useGitCheckout: Scalars["Boolean"]["output"];
  /** User Facing Host which will be user for all user-facing URLs displayed in the Spacelift UI. */
  userFacingHost: Scalars["String"]["output"];
  /** Username which will be used to authenticate requests for cloning repositories. */
  username: Scalars["String"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
  /** Secret for webhooks originating from Bitbucket repositories. */
  webhookSecret: Scalars["String"]["output"];
  /** URL for webhooks originating from Bitbucket repositories. */
  webhookURL: Scalars["String"]["output"];
};

/** BlobStorageAuthMethod is how a Blob Storage integration authenticates its reads. */
export enum BlobStorageAuthMethod {
  /** A static access key and secret (S3-compatible subtype only). */
  AccessKeys = "ACCESS_KEYS",
  /** Anonymous reads from a public bucket. */
  Anonymous = "ANONYMOUS",
  /** An assumed AWS IAM role (AWS S3 subtype only). */
  AwsRole = "AWS_ROLE",
}

/** BlobStorageIntegration shows Blob Storage integration details. */
export type BlobStorageIntegration = {
  __typename?: "BlobStorageIntegration";
  /** The access key ID (ACCESS_KEYS auth method only). Only space admins can read it. */
  accessKeyId: Scalars["String"]["output"];
  /** How reads are authenticated. */
  authMethod: BlobStorageAuthMethod;
  /** The bucket and the optional base prefix, e.g. s3://acme-bucket/acme-infra. */
  baseURI: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  /** The endpoint URL (S3-compatible subtype only). */
  endpoint: Scalars["String"]["output"];
  /** Server-generated external ID for the assumed role's trust policy. Never client-supplied. */
  externalId: Scalars["String"]["output"];
  /** Whether reads are authenticated at all, as opposed to a public bucket. */
  hasCredentials: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** The bucket region (AWS S3 subtype only). */
  region: Scalars["String"]["output"];
  /** The IAM role assumed to read the bucket (AWS_ROLE auth method only). */
  roleArn: Scalars["String"]["output"];
  space: Maybe<Space>;
  /** The kind of blob storage the integration reads from. */
  subtype: BlobStorageSubtype;
  useGitCheckout: Scalars["Boolean"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
};

/** BlobStorageSubtype is the kind of blob storage an integration reads from. */
export enum BlobStorageSubtype {
  /** AWS S3, read with an assumed role or anonymously. */
  AwsS3 = "AWS_S3",
  /** An S3-compatible store (e.g. MinIO, Ceph) at a custom endpoint. */
  S3Compatible = "S3_COMPATIBLE",
}

export type Blueprint = {
  __typename?: "Blueprint";
  /** Whether the blueprint can be deleted */
  canDelete: Scalars["Boolean"]["output"];
  /** CreatedAt is unix timestamp (in seconds) at which the blueprint was created */
  createdAt: Scalars["Int"]["output"];
  /** Indicates whether the blueprint has been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /** Number of deployments for this blueprint */
  deploymentsCount: Scalars["Int"]["output"];
  /** Unix timestamp (in seconds) at which this blueprint version was deprecated, if at all. */
  deprecatedAt: Maybe<Scalars["Int"]["output"]>;
  /** Optional note explaining why this version was deprecated. */
  deprecationNote: Maybe<Scalars["String"]["output"]>;
  /** Description of the blueprint. */
  description: Maybe<Scalars["String"]["output"]>;
  externalIntegrations: Array<BlueprintIntegrationAttachment>;
  groupDetails: BlueprintVersionedGroup;
  /** Blueprint ID, used to identify a blueprint by name (slug) */
  id: Scalars["ID"]["output"];
  /** Inputs of the blueprint. */
  inputs: Array<BlueprintInput>;
  /** Instructions for given blueprint version. */
  instructions: Maybe<Scalars["String"]["output"]>;
  /** Labels associated with the blueprint. */
  labels: Array<Scalars["String"]["output"]>;
  /** Name of the blueprint */
  name: Scalars["String"]["output"];
  /** PublishedAt is unix timestamp (in seconds) at which the blueprint was published */
  publishedAt: Maybe<Scalars["Int"]["output"]>;
  /** RawTemplate of the blueprint. */
  rawTemplate: Scalars["String"]["output"];
  /** Space to which this blueprint belongs. */
  space: Space;
  /** List of keys that are used in the blueprint. */
  stackKeys: Array<Scalars["String"]["output"]>;
  /** State of the blueprint. Published or Draft. */
  state: BlueprintState;
  /**
   * V2 template. For V1 blueprints, returns the migrated template with warnings.
   * For V2 blueprints, returns the raw template as-is with no warnings.
   */
  template: BlueprintTemplate;
  /** Unique identifier of the blueprint (ULID) */
  ulid: Scalars["String"]["output"];
  /** UpdatedAt is unix timestamp (in seconds) at which the blueprint was updated */
  updatedAt: Scalars["Int"]["output"];
  version: Maybe<Scalars["String"]["output"]>;
};

export type BlueprintAttachInput = {
  /** External ID to attach */
  externalIntegration: Scalars["ID"]["input"];
};

export type BlueprintCloneInput = {
  /** Blueprint description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Blueprint labels */
  labels: Array<Scalars["String"]["input"]>;
  /** Blueprint name */
  name: Scalars["String"]["input"];
  /** Space of the blueprint. */
  space: Scalars["ID"]["input"];
};

export type BlueprintCreateInput = {
  /** Blueprint description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Blueprint labels */
  labels: Array<Scalars["String"]["input"]>;
  /** Blueprint name */
  name: Scalars["String"]["input"];
  /** Space of the blueprint. */
  space: Scalars["ID"]["input"];
  /** State of the blueprint */
  state: BlueprintState;
  /** Blueprint body */
  template: InputMaybe<Scalars["String"]["input"]>;
};

export type BlueprintDeployment = {
  __typename?: "BlueprintDeployment";
  /** Actions that the user can perform on this BlueprintDeployment. */
  allowedActions: Array<Action>;
  /** The blueprint used for deployment */
  blueprint: BlueprintDeploymentBlueprint;
  /** The version number of the blueprint used for deployment */
  blueprintVersion: BlueprintDeploymentVersion;
  /** CreatedAt is unix timestamp (in seconds) at which the deployment was created */
  createdAt: Scalars["Int"]["output"];
  /** Deployment description */
  description: Maybe<Scalars["String"]["output"]>;
  /** Deployment ID */
  id: Scalars["ID"]["output"];
  /** List of non-secret inputs used during deployment */
  inputs: Array<BlueprintDeploymentInput>;
  /** Deployment name */
  name: Scalars["String"]["output"];
  /** Whether stacks will be deleted when the scheduled deletion fires (true by default) */
  scheduledDeleteStacks: Maybe<Scalars["Boolean"]["output"]>;
  /** The scheduled deletion timestamp for this deployment (unix seconds), if any */
  scheduledDeleteTimestamp: Maybe<Scalars["Int"]["output"]>;
  /** Search through the history of changes made to this deployment */
  searchChangeHistory: SearchBlueprintDeploymentChangeHistoryOutput;
  /** The space where the deployment was created */
  space: Space;
  /** All stacks for this deployment */
  stacks: Array<BlueprintDeploymentStack>;
  /** The state of the deployment that is calculated based on the state of the managed stacks in the deployment. */
  state: BlueprintDeploymentState;
};

export type BlueprintDeploymentSearchChangeHistoryArgs = {
  input: SearchInput;
};

export type BlueprintDeploymentBlueprint = {
  __typename?: "BlueprintDeploymentBlueprint";
  /** Blueprint ID */
  id: Scalars["ID"]["output"];
};

export type BlueprintDeploymentChangeRecord = {
  __typename?: "BlueprintDeploymentChangeRecord";
  /** Timestamp when this change was created */
  createdAt: Scalars["Int"]["output"];
  /** Change record ID (ULID) */
  id: Scalars["ID"]["output"];
  /** List of inputs at the time of this change */
  inputs: Array<BlueprintDeploymentInput>;
  /** List of inputs before this change (null for the first change) */
  previousInputs: Maybe<Array<BlueprintDeploymentInput>>;
  /** The blueprint version before this change (null for the first change) */
  previousVersion: Maybe<BlueprintDeploymentChangeRecordVersion>;
  /** The blueprint version at the time of this change */
  version: BlueprintDeploymentChangeRecordVersion;
};

export type BlueprintDeploymentChangeRecordConnection = {
  __typename?: "BlueprintDeploymentChangeRecordConnection";
  cursor: Scalars["String"]["output"];
  node: BlueprintDeploymentChangeRecord;
};

export type BlueprintDeploymentChangeRecordVersion = {
  __typename?: "BlueprintDeploymentChangeRecordVersion";
  /** Blueprint version ID */
  id: Scalars["ID"]["output"];
  /** Blueprint version number */
  number: Maybe<Scalars["String"]["output"]>;
  /** Raw template of the blueprint version */
  rawTemplate: Scalars["String"]["output"];
};

export type BlueprintDeploymentConnection = {
  __typename?: "BlueprintDeploymentConnection";
  cursor: Scalars["String"]["output"];
  node: BlueprintDeployment;
};

export type BlueprintDeploymentCreateInput = {
  /** Deployment description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Deployment inputs */
  inputs: Array<BlueprintDeploymentCreateInputPair>;
  /** Deployment name */
  name: Scalars["String"]["input"];
  /** Space where the blueprint will be deployed */
  space: Scalars["ID"]["input"];
};

export type BlueprintDeploymentCreateInputPair = {
  id: Scalars["String"]["input"];
  sensitive: InputMaybe<Scalars["Boolean"]["input"]>;
  value: InputMaybe<Scalars["String"]["input"]>;
};

export type BlueprintDeploymentInput = {
  __typename?: "BlueprintDeploymentInput";
  /** SHA256 checksum of the input value */
  checksum: Scalars["String"]["output"];
  /** Input ID */
  id: Scalars["ID"]["output"];
  /** Whether this is a secret input */
  secret: Scalars["Boolean"]["output"];
  /** Input value */
  value: Scalars["String"]["output"];
};

export type BlueprintDeploymentStack = {
  __typename?: "BlueprintDeploymentStack";
  /** Stack ID */
  id: Scalars["ID"]["output"];
  /** Stack name */
  name: Scalars["String"]["output"];
  /** Stack outputs */
  outputs: Array<StackOutput>;
  /** Stack state */
  state: StackState;
};

export enum BlueprintDeploymentState {
  Destroying = "DESTROYING",
  DestroyingFailed = "DESTROYING_FAILED",
  Discarded = "DISCARDED",
  Failure = "FAILURE",
  Finished = "FINISHED",
  InProgress = "IN_PROGRESS",
  None = "NONE",
  Unconfirmed = "UNCONFIRMED",
}

export type BlueprintDeploymentUpdateInput = {
  /** New description for the deployment */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Full replacement of deployment inputs. Empty array clears all inputs. */
  inputs: InputMaybe<Array<BlueprintDeploymentUpdateInputPair>>;
  /** New name for the deployment (will not change the slug) */
  name: InputMaybe<Scalars["String"]["input"]>;
  /** The ID of the new blueprint version to upgrade to */
  versionId: InputMaybe<Scalars["ID"]["input"]>;
};

export type BlueprintDeploymentUpdateInputPair = {
  id: Scalars["String"]["input"];
  /**
   * If keepOldValue is set to true, the value will not be updated.
   * It's useful for secret values, where we don't want to overwrite the existing value.
   */
  keepOldValue: InputMaybe<Scalars["Boolean"]["input"]>;
  value: InputMaybe<Scalars["String"]["input"]>;
};

export type BlueprintDeploymentUpgradeInput = {
  /** The ID of the new blueprint version to upgrade to */
  versionId: Scalars["ID"]["input"];
};

export type BlueprintDeploymentVersion = {
  __typename?: "BlueprintDeploymentVersion";
  /** Blueprint version ID */
  id: Scalars["ID"]["output"];
  /** Blueprint version number */
  version: Maybe<Scalars["String"]["output"]>;
};

export type BlueprintInput = {
  __typename?: "BlueprintInput";
  /** Default of the blueprint input. */
  default: Scalars["String"]["output"];
  /** Description of the blueprint input. */
  description: Scalars["String"]["output"];
  /** Blueprint ID input. */
  id: Scalars["ID"]["output"];
  /** Name of the blueprint input. */
  name: Scalars["String"]["output"];
  /** Options of the blueprint input. */
  options: Array<Scalars["String"]["output"]>;
  /** Type of the blueprint input. */
  type: BlueprintInputType;
  /** Validations of the blueprint input. */
  validations: Maybe<BlueprintInputValidations>;
};

export enum BlueprintInputType {
  /** Available spaces input - shows list of available spaces in the frontend */
  AvailableSpaces = "AVAILABLE_SPACES",
  /** A boolean value */
  Boolean = "BOOLEAN",
  /** A floating point number */
  Float = "FLOAT",
  /** Long text input */
  LongText = "LONG_TEXT",
  /** An integer number */
  Number = "NUMBER",
  /** Secret text input */
  Secret = "SECRET",
  /** Multiple choice input */
  Select = "SELECT",
  /** Short text input */
  ShortText = "SHORT_TEXT",
}

/** Validations for a blueprint input field. */
export type BlueprintInputValidations = {
  __typename?: "BlueprintInputValidations";
  /** The input must be greater than this value. */
  greaterThan: Maybe<Scalars["Float"]["output"]>;
  /** The input must be greater than or equal to this value. */
  greaterThanOrEqual: Maybe<Scalars["Float"]["output"]>;
  /** Exact length the input string must be. */
  lengthEqual: Maybe<Scalars["Int"]["output"]>;
  /** The input must be less than this value. */
  lessThan: Maybe<Scalars["Float"]["output"]>;
  /** The input must be less than or equal to this value. */
  lessThanOrEqual: Maybe<Scalars["Float"]["output"]>;
  /** Maximum length of the input string. */
  maxLength: Maybe<Scalars["Int"]["output"]>;
  /** Minimum length of the input string. */
  minLength: Maybe<Scalars["Int"]["output"]>;
  /** The input must not be equal to this value. */
  notEqual: Maybe<Scalars["Float"]["output"]>;
  /** Regex pattern the input must match. */
  pattern: Maybe<Scalars["String"]["output"]>;
  /** Whether the input is required. */
  required: Scalars["Boolean"]["output"];
  /** The input must be a multiple of this value. */
  step: Maybe<Scalars["Int"]["output"]>;
};

export type BlueprintIntegrationAttachment = {
  __typename?: "BlueprintIntegrationAttachment";
  /** ID of the blueprint */
  blueprintID: Scalars["ID"]["output"];
  /** Name of the blueprint */
  blueprintName: Scalars["String"]["output"];
  blueprintSpaceDetails: Space;
  /** Is the attachment deleted */
  deleted: Scalars["Boolean"]["output"];
  /** ID of the attachment */
  id: Scalars["ID"]["output"];
  /** ID of the integration */
  integrationID: Scalars["ID"]["output"];
  /** Name of the integration */
  integrationName: Scalars["String"]["output"];
};

export type BlueprintParseResult = {
  __typename?: "BlueprintParseResult";
  /** List of errors */
  errors: Array<Scalars["String"]["output"]>;
  /** Inputs of the blueprint. */
  inputs: Array<BlueprintInput>;
};

export type BlueprintStackCreateInput = {
  templateInputs: InputMaybe<Array<BlueprintStackCreateInputPair>>;
};

export type BlueprintStackCreateInputPair = {
  id: Scalars["String"]["input"];
  value: InputMaybe<Scalars["String"]["input"]>;
};

export type BlueprintStackCreation = {
  __typename?: "BlueprintStackCreation";
  /**
   * An optional run ID which is returned if a run was started.
   * @deprecated Use the runIds field instead.
   */
  runID: Maybe<Scalars["ID"]["output"]>;
  /** Created runs after stack creation. */
  runIds: Array<Scalars["ID"]["output"]>;
  /**
   * Slug of the created stack.
   * @deprecated Use the stackIds field instead.
   */
  stackID: Scalars["ID"]["output"];
  /** Slug of the created stacks. */
  stackIds: Array<Scalars["ID"]["output"]>;
};

export enum BlueprintState {
  /** The blueprint is deleted */
  Deleted = "DELETED",
  /** Blueprint is in draft state */
  Draft = "DRAFT",
  /** Blueprint is in published state. */
  Published = "PUBLISHED",
  /** Invalid "zero value" for the type. */
  Unknown = "UNKNOWN",
}

/** V2 template representation of a blueprint. */
export type BlueprintTemplate = {
  __typename?: "BlueprintTemplate";
  /** Problems the author needs to fix. */
  errors: Array<Scalars["String"]["output"]>;
  /** The template as a YAML string. */
  template: Scalars["String"]["output"];
  /** Warnings generated during the migration. */
  warnings: Array<Scalars["String"]["output"]>;
};

export type BlueprintVersionCreateInput = {
  /** ID of the blueprint versioned group this version belongs to. */
  blueprintID: Scalars["ID"]["input"];
  /** Blueprint version instructions. */
  instructions: InputMaybe<Scalars["String"]["input"]>;
  /** Labels associated with the blueprint version. */
  labels: Array<Scalars["String"]["input"]>;
  /** Blueprint version state (draft, published). */
  state: BlueprintState;
  /** Blueprint template body. */
  template: InputMaybe<Scalars["String"]["input"]>;
  /** Version number. */
  versionNumber: Scalars["String"]["input"];
};

export type BlueprintVersionDeprecateInput = {
  /** Optional note explaining why this version was deprecated. */
  note: InputMaybe<Scalars["String"]["input"]>;
};

/** Limited blueprint version info returned for latest version queries. */
export type BlueprintVersionSummary = {
  __typename?: "BlueprintVersionSummary";
  /** Unix timestamp (in seconds) at which this blueprint version was deprecated, if at all. */
  deprecatedAt: Maybe<Scalars["Int"]["output"]>;
  /** Optional note explaining why this version was deprecated. */
  deprecationNote: Maybe<Scalars["String"]["output"]>;
  /** Blueprint ID, used to identify a blueprint by name (slug) */
  id: Scalars["ID"]["output"];
  /** Unique identifier of the blueprint (ULID) */
  ulid: Scalars["String"]["output"];
  /** Version number of the blueprint */
  version: Maybe<Scalars["String"]["output"]>;
};

export type BlueprintVersionUpdateInput = {
  /** Blueprint version instructions. */
  instructions: InputMaybe<Scalars["String"]["input"]>;
  /** Labels associated with the blueprint version. */
  labels: Array<Scalars["String"]["input"]>;
  /** Blueprint version state (draft, published). */
  state: BlueprintState;
  /** Blueprint template body. */
  template: InputMaybe<Scalars["String"]["input"]>;
  /** Version number. */
  versionNumber: Scalars["String"]["input"];
};

export type BlueprintVersionedGroup = {
  __typename?: "BlueprintVersionedGroup";
  /** Actions that the user can perform on this BlueprintVersionedGroup. */
  allowedActions: Array<Action>;
  /** Get a single blueprint version. */
  blueprintVersion: Maybe<Blueprint>;
  /** Whether the blueprint group can be deleted (has no versions). */
  canDelete: Scalars["Boolean"]["output"];
  /**
   * Get blueprint versions that are compatible upgrade targets from the specified version.
   * Returns only PUBLISHED versions that can be upgraded to from the given version.
   */
  compatibleVersions: Array<Blueprint>;
  /** CreatedAt is unix timestamp (in seconds) at which the blueprint was created */
  createdAt: Scalars["Int"]["output"];
  /** Number of deployments for this blueprint group. */
  deploymentsCount: Scalars["Int"]["output"];
  /** Description of the blueprint. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Blueprint ID, used to identify a blueprint by name (slug) */
  id: Scalars["ID"]["output"];
  /** Labels associated with the blueprint. */
  labels: Array<Scalars["String"]["output"]>;
  /** The latest blueprint version based on creation time. */
  latestVersion: Maybe<BlueprintVersionSummary>;
  /** Name of the blueprint */
  name: Scalars["String"]["output"];
  /** Search for blueprint versions. */
  searchBlueprintVersions: SearchBlueprintsOutput;
  /** Get search suggestions for blueprint versions. */
  searchBlueprintVersionsSuggestions: SearchSuggestionsOutput;
  /** Space to which this blueprint belongs. */
  space: Space;
  /** Unique identifier of the blueprint (ULID) */
  ulid: Scalars["String"]["output"];
  /** UpdatedAt is unix timestamp (in seconds) at which the blueprint was updated */
  updatedAt: Scalars["Int"]["output"];
};

export type BlueprintVersionedGroupBlueprintVersionArgs = {
  id: Scalars["ID"]["input"];
};

export type BlueprintVersionedGroupCompatibleVersionsArgs = {
  versionId: Scalars["ID"]["input"];
};

export type BlueprintVersionedGroupSearchBlueprintVersionsArgs = {
  input: SearchInput;
};

export type BlueprintVersionedGroupSearchBlueprintVersionsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type BlueprintVersionedGroupCreateInput = {
  /** Blueprint description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Initial version details */
  initialVersion: InputMaybe<InitialBlueprintVersionInput>;
  /** Blueprint labels */
  labels: Array<Scalars["String"]["input"]>;
  /** Blueprint name */
  name: Scalars["String"]["input"];
  /** Space of the blueprint. */
  space: Scalars["ID"]["input"];
};

export type BlueprintVersionedGroupUpdateInput = {
  /** Blueprint description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Blueprint labels */
  labels: Array<Scalars["String"]["input"]>;
  /** Blueprint name */
  name: Scalars["String"]["input"];
  /** Space of the blueprint. */
  space: Scalars["ID"]["input"];
};

export type BlueprintVersionedGroupsConnection = {
  __typename?: "BlueprintVersionedGroupsConnection";
  cursor: Scalars["String"]["output"];
  node: BlueprintVersionedGroup;
};

export type BlueprintWithGroupCreateInput = {
  /** Blueprint description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Group in which the blueprint is created. */
  group: Scalars["ID"]["input"];
  /** Blueprint labels */
  labels: Array<Scalars["String"]["input"]>;
  /** State of the blueprint */
  state: BlueprintState;
  /** Blueprint body */
  template: InputMaybe<Scalars["String"]["input"]>;
  /** Version of the blueprint. Must be provided if published. */
  version: InputMaybe<Scalars["String"]["input"]>;
};

export type BlueprintWithGroupUpdateInput = {
  /** Blueprint description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Blueprint labels */
  labels: Array<Scalars["String"]["input"]>;
  /** State of the blueprint */
  state: BlueprintState;
  /** Blueprint body */
  template: InputMaybe<Scalars["String"]["input"]>;
  /** Version of the blueprint. Must be provided if published. */
  version: InputMaybe<Scalars["String"]["input"]>;
};

export type BlueprintsConnection = {
  __typename?: "BlueprintsConnection";
  cursor: Scalars["String"]["output"];
  node: Blueprint;
};

export type ChangeValue = ChangeValueBoolean | ChangeValueFloat | ChangeValueString;

export type ChangeValueBoolean = {
  __typename?: "ChangeValueBoolean";
  value: Scalars["Boolean"]["output"];
};

export type ChangeValueFloat = {
  __typename?: "ChangeValueFloat";
  value: Scalars["Float"]["output"];
};

export type ChangeValueString = {
  __typename?: "ChangeValueString";
  value: Scalars["String"]["output"];
};

export type ClaimMapping = {
  __typename?: "ClaimMapping";
  entries: Array<ClaimMappingEntry>;
};

export type ClaimMappingEntry = {
  __typename?: "ClaimMappingEntry";
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type ClaimMappingEntryInput = {
  name: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type ClaimMappingInput = {
  entries: Array<ClaimMappingEntryInput>;
};

/** Possible CloudFormation entity types. */
export type CloudFormationEntity = CloudFormationOutput | CloudFormationResource;

/** Metadata for a CloudFormation output. */
export type CloudFormationOutput = {
  __typename?: "CloudFormationOutput";
  /** User-provided description of the output. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Optional exported name used for cross-stack references. */
  export: Maybe<Scalars["String"]["output"]>;
  /** Value of this output. */
  value: Scalars["String"]["output"];
};

/** Metadata for a CloudFormation resource. */
export type CloudFormationResource = {
  __typename?: "CloudFormationResource";
  /** Logical resource ID. */
  logicalResourceId: Scalars["String"]["output"];
  /** Physical resource ID. */
  physicalResourceId: Scalars["String"]["output"];
  /** Definition of resource. */
  template: Scalars["String"]["output"];
};

/** Commit represents a GitHub commit. */
export type Commit = {
  __typename?: "Commit";
  /** GitHub username of the Commit author (optional). */
  authorLogin: Maybe<Scalars["String"]["output"]>;
  /** Name of the Commit author (required). */
  authorName: Scalars["String"]["output"];
  /** Git commit SHA. */
  hash: Scalars["String"]["output"];
  /** Short message associated with the commit (only the first line!); */
  message: Scalars["String"]["output"];
  /** Git commit tag */
  tag: Scalars["String"]["output"];
  /** Unix timestamp of the commit. */
  timestamp: Scalars["Int"]["output"];
  /** Full URL linking to the commit in GitHub. */
  url: Scalars["String"]["output"];
};

/**
 * ConfigElement is a stack runtime configuration element: environment variable
 * or file mount.
 */
export type ConfigElement = {
  __typename?: "ConfigElement";
  /** Category of the config element (e.g., Spacelift-managed environment variables). */
  category: Maybe<ConfigElementCategory>;
  /** SHA256 checksum of the value. */
  checksum: Scalars["String"]["output"];
  /**
   * Unix timestamp representing the creation of the config element. Will be
   * empty if the element is computed at runtime (eg. by a cloud integration).
   * Note that config elements are considered immutable, so this value is reset
   * when the value changes.
   */
  createdAt: Maybe<Scalars["Int"]["output"]>;
  /** Description of the config element. */
  description: Scalars["String"]["output"];
  /** File mode (user/group/other) for the file mount. */
  fileMode: Maybe<Scalars["String"]["output"]>;
  /** Environment variable name or file mount relative path. */
  id: Scalars["ID"]["output"];
  /** Whether the config element is only known at runtime. */
  runtime: Scalars["Boolean"]["output"];
  /** Config element type. */
  type: ConfigType;
  /**
   * Environment variable value, only exposed if the variable is not
   * marked as write-only.
   */
  value: Maybe<Scalars["String"]["output"]>;
  /**
   * When a variable is marked as write-only, its value is only accessible
   * to the Run, but not in the API or the UI.
   */
  writeOnly: Scalars["Boolean"]["output"];
};

export enum ConfigElementCategory {
  /** Element is managed by Spacelift (API tokens, OIDC tokens, TF_VAR_spacelift_* metadata). */
  SpaceliftEnvironment = "SPACELIFT_ENVIRONMENT",
}

export type ConfigElementWithSource = {
  __typename?: "ConfigElementWithSource";
  /** Optional context if the element is coming from a context. */
  context: Maybe<StackContextAttachment>;
  /** Wrapped config element. */
  element: ConfigElement;
  /** Optional dependency if the element is coming from a dependent stack. */
  stackDependency: Maybe<StackDependency>;
};

/** Arguments used to create and update an individual ConfigElement. */
export type ConfigInput = {
  description: InputMaybe<Scalars["String"]["input"]>;
  fileMode: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  type: ConfigType;
  value: Scalars["String"]["input"];
  writeOnly: Scalars["Boolean"]["input"];
};

/** ConfigType is the type of the configuration element. */
export enum ConfigType {
  /** Environment variable. */
  EnvironmentVariable = "ENVIRONMENT_VARIABLE",
  /** File mounted in the workspace. */
  FileMount = "FILE_MOUNT",
}

export type Context = Hookable & {
  __typename?: "Context";
  /** Actions that the user can perform on the Context */
  allowedActions: Array<Action>;
  /** Single stack attachment for this context. */
  attachedStack: Maybe<ContextStackAttachment>;
  /** List of stacks attached to this context. */
  attachedStacks: Array<ContextStackAttachment>;
  /** Full list of stack config elements. */
  config: Array<ConfigElement>;
  /** Single context config element. */
  configElement: Maybe<ConfigElement>;
  /** Unix timestamp representing the context creation. */
  createdAt: Scalars["Int"]["output"];
  /** Free-form context description for the users, supports Markdown. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether any stacks are attached to this policy, either directly or via auto-attachment. */
  hasAttachedStacks: Scalars["Boolean"]["output"];
  /** List of hooks extending this context. */
  hooks: Hooks;
  /** Unique (within a single organization), immutable name of the context. */
  id: Scalars["ID"]["output"];
  /** User-defined labels set on the context. */
  labels: Array<Scalars["String"]["output"]>;
  /** Fancy, mutable name of the context to show in the UI. */
  name: Scalars["String"]["output"];
  /**
   * Plugin that is managing the context.
   * Used to indicate that modifications are restricted by a plugin action.
   */
  plugin: Maybe<Plugin>;
  /** ID of the space this Context belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this Context belongs to. */
  spaceDetails: Space;
  /** Unix timestamp of the last context update. */
  updatedAt: Scalars["Int"]["output"];
};

export type ContextAttachedStackArgs = {
  id: Scalars["ID"]["input"];
};

export type ContextConfigElementArgs = {
  id: Scalars["ID"]["input"];
};

/** ContextInput represents the data used to configure a Context. */
export type ContextInput = {
  configAttachments: InputMaybe<Array<ConfigInput>>;
  description: InputMaybe<Scalars["String"]["input"]>;
  hooks: InputMaybe<HooksInput>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
  stackAttachments: InputMaybe<Array<ContextStackAttachmentInput>>;
};

/** ContextStackAttachment is the stack attachment viewed from the Context. */
export type ContextStackAttachment = {
  __typename?: "ContextStackAttachment";
  /** Creation timestamp of the attachment. */
  createdAt: Scalars["Int"]["output"];
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** Whether the stack is autoattached. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** True if the attached stack is type of Module. */
  isModule: Scalars["Boolean"]["output"];
  /** The priority of the attachment. */
  priority: Scalars["Int"]["output"];
  /** Slug of the attached stack. */
  stackId: Scalars["ID"]["output"];
  /** Name of the attached stack. */
  stackName: Scalars["String"]["output"];
  /** Space details of the attached stack. */
  stackSpaceDetails: Space;
};

export type ContextStackAttachmentInput = {
  priority: Scalars["Int"]["input"];
  stack: Scalars["ID"]["input"];
};

export type ContextsConnection = {
  __typename?: "ContextsConnection";
  cursor: Scalars["String"]["output"];
  node: Context;
};

export type CustomVcsInput = {
  /** Free-form description of the integration. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** isDefault indicates whether this integration should be used as the default. If not provided, defaults to false. */
  isDefault: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Labels for the integration. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The name of the integration */
  name: Scalars["String"]["input"];
  /** The space this VCS integration belongs to. */
  spaceID: Scalars["ID"]["input"];
  /** Indicates whether the integration should use git checkout. If false source code will be downloaded using the VCS API. */
  useGitCheckout: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Additional options for configuring VCS check behavior. */
  vcsCheckOptions: InputMaybe<VcsCheckOptionsInput>;
  /** vcsChecks contains all the VCS checks enabled for this integration. If not provided, defaults to INDIVIDUAL */
  vcsChecks: InputMaybe<VcsCheck>;
};

export type CustomVcsUpdateInput = {
  /** Free-form description of the integration. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** The slug of the integration that should be updated. */
  id: Scalars["ID"]["input"];
  /** Labels for the integration. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * The slug of the space that the integration will belong to after
   * the update.
   */
  space: Scalars["ID"]["input"];
  /** Indicates whether the integration should use git checkout. If false source code will be downloaded using the VCS API. */
  useGitCheckout: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Additional options for configuring VCS check behavior. */
  vcsCheckOptions: InputMaybe<VcsCheckOptionsInput>;
  /** vcsChecks contains all the VCS checks enabled for this integration. If not provided, defaults to 1 (Individual). */
  vcsChecks: InputMaybe<VcsCheck>;
};

export type DataPoint = {
  __typename?: "DataPoint";
  labels: Array<Scalars["String"]["output"]>;
  timestamp: Scalars["Int"]["output"];
  value: Scalars["Float"]["output"];
};

export type DebugInfo = {
  __typename?: "DebugInfo";
  /** Describes git commit of the current binary. Returns empty string in SaaS. */
  commitSha: Scalars["String"]["output"];
  /** Describes the self-hosted licence representation. If it's null, it means customer doesnt have a license.  Not valid in SaaS. */
  selfHostedLicence: Maybe<SelfHostedLicence>;
  /** Describes spacelift self-hosted version. Returns empty string in SaaS. */
  selfHostedVersion: Scalars["String"]["output"];
};

/** Delta is the number of resources affected by a Run in various ways. */
export type Delta = {
  __typename?: "Delta";
  /** Count of resources to create. */
  addCount: Scalars["Int"]["output"];
  /** Count of resources to modify in-place. */
  changeCount: Scalars["Int"]["output"];
  /** Count of resources to destroy. */
  deleteCount: Scalars["Int"]["output"];
  /** Count of failed resources. */
  failedCount: Scalars["Int"]["output"];
  /** Count of resources to be forgotten. */
  forgetCount: Scalars["Int"]["output"];
  /** Count of ignored resources. */
  ignoreCount: Scalars["Int"]["output"];
  /** Count of resources to import. */
  importCount: Scalars["Int"]["output"];
  /** Count of resources to be moved. */
  moveCount: Scalars["Int"]["output"];
  /** Count of ok resources. */
  okCount: Scalars["Int"]["output"];
  /** Count of rescued resources. */
  rescueCount: Scalars["Int"]["output"];
  /** Total number of resources in the state before applying the change. */
  resources: Scalars["Int"]["output"];
  /** Count of skipped resources. */
  skipCount: Scalars["Int"]["output"];
  /** Count of unreachable resources. */
  unreachableCount: Scalars["Int"]["output"];
};

/** DriftDetectionIntegration describes a Stack's drift detection configuration. */
export type DriftDetectionIntegration = {
  __typename?: "DriftDetectionIntegration";
  /** Deleted boolean */
  deleted: Scalars["Boolean"]["output"];
  /**
   * Whether to ignore stack state when running drift detection.
   * If False, drift detection only runs on green finished stacks.
   */
  ignoreState: Scalars["Boolean"]["output"];
  /**
   * When the next detection run will be scheduled.
   * Null if detection or reconciliation is in progress.
   */
  nextSchedule: Maybe<Scalars["Int"]["output"]>;
  /** Whether to schedule a reconciliation run when drift has been detected. */
  reconcile: Scalars["Boolean"]["output"];
  /** Drift detection will be scheduled according to this cron schedule expression. */
  schedule: Array<Scalars["String"]["output"]>;
  /** Cron schedule expressions will apply for this timezone. */
  timezone: Scalars["String"]["output"];
};

/** Arguments used to create and update an individual DriftDetectionIntegration configuration. */
export type DriftDetectionIntegrationInput = {
  /**
   * Whether to ignore stack state when running drift detection.
   * If False, drift detection only runs on green finished stacks.
   */
  ignoreState: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether to schedule a reconciliation run when drift has been detected. */
  reconcile: Scalars["Boolean"]["input"];
  /** Drift detection will be scheduled according to this cron schedule expression. */
  schedule: Array<Scalars["String"]["input"]>;
  /** Cron schedule expressions will apply for this timezone. Defaults to UTC. */
  timezone: InputMaybe<Scalars["String"]["input"]>;
};

export type DriftDetectionIntegrationTile = {
  __typename?: "DriftDetectionIntegrationTile";
  driftDetetionIntegration: DriftDetectionIntegration;
  stackTile: StackTile;
};

/** EffectiveTerragruntVersionResult represents the effective Terragrunt and Terraform versions to be used in a stack. */
export type EffectiveTerragruntVersionResult = {
  __typename?: "EffectiveTerragruntVersionResult";
  /** Effective Terraform version to be used in a stack. Returns null if tool is set to MANUALLY_PROVISIONED. */
  effectiveTerraformVersion: Maybe<Scalars["String"]["output"]>;
  /** Effective Terragrunt version to be used in a stack. Returns null if tool is set to MANUALLY_PROVISIONED. */
  effectiveTerragruntVersion: Maybe<Scalars["String"]["output"]>;
  /** The tool used to perform the compatibility check. */
  tool: TerragruntTool;
};

export type EntityAttributeChange = {
  __typename?: "EntityAttributeChange";
  changeForPhase: EntityAttributeChangeForPhase;
  /** JSON path to the changed property */
  path: Scalars["String"]["output"];
};

export type EntityAttributeChangeForPhase = {
  __typename?: "EntityAttributeChangeForPhase";
  /** The property value after, nil if removed. */
  after: Maybe<ChangeValue>;
  /**
   * True when the after value is "known after apply" — the value cannot be determined
   * at plan time and will only be resolved during apply. Clients should render this
   * as "(known after apply)" rather than treating `after` as a literal null.
   */
  afterUnknown: Scalars["Boolean"]["output"];
  /** The property value before, nil if added. */
  before: Maybe<ChangeValue>;
  metadata: EntityAttributeChangeForPhaseMetadata;
};

export type EntityAttributeChangeForPhaseMetadata = {
  __typename?: "EntityAttributeChangeForPhaseMetadata";
  phase: EntityChangePhase;
  type: EntityChangeType;
};

export type EntityChangeCollectionInputV2 = {
  /**
   * List the entity changes after this ID
   * When paginating the PageInfo.endCursor returned contains the next after value
   */
  after: InputMaybe<Scalars["String"]["input"]>;
  /** List the entity changes with in this change phase */
  changePhase: InputMaybe<EntityChangePhase>;
  /** List the entity changes with this change type */
  changeType: InputMaybe<EntityChangeType>;
  /** List the first * items */
  first: InputMaybe<Scalars["Int"]["input"]>;
};

export type EntityChangeConnection = {
  __typename?: "EntityChangeConnection";
  cursor: Scalars["String"]["output"];
  node: EntityChangeV3;
};

export type EntityChangeConnectionV2 = {
  __typename?: "EntityChangeConnectionV2";
  cursor: Scalars["String"]["output"];
  node: EntityChangeV2;
};

export type EntityChangeMetadata = {
  __typename?: "EntityChangeMetadata";
  moved: Scalars["Boolean"]["output"];
  result: EntityChangeResult;
  type: EntityChangeType;
};

export enum EntityChangePhase {
  /** entity change was performed during the applying phase */
  Apply = "APPLY",
  /** entity change was performed during a drift detection run */
  Drift = "DRIFT",
  /** entity change was performed during the planning phase */
  Plan = "PLAN",
}

/** Status of a entity change. */
export enum EntityChangeResult {
  /** Change was planned and has not been applied. */
  Failed = "FAILED",
  /**
   * Change was planned and has been applied but has partially failed.
   * Change type is REPLACE_* and either ADD or DELETE has not been applied.
   */
  Partial = "PARTIAL",
  /** Change has not been applied. */
  Planned = "PLANNED",
  /** Change was planned and has been applied. */
  Successful = "SUCCESSFUL",
  /** Change result is unknown */
  Unknown = "UNKNOWN",
  /** Change which wasn't planned but is being applied. */
  Unplanned = "UNPLANNED",
}

/** Type of a entity change. */
export enum EntityChangeType {
  /** A new entity will be created. */
  Add = "ADD",
  /** An existing entity will be updated in-place. */
  Change = "CHANGE",
  /**
   * An existing entity will be removed from the state but not destroyed, and a
   * replacement will be created.
   */
  CreateAfterForgotten = "CREATE_AFTER_FORGOTTEN",
  /** An existing entity will be deleted. */
  Delete = "DELETE",
  /** A task that failed. */
  Failed = "FAILED",
  /** An existing entity will be removed from the state but not destroyed. */
  Forget = "FORGET",
  /** A task that resulted with status ignored. */
  Ignored = "IGNORED",
  /** A new entity will be imported. */
  Import = "IMPORT",
  /** A no-op change. */
  Noop = "NOOP",
  /**
   * Ansible specific types
   * A task that resulted with status ok.
   */
  Ok = "OK",
  /** A read, no-op change. */
  Read = "READ",
  /** An existing entity will replaced by first creating a replacement and then deleting the original. */
  ReplaceCreateBeforeDestroy = "REPLACE_CREATE_BEFORE_DESTROY",
  /** An existing entity will replaced by first deleting the original and then creating a replacement. */
  ReplaceDestroyBeforeCreate = "REPLACE_DESTROY_BEFORE_CREATE",
  /** A task that resulted with status rescued. */
  Rescued = "RESCUED",
  /** A task that resulted with status skipped. */
  Skipped = "SKIPPED",
  /** A host that was unreachable. */
  Unreachable = "UNREACHABLE",
}

/** A Terraform managed entity change description. */
export type EntityChangeV2 = {
  __typename?: "EntityChangeV2";
  /** ManagedEntity after change. */
  entity: ManagedEntityV2;
  /** Phase */
  phase: EntityChangePhase;
  /** Change type */
  type: EntityChangeType;
};

/** A Terraform-family (Terraform, OpenTofu, Terragrunt) managed entity change description. */
export type EntityChangeV3 = {
  __typename?: "EntityChangeV3";
  /** The address of the resource */
  address: Scalars["String"]["output"];
  /**
   * Changes here is a list of the changes that happened to the individual resource
   * For example: if someone edited the tags on an EC2 instance, this would be a list of the tags that changed
   */
  attributeChanges: Array<EntityAttributeChange>;
  /** This holds the resultant change type for the resource as a whole (ie, replaced, created etc) */
  metadata: EntityChangeMetadata;
  /** The previous address of the resource in the case of the resource being moved */
  previousAddress: Scalars["String"]["output"];
};

export type EntityChangesInputV3 = {
  changePhase: InputMaybe<EntityChangePhase>;
  changeType: InputMaybe<EntityChangeType>;
};

export type EntityChangesV2 = {
  __typename?: "EntityChangesV2";
  edges: Array<EntityChangeConnectionV2>;
  pageInfo: PageInfo;
};

/** Vendor-specific managed entity metadata. */
export type EntityVendor =
  | EntityVendorAnsible
  | EntityVendorCloudFormation
  | EntityVendorKubernetes
  | EntityVendorPulumi
  | EntityVendorTerraform;

export type EntityVendorAnsible = {
  __typename?: "EntityVendorAnsible";
  /** Type-specific managed entity metadata. */
  ansible: AnsibleEntity;
};

export type EntityVendorCloudFormation = {
  __typename?: "EntityVendorCloudFormation";
  /** Type-specific managed entity metadata. */
  cloudFormation: CloudFormationEntity;
};

export type EntityVendorKubernetes = {
  __typename?: "EntityVendorKubernetes";
  /** Type-specific managed entity metadata. */
  kubernetes: KubernetesEntity;
};

export type EntityVendorPulumi = {
  __typename?: "EntityVendorPulumi";
  /** Type-specific managed entity metadata. */
  pulumi: PulumiEntity;
};

export type EntityVendorTerraform = {
  __typename?: "EntityVendorTerraform";
  /** Type-specific managed entity metadata. */
  terraform: TerraformEntity;
};

export type EnvVar = {
  __typename?: "EnvVar";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type EnvVarInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** A generic environment variable structure */
export type EnvironmentVariable = {
  /** Key of an environment variable */
  key: Scalars["String"]["input"];
  /** Value of an environment variable */
  value: Scalars["String"]["input"];
};

/**
 * ExternalIdForStackResult contains information needed for creating AWS AssumeRole
 * policies for an integration stack attachment.
 */
export type ExternalIdForStackResult = {
  __typename?: "ExternalIdForStackResult";
  /** An example AssumeRole policy statement that allows the stack to assume the role. */
  assumeRolePolicyStatement: Scalars["String"]["output"];
  /** The external ID that would be used when assuming the role for the stack. */
  externalId: Scalars["String"]["output"];
};

export type ExternalIntegration = {
  __typename?: "ExternalIntegration";
  /** API key related to the integration */
  apiKey: ApiKey;
  attachedBlueprints: Array<BlueprintIntegrationAttachment>;
  /** Timestamp of when the integration was created */
  createdAt: Scalars["Int"]["output"];
  /** Type-specific configuration */
  customConfig: ExternalIntegrationConfig;
  /** Whether the integration is deleted */
  deleted: Scalars["Boolean"]["output"];
  /** Description of the integration */
  description: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier for the integration */
  id: Scalars["ID"]["output"];
  /** Name of the integration */
  name: Scalars["String"]["output"];
  /** Associated space */
  spaceDetails: Space;
  /** Type of the integration */
  type: Scalars["String"]["output"];
};

export type ExternalIntegrationConfig = ExternalIntegrationConfigServiceNow;

export type ExternalIntegrationConfigServiceNow = {
  __typename?: "ExternalIntegrationConfigServiceNow";
  /** Base URL for the ServiceNow instance */
  baseURL: Scalars["String"]["output"];
  /** Username for authentication */
  username: Scalars["String"]["output"];
};

export type ExternalIntegrationInput = {
  /** Additional integration-specific data */
  customConfigData: IntegrationCustomConfigData;
  /** Description of the integration (optional) */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the integration */
  name: Scalars["String"]["input"];
  /** Space to use for this integration */
  space: Scalars["ID"]["input"];
  /** Type of the integration */
  type: Scalars["String"]["input"];
};

/** Used to evaluate a boolean flag. */
export type FeatureFlagBoolEvaluation = {
  /** The default value to be returned if no value is set for the flag. */
  defaultValue: Scalars["Boolean"]["input"];
  /** The name of the flag. */
  name: Scalars["String"]["input"];
};

/**
 * Represents an individual flag that you want to evaluate. Only one of intEvaluation
 * or boolEvaluation should be provided, depending on the type of flag you're evaluating.
 */
export type FeatureFlagEvaluation = {
  /** boolEvaluation is used when evaluating a boolean feature flag. */
  boolEvaluation: InputMaybe<FeatureFlagBoolEvaluation>;
  /** intEvaluation is used when evaluating an int feature flag. */
  intEvaluation: InputMaybe<FeatureFlagIntEvaluation>;
};

/** The input to the evaluateFeatureFlags request. Used to evaluate feature flags in Self-Hosted instances. */
export type FeatureFlagEvaluationInput = {
  /** The set of flags to evaluate. */
  flags: Array<FeatureFlagEvaluation>;
};

/** The result of evaluating a feature flag. */
export type FeatureFlagEvaluationResult = {
  __typename?: "FeatureFlagEvaluationResult";
  /** The name of the flag. */
  name: Scalars["String"]["output"];
  /** The value of the flag. */
  value: Scalars["String"]["output"];
};

/** Used to evaluate an int flag. */
export type FeatureFlagIntEvaluation = {
  /** The default value to be returned if no value is set for the flag. */
  defaultValue: Scalars["Int"]["input"];
  /** The name of the flag. */
  name: Scalars["String"]["input"];
};

/** All supported federation providers. */
export enum FederationProvider {
  GithubOauth = "GITHUB_OAUTH",
  GitlabOauth = "GITLAB_OAUTH",
  GoogleOauth = "GOOGLE_OAUTH",
  MicrosoftOauth = "MICROSOFT_OAUTH",
  MicrosoftTeamsOauth = "MICROSOFT_TEAMS_OAUTH",
  Oidc = "OIDC",
  Saml = "SAML",
  SlackOauth = "SLACK_OAUTH",
}

/** FlowsInstance represents a configured Flows deployment that accounts can link to. */
export type FlowsInstance = {
  __typename?: "FlowsInstance";
  /** The API URL for this Flows instance. */
  apiURL: Scalars["String"]["output"];
  /** The redirect URL for this Flows instance. */
  redirectURL: Scalars["String"]["output"];
};

/** FlowsIntegration represents a link between a Spacelift account and a Flows organization. */
export type FlowsIntegration = {
  __typename?: "FlowsIntegration";
  /** The base URL of the Flows instance. */
  baseURL: Scalars["String"]["output"];
  /** When the link was created. */
  createdAt: Scalars["Int"]["output"];
  /** The Flows organization ID this account is linked to. */
  organizationID: Scalars["String"]["output"];
  /** The Flows organization name this account is linked to. */
  organizationName: Scalars["String"]["output"];
  /** When the link was last updated. */
  updatedAt: Scalars["Int"]["output"];
};

/**
 * FlowsProject is a project in the linked Flows organization. It is the unit to
 * which Space role bindings are assigned (resource-side authorization), the same
 * way an Stack Role Binding is. The id is the external Flows project UUID.
 */
export type FlowsProject = {
  __typename?: "FlowsProject";
  /** The external Flows project UUID. */
  id: Scalars["ID"]["output"];
  /** The Flows project name. */
  name: Scalars["String"]["output"];
  /**
   * The Space role bindings currently assigned to this project (only those in
   * spaces the caller can administer are returned).
   */
  roleBindings: Array<FlowsProjectRoleBinding>;
};

/** FlowsProjectRoleBinding grants a Space Role to a Flows project. */
export type FlowsProjectRoleBinding = {
  __typename?: "FlowsProjectRoleBinding";
  /** The external Flows project UUID this binding applies to. */
  flowsProjectID: Scalars["ID"]["output"];
  /** The binding ID. */
  id: Scalars["ID"]["output"];
  /** The role granted in the space. */
  role: Role;
  /** The space this binding grants access to. */
  space: Space;
};

/** Input for assigning a batch of Flows project role bindings. */
export type FlowsProjectRoleBindingBatchInput = {
  bindings: Array<FlowsProjectRoleBindingInput>;
};

/** Input for assigning a single (space, role) binding to a Flows project. */
export type FlowsProjectRoleBindingInput = {
  /** The external Flows project UUID. */
  flowsProjectID: Scalars["ID"]["input"];
  /** The role ULID. */
  roleID: Scalars["ID"]["input"];
  /** The space slug. */
  spaceID: Scalars["ID"]["input"];
};

/** ForceApplyMode controls whether a run should force apply even when delta is zero. */
export enum ForceApplyMode {
  /** Force apply this run and propagate to all triggered dependents. */
  Cascade = "CASCADE",
  /** Force apply this run only, do not propagate to dependents. */
  Single = "SINGLE",
}

export type GpgKey = {
  __typename?: "GPGKey";
  /** Timestamp of when the key was created. */
  createdAt: Scalars["Int"]["output"];
  /** Login of the user who created the key. */
  createdBy: Scalars["String"]["output"];
  /** Optional, human-readable description of the GPG key. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Globally unique key identifier. */
  id: Scalars["ID"]["output"];
  /** Name of the key. */
  name: Scalars["String"]["output"];
  /** Timestamp of when the key was revoked, if it has been revoked. */
  revokedAt: Maybe<Scalars["Int"]["output"]>;
  /** Login of the user who revoked the key, if it has been revoked. */
  revokedBy: Maybe<Scalars["String"]["output"]>;
  /** Timestamp of when the key was last updated. */
  updatedAt: Scalars["Int"]["output"];
};

export type GenericFormDescription = {
  __typename?: "GenericFormDescription";
  name: Scalars["String"]["output"];
  /** JSON encoded properties of the form */
  properties: Maybe<Scalars["String"]["output"]>;
};

/** GitHubAppManifest represents the data needed by the GitHub app creation form. */
export type GitHubAppManifest = {
  __typename?: "GitHubAppManifest";
  /** Endpoint for the POST request to GitHub, including temporary state. */
  endpoint: Scalars["String"]["output"];
  /** The content of the manifest. */
  manifest: Scalars["String"]["output"];
};

/** Arguments used to create a GitHub App manifest form. */
export type GitHubAppManifestInput = {
  /** API host. If not provided, uses https://api.github.com */
  apiHost: InputMaybe<Scalars["String"]["input"]>;
  /** GUI host name. If not provided, uses https://github.com */
  host: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Name of the GitHub account that is going to be the owner of the application.
   * Empty for personal accounts.
   */
  ownerName: InputMaybe<Scalars["String"]["input"]>;
  /** Type of the GitHub account that is going to be the owner of the application. */
  ownerType: AccountType;
};

export enum GitHubAppStatus {
  AppNotFound = "APP_NOT_FOUND",
  CouldNotDecode = "COULD_NOT_DECODE",
  Error = "ERROR",
  Ok = "OK",
  VcsAgentError = "VCS_AGENT_ERROR",
  VcsAgentErrorForbidden = "VCS_AGENT_ERROR_FORBIDDEN",
  VcsAgentErrorNoPoolAgentConnected = "VCS_AGENT_ERROR_NO_POOL_AGENT_CONNECTED",
  VcsAgentErrorTimeout = "VCS_AGENT_ERROR_TIMEOUT",
  VcsAgentPoolNotFound = "VCS_AGENT_POOL_NOT_FOUND",
}

/** GithubEnterpriseIntegration shows GitHub Enterprise integration details. */
export type GithubEnterpriseIntegration = {
  __typename?: "GithubEnterpriseIntegration";
  apiHost: Scalars["String"]["output"];
  appID: Scalars["String"]["output"];
  appUrl: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  githubAppExists: Scalars["Boolean"]["output"];
  githubAppStatus: GitHubAppStatus;
  id: Scalars["ID"]["output"];
  installations: Array<GithubEnterpriseIntegrationInstallation>;
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  space: Maybe<Space>;
  useGitCheckout: Scalars["Boolean"]["output"];
  userFacingHost: Scalars["String"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
  webhookSecret: Scalars["String"]["output"];
  webhookUrl: Scalars["String"]["output"];
};

/**
 * GithubEnterpriseIntegrationInstallation represents a single GitHub Enterprise
 * custom app installation.
 */
export type GithubEnterpriseIntegrationInstallation = {
  __typename?: "GithubEnterpriseIntegrationInstallation";
  accountName: Scalars["String"]["output"];
  accountType: Maybe<Scalars["String"]["output"]>;
  installationId: Scalars["String"]["output"];
  installationUrl: Maybe<Scalars["String"]["output"]>;
};

/** GithubIntegration shows build-in GitHub integration details. */
export type GithubIntegration = {
  __typename?: "GithubIntegration";
  apiHost: Scalars["String"]["output"];
  isEnterprise: Scalars["Boolean"]["output"];
  useGitCheckout: Scalars["Boolean"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
};

/** GitlabIntegration shows Gitlab integration details. */
export type GitlabIntegration = {
  __typename?: "GitlabIntegration";
  apiHost: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  space: Maybe<Space>;
  useGitCheckout: Scalars["Boolean"]["output"];
  userFacingHost: Scalars["String"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
  webhookSecret: Scalars["String"]["output"];
  webhookUrl: Scalars["String"]["output"];
};

export type Hookable = {
  /** Hooks extending this entity. */
  hooks: Hooks;
};

/** Hooks represents a collection of hooks extending the standard run lifecycle. */
export type Hooks = {
  __typename?: "Hooks";
  /** List of after-apply scripts. */
  afterApply: Array<Scalars["String"]["output"]>;
  /** List of after-destroy scripts. */
  afterDestroy: Array<Scalars["String"]["output"]>;
  /** List of after-init scripts. */
  afterInit: Array<Scalars["String"]["output"]>;
  /** List of after-perform scripts. */
  afterPerform: Array<Scalars["String"]["output"]>;
  /** List of after-plan scripts. */
  afterPlan: Array<Scalars["String"]["output"]>;
  /** List of after-run scripts. */
  afterRun: Array<Scalars["String"]["output"]>;
  /** List of before-apply scripts. */
  beforeApply: Array<Scalars["String"]["output"]>;
  /** List of before-destroy scripts. */
  beforeDestroy: Array<Scalars["String"]["output"]>;
  /** List of before-init scripts. */
  beforeInit: Array<Scalars["String"]["output"]>;
  /** List of before-perform scripts. */
  beforePerform: Array<Scalars["String"]["output"]>;
  /** List of before-plan scripts. */
  beforePlan: Array<Scalars["String"]["output"]>;
};

export type HooksInput = {
  afterApply: Array<Scalars["String"]["input"]>;
  afterDestroy: Array<Scalars["String"]["input"]>;
  afterInit: Array<Scalars["String"]["input"]>;
  afterPerform: Array<Scalars["String"]["input"]>;
  afterPlan: Array<Scalars["String"]["input"]>;
  afterRun: Array<Scalars["String"]["input"]>;
  beforeApply: Array<Scalars["String"]["input"]>;
  beforeDestroy: Array<Scalars["String"]["input"]>;
  beforeInit: Array<Scalars["String"]["input"]>;
  beforePerform: Array<Scalars["String"]["input"]>;
  beforePlan: Array<Scalars["String"]["input"]>;
};

/** Identity represents a V2 identity record linked to a user via federation. */
export type Identity = {
  __typename?: "Identity";
  /** Federation records linking this identity to external providers. */
  federations: Array<IdentityFederation>;
  /** ULID of the identity. */
  id: Scalars["ID"]["output"];
};

/** IdentityFederation represents the link between an identity and an external identity provider. */
export type IdentityFederation = {
  __typename?: "IdentityFederation";
  /** External ID from the identity provider. */
  externalID: Scalars["String"]["output"];
  /** External username from the identity provider, if available. */
  externalUsername: Maybe<Scalars["String"]["output"]>;
  /** Federation provider. */
  provider: FederationProvider;
};

export enum IdentityProvider {
  /** Default setting for self-hosted installations before SAML or OIDC is configured. Not valid in SaaS. */
  Empty = "EMPTY",
  Github = "GITHUB",
  Gitlab = "GITLAB",
  Google = "GOOGLE",
  Microsoft = "MICROSOFT",
  Oidc = "OIDC",
  Saml = "SAML",
  Unknown = "UNKNOWN",
}

export type InitialBlueprintVersionInput = {
  /** Blueprint version description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Version number */
  number: Scalars["String"]["input"];
  /** Raw template YAML for the initial version */
  rawTemplate: InputMaybe<Scalars["String"]["input"]>;
};

export type InitialTemplateVersionInput = {
  /** Template version description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Version number */
  number: Scalars["String"]["input"];
  /** Raw template YAML for the initial version */
  rawTemplate: InputMaybe<Scalars["String"]["input"]>;
};

export type IntegrationCustomConfigData = {
  /** ServiceNow integration-specific data (optional) */
  serviceNow: InputMaybe<ServiceNowExtraDataInput>;
};

export type IntegrationsCount = {
  __typename?: "IntegrationsCount";
  ai: Scalars["Int"]["output"];
  aws: Scalars["Int"]["output"];
  azure: Scalars["Int"]["output"];
  azureDevOps: Scalars["Int"]["output"];
  backstage: Scalars["Int"]["output"];
  bitbucketCloud: Scalars["Int"]["output"];
  bitbucketDatacenter: Scalars["Int"]["output"];
  blobStorage: Scalars["Int"]["output"];
  github: Scalars["Int"]["output"];
  gitlab: Scalars["Int"]["output"];
  origin: Scalars["Int"]["output"];
  serviceNow: Scalars["Int"]["output"];
  slack: Scalars["Int"]["output"];
  vcsAgentPools: Scalars["Int"]["output"];
  webhooks: Scalars["Int"]["output"];
};

/** IntentChatConversation represents a chat conversation for Intent. */
export type IntentChatConversation = {
  __typename?: "IntentChatConversation";
  /** Timestamp when the conversation was created */
  createdAt: Scalars["Int"]["output"];
  /** Description of the conversation */
  description: Maybe<Scalars["String"]["output"]>;
  /** Globally unique ID of the conversation */
  id: Scalars["ID"]["output"];
  /** Last used AI integration for this conversation. */
  lastUsedAIIntegration: Maybe<AiIntegration>;
  /** Last used AI model for this conversation. */
  lastUsedAIModel: Maybe<Scalars["String"]["output"]>;
  /** Messages in the conversation */
  messages: Array<IntentChatMessage>;
  /**
   * Markdown transcript of the conversation, for continuing it in an
   * external agentic harness. Tool calls and their results are included
   * verbatim; reasoning is dropped. offset is the index of the first message
   * to include (default 0) and limit caps the number of messages (default
   * all), so a long conversation can be read in pages.
   */
  transcript: Scalars["String"]["output"];
  /** Timestamp when the conversation was last updated */
  updatedAt: Scalars["Int"]["output"];
  /** Monotonic version incremented on message changes */
  version: Scalars["Int"]["output"];
};

/** IntentChatConversation represents a chat conversation for Intent. */
export type IntentChatConversationTranscriptArgs = {
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
};

/** IntentChatMessage represents a single message in a chat conversation. */
export type IntentChatMessage = {
  __typename?: "IntentChatMessage";
  /** Content of the message as JSON */
  content: Scalars["String"]["output"];
  /** Globally unique ID of the message */
  id: Scalars["ID"]["output"];
  /** Role of the message sender (user, assistant, system, etc.) */
  role: Scalars["String"]["output"];
};

/** A page of resources managed by a spacelift/module intent resource. */
export type IntentModuleResourcesOutput = {
  __typename?: "IntentModuleResourcesOutput";
  edges: Array<IntentResourceConnection>;
  pageInfo: PageInfo;
};

/** IntentProject represents the execution context for MCP tool operations. */
export type IntentProject = {
  __typename?: "IntentProject";
  /** Actions that the user can perform on this IntentProject. */
  allowedActions: Array<Action>;
  /** List of policies that can be attached to this project. */
  attachablePolicies: Array<Policy>;
  /** List of policies attached to this project */
  attachedPolicies: Array<IntentProjectPolicyAttachment>;
  /** AWS integrations attached to this intent project. */
  awsIntegrationIntentProjectAttachment: Maybe<AwsIntegrationIntentProjectAttachment>;
  /** List of configuration elements (environment variables and file mounts) */
  configElements: Array<ConfigElement>;
  /** Unix timestamp representing the intent project creation. */
  createdAt: Scalars["Int"]["output"];
  /** Who created this intent project. */
  createdBy: Maybe<Scalars["String"]["output"]>;
  /** Free-form intent project description for the users, supports Markdown. */
  description: Maybe<Scalars["String"]["output"]>;
  /**
   * HCL representation of the project with pagination support.
   * page: Page number (1-based), defaults to 1
   * pageSize: Number of resources per page (1-500), defaults to 50
   */
  hcl: IntentProjectHclResult;
  /** Unique (within a single organization), immutable name of the intent project. */
  id: Scalars["ID"]["output"];
  /**
   * Whether this project is the caller's most recently activated one (per-session).
   * Distinct from `state`: `state` is a project-wide read-only mode shared by all
   * callers, while `isActive` is a per-caller flag tracking which project the
   * caller's MCP/UI commands are currently targeting. Always false for machine sessions.
   */
  isActive: Scalars["Boolean"]["output"];
  /** True if intent project is locked */
  isLocked: Scalars["Boolean"]["output"];
  /** Arbitrary labels set by the user, used for policy autoattachment and filtering. */
  labels: Array<Scalars["String"]["output"]>;
  /** Unix timestamp when any resource in this intent project was last modified. */
  lastResourcesUpdatedAt: Maybe<Scalars["Int"]["output"]>;
  /** User that has locked this intent project. */
  lockedBy: Maybe<Scalars["String"]["output"]>;
  /** Lock expiration time unix timestamp. */
  lockedUntil: Maybe<Scalars["Int"]["output"]>;
  /** Fancy, mutable name of the intent project to show in the UI. */
  name: Scalars["String"]["output"];
  /**
   * Optional Docker image used to run intent tasks for this project.
   * Empty string means the system default intent worker image is used.
   */
  runnerImage: Scalars["String"]["output"];
  /** Search intent resources with a set of predicates, ordering and paging. */
  searchIntentResources: SearchIntentResourcesOutput;
  /** Search intent resources operations with a set of predicates, ordering and paging */
  searchIntentResourcesOperations: SearchIntentResourcesOperationsOutput;
  /** Information about fields available for searching intent resource operations */
  searchIntentResourcesOperationsSuggestions: SearchSuggestionsOutput;
  /** Information about fields available for searching intent resources. */
  searchIntentResourcesSuggestions: SearchSuggestionsOutput;
  /** ID of the space this IntentProject belongs to. */
  space: Space;
  /** Intent Project state */
  state: Scalars["String"]["output"];
  /** Unix timestamp of the last intent project update. */
  updatedAt: Scalars["Int"]["output"];
  /** Worker pool assigned to this intent project for task execution. */
  workerPool: Maybe<WorkerPool>;
};

/** IntentProject represents the execution context for MCP tool operations. */
export type IntentProjectHclArgs = {
  page: InputMaybe<Scalars["Int"]["input"]>;
  pageSize: InputMaybe<Scalars["Int"]["input"]>;
};

/** IntentProject represents the execution context for MCP tool operations. */
export type IntentProjectSearchIntentResourcesArgs = {
  input: SearchInput;
};

/** IntentProject represents the execution context for MCP tool operations. */
export type IntentProjectSearchIntentResourcesOperationsArgs = {
  input: SearchInput;
};

/** IntentProject represents the execution context for MCP tool operations. */
export type IntentProjectSearchIntentResourcesOperationsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** IntentProject represents the execution context for MCP tool operations. */
export type IntentProjectSearchIntentResourcesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** IntentProjectHclResult contains paginated HCL output for an intent project. */
export type IntentProjectHclResult = {
  __typename?: "IntentProjectHclResult";
  /** Whether there are more resources available */
  hasMore: Scalars["Boolean"]["output"];
  /** HCL representation of the project resources */
  hcl: Scalars["String"]["output"];
};

export type IntentProjectPolicyAttachment = {
  __typename?: "IntentProjectPolicyAttachment";
  /**
   * List of all the policy evaluation records associated with this policy
   * attachment.
   */
  evaluationRecords: Array<PolicyEvaluationRecord>;
  /** Returns a single policy evaluation sample */
  evaluationSample: Maybe<PolicyEvaluationSample>;
  /** Globally unique Policy attachment identifier. */
  id: Scalars["ID"]["output"];
  /** True if the policy was attached automatically via an `autoattach:` label match. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** Body of the attached Policy. */
  policyBody: Scalars["String"]["output"];
  /** ID of the attached Policy. */
  policyId: Scalars["ID"]["output"];
  /** Labels of the attached Policy. */
  policyLabels: Array<Scalars["String"]["output"]>;
  /** Name of the attached Policy. */
  policyName: Scalars["String"]["output"];
  /** Type of the attached Policy. */
  policyType: PolicyType;
};

export type IntentProjectPolicyAttachmentEvaluationSampleArgs = {
  key: Scalars["String"]["input"];
};

/**
 * IntentProjectReference is a lightweight pointer to an IntentProject,
 * returned by relations (e.g. WorkerPool.intentProjects) that don't need to
 * expose the full IntentProject surface area.
 */
export type IntentProjectReference = {
  __typename?: "IntentProjectReference";
  /** Globally unique slug of the IntentProject. */
  id: Scalars["ID"]["output"];
  /** Human-readable name of the IntentProject. */
  name: Scalars["String"]["output"];
};

export type IntentProjectReferencesConnection = {
  __typename?: "IntentProjectReferencesConnection";
  cursor: Scalars["String"]["output"];
  node: IntentProjectReference;
};

export type IntentProjectsConnection = {
  __typename?: "IntentProjectsConnection";
  cursor: Scalars["String"]["output"];
  node: IntentProject;
};

/** Intent resource managed by intent projects */
export type IntentResource = {
  __typename?: "IntentResource";
  /** Address of the IntentResource in the module. */
  address: Scalars["String"]["output"];
  /** Who changed this resource. */
  changedBy: Scalars["String"]["output"];
  /** Dependencies for this resource. */
  dependencies: Array<IntentResourceDependency>;
  /** Hcl representation of the resource */
  hcl: Scalars["String"]["output"];
  /** IntentProject this resource belongs to. */
  intentProjectID: Scalars["String"]["output"];
  /** IntentResource Name. */
  name: Scalars["String"]["output"];
  /** Operation performed on this resource. */
  operation: Scalars["String"]["output"];
  /** Provider name. */
  provider: Scalars["String"]["output"];
  /** Resource ID from the state. */
  resourceID: Scalars["String"]["output"];
  /** IntentResource Type. */
  resourceType: Scalars["String"]["output"];
  /** Resource state in JSON format */
  state: Scalars["String"]["output"];
};

/** Intent resource managed by intent projects */
export type IntentResourceDependenciesArgs = {
  direction: InputMaybe<IntentResourceDependencyDirection>;
};

export type IntentResourceConnection = {
  __typename?: "IntentResourceConnection";
  cursor: Scalars["String"]["output"];
  node: IntentResource;
};

/** Dependency relationship between two intent resources. */
export type IntentResourceDependency = {
  __typename?: "IntentResourceDependency";
  /** Type of dependency. */
  dependencyType: IntentResourceDependencyType;
  /** Optional explanation of why this dependency exists. */
  explanation: Maybe<Scalars["String"]["output"]>;
  /** Field mappings showing which fields impact which. */
  fieldMappings: Array<IntentResourceDependencyFieldMapping>;
  /** Resource that depends on another. */
  fromResourceID: Scalars["String"]["output"];
  /** Unique identifier. */
  id: Scalars["ID"]["output"];
  /** Resource that is depended upon. */
  toResourceID: Scalars["String"]["output"];
};

/** Direction for querying dependencies. */
export enum IntentResourceDependencyDirection {
  /** Both directions. */
  Both = "BOTH",
  /** What this resource depends on. */
  Dependencies = "DEPENDENCIES",
  /** What depends on this resource. */
  Dependents = "DEPENDENTS",
}

/** Field mapping in a dependency relationship. */
export type IntentResourceDependencyFieldMapping = {
  __typename?: "IntentResourceDependencyFieldMapping";
  /** How this field dependency works. */
  description: Scalars["String"]["output"];
  /** Field in the dependent resource. */
  sourceField: Scalars["String"]["output"];
  /** Field in the dependency target. */
  targetField: Scalars["String"]["output"];
};

/** Field mapping input for creating dependencies. */
export type IntentResourceDependencyFieldMappingInput = {
  /** How this field dependency works. */
  description: Scalars["String"]["input"];
  /** Field in the dependent resource. */
  sourceField: Scalars["String"]["input"];
  /** Field in the dependency target. */
  targetField: Scalars["String"]["input"];
};

/** Type of dependency between intent resources. */
export enum IntentResourceDependencyType {
  DataSource = "DATA_SOURCE",
  Explicit = "EXPLICIT",
  Implicit = "IMPLICIT",
}

/** Intent resource operation */
export type IntentResourceOperation = {
  __typename?: "IntentResourceOperation";
  /** Policy allows */
  allow: Array<Scalars["String"]["output"]>;
  /** Author of the operation. */
  author: Maybe<Scalars["String"]["output"]>;
  /** Timestamp representing the operation time. */
  createdAt: Scalars["Int"]["output"];
  /** State before operation */
  currentState: Maybe<Scalars["String"]["output"]>;
  /** Policy denials */
  deny: Array<Scalars["String"]["output"]>;
  /** Indicates the reason for failure, if the operation did not succeed */
  failed: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Returns whether the operation applies to an existing resource. */
  isExistingResource: Scalars["Boolean"]["output"];
  /** Operation */
  operation: Scalars["String"]["output"];
  /** State after operation */
  proposedState: Maybe<Scalars["String"]["output"]>;
  /** Provider */
  provider: Scalars["String"]["output"];
  /** Resource ID */
  resourceID: Scalars["String"]["output"];
  /** Resource type */
  resourceType: Scalars["String"]["output"];
  /** List of reviews for this operation. */
  reviews: Array<IntentResourceOperationReview>;
  /** State of operation */
  state: IntentResourceOperationState;
};

export type IntentResourceOperationReview = {
  __typename?: "IntentResourceOperationReview";
  /** Author of the review. */
  author: Scalars["String"]["output"];
  /** Decision made by the reviewer. */
  decision: IntentResourceOperationReviewDecision;
  /** Unique ID of the operation review. */
  id: Scalars["ID"]["output"];
  /** Optional note, if any. */
  note: Maybe<Scalars["String"]["output"]>;
  /** Unix timestamp of the review. */
  timestamp: Scalars["Int"]["output"];
};

export enum IntentResourceOperationReviewDecision {
  Allow = "ALLOW",
  Deny = "DENY",
}

/** IntentResourceOperationState represents a discrete state of a operation on intent resource. */
export enum IntentResourceOperationState {
  /** The operation has failed. */
  Failed = "FAILED",
  /** The operation has finished successfully. */
  Finished = "FINISHED",
  /** The operation is pending execution. */
  Pending = "PENDING",
  /** The operation is pending for manual allow/deny. */
  PendingReview = "PENDING_REVIEW",
  /** The operation has reviewed and ready for execution. */
  ReadyForExecution = "READY_FOR_EXECUTION",
  /** An invalid "zero-value" for the intent resource operation state. */
  Unknown = "UNKNOWN",
}

export type IntentResourcesOperationConnection = {
  __typename?: "IntentResourcesOperationConnection";
  cursor: Scalars["String"]["output"];
  node: IntentResourceOperation;
};

export type KeyValuePair = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type KeyValuePairType = {
  __typename?: "KeyValuePairType";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** Possible Kubernetes entity types. */
export type KubernetesEntity = KubernetesResource | KubernetesRoot;

/** Metadata for a Kubernetes resource. */
export type KubernetesResource = {
  __typename?: "KubernetesResource";
  /** Data of the Kubernetes resource. */
  data: Scalars["String"]["output"];
};

/** Metadata for a Kubernetes infra root. */
export type KubernetesRoot = {
  __typename?: "KubernetesRoot";
  /**
   * This field exists solely for the purpose of adhering to the GraphQL spec,
   * which requires presence of at least one field in a type.
   */
  phantom: Scalars["Boolean"]["output"];
};

export enum KubernetesWorkflowTool {
  /** A custom workflow tool. */
  Custom = "CUSTOM",
  /** Standard workflow using kubectl. */
  Kubernetes = "KUBERNETES",
}

export type LicenseDateRange = {
  __typename?: "LicenseDateRange";
  /** Describes the start time of the license. */
  begin: Scalars["Int"]["output"];
  /** Describes the end time of the license. May be null if the license has no end date. */
  end: Maybe<Scalars["Int"]["output"]>;
};

export type LocalWorkspaceUpload = {
  __typename?: "LocalWorkspaceUpload";
  id: Scalars["ID"]["output"];
  /** HTTP headers that should be sent with the upload request. */
  uploadHeaders: Maybe<StringMap>;
  /** URL to upload the archived workspace to. */
  uploadUrl: Scalars["String"]["output"];
};

/** LogMessage represents a single log line. */
export type LogMessage = {
  __typename?: "LogMessage";
  /** Actual message. */
  message: Scalars["String"]["output"];
  /** Unix timestamp representing log line creation. */
  timestamp: Scalars["Int"]["output"];
};

export type LogsDownloadUrl = {
  __typename?: "LogsDownloadURL";
  /** Indicates the logs were deleted on demand. Implies expired. */
  deleted: Scalars["Boolean"]["output"];
  /** Indicates the logs have expired or were never written. */
  expired: Scalars["Boolean"]["output"];
  /** Indicates the run is still in the requested state and logs are not necessarily available yet. */
  ongoing: Scalars["Boolean"]["output"];
  /** Pre-signed URL to download the compacted logs. */
  url: Maybe<Scalars["String"]["output"]>;
};

/** LogsResponse is a response to a query for a batch of logs. */
export type LogsResponse = {
  __typename?: "LogsResponse";
  /** Whether the logs were deleted on demand. Implies expired. */
  deleted: Scalars["Boolean"]["output"];
  /** Whether the log stream even exists. */
  exists: Scalars["Boolean"]["output"];
  /** Whether the logs stream has expired. */
  expired: Scalars["Boolean"]["output"];
  /** Is the log stream finished. */
  finished: Scalars["Boolean"]["output"];
  /** Is more messages available. */
  hasMore: Scalars["Boolean"]["output"];
  /** List of messages. */
  messages: Array<LogMessage>;
  /** Token used to retrieve the next batch of log messages. */
  nextToken: Maybe<Scalars["String"]["output"]>;
  /** Indicates the run is still in the requested state and logs are not necessarily available yet. */
  ongoing: Scalars["Boolean"]["output"];
};

export type ManagedEntitiesConnection = {
  __typename?: "ManagedEntitiesConnection";
  cursor: Scalars["String"]["output"];
  node: ManagedEntity;
};

export type ManagedEntitiesGroup = {
  count: Scalars["Int"]["output"];
  drifted: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["Int"]["output"];
};

export type ManagedEntitiesGroupedByProviders = ManagedEntitiesGroup & {
  __typename?: "ManagedEntitiesGroupedByProviders";
  /** Number of resources belonging to this provider */
  count: Scalars["Int"]["output"];
  /** Number of drifted resources beloning to this provider */
  drifted: Scalars["Int"]["output"];
  /** Provider name */
  id: Scalars["ID"]["output"];
  /** Last updated resource belonging to this provider */
  updatedAt: Scalars["Int"]["output"];
};

export type ManagedEntitiesGroupedByProvidersConnection = {
  __typename?: "ManagedEntitiesGroupedByProvidersConnection";
  cursor: Scalars["String"]["output"];
  node: ManagedEntitiesGroupedByProviders;
};

export type ManagedEntitiesGroupedByStacks = ManagedEntitiesGroup & {
  __typename?: "ManagedEntitiesGroupedByStacks";
  /** Number of resources in this stack */
  count: Scalars["Int"]["output"];
  /** Number of drifted resources in this stack */
  drifted: Scalars["Int"]["output"];
  /** Stack ID */
  id: Scalars["ID"]["output"];
  /** Name of the stack to which the resource belongs */
  stackName: Scalars["String"]["output"];
  /** Space ID of the stack to which the resource belongs */
  stackSpaceID: Scalars["ID"]["output"];
  /** Space name of the stack to which the resource belongs */
  stackSpaceName: Scalars["String"]["output"];
  /** Vendor of the stack to which the resource belongs */
  stackVendor: StackVendor;
  /** Last updated resource in this stack */
  updatedAt: Scalars["Int"]["output"];
};

export type ManagedEntitiesGroupedByStacksConnection = {
  __typename?: "ManagedEntitiesGroupedByStacksConnection";
  cursor: Scalars["String"]["output"];
  node: ManagedEntitiesGroupedByStacks;
};

export type ManagedEntitiesGroupedByTypes = ManagedEntitiesGroup & {
  __typename?: "ManagedEntitiesGroupedByTypes";
  /** Number of resources of this type */
  count: Scalars["Int"]["output"];
  /** Number of drifted resources of this type */
  drifted: Scalars["Int"]["output"];
  /** Resource type */
  id: Scalars["ID"]["output"];
  /** Last updated resource of this type */
  updatedAt: Scalars["Int"]["output"];
};

export type ManagedEntitiesGroupedByTypesConnection = {
  __typename?: "ManagedEntitiesGroupedByTypesConnection";
  cursor: Scalars["String"]["output"];
  node: ManagedEntitiesGroupedByTypes;
};

/** Managed infrastructure entity */
export type ManagedEntity = {
  __typename?: "ManagedEntity";
  /** Address of the ManagedEntity in the module. */
  address: Scalars["String"]["output"];
  /** Run which created this entity. */
  creator: Maybe<Run>;
  /** Unix timestamp of when drift was detected on this entity, if ever. */
  drifted: Maybe<Scalars["Int"]["output"]>;
  /** ID of the ManagedEntity in Spacelift. */
  id: Scalars["ID"]["output"];
  /** ManagedEntity Name. */
  name: Scalars["String"]["output"];
  /** Parent of this entity. May be a module or may be another entity. */
  parent: Scalars["String"]["output"];
  /** Stack id of this entity. */
  stackId: Scalars["ID"]["output"];
  /** Stack name of this entity. */
  stackName: Scalars["String"]["output"];
  /** Stack vendor of this entity. */
  stackVendor: StackVendor;
  /** Custom metadata attached to the entity by a third-party integration. */
  thirdPartyMetadata: Maybe<Scalars["String"]["output"]>;
  /** ManagedEntity Type. */
  type: Scalars["String"]["output"];
  /** UpdatedAt is unix timestamp (in seconds) at which the entity was updated */
  updatedAt: Scalars["Int"]["output"];
  /** Run which last updated this entity. */
  updater: Maybe<Run>;
  /** Vendor specific metadata of this entity. */
  vendor: EntityVendor;
};

/** Managed infrastructure entity V2 */
export type ManagedEntityV2 = {
  __typename?: "ManagedEntityV2";
  /** Address of the ManagedEntity in the module. */
  address: Scalars["String"]["output"];
  /** Run which created this entity. */
  creator: Maybe<Run>;
  /** Unix timestamp of when drift was detected on this entity, if ever. */
  drifted: Maybe<Scalars["Int"]["output"]>;
  /** ID of the ManagedEntity in Spacelift. */
  id: Scalars["ID"]["output"];
  /** ManagedEntity Name. */
  name: Scalars["String"]["output"];
  /** Parent of this entity. May be a module or may be another entity. */
  parent: Scalars["String"]["output"];
  /** Custom metadata attached to the entity by a third-party integration. */
  thirdPartyMetadata: Maybe<Scalars["String"]["output"]>;
  /** ManagedEntity Type. */
  type: Scalars["String"]["output"];
  /** Run which last updated this entity. */
  updater: Maybe<Run>;
};

/** This represent a managed state version */
export type ManagedStateVersion = {
  __typename?: "ManagedStateVersion";
  /** The unique ID of the state version */
  id: Scalars["ID"]["output"];
  /** True if the state has been manually imported */
  imported: Scalars["Boolean"]["output"];
  /** When the version is a rollback to a manually imported state this will be set to imported state timestamp */
  importedTimestamp: Maybe<Scalars["Int"]["output"]>;
  /** The username that initiated the import */
  importedUsername: Maybe<Scalars["String"]["output"]>;
  /** Unix timestamp of the last time the state has been modified */
  lastModified: Scalars["Int"]["output"];
  /** Indicate if this state is a rollback */
  rollback: Scalars["Boolean"]["output"];
  /** The username that initiated the rollback */
  rollbackUsername: Maybe<Scalars["String"]["output"]>;
  /**
   * Represents the run that has generated the current version of the state
   * If the version is a rollback, the run will be the one that generated the rolled back version
   */
  run: Maybe<Run>;
  /** The size of the state in bytes */
  size: Scalars["Int"]["output"];
};

/** ManagedStateVersionConnection represents a single worker pool in a page of results. */
export type ManagedStateVersionConnection = {
  __typename?: "ManagedStateVersionConnection";
  cursor: Scalars["String"]["output"];
  node: ManagedStateVersion;
};

export type ManagedStateVersionOutput = {
  __typename?: "ManagedStateVersionOutput";
  edges: Array<ManagedStateVersionConnection>;
  pageInfo: PageInfo;
};

export type ManagedUser = {
  __typename?: "ManagedUser";
  /** List of permissions given explicitly to given user. */
  accessRules: Array<SpaceAccessRule>;
  /** Number of groups in your identity provider that this user was a member of on last login. */
  groupCount: Scalars["Int"]["output"];
  /** Globally unique, immutable ID of ManagedUser. */
  id: Scalars["ID"]["output"];
  /** Email through which user was invited to given account. Can be empty. */
  invitationEmail: Maybe<Scalars["String"]["output"]>;
  /** Unix timestamp (in seconds) at which user has last authenticated. */
  lastLoginTime: Maybe<Scalars["Int"]["output"]>;
  /** Groups in your identity provider that this user was a member of on last login. */
  latestGroups: Array<Scalars["String"]["output"]>;
  /** Invitation details for the latest invitation sent to given user. Can be empty. */
  latestInvitation: Maybe<ManagedUserInvitation>;
  /** Identity provider used for authenticating given user. */
  loginMethod: IdentityProvider;
  /** Personal API keys owned by this user. Root admins only. */
  personalApiKeys: Array<ApiKey>;
  /** Role describes if user is an admin or ordinary user. */
  role: UserRole;
  /** Names of groups the user is a SCIM-provisioned member of. */
  scimGroupMemberships: Array<Scalars["String"]["output"]>;
  /** SCIM metadata for users provisioned via SCIM. Null if not SCIM-provisioned. */
  scimMetadata: Maybe<ScimUserMetadata>;
  /** ID of slack user that will have the same permissions as given managed user when using Spacelift through Slack integration. */
  slackMemberID: Maybe<Scalars["String"]["output"]>;
  /** Number of spaces user was explicitly given permissions to. */
  spaceCount: Scalars["Int"]["output"];
  /** Status is user status. */
  status: UserStatus;
  /** Roles that are binded to this user. */
  userRoleBindings: Array<UserRoleBinding>;
  /** Username from account's identity provider. */
  username: Scalars["String"]["output"];
};

export type ManagedUserGroup = {
  __typename?: "ManagedUserGroup";
  /** List of permissions given explicitly to given user group. */
  accessRules: Array<SpaceAccessRule>;
  /** Description is optional, user-provided text describing the group resource or serving as a human-readable name. */
  description: Scalars["String"]["output"];
  /** Name of user group from account's identity provider. */
  groupName: Scalars["String"]["output"];
  /** Globally unique, immutable ID of ManagedUserGroup. */
  id: Scalars["ID"]["output"];
  /** Identity provider authorized with group permissions. */
  identityProvider: IdentityProvider;
  /** Unix timestamp (in seconds) at which user from this group was last authenticated. */
  lastLoginTime: Maybe<Scalars["Int"]["output"]>;
  /** Members of this group, returned as ManagedUser resolvers. */
  managedUsers: Array<ManagedUser>;
  /** Number of members of this group who logged into this account. */
  memberCount: Scalars["Int"]["output"];
  /** Members of this group */
  members: Array<Scalars["String"]["output"]>;
  /** SCIM metadata for groups provisioned via SCIM. Null if not SCIM-provisioned. */
  scimMetadata: Maybe<ScimGroupMetadata>;
  /** Number of spaces user group was explicitly given permissions to. */
  spaceCount: Scalars["Int"]["output"];
  /** Status is user group status. */
  status: UserGroupStatus;
  /** List of user group role bindings for this group. */
  userRoleBindings: Array<UserGroupRoleBinding>;
};

export type ManagedUserGroupCreateInput = {
  /** new access rules */
  accessRules: Array<SpaceAccessRuleInput>;
  description: InputMaybe<Scalars["String"]["input"]>;
  groupName: Scalars["String"]["input"];
};

export type ManagedUserGroupCreateInputV2 = {
  description: InputMaybe<Scalars["String"]["input"]>;
  groupName: Scalars["String"]["input"];
  roleBindings: Array<RoleBindingInput>;
};

export type ManagedUserGroupIntegration = {
  __typename?: "ManagedUserGroupIntegration";
  /** List of permissions given explicitly to given user group. */
  accessRules: Array<SpaceAccessRule>;
  /** Globally unique, immutable ID of ManagedUserGroupIntegration. */
  id: Scalars["ID"]["output"];
  /** Human-readable name of the integration. */
  integrationName: Scalars["String"]["output"];
  /** Specifies which fields of this integration are relevant and how they should be utilized. */
  integrationType: ManagedUserGroupIntegrationType;
  /** ID of slack channel that this ManagedUserGroupIntegration provides permissions to. */
  slackChannelID: Maybe<Scalars["String"]["output"]>;
};

export type ManagedUserGroupIntegrationCreateInput = {
  /** new access rules */
  accessRules: Array<SpaceAccessRuleInput>;
  /** user-picked human-readable integration name used for display purposes */
  integrationName: Scalars["String"]["input"];
  /** type of integration that should be created */
  integrationType: ManagedUserGroupIntegrationType;
  /** id of slack channel that should be granted specified permissions */
  slackChannelID: Scalars["String"]["input"];
};

export enum ManagedUserGroupIntegrationType {
  Slack = "SLACK",
}

export type ManagedUserGroupIntegrationUpdateInput = {
  /** new access rules */
  accessRules: Array<SpaceAccessRuleInput>;
  /** unique identifier of modified user group integration */
  id: Scalars["ID"]["input"];
  /** user-picked human-readable integration name used for display purposes */
  integrationName: Scalars["String"]["input"];
  /** id of slack channel that should be granted specified permissions */
  slackChannelID: Scalars["String"]["input"];
};

export type ManagedUserGroupUpdateInput = {
  /** new access rules */
  accessRules: Array<SpaceAccessRuleInput>;
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Globally unique, immutable ID of ManagedUserGroup. */
  id: Scalars["ID"]["input"];
};

export type ManagedUserGroupUpdateInputV2 = {
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Globally unique, immutable ID of ManagedUserGroup. */
  id: Scalars["ID"]["input"];
};

export type ManagedUserInvitation = {
  __typename?: "ManagedUserInvitation";
  /** Unix timestamp (in seconds) at which this invitation was issued. */
  createdAt: Scalars["Int"]["output"];
  /** Unix timestamp (in seconds) at which the invitation was sent. Can be empty for unsent invitations. */
  sentAt: Maybe<Scalars["Int"]["output"]>;
};

export type ManagedUserInviteInput = {
  /** Access rules for the user. */
  accessRules: Array<SpaceAccessRuleInput>;
  /** Email address of the user to invite. */
  email: InputMaybe<Scalars["String"]["input"]>;
  /** Email address of the user to invite. */
  invitationEmail: InputMaybe<Scalars["String"]["input"]>;
  /** new slack member ID */
  slackMemberID: InputMaybe<Scalars["String"]["input"]>;
  /** Unique identifier of a user within an identity provider. */
  username: Scalars["String"]["input"];
};

export type ManagedUserInviteInputV2 = {
  /** Email address of the user to invite. */
  invitationEmail: InputMaybe<Scalars["String"]["input"]>;
  /** Access rules for the user. */
  roleBindings: Array<RoleBindingInput>;
  /** new slack member ID */
  slackMemberID: InputMaybe<Scalars["String"]["input"]>;
  /** Unique identifier of a user within an identity provider. */
  username: Scalars["String"]["input"];
};

export type ManagedUserUpdateInput = {
  /** new access rules */
  accessRules: Array<SpaceAccessRuleInput>;
  /** Globally unique, immutable ID of ManagedUser to update. */
  id: Scalars["ID"]["input"];
  /** new slack member ID */
  slackMemberID: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * MessageQueueStats is a point-in-time snapshot of how many messages a single
 * queue currently holds. Surfaces only the two signals that drive the
 * parallelism decision: messages ready to be picked up and messages already in
 * flight. The UI can sum them for a "current load" display.
 */
export type MessageQueueStats = {
  __typename?: "MessageQueueStats";
  /** The kind of backend serving this queue (e.g. "postgres", "aws_sqs"). */
  clientType: Scalars["String"]["output"];
  /** Messages received but not yet acked or deleted. */
  inFlight: Scalars["Int"]["output"];
  /** Stable queue name, suitable for display (e.g. "async-jobs", "dlq"). */
  queueName: Scalars["String"]["output"];
  /** Messages ready to be received. */
  visible: Scalars["Int"]["output"];
};

export type MetricsInput = {
  /** End time of the metrics */
  endTime: Scalars["Int"]["input"];
  /** Start time of the metrics */
  startTime: Scalars["Int"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type Module = {
  __typename?: "Module";
  /** Administrative modules can manage other Stacks at runtime. */
  administrative: Scalars["Boolean"]["output"];
  /**
   * API host, useful for building links in the GUI. It may be empty if the
   * Module's original VCS provider has been removed.
   */
  apiHost: Maybe<Scalars["String"]["output"]>;
  /** List of aws integrations that can be attached to this Module. */
  attachableAwsIntegrations: Array<AwsIntegration>;
  /** List of azure integrations that can be attached to this Module. */
  attachableAzureIntegrations: Array<AzureIntegration>;
  /** List of contexts that can be attached to this Module. */
  attachableContexts: Array<Context>;
  /** List of policies that can be attached to this Module. */
  attachablePolicies: Array<Policy>;
  /** List of vcs integrations that can be attached to this Module. */
  attachableVcsIntegrations: Array<VcsIntegration>;
  /** List of worker pools that can be attached to this Module. */
  attachableWorkerPools: Array<WorkerPool>;
  /** List of Azure integrations attached to this Module. */
  attachedAzureIntegrations: Array<StackAzureIntegrationAttachment>;
  /** List of contexts attached to this Module. */
  attachedContexts: Array<StackContextAttachment>;
  /** List of policies attached to this Module. */
  attachedPolicies: Array<StackPolicyAttachment>;
  /** Git branch of the repo that the Module is tracking. */
  branch: Scalars["String"]["output"];
  /** Whether the user has read privileges for this Module. */
  canRead: Scalars["Boolean"]["output"];
  /** Whether the user has write privileges for this Module. */
  canWrite: Scalars["Boolean"]["output"];
  /** Full list of module config elements. */
  config: Array<ConfigElement>;
  /** Single Module config element. */
  configElement: Maybe<ConfigElement>;
  /** Timestamp representing the module creation. */
  createdAt: Scalars["Int"]["output"];
  /** Current module version. */
  current: Maybe<Version>;
  /** Free-form module description for the users, supports Markdown. */
  description: Maybe<Scalars["String"]["output"]>;
  /**
   * The list of paths that are used for sparse checkout, if any. If empty sparse checkout is not used - whole repository is checked out.
   * Note: this field is only used if git checkout is enabled. See https://docs.spacelift.io/concepts/stack/stack-settings#labels
   */
  gitSparseCheckoutPaths: Maybe<Array<Scalars["String"]["output"]>>;
  /** Indicates whether the GitHub Checks "Deploy" action is enabled. */
  githubActionDeploy: Scalars["Boolean"]["output"];
  /** Unique (within a single organization), immutable name of the Module. */
  id: Scalars["ID"]["output"];
  /** Integrations between a Module and external systems. */
  integrations: Maybe<StackIntegrations>;
  /** If module is disabled, it will not be able to create any runs. */
  isDisabled: Scalars["Boolean"]["output"];
  /** Labels applied to a Module. */
  labels: Array<Scalars["String"]["output"]>;
  /**
   * LastPulledAt is unix timestamp (in seconds) at which any version of this module was
   * most recently downloaded. Null if no version has ever been pulled. For shared or
   * public modules this timestamp reflects usage across all consumers, not just the
   * requesting account.
   */
  lastPulledAt: Maybe<Scalars["Int"]["output"]>;
  /** Latest module version. */
  latest: Maybe<Version>;
  /** Whether triggering local workspace based Versions on this Module is enabled. */
  localPreviewEnabled: Scalars["Boolean"]["output"];
  /** List of the accounts and spaces which have access to the Module. */
  moduleShares: Array<ModuleShare>;
  /** The value to use for the Terraform `source` property when accessing the module. */
  moduleSource: Scalars["String"]["output"];
  /** Provider-independent name of the Terraform module. */
  name: Scalars["String"]["output"];
  /** Repository namespace. */
  namespace: Scalars["String"]["output"];
  /**
   * Subdomain of the account owner - if the module is owned by another account
   * and just shared with the current one, this will be used to point the user
   * to the "canonical" location of the module.
   */
  ownerSubdomain: Scalars["String"]["output"];
  /** Retrieve module policy attachment by a known ID. */
  policyAttachment: Maybe<StackPolicyAttachment>;
  /**
   * Project root is the optional directory relative to the workspace root
   * containing the root directory of the module.
   */
  projectRoot: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether deletion protection is currently "on" for the stack. */
  protectFromDeletion: Scalars["Boolean"]["output"];
  /** Provider of the repository */
  provider: VcsProvider;
  /**
   * Public indicates that the Module is shared with the entire world. Public Modules
   * cannot be deleted or marked private.
   */
  public: Scalars["Boolean"]["output"];
  /**
   * List of up to 50 most recent open Pull Requests targeting Module's tracked
   * branch.
   */
  pullRequests: Array<PullRequest>;
  /** GitHub repository tracked by this Module, as account/repo. */
  repository: Scalars["String"]["output"];
  /** A list of tags for the tracked repository. */
  repositoryTags: Array<Scalars["String"]["output"]>;
  /** Git repository URL tracked by this Module. */
  repositoryURL: Maybe<Scalars["String"]["output"]>;
  /** Individual Run (or task) by ID. */
  run: Maybe<Run>;
  /** Optional runner image used to process the module metadata during parsing Run. */
  runnerImage: Maybe<Scalars["String"]["output"]>;
  /**
   * List of runs from a start timestamp inclusive to an end timestamp exclusive.
   * Caveat: It uses Ints serialized to Strings, because serializing Ints to JSON
   * is apparently really hard in JavaScript.
   * Also, note that the maximum supported range is 8 days (691,200 seconds).
   */
  runsInRange: Array<Run>;
  /**
   * Calculated runtime config containing elements coming from contexts,
   * Module and various integrations.
   */
  runtimeConfig: Array<ConfigElementWithSource>;
  searchModuleVersions: SearchVersionsOutput;
  searchModuleVersionsSuggestions: SearchSuggestionsOutput;
  /**
   * List of the accounts (subdomains) which have access to the Module.
   * @deprecated Use moduleShares field instead.
   */
  sharedAccounts: Array<Scalars["String"]["output"]>;
  /** Whether vendor binary downloads should be skipped during runs. */
  skipVendorBinaryDownload: Scalars["Boolean"]["output"];
  /** ID of the space this Module belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this Module belongs to. */
  spaceDetails: Space;
  /** Is the module starred by the current user. */
  starred: Scalars["Boolean"]["output"];
  /** TerraformProvider represents Module's Terraform provider */
  terraformProvider: Scalars["String"]["output"];
  /**
   * The VCS integration used by this module. This may either be a default integration,
   * or a space-level integration. If a space-level integration is being used by the module,
   * and that integration is deleted, this property will be null. Additionally, if the
   * module is using a default integration, and none exists, this property will be null.
   */
  vcsIntegration: Maybe<VcsIntegration>;
  /** Retrieve a single Version by its ID. */
  version: Maybe<Version>;
  /** Find a Version by either its ID or version number. */
  versionFind: Maybe<Version>;
  /**
   * Paginate through all Versions of the current Module. By default, only
   * ACTIVE and PENDING versions are shown, but setting includeFailed to true
   * will show all versions.
   */
  versions: Array<Version>;
  /**
   * VersionsCount returns the number of versions of the module in a specified state.
   * If state is not provided, it will return the count of active versions.
   */
  versionsCount: Scalars["Int"]["output"];
  /**
   * WorkerPool associated with the Module, if any. If the Module is associated
   * with the shared default worker pool, this field is empty.
   */
  workerPool: Maybe<WorkerPool>;
  /** The tool used by the stack for executing workflow stages. */
  workflowTool: TerraformWorkflowTool;
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleConfigElementArgs = {
  id: Scalars["ID"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type ModulePolicyAttachmentArgs = {
  id: Scalars["ID"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleRunArgs = {
  id: Scalars["ID"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleRunsInRangeArgs = {
  end: Scalars["String"]["input"];
  start: Scalars["String"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleSearchModuleVersionsArgs = {
  input: SearchInput;
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleSearchModuleVersionsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleVersionArgs = {
  id: Scalars["ID"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleVersionFindArgs = {
  term: Scalars["String"]["input"];
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleVersionsArgs = {
  before: InputMaybe<Scalars["ID"]["input"]>;
  includeFailed: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Module is a versioned and tested reusable collection of resources */
export type ModuleVersionsCountArgs = {
  state: InputMaybe<VersionState>;
};

/** ModuleConnection represents a single module in a page of results. */
export type ModuleConnection = {
  __typename?: "ModuleConnection";
  cursor: Scalars["String"]["output"];
  node: Module;
};

/** All arguments to create an individual Module. */
export type ModuleCreateInput = {
  /** Module name. */
  name: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Namespace is the optional namespace which the repository belongs to. If not
   * provided, the name of the linked GitHub account is used.
   */
  namespace: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Provider is the optional VCS provider that provides access to the Git
   * repository linked to the Module.
   */
  provider: InputMaybe<VcsProvider>;
  /** Name of the repository to track. */
  repository: Scalars["String"]["input"];
  /** URL of the repository to track. */
  repositoryURL: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the Space this Stack should be in. */
  space: InputMaybe<Scalars["ID"]["input"]>;
  /** Terraform provider for which this module is meant. */
  terraformProvider: InputMaybe<Scalars["String"]["input"]>;
  updateInput: ModuleUpdateInput;
  /**
   * The ID of the VCS integration used by this stack. This should only be provided if the default (account-level)
   * integration is not being used (i.e. a space-level integration is being used).
   */
  vcsIntegrationId: InputMaybe<Scalars["ID"]["input"]>;
  /** Defines the tool that will be used to execute the workflow. */
  workflowTool: InputMaybe<TerraformWorkflowTool>;
};

/** ModuleInput represents a single module input variable in ModuleMetadata. */
export type ModuleInput = {
  __typename?: "ModuleInput";
  default: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  type: Scalars["String"]["output"];
};

/** ModuleMetadata represents a root module or a submodule within the module repository. */
export type ModuleMetadata = {
  __typename?: "ModuleMetadata";
  changelog: Scalars["String"]["output"];
  dependencies: Array<Scalars["String"]["output"]>;
  empty: Scalars["Boolean"]["output"];
  inputs: Array<ModuleInput>;
  name: Scalars["String"]["output"];
  outputs: Array<ModuleOutput>;
  path: Scalars["String"]["output"];
  providerDependencies: Array<ModuleProviderDependency>;
  readme: Scalars["String"]["output"];
  resources: Array<ModuleResource>;
};

/** ModuleOutput represents a single module output in ModuleMetadata. */
export type ModuleOutput = {
  __typename?: "ModuleOutput";
  description: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

/** ModuleProviderDependency represents a single module's provider dependency. */
export type ModuleProviderDependency = {
  __typename?: "ModuleProviderDependency";
  name: Scalars["String"]["output"];
  namespace: Scalars["String"]["output"];
  source: Scalars["String"]["output"];
  version: Scalars["String"]["output"];
};

/** ModuleRepositoryMetadata represents the entire module repository metadata. */
export type ModuleRepositoryMetadata = {
  __typename?: "ModuleRepositoryMetadata";
  examples: Array<ModuleMetadata>;
  root: ModuleMetadata;
  submodules: Array<ModuleMetadata>;
};

/** ModuleResource represents a single resource managed by a module. */
export type ModuleResource = {
  __typename?: "ModuleResource";
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ModuleShare = {
  __typename?: "ModuleShare";
  /** Source of the module share (where it's shared from). */
  from: ModuleShareScope;
  /** Unique identifier of the module share. */
  id: Scalars["ID"]["output"];
  /** Module information for the shared item. */
  module: ModuleShareModule;
  /** Target of the module share (where it's shared to). */
  to: ModuleShareScope;
};

export type ModuleShareAccount = {
  __typename?: "ModuleShareAccount";
  subdomain: Scalars["String"]["output"];
};

export type ModuleShareInput = {
  accounts: Array<Scalars["ID"]["input"]>;
  spaces: Array<Scalars["ID"]["input"]>;
};

export type ModuleShareModule = {
  __typename?: "ModuleShareModule";
  current: Maybe<SharedVersion>;
  description: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  latest: Maybe<SharedVersion>;
  name: Scalars["String"]["output"];
};

export type ModuleShareScope = {
  __typename?: "ModuleShareScope";
  /** Account information, if the sharing scope is an account. */
  account: ModuleShareAccount;
  /** Space information, if the sharing scope is a space. */
  space: Maybe<ModuleShareSpace>;
};

/**
 * ModuleShareSpace is a deliberately restricted projection on a Space. It exposes
 * only non-sensitive fields.
 * A module share is visible to users in the TARGET space, who may have no access to the SOURCE space.
 * Using the full `Space` type here leaked source-space details (description, labels, inheritEntities,
 * access rules) to those principals regardless of their access level, because
 * Space's field resolvers do not gate on access level. Narrowing the type makes
 * the sensitive fields impossible to query.
 * See https://app.clickup.com/t/869dzpd8k
 */
export type ModuleShareSpace = {
  __typename?: "ModuleShareSpace";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  parentSpace: Maybe<Scalars["ID"]["output"]>;
};

/** Arguments used to create and update an individual Module. */
export type ModuleUpdateInput = {
  /** Administrative stacks can manage other Stacks at runtime. */
  administrative: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Name of the branch to track. */
  branch: Scalars["String"]["input"];
  /** Optional free-form description of the Module. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The list of paths that are used for sparse checkout, if any. If empty sparse checkout is not used - whole repository is checked out.
   * Note: this field is only used if git checkout is enabled. See https://docs.spacelift.io/concepts/stack/stack-settings#labels
   */
  gitSparseCheckoutPaths: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** When set to true, the "Deploy" action will be enabled on GitHub Checks Run (default: true). */
  githubActionDeploy: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When set to true, the module will not be able to create runs. */
  isDisabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional list of Module labels. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether triggering local workspace based Versions on this Module is enabled */
  localPreviewEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Project root is the optional directory relative to the workspace root
   * containing the root directory of the module.
   */
  projectRoot: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether deletion protection is currently "on" for the module. */
  protectFromDeletion: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional runner image used to process the module metadata during parsing Run. */
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  /** Optional list of the accounts (subdomains) which have access to the Module. */
  sharedAccounts: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether vendor binary downloads should be skipped during runs. */
  skipVendorBinaryDownload: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ID of the Space this Stack should be in. */
  space: InputMaybe<Scalars["ID"]["input"]>;
  /** ID of the worker pool for the Module to use. */
  workerPool: InputMaybe<Scalars["ID"]["input"]>;
};

/** Arguments used to update an individual Module. */
export type ModuleUpdateV2Input = {
  /** Administrative stacks can manage other Stacks at runtime. */
  administrative: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Name of the branch to track. */
  branch: Scalars["String"]["input"];
  /** Optional free-form description of the Module. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The list of paths that are used for sparse checkout, if any. If empty sparse checkout is not used - whole repository is checked out.
   * Note: this field is only used if git checkout is enabled. See https://docs.spacelift.io/concepts/stack/stack-settings#labels
   */
  gitSparseCheckoutPaths: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** When set to true, the "Deploy" action will be enabled on GitHub Checks Run (default: true). */
  githubActionDeploy: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional list of Module labels. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether triggering local workspace based Versions on this Module is enabled. */
  localPreviewEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Namespace is the optional namespace which the repository belongs to. If not
   * provided, the name of the linked GitHub account is used.
   */
  namespace: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Project root is the optional directory relative to the workspace root
   * containing the root directory of the module.
   */
  projectRoot: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether deletion protection is currently "on" for the module. */
  protectFromDeletion: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Provider is the optional VCS provider that provides access to the Git
   * repository linked to the Module.
   */
  provider: InputMaybe<VcsProvider>;
  /** Name of the repository to track. */
  repository: Scalars["String"]["input"];
  /** Optional URL of the repository to track. */
  repositoryURL: InputMaybe<Scalars["String"]["input"]>;
  /** Optional runner image used to process the module metadata during parsing Run. */
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  /** Optional list of the accounts (subdomains) which have access to the Module. */
  sharedAccounts: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether vendor binary downloads should be skipped during runs. */
  skipVendorBinaryDownload: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ID of the Space this Stack should be in. */
  space: InputMaybe<Scalars["ID"]["input"]>;
  /**
   * The ID of the VCS integration used by this stack. This should only be provided if the default (account-level)
   * integration is not being used (i.e. a space-level integration is being used).
   */
  vcsIntegrationId: InputMaybe<Scalars["ID"]["input"]>;
  /** ID of the worker pool for the Module to use. */
  workerPool: InputMaybe<Scalars["ID"]["input"]>;
  /** Defines the tool that will be used to execute the workflow. */
  workflowTool: InputMaybe<TerraformWorkflowTool>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Delete the account */
  accountConfirmDelete: Scalars["Boolean"]["output"];
  /** Request an admin to enable Infra Assistant for the account */
  accountRequestInfraAssistantEnabling: Scalars["Boolean"]["output"];
  /** Request an admin to enable personal API keys for the account */
  accountRequestPersonalApiKeysEnabling: Scalars["Boolean"]["output"];
  /** Set Infra Assistant build mode enabled state. Requires T&C to be accepted first. */
  accountSetInfraAssistantBuildModeEnabled: Scalars["Boolean"]["output"];
  /** Set Infra Assistant enabled state. Requires T&C to be accepted first. */
  accountSetInfraAssistantEnabled: Scalars["Boolean"]["output"];
  /** Replace the account's custom OAuth2 redirect host allowlist (exact hostnames or "*.subdomain" wildcards) */
  accountSetOAuthRedirectAllowlist: Array<Scalars["String"]["output"]>;
  /** Set the OIDC subject template for the account */
  accountSetOIDCSubjectTemplate: Maybe<Scalars["String"]["output"]>;
  /**
   * Allow or refuse personal API key creation for the account. With enabled false
   * and disableExistingKeys true, every personal key on the account is disabled.
   */
  accountSetPersonalApiKeysEnabled: Scalars["Boolean"]["output"];
  /** Set Spacelift Intelligence enabled state. Enabling implies acceptance of the Spacelift Intelligence Terms of Use and enables all sub-features. */
  accountSetSpaceliftIntelligenceEnabled: Scalars["Boolean"]["output"];
  /**
   * Enable/disable API key creation from non-human sessions.
   * When enabled, non-human sessions (API keys, Admin Stacks) can manage API keys.
   */
  accountToggleAPIKeyManagementFromNonHumans: Scalars["Boolean"]["output"];
  /** Allow/Disallow non-root admins to create subspaces. */
  accountToggleAllowNonRootAdminSpaceCreation: Scalars["Boolean"]["output"];
  /** Mark/unmark the Account for deletion. */
  accountToggleDeletionMark: Scalars["Boolean"]["output"];
  /** Enable/disable enforcing MFA for the Account. */
  accountToggleEnforcingMFA: Scalars["Boolean"]["output"];
  /** Update the authorization schema used by the account */
  accountUpdateAuthorizationScheme: AuthorizationScheme;
  /** Update Account's Awareness Source */
  accountUpdateAwarenessSourceSurvey: Maybe<AwarenessSourceSurvey>;
  /** Update Account's default public worker pool runner image */
  accountUpdateDefaultWorkerPoolRunnerImages: Maybe<AccountUpdateDefaultWorkerPoolRunnerImagesResult>;
  /** Update Account's Security Email */
  accountUpdateSecurityEmail: Scalars["String"]["output"];
  /** Update limit of runs created by a single VCS event for this account */
  accountUpdateVCSEventTriggeredRunsLimit: Maybe<Scalars["Int"]["output"]>;
  /** Create an AI integration. */
  aiIntegrationCreate: AiIntegration;
  /** Delete an AI integration. */
  aiIntegrationDelete: Maybe<AiIntegration>;
  /**
   * Enable or disable an AI integration for the calling account. Works for both
   * account-owned and shared Spacelift-provided integrations. Enabling a
   * Spacelift-provided integration requires Spacelift Intelligence to be on.
   * Disabling one is always allowed, so an account can opt out before it turns
   * Spacelift Intelligence on.
   */
  aiIntegrationToggle: AiIntegration;
  /**
   * Update an AI integration. Spacelift-provided integrations are managed and
   * cannot be updated through this mutation.
   */
  aiIntegrationUpdate: AiIntegration;
  /** Create an API key. */
  apiKeyCreate: ApiKey;
  /** Delete an API key. */
  apiKeyDelete: Maybe<ApiKey>;
  /**
   * Enable/disable non-root managers for API keys. Settings this to true means
   * that admins of non-root spaces can create an API key up to their current
   * level of permissions. Also, if this is set to true, then the API key
   * creator can delete the API key regardless of their current permissions.
   */
  apiKeyEnableNonRootManagers: Scalars["Boolean"]["output"];
  /** Reset the secret of an API key. */
  apiKeyReset: Maybe<ApiKey>;
  apiKeyRoleBindingBatchCreate: Array<ApiKeyRoleBinding>;
  apiKeyRoleBindingCreate: ApiKeyRoleBinding;
  apiKeyRoleBindingDelete: Maybe<ApiKeyRoleBinding>;
  apiKeyRoleBindingUpdate: ApiKeyRoleBinding;
  /** Update an API key. */
  apiKeyUpdate: ApiKey;
  /** Exchange an API token for a Spacelift User. */
  apiKeyUser: Maybe<User>;
  /** Delete audit trail webhook. */
  auditTrailDeleteWebhook: Maybe<AuditTrailWebhook>;
  /** Set audit trail webhook for the Account. */
  auditTrailSetWebhook: AuditTrailWebhook;
  auditTrailWebhookDeleteHeaders: AuditTrailWebhook;
  auditTrailWebhookSetHeaders: AuditTrailWebhook;
  /**
   * Attaches the specified AWS integration to a Stack. Note that at least one of either the 'read'
   * or 'write' parameters must be true, and a Stack can have at most one read, and one write attachment.
   * A single integration can be attached for both read and write.
   */
  awsIntegrationAttach: AwsIntegrationStackAttachment;
  /** Updates an AWS integration attachment. */
  awsIntegrationAttachmentUpdate: AwsIntegrationStackAttachment;
  /** Creates an AWS integration. */
  awsIntegrationCreate: AwsIntegration;
  /** Deletes the integration with the specified ID. */
  awsIntegrationDelete: Maybe<AwsIntegration>;
  /** Detaches an AWS integration from a Stack, using the unique ID of the attachment. */
  awsIntegrationDetach: Maybe<AwsIntegrationStackAttachment>;
  /** Attach AWS integration to an intent project. */
  awsIntegrationIntentProjectAttach: AwsIntegrationIntentProjectAttachment;
  /** Detach AWS integration from an intent project. */
  awsIntegrationIntentProjectDetach: AwsIntegrationIntentProjectAttachment;
  /** Updates the integration with the specified ID. */
  awsIntegrationUpdate: AwsIntegration;
  /** Creates the Azure DevOps Repo integration. */
  azureDevOpsRepoIntegrationCreate: AzureDevOpsRepoIntegration;
  /** Deletes the Azure DevOps Repo integration. */
  azureDevOpsRepoIntegrationDelete: Maybe<AzureDevOpsRepoIntegration>;
  /** Tests the Azure DevOps Repo integration. */
  azureDevOpsRepoIntegrationTest: Scalars["Boolean"]["output"];
  /** Updates the Azure DevOps Repo integration with new properties. */
  azureDevOpsRepoIntegrationUpdate: AzureDevOpsRepoIntegration;
  /**
   * Attaches the specified Azure integration to a Stack. Note that at least one of either the 'read'
   * or 'write' parameters must be true, and a Stack can have at most one read, and one write attachment.
   * A single integration can be attached for both read and write. The subscriptionId can be
   * set when attaching an integration to override the default Azure subscription Id configured
   * against the integration.
   */
  azureIntegrationAttach: AzureIntegrationStackAttachment;
  /** Updates an Azure integration attachment. */
  azureIntegrationAttachmentUpdate: AzureIntegrationStackAttachment;
  /** Creates an Azure integration. */
  azureIntegrationCreate: AzureIntegration;
  /** Deletes the integration with the specified ID. */
  azureIntegrationDelete: Maybe<AzureIntegration>;
  /** Detaches an Azure integration from a Stack, using the unique ID of the attachment. */
  azureIntegrationDetach: Maybe<AzureIntegrationStackAttachment>;
  /** Updates the integration with the specified ID. */
  azureIntegrationUpdate: AzureIntegration;
  /**
   * Creates a new billing subscription
   * addons argument can be ignored because it has not implemented yet.
   */
  billingSubscriptionCreate: BillingSubscription;
  /** Cancels current subscription */
  billingSubscriptionDelete: Maybe<BillingSubscription>;
  /** Updates the billing info of an existing subscription */
  billingSubscriptionUpdateInfo: BillingSubscription;
  /** Updates the billing tier of an existing billing subscription */
  billingSubscriptionUpdateTier: BillingSubscription;
  /** Updates an existing billing subscription */
  billingSubscriptionUpdateV2: BillingSubscription;
  /** Creates the Bitbucket Cloud integration. */
  bitbucketCloudIntegrationCreate: BitbucketCloudIntegration;
  /** Creates the Bitbucket Cloud integration. */
  bitbucketCloudIntegrationCreateV2: BitbucketCloudIntegration;
  /** Deletes the Bitbucket Cloud integration. */
  bitbucketCloudIntegrationDelete: Maybe<BitbucketCloudIntegration>;
  /** Regenerates the webhook secret for Bitbucket Cloud integration. */
  bitbucketCloudIntegrationRegenerateWebhookSecret: BitbucketCloudIntegration;
  /** Tests the Bitbucket Cloud integration. */
  bitbucketCloudIntegrationTest: Scalars["Boolean"]["output"];
  /** Updates the Bitbucket Cloud integration with new properties. */
  bitbucketCloudIntegrationUpdate: BitbucketCloudIntegration;
  /** Updates the Bitbucket Cloud integration with new properties. */
  bitbucketCloudIntegrationUpdateV2: BitbucketCloudIntegration;
  /** Creates the Bitbucket Datacenter integration. */
  bitbucketDatacenterIntegrationCreate: BitbucketDatacenterIntegration;
  /** Deletes the Bitbucket Datacenter integration. */
  bitbucketDatacenterIntegrationDelete: Maybe<BitbucketDatacenterIntegration>;
  /** Regenerates the webhook secret for Bitbucket Datacenter integration. */
  bitbucketDatacenterIntegrationRegenerateWebhookSecret: BitbucketDatacenterIntegration;
  /** Tests the Bitbucket Datacenter integration. */
  bitbucketDatacenterIntegrationTest: Scalars["Boolean"]["output"];
  /** Updates the Bitbucket Datacenter integration with new properties. */
  bitbucketDatacenterIntegrationUpdate: BitbucketDatacenterIntegration;
  /** Creates a Blob Storage integration. */
  blobStorageIntegrationCreate: BlobStorageIntegration;
  /** Deletes a Blob Storage integration. Fails while stacks are still attached to it. */
  blobStorageIntegrationDelete: Maybe<BlobStorageIntegration>;
  /** Updates a Blob Storage integration with new properties. */
  blobStorageIntegrationUpdate: BlobStorageIntegration;
  blueprintAttachToIntegration: BlueprintIntegrationAttachment;
  blueprintClone: Blueprint;
  /** Create a blueprint. */
  blueprintCreate: Blueprint;
  blueprintCreateStack: BlueprintStackCreation;
  /** Delete an existing blueprint. */
  blueprintDelete: Maybe<Blueprint>;
  /**
   * Deploy a blueprint
   * @deprecated Use templateDeploymentCreate instead
   */
  blueprintDeploymentCreate: Maybe<BlueprintDeployment>;
  /**
   * Delete a blueprint deployment
   * @deprecated Use templateDeploymentDelete instead
   */
  blueprintDeploymentDelete: Maybe<BlueprintDeployment>;
  /**
   * Rollback a blueprint deployment to a previous state from its change history
   * @deprecated Use templateDeploymentRollback instead
   */
  blueprintDeploymentRollback: Maybe<BlueprintDeployment>;
  /**
   * Upgrade a blueprint deployment to a new version and update deployment metadata
   * @deprecated Use templateDeploymentUpdate instead
   */
  blueprintDeploymentUpdate: Maybe<BlueprintDeployment>;
  blueprintDetachIntegration: BlueprintIntegrationAttachment;
  blueprintParseTemplate: BlueprintParseResult;
  /** Update an existing blueprint. */
  blueprintUpdate: Blueprint;
  /** @deprecated Use templateVersionCreate instead */
  blueprintVersionCreate: Blueprint;
  /** @deprecated Use templateVersionDelete instead */
  blueprintVersionDelete: Maybe<Blueprint>;
  /**
   * Mark a published blueprint version as deprecated.
   * @deprecated Use templateVersionDeprecate instead
   */
  blueprintVersionDeprecate: Blueprint;
  /** @deprecated Use the templateVersionParseTemplate query instead */
  blueprintVersionParseTemplate: BlueprintParseResult;
  /** @deprecated Use templateVersionUpdate instead */
  blueprintVersionUpdate: Blueprint;
  /** @deprecated Use templateCreate instead */
  blueprintVersionedGroupCreate: BlueprintVersionedGroup;
  /** @deprecated Use templateDelete instead */
  blueprintVersionedGroupDelete: Maybe<BlueprintVersionedGroup>;
  /** @deprecated Use templateUpdate instead */
  blueprintVersionedGroupUpdate: BlueprintVersionedGroup;
  /** Create a blueprint. */
  blueprintWithGroupCreate: Blueprint;
  /** Delete an existing blueprint. */
  blueprintWithGroupDelete: Maybe<Blueprint>;
  /** Update an existing blueprint. */
  blueprintWithGroupUpdate: Blueprint;
  /** Generates a confirmation token for CLI auth. */
  cliConfirmationToken: Scalars["String"]["output"];
  /** Complete generic form with the data provided in input */
  completeGenericForm: Scalars["Boolean"]["output"];
  /** Attach context to a Stack. */
  contextAttach: ContextStackAttachment;
  /** Add a context config element. Requires 'Context Update' permission on the context Space. */
  contextConfigAdd: ConfigElement;
  /** Delete a context config element. Requires 'Context Update' permission on the context Space. */
  contextConfigDelete: Maybe<ConfigElement>;
  /**
   * Create a new context.
   * @deprecated Please use contextCreateV2.
   */
  contextCreate: Context;
  /** Create a new context (v2). */
  contextCreateV2: Context;
  /** Delete an existing context. */
  contextDelete: Maybe<Context>;
  /** Detach context from a a Stack. */
  contextDetach: Maybe<ContextStackAttachment>;
  /**
   * Update an existing context.
   * @deprecated Please use contextUpdateV2.
   */
  contextUpdate: Context;
  /**
   * Update an existing context (v2).
   *
   * replaceConfigElements allow to specify if we want to also update config elements.
   * When it's not specified or false, input.configAttachments will be ignored and no config elements will be altered.
   * When true, the config elements attached to the context will be replaced with the values included in the request.
   * If an existing element is not included, it will be deleted from the context.
   *
   */
  contextUpdateV2: Context;
  /** Create an OAuth2 client for SCIM provisioning */
  createOauthClientForSCIM: ScimOauthClient;
  /** Delete the OAuth2 client for SCIM provisioning */
  deleteOauthClientForSCIM: Scalars["Boolean"]["output"];
  /** Dismisses all notifications. */
  dismissAllNotifications: Maybe<Scalars["Int"]["output"]>;
  /** Dismisses notifications by grouping key. */
  dismissNotificationGroup: Array<Notification>;
  /** Dismisses notifications. */
  dismissNotifications: Array<Notification>;
  externalIntegrationCreate: ExternalIntegration;
  externalIntegrationDelete: Maybe<ExternalIntegration>;
  /**
   * Assigns a batch of (space, role) bindings to Flows projects. Requires admin
   * access to every target space. Returns the created bindings.
   */
  flowsProjectRoleBindingBatchCreate: Array<FlowsProjectRoleBinding>;
  /** Removes a single Flows project role binding by its ID. */
  flowsProjectRoleBindingDelete: Maybe<FlowsProjectRoleBinding>;
  /** Create a GitHub integration using an app created from a manifest. */
  githubAppCreateFromManifest: GithubEnterpriseIntegration;
  /** Create data for the GitHub app creation form - internal. */
  githubAppGenerateManifest: GitHubAppManifest;
  /** Creates the GitHub Enterprise integration */
  githubEnterpriseIntegrationCreate: GithubEnterpriseIntegration;
  /** Deletes the GitHub Enterprise integration */
  githubEnterpriseIntegrationDelete: Maybe<GithubEnterpriseIntegration>;
  /** Regenerates the webhook secret for GitHub Enterprise integration. */
  githubEnterpriseIntegrationRegenerateWebhookSecret: GithubEnterpriseIntegration;
  /** Tests the GitHub Enterprise integration */
  githubEnterpriseIntegrationTest: Scalars["Boolean"]["output"];
  /** Updates the GitHub Enterprise integration */
  githubEnterpriseIntegrationUpdate: GithubEnterpriseIntegration;
  /** Updates the build-in GitHub integration */
  githubIntegrationUpdate: GithubIntegration;
  /** Creates the GitLab integration. */
  gitlabIntegrationCreate: GitlabIntegration;
  /** Deletes the GitLab integration. */
  gitlabIntegrationDelete: Maybe<GitlabIntegration>;
  /** Regenerates the webhook secret for GitLab integration. */
  gitlabIntegrationRegenerateWebhookSecret: GitlabIntegration;
  /** Tests the GitLab integration. */
  gitlabIntegrationTest: Scalars["Boolean"]["output"];
  /** Updates the GitLab integration with a new access token and (optionally) API host or User Facing Host. */
  gitlabIntegrationUpdate: GitlabIntegration;
  /** Creates a new GPG key to be used for signing binaries. */
  gpgKeyCreate: GpgKey;
  /** Revokes a GPG key to be used for signing binaries. */
  gpgKeyRevoke: GpgKey;
  /** Updates the description on the GPG key. */
  gpgKeyUpdate: GpgKey;
  /** Group user event */
  groupUserEvent: Scalars["Boolean"]["output"];
  /** Identify user event */
  identifyUserEvent: Scalars["Boolean"]["output"];
  /** Unlink an external provider from the current user's identity. */
  identityFederationUnlink: Maybe<Identity>;
  intentChatConversationCreate: IntentChatConversation;
  intentChatConversationDelete: Maybe<IntentChatConversation>;
  intentChatConversationUpdate: Maybe<IntentChatConversation>;
  intentProjectActivate: IntentProject;
  intentProjectAttachWorkerPool: IntentProject;
  intentProjectConfigAdd: ConfigElement;
  intentProjectConfigDelete: ConfigElement;
  intentProjectConfigUpdate: ConfigElement;
  intentProjectCreate: IntentProject;
  intentProjectDelete: Maybe<IntentProject>;
  intentProjectDetachWorkerPool: IntentProject;
  intentProjectDisable: IntentProject;
  intentProjectEnable: IntentProject;
  intentProjectUnlock: IntentProject;
  intentProjectUpdate: IntentProject;
  intentResourceDependencyAdd: IntentResourceDependency;
  intentResourceDependencyRemove: IntentResourceDependency;
  intentResourceOperationReview: IntentResourceOperationReview;
  intentResourceStateEject: IntentResource;
  /** End the current session. */
  logout: Maybe<Session>;
  managedUserDelete: ManagedUser;
  /** @deprecated Please use managedUserGroupCreateV2. */
  managedUserGroupCreate: ManagedUserGroup;
  managedUserGroupCreateV2: ManagedUserGroup;
  managedUserGroupDelete: ManagedUserGroup;
  managedUserGroupIntegrationCreate: ManagedUserGroupIntegration;
  managedUserGroupIntegrationDelete: ManagedUserGroupIntegration;
  managedUserGroupIntegrationUpdate: ManagedUserGroupIntegration;
  /** @deprecated Please use managedUserGroupUpdateV2. */
  managedUserGroupUpdate: ManagedUserGroup;
  managedUserGroupUpdateV2: ManagedUserGroup;
  /** @deprecated Please use managedUserInviteV2. */
  managedUserInvite: ManagedUser;
  managedUserInviteV2: ManagedUser;
  managedUserRequestInvite: Scalars["Boolean"]["output"];
  managedUserRequestRoleChange: Scalars["Boolean"]["output"];
  managedUserResendInvite: ManagedUser;
  managedUserUpdate: ManagedUser;
  /** Create a new Module. */
  moduleCreate: Module;
  /** Delete an existing Module, assuming it has no active versions. */
  moduleDelete: Maybe<Module>;
  /** Disable the module, so it cannot create new runs. */
  moduleDisable: Module;
  /** Enable the module. */
  moduleEnable: Module;
  /** Change Terraform registry from private to public. */
  modulePublish: Module;
  /** Share a module with another account or another space */
  moduleShare: Array<ModuleShare>;
  /** Update an existing Module (v1 API, does not support updating source). */
  moduleUpdate: Module;
  /** Update an existing Module (v2 API). */
  moduleUpdateV2: Module;
  /** Create a new NamedWebhooksIntegration for a space */
  namedWebhooksIntegrationCreate: NamedWebhooksIntegration;
  /** Delete a NamedWebhooksIntegration from a space */
  namedWebhooksIntegrationDelete: NamedWebhooksIntegration;
  /** Remove secret headers for a named webhook */
  namedWebhooksIntegrationDeleteHeaders: NamedWebhooksIntegration;
  /** Set secret headers for a named webhook to use when sending requests */
  namedWebhooksIntegrationSetHeaders: NamedWebhooksIntegration;
  /** Update a NamedWebhooksIntegration for a space */
  namedWebhooksIntegrationUpdate: NamedWebhooksIntegration;
  /** Get a GitHub URL to redirect to. */
  oauthRedirect: OAuthRedirect;
  /** Exchange code and temporary token for a GitHub token. */
  oauthToken: Scalars["String"]["output"];
  /** Exchange GitHub token for a Spacelift User. */
  oauthUser: User;
  /** Set up OIDC integration. */
  oidcCreate: OidcSettings;
  /** Delete OIDC integration. */
  oidcDelete: Maybe<OidcSettings>;
  /** Update OIDC settings to change claim mappings. */
  oidcUpdate: OidcSettings;
  /**
   * Enqueues OpenTofu vendor migration (or rollback) for every stack that matches
   * the given search filter. The mutation is asynchronous.
   *
   * The target argument determines direction:
   * - target=OpenTofu: migrate matching legacy stacks (vendor=Terraform,
   *   workflow_tool=OPEN_TOFU) to native OpenTofu vendor.
   * - target=Terraform: roll back previously migrated stacks to the legacy shape.
   *
   * When triggerRun=true, the drain queues a tracked run on each stack after it
   * successfully migrates — useful for validating the new vendor against the
   * customer's existing configuration.
   *
   * Stacks already in the target state, already in the queue, or in conflict
   * are silently skipped.
   */
  openTofuMigrate: OpenTofuMigrateResult;
  /**
   * Removes all pending (TO_MIGRATE / TO_ROLLBACK) entries from the migration
   * queue. Already-processed entries (MIGRATED, ROLLEDBACK, FAILED) are not affected.
   */
  openTofuMigrationQueueClean: OpenTofuMigrationQueueCleanResult;
  /** Uninstalls the built-in Origin (Cursor) integration for the account. */
  originIntegrationDelete: Scalars["Boolean"]["output"];
  /**
   * Returns the Origin (Cursor) consent URL that an account admin should be sent
   * to in order to install the global Spacelift Origin app on their namespace.
   */
  originIntegrationInstallURL: Scalars["String"]["output"];
  /** Updates the built-in Origin (Cursor) integration. */
  originIntegrationUpdate: OriginIntegration;
  /** Page user event */
  pageUserEvent: Scalars["Boolean"]["output"];
  personalApiKeyCreate: ApiKey;
  /** Revoke a personal API key. Root admins only. The owner can only delete it afterwards. */
  personalApiKeyDisable: ApiKey;
  /** Delete an existing Plugin. */
  pluginDelete: Maybe<Plugin>;
  /** Install a plugin from a plugin template */
  pluginInstall: Plugin;
  /** Create a new Plugin Template. */
  pluginTemplateCreate: PluginTemplate;
  /** Delete an existing Plugin Template. */
  pluginTemplateDelete: Maybe<PluginTemplate>;
  /** Update an existing Plugin. */
  pluginUpdate: Plugin;
  /** Attach Policy to a Stack. */
  policyAttach: PolicyStackAttachment;
  /**
   * Create a new Policy.
   * @deprecated Use PolicyCreatev2 instead.
   */
  policyCreate: Policy;
  /** Create a new Policy (v2 API). */
  policyCreatev2: Policy;
  /** Delete an existing Policy. */
  policyDelete: Maybe<Policy>;
  /** Detach Policy from a Stack. */
  policyDetach: Maybe<PolicyStackAttachment>;
  /** Attach Policy to a Intent Project */
  policyIntentProjectAttach: PolicyIntentProjectAttachment;
  /** Detach Policy from a Intent Project */
  policyIntentProjectDetach: PolicyIntentProjectAttachment;
  /**
   * Simulate policy evaluation.
   * @deprecated Use policySimulatev2 instead.
   */
  policySimulate: Scalars["String"]["output"];
  /** Simulate policy evaluation. (v2 API). */
  policySimulatev2: Scalars["String"]["output"];
  /**
   * Update an existing Policy.
   * @deprecated Use PolicyUpdatev2 instead.
   */
  policyUpdate: Policy;
  /** Update a Policy (v2 API). */
  policyUpdatev2: Policy;
  /**
   * Trigger a proposed Run. By default, this mutation triggers a proposed run for the
   * commit currently tracked by a Stack or, if the Stack is not yet tracking any
   * commit, against the HEAD of the Stack's tracked branch. These defaults can
   * be overridden. In contrary to the generic runTrigger mutation, proposeWithOverrides allows
   * overriding environment variables in the proposed runs to enable more complex testing environment.
   * Bear in mind that these environment variables are NOT supposed to be secrets, therefore are not treated as such.
   */
  proposeWithOverrides: Run;
  /** Create a commit in a Repo */
  repoCommitCreate: RepoCommit;
  /** Create a new Repo */
  repoCreate: Repo;
  /** Delete a Repo (only if no stacks attached) */
  repoDelete: Scalars["Boolean"]["output"];
  /** Update an existing Repo */
  repoUpdate: Repo;
  /** Reset the OAuth2 client credentials for SCIM provisioning */
  resetOauthClientForSCIM: ScimOauthClient;
  /**
   * Create a revision (commit files) in a Repo
   * @deprecated Use repoCommitCreate instead.
   */
  revisionCreate: Revision;
  /** Create a new Role. */
  roleCreate: Role;
  roleDelete: Maybe<Role>;
  roleUpdate: Maybe<Role>;
  /** Cancel a Run that has not yet started. */
  runCancel: Run;
  /** Comment on the run. */
  runComment: RunComment;
  /**
   * Confirm a Run that's waiting to be applied. If the Run ID is not passed, the
   * Run that's currently blocking the stack will be confirmed.
   */
  runConfirm: Run;
  /**
   * Discard a Run that's waiting to be applied. If the Run ID is not passed, the
   * Run that's currently blocking the stack will be discarded.
   */
  runDiscard: Run;
  /** Discard all runs in a stack that are in a discardable state. */
  runDiscardAll: RunDiscardAll;
  /** Experimental: Mark a run external dependency as completed. */
  runExternalDependencyMarkAsCompleted: RunExternalDependencyMarkAsCompletedResponse;
  /**
   * Force-kill a Run that's currently in progress by sending SIGKILL immediately.
   * Should be used after runStop when the process has not terminated within an acceptable time.
   */
  runKill: Run;
  /**
   * Permanently delete the stored logs of a finished Run, ahead of the account's
   * log retention period. Restricted to root space admins.
   */
  runLogsDelete: Run;
  /**
   * Sets the prioritization value of a run.
   * When prioritized, the run will take precedence over other queued runs for the worker pool it is assigned to.
   * Equivalent to runPrioritySet with the high preset when true and the normal preset when false.
   * @deprecated Use runPrioritySet instead.
   */
  runPrioritizeSet: Run;
  /**
   * Sets the priority preset of a run.
   * Controls run scheduling priority with named presets.
   */
  runPrioritySet: Run;
  /** Promote a proposed Run to a tracked one. */
  runPromote: Run;
  /** Create proposed run based on provided local workspace. */
  runProposeLocalWorkspace: Run;
  /**
   * Stub for the Terraform provider for creating runs. The Terraform provider
   * only needs to be able to trigger a run but will not follow it, so we do not
   * expose anything else than the ID. By default, a tracked run is created, but
   * this can be overridden by setting the proposed argument to true.
   */
  runResourceCreate: Scalars["ID"]["output"];
  /** Retry a PR Run that has finished. */
  runRetry: Run;
  /** Add a run review. */
  runReview: RunReview;
  /** Stop a Run that's currently in progress. */
  runStop: Run;
  /** Set a run state to `PENDING_PLAN` to force a replan. */
  runTargetedReplan: Run;
  /**
   * Trigger a Run. By default, this mutation triggers a tracked run for the
   * commit currently tracked by a Stack or, if the Stack is not yet tracking any
   * commit, against the HEAD of the Stack's tracked branch. These defaults can
   * be overridden.
   */
  runTrigger: Run;
  /**
   * Trigger runs for multiple stacks as a single batch with a shared dependency tree.
   * For tracked runs, downstream dependents are resolved across all input stacks together,
   * so a shared dependent only gets a single run.
   * The output contains the runs created for the requested stacks as well as any runs
   * created for their dependents, in no particular order — correlate results to the input
   * via each run's stack rather than by position. A run's full details are only exposed
   * when you have read access to its stack; otherwise only its id is returned.
   */
  runTriggerBatch: RunTriggerBatchOutput;
  /** Set up SAML integration. */
  samlCreate: SamlSettings;
  /** Delete SAML integration. */
  samlDelete: Maybe<SamlSettings>;
  /** Update SAML settings to change claim mappings. */
  samlUpdate: SamlSettings;
  /** Create a new saved filter. */
  savedFilterCreate: SavedFilter;
  /** Delete a saved filter. */
  savedFilterDelete: Maybe<SavedFilter>;
  /** Update a saved filter. */
  savedFilterUpdate: SavedFilter;
  /** Create a new Scan configuration. */
  scanCreate: Scan;
  /** Delete a Scan configuration. */
  scanDelete: Maybe<Scan>;
  /** Cancel a queued Scan run before a worker picks it up. */
  scanRunCancel: ScanRun;
  /**
   * Ask the worker running a Scan run to abandon it. The run becomes STOPPED
   * once the worker reports back.
   */
  scanRunStop: ScanRun;
  /** Queue a new run of an existing Scan. */
  scanRunTrigger: ScanRun;
  /** Update an existing Scan configuration. */
  scanUpdate: Scan;
  /** Delete a security key. */
  securityKeyDelete: Maybe<SecurityKey>;
  /** Invalidate a Session. NOTE: this functionality is not available in the Starter tier. */
  sessionDelete: Maybe<Session>;
  /** Invalidate all account sessions except for the session making the request. Returns the deleted sessions. */
  sessionDeleteAll: Array<Maybe<Session>>;
  /**
   * Deletes the instance-wide Slack configuration. Only available on Self-Hosted instances.
   * Calling this mutation on a Spacelift SaaS account will result in an error.
   */
  slackAppConfigDelete: Maybe<SlackAppConfig>;
  /**
   * Sets the instance-wide Slack App configuration. This is used to connect your Spacelift installation
   * to a Slack App that can be used for the Slack integration. Only available on Self-Hosted instances.
   * Calling this mutation on a Spacelift SaaS account will result in an error.
   */
  slackAppConfigSet: SlackAppConfig;
  /** Get a Slack URL to redirect to. Optionally specify a Slack environment (defaults to COMMERCIAL). */
  slackOauthRedirect: OAuthRedirect;
  /** Creates a new space */
  spaceCreate: Space;
  /** Deletes space */
  spaceDelete: Space;
  /** Updates space */
  spaceUpdate: Space;
  /** Add a stack config element. */
  stackConfigAdd: ConfigElement;
  /** Delete a stack config element. */
  stackConfigDelete: Maybe<ConfigElement>;
  /**
   * Create a new stack. The third argument (stackObjectID) is optional, and
   * should only be used when creating a Stack with pre-existing state that is
   * handed over to Spacelift for further management.
   */
  stackCreate: Stack;
  /** Create a new stack based on existing Intent Project */
  stackCreateFromIntent: Stack;
  /** Delete an existing stack. */
  stackDelete: Maybe<Stack>;
  /** Adds reference output/input */
  stackDependenciesAddReference: StackDependencyReference;
  /** Adds multiple references output/input in a single request. */
  stackDependenciesAddReferences: Array<StackDependencyReference>;
  /** Creates multiple stack dependencies in a single request. */
  stackDependenciesCreateInBatch: Array<StackDependency>;
  /** Deletes reference output/input from stack dependency */
  stackDependenciesDeleteReference: Maybe<StackDependencyReference>;
  /** Deletes multiple references from stack dependency. */
  stackDependenciesDeleteReferences: Array<StackDependencyReference>;
  /** Updates reference output/input */
  stackDependenciesUpdateReference: StackDependencyReference;
  /** Updates multiple references output/input in a single request. */
  stackDependenciesUpdateReferences: Array<StackDependencyReference>;
  /** Create a new stack dependency. */
  stackDependencyCreate: StackDependency;
  /** Delete a stack dependency. */
  stackDependencyDelete: Maybe<StackDependency>;
  /** Update an existing stack dependency. */
  stackDependencyUpdate: StackDependency;
  /** Disable the stack, so it cannot create new runs. */
  stackDisable: Stack;
  /** Enable the stack. */
  stackEnable: Stack;
  /** Create a stack AWS integration by setting a role ARN. */
  stackIntegrationAwsCreate: StackIntegrationAws;
  /** Delete an AWS integration by unsetting a role ARN. */
  stackIntegrationAwsDelete: Maybe<StackIntegrationAws>;
  /** Create a new DriftDetectionIntegration for stack */
  stackIntegrationDriftDetectionCreate: DriftDetectionIntegration;
  /** Delete DriftDetectionIntegration for stack */
  stackIntegrationDriftDetectionDelete: Maybe<DriftDetectionIntegration>;
  /** Update DriftDetectionIntegration for stack */
  stackIntegrationDriftDetectionUpdate: DriftDetectionIntegration;
  /**
   * Create a stack GCP integration by generating a service account. If the
   * service account already exists, it is not changed.
   * @deprecated Use OIDC integration instead.
   */
  stackIntegrationGcpCreate: StackIntegrationGcp;
  /**
   * Delete a stack GCP integration by deleting a service account.
   * @deprecated Use OIDC integration instead.
   */
  stackIntegrationGcpDelete: Maybe<StackIntegrationGcp>;
  /** Lock the stack for exclusive use. */
  stackLock: Stack;
  /**
   * Import a previously uploaded state file into a managed-state stack.
   * NOTE: the `state` argument is the objectId returned by the stateUploadUrl
   * mutation, which points at the file you uploaded via its pre-signed URL.
   */
  stackManagedStateImport: Maybe<Scalars["Boolean"]["output"]>;
  stackManagedStateRollback: ManagedStateVersion;
  /**
   * Migrate stack vendor configuration.
   * Supports bidirectional migration between Terraform stacks with 'terragrunt' label and native Terragrunt.
   */
  stackMigrateVendor: Stack;
  /**
   * Migrate stack vendor configuration for all stacks that need it.
   * The operation has a time limit and may not migrate all stacks in a single call.
   */
  stackMigrateVendorAll: StackMigrateVendorAllResult;
  /**
   * Change the slug of an existing stack. The slug will be generated from the
   * current stack name. WARNING: if you're referring to this stack by ID from
   * Terraform resources then some of those resources will be recreated. Make
   * sure you know exactly what you're doing!
   */
  stackReslug: Stack;
  stackRoleBindingBatchCreate: Array<StackRoleBinding>;
  stackRoleBindingCreate: StackRoleBinding;
  stackRoleBindingDelete: Maybe<StackRoleBinding>;
  stackRoleBindingUpdate: StackRoleBinding;
  /** Create a new ScheduledDelete for stack */
  stackScheduledDeleteCreate: ScheduledDelete;
  /** Delete ScheduledDelete for stack */
  stackScheduledDeleteDelete: Maybe<ScheduledDelete>;
  /** Update ScheduledDelete for stack */
  stackScheduledDeleteUpdate: ScheduledDelete;
  /** Create a new ScheduledRun for stack */
  stackScheduledRunCreate: ScheduledRun;
  /** Delete ScheduledRun for stack */
  stackScheduledRunDelete: Maybe<ScheduledRun>;
  /** Update ScheduledRun for stack */
  stackScheduledRunUpdate: ScheduledRun;
  /** Create a new ScheduledTask for stack */
  stackScheduledTaskCreate: ScheduledTask;
  /** Delete ScheduledTask for stack */
  stackScheduledTaskDelete: Maybe<ScheduledTask>;
  /** Update ScheduledTask for stack */
  stackScheduledTaskUpdate: ScheduledTask;
  /**
   * Set the current commit on an existing stack. The current commit is what is
   * used for tasks and - by default - for triggering tracked runs (deployments).
   */
  stackSetCurrentCommit: Stack;
  /** Sync the tracked commit of the stack. */
  stackSyncCommit: Stack;
  /** Unlock the stack. */
  stackUnlock: Stack;
  /** Update an existing stack. */
  stackUpdate: Stack;
  /** Sets or unsets star on a Stack or Module. */
  starSet: Stack;
  /**
   * Generate pre-signed state download URL for a stack.
   * Requires external state access to be enabled on the stack.
   */
  stateDownloadUrl: StateDownloadUrl;
  /** Generate pre-signed state upload URL. */
  stateUploadUrl: StateUploadUrl;
  /** Create a Task from a command. */
  taskCreate: Run;
  templateCreate: Template;
  templateDelete: Maybe<Template>;
  /** Deploy a template */
  templateDeploymentCreate: Maybe<TemplateDeployment>;
  /**
   * Delete a template deployment.
   * If skipStackDeletion is true, the deployment record is removed and stacks are
   * detached (made standalone) instead of being destroyed.
   */
  templateDeploymentDelete: Maybe<TemplateDeployment>;
  /** Rollback a template deployment to a previous state from its change history */
  templateDeploymentRollback: Maybe<TemplateDeployment>;
  /** Upgrade a template deployment to a new version and update deployment metadata */
  templateDeploymentUpdate: Maybe<TemplateDeployment>;
  templateUpdate: Template;
  templateVersionCreate: TemplateVersion;
  templateVersionDelete: Maybe<TemplateVersion>;
  /** Mark a published template version as deprecated. */
  templateVersionDeprecate: TemplateVersion;
  /** @deprecated Use the templateVersionParseTemplate query instead */
  templateVersionParseTemplate: BlueprintParseResult;
  templateVersionUpdate: TemplateVersion;
  /**
   * Creates a new Terraform provider. Note that the type needs to be unique within
   * the account, and it can then be used as the provider's ID.
   */
  terraformProviderCreate: TerraformProvider;
  /** Deletes a Terraform Provider */
  terraformProviderDelete: Maybe<TerraformProvider>;
  /** Changes public visibility of the Terraform Provider */
  terraformProviderSetVisibility: TerraformProvider;
  /** Updates an existing Terraform Provider */
  terraformProviderUpdate: TerraformProvider;
  /** Create a new Terraform provider version. */
  terraformProviderVersionCreate: NewTerraformProviderVersion;
  /** Delete a draft Terraform provider version. */
  terraformProviderVersionDelete: TerraformProviderVersion;
  /** Publish an existing Terraform provider version. */
  terraformProviderVersionPublish: TerraformProviderVersion;
  /**
   * Register a platform supported by the version. The result is presigned
   * upload URL that can be used to upload the platform binary.
   * This call is idempotent so registering the same platform multiple times will
   * not create multiple copies, but once a platform is registered, the binary
   * must be uploaded.
   */
  terraformProviderVersionRegisterPlatform: Scalars["String"]["output"];
  /**
   * This mutation is similar to terraformProviderVersionRegisterPlatform,
   * but it also returns the optional uploadHeaders required for the upload request.
   */
  terraformProviderVersionRegisterPlatformV2: TerraformProviderVersionRegisterPlatformV2Output;
  /** Revoke a published Terraform provider version. */
  terraformProviderVersionRevoke: TerraformProviderVersion;
  /** Update an existing Terraform provider version. */
  terraformProviderVersionUpdate: TerraformProviderVersion;
  /** Upload documentation for a Terraform provider version. */
  terraformProviderVersionUploadDocs: TerraformProviderVersion;
  /**
   * Verify the GPG signature of the SHA256SUMS file, confirm the file
   * contains entries for all registered platform archives and verify their checksums.
   */
  terraformProviderVersionVerify: TerraformProviderVersion;
  /** Unlock a single locked Tofu workspace. */
  tofuWorkspaceUnlock: TofuWorkspace;
  /** Unlock all locked Tofu workspaces in a stack. */
  tofuWorkspaceUnlockAll: TofuWorkspaceUnlockAllResponse;
  /** Track user event */
  trackUserEvent: Scalars["Boolean"]["output"];
  /**
   * Upload a persistent UI config. Consecutive calls will overwrite the previous config.
   * UI config is a JSON blob.
   */
  uiConfigStore: Scalars["Boolean"]["output"];
  /** Upload workspace for later processing in other mutations. */
  uploadLocalWorkspace: LocalWorkspaceUpload;
  userGroupRoleBindingBatchCreate: Array<UserGroupRoleBinding>;
  userGroupRoleBindingCreate: UserGroupRoleBinding;
  userGroupRoleBindingDelete: Maybe<UserGroupRoleBinding>;
  userGroupRoleBindingUpdate: UserGroupRoleBinding;
  /** Abandon the active user guide */
  userGuideAbandon: UserGuideProgress;
  /** Creates a new certificate for completing a course. Returns an error if a certificate already exists for this user and group. */
  userGuideCertificationCreate: UserGuideCertification;
  /** Updates the display name of an existing certificate. Returns an error if the certificate does not exist. */
  userGuideCertificationUpdate: UserGuideCertification;
  /** Complete the active user guide */
  userGuideComplete: UserGuideProgress;
  /** Move to the next step for the active user guide */
  userGuideMoveToNextStep: UserGuideProgress;
  /** Move to the previous step for the active user guide */
  userGuideMoveToPreviousStep: UserGuideProgress;
  /** Restart a user guide from step 0 while preserving completion history */
  userGuideRestart: UserGuideProgress;
  /** Start a user guide */
  userGuideStart: UserGuideProgress;
  userRoleBindingBatchCreate: Array<UserRoleBinding>;
  userRoleBindingCreate: UserRoleBinding;
  userRoleBindingDelete: Maybe<UserRoleBinding>;
  userRoleBindingUpdate: UserRoleBinding;
  /** Delete all security keys for the current user. */
  userSecurityKeyDeleteAll: Array<Maybe<SecurityKey>>;
  /** Create a new VCSAgentPool. */
  vcsAgentPoolCreate: VcsAgentPool;
  /** Delete an existing VCSAgentPool. */
  vcsAgentPoolDelete: Maybe<VcsAgentPool>;
  /** Recreate the credentials necessary to connect VCSAgentPool's agents to the gateways. */
  vcsAgentPoolReset: VcsAgentPool;
  /** Update an existing VCSAgentPool. */
  vcsAgentPoolUpdate: VcsAgentPool;
  /** Set notes on the Version. */
  versionAnnotate: Version;
  /** Create Version based on optional SHA or branch head. */
  versionCreate: Version;
  /** Delete version. This action cannot be undone. */
  versionDelete: Maybe<Version>;
  /** Create Version test run based on provided local workspace. */
  versionProposeLocalWorkspace: Array<Run>;
  versionPush: Version;
  /** Trigger failed Version. */
  versionTrigger: Version;
  /** Yank the version (mark it as bad). This action cannot be undone. */
  versionYank: Version;
  /** Create a new WebhooksIntegration for stack */
  webhooksIntegrationCreate: WebhooksIntegration;
  /** Delete WebhooksIntegration for stack */
  webhooksIntegrationDelete: Maybe<WebhooksIntegration>;
  /** Update WebhooksIntegration for stack */
  webhooksIntegrationUpdate: WebhooksIntegration;
  /** Toggles draining on the worker. */
  workerDrainSet: Worker;
  /** Create a new WorkerPool. */
  workerPoolCreate: WorkerPool;
  /** Cycles the workerpool */
  workerPoolCycle: Scalars["Boolean"]["output"];
  /** Delete an existing WorkerPool. */
  workerPoolDelete: Maybe<WorkerPool>;
  /**
   * Recreate the credentials necessary to connect WorkerPool's workers to the
   * control plane.
   */
  workerPoolReset: WorkerPool;
  /** Update an existing WorkerPool. */
  workerPoolUpdate: WorkerPool;
};

export type MutationAccountSetInfraAssistantBuildModeEnabledArgs = {
  enabled: Scalars["Boolean"]["input"];
};

export type MutationAccountSetInfraAssistantEnabledArgs = {
  enabled: Scalars["Boolean"]["input"];
};

export type MutationAccountSetOAuthRedirectAllowlistArgs = {
  hosts: Array<Scalars["String"]["input"]>;
};

export type MutationAccountSetOidcSubjectTemplateArgs = {
  template: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAccountSetPersonalApiKeysEnabledArgs = {
  disableExistingKeys: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled: Scalars["Boolean"]["input"];
};

export type MutationAccountSetSpaceliftIntelligenceEnabledArgs = {
  enabled: Scalars["Boolean"]["input"];
};

export type MutationAccountToggleDeletionMarkArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  reason: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAccountUpdateAuthorizationSchemeArgs = {
  schema: AuthorizationScheme;
};

export type MutationAccountUpdateAwarenessSourceSurveyArgs = {
  completed: Scalars["Boolean"]["input"];
  response: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAccountUpdateDefaultWorkerPoolRunnerImagesArgs = {
  privateWorkerPoolRunnerImage: InputMaybe<Scalars["String"]["input"]>;
  publicWorkerPoolRunnerImage: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAccountUpdateSecurityEmailArgs = {
  securityEmail: Scalars["String"]["input"];
};

export type MutationAccountUpdateVcsEventTriggeredRunsLimitArgs = {
  limit: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationAiIntegrationCreateArgs = {
  apiKey: InputMaybe<Scalars["String"]["input"]>;
  baseURL: InputMaybe<Scalars["String"]["input"]>;
  description: InputMaybe<Scalars["String"]["input"]>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  models: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  providerConfig: InputMaybe<AiProviderConfigInput>;
  providerIntegrationId: InputMaybe<Scalars["ID"]["input"]>;
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationAiIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationAiIntegrationToggleArgs = {
  enabled: Scalars["Boolean"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationAiIntegrationUpdateArgs = {
  apiKey: InputMaybe<Scalars["String"]["input"]>;
  baseURL: InputMaybe<Scalars["String"]["input"]>;
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  models: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  providerConfig: InputMaybe<AiProviderConfigInput>;
  providerIntegrationId: InputMaybe<Scalars["ID"]["input"]>;
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationApiKeyCreateArgs = {
  input: ApiKeyInput;
};

export type MutationApiKeyDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationApiKeyEnableNonRootManagersArgs = {
  enable: Scalars["Boolean"]["input"];
};

export type MutationApiKeyResetArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationApiKeyRoleBindingBatchCreateArgs = {
  input: ApiKeyRoleBindingBatchInput;
};

export type MutationApiKeyRoleBindingCreateArgs = {
  input: ApiKeyRoleBindingInput;
};

export type MutationApiKeyRoleBindingDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationApiKeyRoleBindingUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: ApiKeyRoleBindingInput;
};

export type MutationApiKeyUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: ApiKeyUpdateInput;
};

export type MutationApiKeyUserArgs = {
  id: Scalars["ID"]["input"];
  secret: Scalars["String"]["input"];
};

export type MutationAuditTrailSetWebhookArgs = {
  input: AuditTrailWebhookInput;
};

export type MutationAuditTrailWebhookDeleteHeadersArgs = {
  input: AuditTrailWebhookDeleteHeadersInput;
};

export type MutationAuditTrailWebhookSetHeadersArgs = {
  input: AuditTrailWebhookSetHeadersInput;
};

export type MutationAwsIntegrationAttachArgs = {
  id: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
  stack: Scalars["ID"]["input"];
  write: Scalars["Boolean"]["input"];
};

export type MutationAwsIntegrationAttachmentUpdateArgs = {
  id: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
  write: Scalars["Boolean"]["input"];
};

export type MutationAwsIntegrationCreateArgs = {
  autoattachEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  durationSeconds: InputMaybe<Scalars["Int"]["input"]>;
  externalID: InputMaybe<Scalars["String"]["input"]>;
  generateCredentialsInWorker: Scalars["Boolean"]["input"];
  labels: Array<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  region: InputMaybe<Scalars["String"]["input"]>;
  roleArn: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
  tagAssumeRole: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationAwsIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationAwsIntegrationDetachArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationAwsIntegrationIntentProjectAttachArgs = {
  awsRegion: Scalars["String"]["input"];
  integration: Scalars["ID"]["input"];
  intentProject: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
  write: Scalars["Boolean"]["input"];
};

export type MutationAwsIntegrationIntentProjectDetachArgs = {
  integration: Scalars["ID"]["input"];
  intentProject: Scalars["ID"]["input"];
};

export type MutationAwsIntegrationUpdateArgs = {
  autoattachEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  durationSeconds: Scalars["Int"]["input"];
  externalID: Scalars["String"]["input"];
  generateCredentialsInWorker: Scalars["Boolean"]["input"];
  id: Scalars["ID"]["input"];
  labels: Array<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  region: InputMaybe<Scalars["String"]["input"]>;
  roleArn: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
  tagAssumeRole: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationAzureDevOpsRepoIntegrationCreateArgs = {
  accessibleProjects: InputMaybe<Array<Scalars["String"]["input"]>>;
  customInput: InputMaybe<CustomVcsInput>;
  organizationURL: Scalars["String"]["input"];
  personalAccessToken: Scalars["String"]["input"];
  userFacingHost: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAzureDevOpsRepoIntegrationDeleteArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationAzureDevOpsRepoIntegrationTestArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationAzureDevOpsRepoIntegrationUpdateArgs = {
  accessibleProjects: InputMaybe<Array<Scalars["String"]["input"]>>;
  customInput: InputMaybe<CustomVcsUpdateInput>;
  organizationURL: Scalars["String"]["input"];
  personalAccessToken: InputMaybe<Scalars["String"]["input"]>;
  userFacingHost: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAzureIntegrationAttachArgs = {
  id: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
  stack: Scalars["ID"]["input"];
  subscriptionId: InputMaybe<Scalars["String"]["input"]>;
  write: Scalars["Boolean"]["input"];
};

export type MutationAzureIntegrationAttachmentUpdateArgs = {
  id: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
  subscriptionId: InputMaybe<Scalars["String"]["input"]>;
  write: Scalars["Boolean"]["input"];
};

export type MutationAzureIntegrationCreateArgs = {
  autoattachEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultSubscriptionId: InputMaybe<Scalars["String"]["input"]>;
  labels: Array<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
  tenantID: Scalars["String"]["input"];
};

export type MutationAzureIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationAzureIntegrationDetachArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationAzureIntegrationUpdateArgs = {
  autoattachEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultSubscriptionId: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: Array<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBillingSubscriptionCreateArgs = {
  addons: InputMaybe<Array<BillingAddonType>>;
  input: SubscriptionInput;
  interval: InputMaybe<BillingCycleInterval>;
  paymentMethodID: Scalars["String"]["input"];
  tier: InputMaybe<BillingTier>;
};

export type MutationBillingSubscriptionUpdateInfoArgs = {
  input: SubscriptionInput;
};

export type MutationBillingSubscriptionUpdateTierArgs = {
  interval: InputMaybe<BillingCycleInterval>;
  tier: BillingTier;
};

export type MutationBillingSubscriptionUpdateV2Args = {
  input: SubscriptionUpdateV2Input;
};

export type MutationBitbucketCloudIntegrationCreateArgs = {
  appPassword: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  username: Scalars["String"]["input"];
};

export type MutationBitbucketCloudIntegrationCreateV2Args = {
  input: BitbucketCloudIntegrationInput;
};

export type MutationBitbucketCloudIntegrationDeleteArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBitbucketCloudIntegrationRegenerateWebhookSecretArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBitbucketCloudIntegrationTestArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBitbucketCloudIntegrationUpdateArgs = {
  appPassword: InputMaybe<Scalars["String"]["input"]>;
  customInput: InputMaybe<CustomVcsUpdateInput>;
  username: Scalars["String"]["input"];
};

export type MutationBitbucketCloudIntegrationUpdateV2Args = {
  input: BitbucketCloudIntegrationUpdateInput;
};

export type MutationBitbucketDatacenterIntegrationCreateArgs = {
  accessToken: Scalars["String"]["input"];
  apiHost: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  userFacingHost: Scalars["String"]["input"];
  username: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationBitbucketDatacenterIntegrationDeleteArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBitbucketDatacenterIntegrationRegenerateWebhookSecretArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBitbucketDatacenterIntegrationTestArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBitbucketDatacenterIntegrationUpdateArgs = {
  accessToken: InputMaybe<Scalars["String"]["input"]>;
  apiHost: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsUpdateInput>;
  userFacingHost: Scalars["String"]["input"];
  username: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationBlobStorageIntegrationCreateArgs = {
  accessKeyId: InputMaybe<Scalars["String"]["input"]>;
  authMethod: BlobStorageAuthMethod;
  baseURI: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  endpoint: InputMaybe<Scalars["String"]["input"]>;
  region: InputMaybe<Scalars["String"]["input"]>;
  roleArn: InputMaybe<Scalars["String"]["input"]>;
  secretAccessKey: InputMaybe<Scalars["String"]["input"]>;
  subtype: BlobStorageSubtype;
};

export type MutationBlobStorageIntegrationDeleteArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationBlobStorageIntegrationUpdateArgs = {
  accessKeyId: InputMaybe<Scalars["String"]["input"]>;
  authMethod: BlobStorageAuthMethod;
  baseURI: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsUpdateInput>;
  endpoint: InputMaybe<Scalars["String"]["input"]>;
  region: InputMaybe<Scalars["String"]["input"]>;
  roleArn: InputMaybe<Scalars["String"]["input"]>;
  secretAccessKey: InputMaybe<Scalars["String"]["input"]>;
  subtype: BlobStorageSubtype;
};

export type MutationBlueprintAttachToIntegrationArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintAttachInput;
};

export type MutationBlueprintCloneArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintCloneInput;
};

export type MutationBlueprintCreateArgs = {
  input: BlueprintCreateInput;
};

export type MutationBlueprintCreateStackArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintStackCreateInput;
};

export type MutationBlueprintDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintDeploymentCreateArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintDeploymentCreateInput;
};

export type MutationBlueprintDeploymentDeleteArgs = {
  blueprintID: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintDeploymentRollbackArgs = {
  blueprintID: Scalars["ID"]["input"];
  changeRecordID: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintDeploymentUpdateArgs = {
  blueprintID: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
  input: BlueprintDeploymentUpdateInput;
};

export type MutationBlueprintDetachIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintParseTemplateArgs = {
  template: Scalars["String"]["input"];
};

export type MutationBlueprintUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintCreateInput;
};

export type MutationBlueprintVersionCreateArgs = {
  input: BlueprintVersionCreateInput;
};

export type MutationBlueprintVersionDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintVersionDeprecateArgs = {
  id: Scalars["ID"]["input"];
  input: InputMaybe<BlueprintVersionDeprecateInput>;
};

export type MutationBlueprintVersionParseTemplateArgs = {
  template: Scalars["String"]["input"];
};

export type MutationBlueprintVersionUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintVersionUpdateInput;
};

export type MutationBlueprintVersionedGroupCreateArgs = {
  input: BlueprintVersionedGroupCreateInput;
};

export type MutationBlueprintVersionedGroupDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintVersionedGroupUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintVersionedGroupUpdateInput;
};

export type MutationBlueprintWithGroupCreateArgs = {
  input: BlueprintWithGroupCreateInput;
};

export type MutationBlueprintWithGroupDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationBlueprintWithGroupUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: BlueprintWithGroupUpdateInput;
};

export type MutationCliConfirmationTokenArgs = {
  pubKey: Scalars["String"]["input"];
};

export type MutationCompleteGenericFormArgs = {
  data: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationContextAttachArgs = {
  id: Scalars["ID"]["input"];
  priority: Scalars["Int"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationContextConfigAddArgs = {
  config: ConfigInput;
  context: Scalars["ID"]["input"];
};

export type MutationContextConfigDeleteArgs = {
  context: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationContextCreateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationContextCreateV2Args = {
  input: ContextInput;
};

export type MutationContextDeleteArgs = {
  force: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationContextDetachArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationContextUpdateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationContextUpdateV2Args = {
  id: Scalars["ID"]["input"];
  input: ContextInput;
  replaceConfigElements: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationDismissNotificationGroupArgs = {
  groupingKey: Scalars["ID"]["input"];
};

export type MutationDismissNotificationsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationExternalIntegrationCreateArgs = {
  input: ExternalIntegrationInput;
};

export type MutationExternalIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationFlowsProjectRoleBindingBatchCreateArgs = {
  input: FlowsProjectRoleBindingBatchInput;
};

export type MutationFlowsProjectRoleBindingDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationGithubAppCreateFromManifestArgs = {
  code: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  state: Scalars["String"]["input"];
};

export type MutationGithubAppGenerateManifestArgs = {
  input: GitHubAppManifestInput;
};

export type MutationGithubEnterpriseIntegrationCreateArgs = {
  apiHost: Scalars["String"]["input"];
  appID: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  privateKey: Scalars["String"]["input"];
  userFacingHost: InputMaybe<Scalars["String"]["input"]>;
  webhookSecret: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationGithubEnterpriseIntegrationDeleteArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGithubEnterpriseIntegrationRegenerateWebhookSecretArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGithubEnterpriseIntegrationTestArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGithubEnterpriseIntegrationUpdateArgs = {
  apiHost: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsUpdateInput>;
  privateKey: InputMaybe<Scalars["String"]["input"]>;
  userFacingHost: InputMaybe<Scalars["String"]["input"]>;
  webhookSecret: Scalars["String"]["input"];
};

export type MutationGithubIntegrationUpdateArgs = {
  useGitCheckout: InputMaybe<Scalars["Boolean"]["input"]>;
  vcsCheckOptions: InputMaybe<VcsCheckOptionsInput>;
  vcsChecks: VcsCheck;
};

export type MutationGitlabIntegrationCreateArgs = {
  apiHost: Scalars["String"]["input"];
  customInput: InputMaybe<CustomVcsInput>;
  privateToken: Scalars["String"]["input"];
  userFacingHost: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationGitlabIntegrationDeleteArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGitlabIntegrationRegenerateWebhookSecretArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGitlabIntegrationTestArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationGitlabIntegrationUpdateArgs = {
  apiHost: InputMaybe<Scalars["String"]["input"]>;
  customInput: InputMaybe<CustomVcsUpdateInput>;
  privateToken: InputMaybe<Scalars["String"]["input"]>;
  userFacingHost: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationGpgKeyCreateArgs = {
  asciiArmor: Scalars["String"]["input"];
  description: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationGpgKeyRevokeArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationGpgKeyUpdateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationGroupUserEventArgs = {
  context: InputMaybe<Scalars["String"]["input"]>;
  traits: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationIdentifyUserEventArgs = {
  context: InputMaybe<Scalars["String"]["input"]>;
  traits: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationIdentityFederationUnlinkArgs = {
  provider: FederationProvider;
};

export type MutationIntentChatConversationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationIntentChatConversationUpdateArgs = {
  description: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationIntentProjectActivateArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationIntentProjectAttachWorkerPoolArgs = {
  intentProject: Scalars["ID"]["input"];
  workerPool: Scalars["ID"]["input"];
};

export type MutationIntentProjectConfigAddArgs = {
  config: ConfigInput;
  project: Scalars["ID"]["input"];
};

export type MutationIntentProjectConfigDeleteArgs = {
  config: Scalars["ID"]["input"];
  project: Scalars["ID"]["input"];
};

export type MutationIntentProjectConfigUpdateArgs = {
  config: ConfigInput;
  project: Scalars["ID"]["input"];
};

export type MutationIntentProjectCreateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  space: Scalars["ID"]["input"];
  workerPool: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationIntentProjectDeleteArgs = {
  id: Scalars["ID"]["input"];
  keepResources: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationIntentProjectDetachWorkerPoolArgs = {
  intentProject: Scalars["ID"]["input"];
};

export type MutationIntentProjectDisableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationIntentProjectEnableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationIntentProjectUnlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationIntentProjectUpdateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: InputMaybe<Scalars["String"]["input"]>;
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  space: InputMaybe<Scalars["ID"]["input"]>;
  workerPool: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationIntentResourceDependencyAddArgs = {
  dependencyType: IntentResourceDependencyType;
  explanation: InputMaybe<Scalars["String"]["input"]>;
  fieldMappings: InputMaybe<Array<IntentResourceDependencyFieldMappingInput>>;
  fromResourceID: Scalars["String"]["input"];
  intentProject: Scalars["ID"]["input"];
  toResourceID: Scalars["String"]["input"];
};

export type MutationIntentResourceDependencyRemoveArgs = {
  fromResourceID: Scalars["String"]["input"];
  intentProject: Scalars["ID"]["input"];
  toResourceID: Scalars["String"]["input"];
};

export type MutationIntentResourceOperationReviewArgs = {
  decision: IntentResourceOperationReviewDecision;
  intentProject: Scalars["ID"]["input"];
  note: InputMaybe<Scalars["String"]["input"]>;
  operationID: Scalars["ID"]["input"];
};

export type MutationIntentResourceStateEjectArgs = {
  intentProject: Scalars["ID"]["input"];
  resourceID: Scalars["String"]["input"];
};

export type MutationManagedUserDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationManagedUserGroupCreateArgs = {
  input: ManagedUserGroupCreateInput;
};

export type MutationManagedUserGroupCreateV2Args = {
  input: ManagedUserGroupCreateInputV2;
};

export type MutationManagedUserGroupDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationManagedUserGroupIntegrationCreateArgs = {
  input: ManagedUserGroupIntegrationCreateInput;
};

export type MutationManagedUserGroupIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationManagedUserGroupIntegrationUpdateArgs = {
  input: ManagedUserGroupIntegrationUpdateInput;
};

export type MutationManagedUserGroupUpdateArgs = {
  input: ManagedUserGroupUpdateInput;
};

export type MutationManagedUserGroupUpdateV2Args = {
  input: ManagedUserGroupUpdateInputV2;
};

export type MutationManagedUserInviteArgs = {
  input: ManagedUserInviteInput;
};

export type MutationManagedUserInviteV2Args = {
  input: ManagedUserInviteInputV2;
};

export type MutationManagedUserRequestInviteArgs = {
  email: Scalars["String"]["input"];
  userName: Scalars["String"]["input"];
};

export type MutationManagedUserRequestRoleChangeArgs = {
  requestedAccessLevel: SpaceAccessLevel;
  spaceId: Scalars["ID"]["input"];
};

export type MutationManagedUserResendInviteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationManagedUserUpdateArgs = {
  input: ManagedUserUpdateInput;
};

export type MutationModuleCreateArgs = {
  input: ModuleCreateInput;
};

export type MutationModuleDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationModuleDisableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationModuleEnableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationModulePublishArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationModuleShareArgs = {
  id: Scalars["ID"]["input"];
  input: ModuleShareInput;
};

export type MutationModuleUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: ModuleUpdateInput;
};

export type MutationModuleUpdateV2Args = {
  id: Scalars["ID"]["input"];
  input: ModuleUpdateV2Input;
};

export type MutationNamedWebhooksIntegrationCreateArgs = {
  input: NamedWebhooksIntegrationInput;
};

export type MutationNamedWebhooksIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationNamedWebhooksIntegrationDeleteHeadersArgs = {
  headerKeys: Array<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationNamedWebhooksIntegrationSetHeadersArgs = {
  id: Scalars["ID"]["input"];
  input: NamedWebhookHeaderInput;
};

export type MutationNamedWebhooksIntegrationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: NamedWebhooksIntegrationInput;
};

export type MutationOauthTokenArgs = {
  code: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
  temporaryToken: Scalars["String"]["input"];
};

export type MutationOauthUserArgs = {
  token: Scalars["String"]["input"];
};

export type MutationOidcCreateArgs = {
  claimMapping: InputMaybe<ClaimMappingInput>;
  clientCredentials: Scalars["String"]["input"];
  clientId: Scalars["String"]["input"];
  identityProviderHost: Scalars["String"]["input"];
};

export type MutationOidcUpdateArgs = {
  input: OidcUpdateInput;
};

export type MutationOpenTofuMigrateArgs = {
  input: SearchInput;
  target: StackVendor;
  triggerRun: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationOriginIntegrationInstallUrlArgs = {
  spaceID: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationOriginIntegrationUpdateArgs = {
  vcsCheckOptions: InputMaybe<VcsCheckOptionsInput>;
  vcsChecks: VcsCheck;
};

export type MutationPageUserEventArgs = {
  context: InputMaybe<Scalars["String"]["input"]>;
  name: InputMaybe<Scalars["String"]["input"]>;
  properties: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPersonalApiKeyCreateArgs = {
  input: PersonalApiKeyInput;
};

export type MutationPersonalApiKeyDisableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPluginDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPluginInstallArgs = {
  input: PluginInstallInput;
};

export type MutationPluginTemplateCreateArgs = {
  input: PluginTemplateCreateInput;
};

export type MutationPluginTemplateDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPluginUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PluginUpdateInput;
};

export type MutationPolicyAttachArgs = {
  id: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationPolicyCreateArgs = {
  body: Scalars["String"]["input"];
  description: InputMaybe<Scalars["String"]["input"]>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
  type: PolicyType;
};

export type MutationPolicyCreatev2Args = {
  input: PolicyCreateInput;
};

export type MutationPolicyDeleteArgs = {
  force: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationPolicyDetachArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPolicyIntentProjectAttachArgs = {
  id: Scalars["ID"]["input"];
  intentProject: Scalars["ID"]["input"];
};

export type MutationPolicyIntentProjectDetachArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPolicySimulateArgs = {
  body: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
  libraries: InputMaybe<PolicyLibrariesInput>;
  type: PolicyType;
};

export type MutationPolicySimulatev2Args = {
  input: PolicySimulateInput;
};

export type MutationPolicyUpdateArgs = {
  body: Scalars["String"]["input"];
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationPolicyUpdatev2Args = {
  id: Scalars["ID"]["input"];
  input: PolicyUpdateInput;
};

export type MutationProposeWithOverridesArgs = {
  commitSha: InputMaybe<Scalars["String"]["input"]>;
  environmentVarsOverrides: InputMaybe<Array<EnvironmentVariable>>;
  stack: Scalars["ID"]["input"];
};

export type MutationRepoCommitCreateArgs = {
  input: RepoCommitCreateInput;
};

export type MutationRepoCreateArgs = {
  input: RepoCreateInput;
};

export type MutationRepoDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRepoUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: RepoUpdateInput;
};

export type MutationRevisionCreateArgs = {
  input: RevisionCreateInput;
};

export type MutationRoleCreateArgs = {
  input: RoleInput;
};

export type MutationRoleDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRoleUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: RoleUpdateInput;
};

export type MutationRunCancelArgs = {
  note: InputMaybe<Scalars["String"]["input"]>;
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunCommentArgs = {
  body: Scalars["String"]["input"];
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunConfirmArgs = {
  note: InputMaybe<Scalars["String"]["input"]>;
  run: InputMaybe<Scalars["ID"]["input"]>;
  stack: Scalars["ID"]["input"];
};

export type MutationRunDiscardArgs = {
  note: InputMaybe<Scalars["String"]["input"]>;
  run: InputMaybe<Scalars["ID"]["input"]>;
  stack: Scalars["ID"]["input"];
};

export type MutationRunDiscardAllArgs = {
  note: InputMaybe<Scalars["String"]["input"]>;
  stack: Scalars["ID"]["input"];
};

export type MutationRunExternalDependencyMarkAsCompletedArgs = {
  dependency: Scalars["ID"]["input"];
  status: RunExternalDependencyStatus;
};

export type MutationRunKillArgs = {
  note: InputMaybe<Scalars["String"]["input"]>;
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
  state: InputMaybe<RunState>;
};

export type MutationRunLogsDeleteArgs = {
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunPrioritizeSetArgs = {
  prioritize: Scalars["Boolean"]["input"];
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunPrioritySetArgs = {
  preset: RunPriorityPreset;
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunPromoteArgs = {
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunProposeLocalWorkspaceArgs = {
  environmentVarsOverrides: InputMaybe<Array<EnvironmentVariable>>;
  stack: Scalars["ID"]["input"];
  workspace: Scalars["ID"]["input"];
};

export type MutationRunResourceCreateArgs = {
  commitSha: InputMaybe<Scalars["String"]["input"]>;
  proposed: InputMaybe<Scalars["Boolean"]["input"]>;
  stack: Scalars["ID"]["input"];
};

export type MutationRunRetryArgs = {
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationRunReviewArgs = {
  decision: RunReviewDecision;
  note: InputMaybe<Scalars["String"]["input"]>;
  run: InputMaybe<Scalars["ID"]["input"]>;
  stack: Scalars["ID"]["input"];
};

export type MutationRunStopArgs = {
  note: InputMaybe<Scalars["String"]["input"]>;
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
  state: InputMaybe<RunState>;
};

export type MutationRunTargetedReplanArgs = {
  run: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
  targets: Array<Scalars["String"]["input"]>;
};

export type MutationRunTriggerArgs = {
  commitSha: InputMaybe<Scalars["String"]["input"]>;
  forceApply: InputMaybe<ForceApplyMode>;
  runType: InputMaybe<RunType>;
  runtimeConfig: InputMaybe<RuntimeConfigInput>;
  stack: Scalars["ID"]["input"];
};

export type MutationRunTriggerBatchArgs = {
  input: RunTriggerBatchInput;
};

export type MutationSamlCreateArgs = {
  claimMapping: InputMaybe<ClaimMappingInput>;
  dynamic: Scalars["Boolean"]["input"];
  metadata: Scalars["String"]["input"];
  nameIDFormat: InputMaybe<SamlNameIdFormat>;
};

export type MutationSamlUpdateArgs = {
  input: SamlUpdateInput;
};

export type MutationSavedFilterCreateArgs = {
  input: SavedFilterInput;
};

export type MutationSavedFilterDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationSavedFilterUpdateArgs = {
  data: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  isPublic: Scalars["Boolean"]["input"];
  name: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationScanCreateArgs = {
  input: ScanInput;
};

export type MutationScanDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationScanRunCancelArgs = {
  id: Scalars["ID"]["input"];
  note: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationScanRunStopArgs = {
  id: Scalars["ID"]["input"];
  note: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationScanRunTriggerArgs = {
  scan: Scalars["ID"]["input"];
};

export type MutationScanUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: ScanInput;
};

export type MutationSecurityKeyDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationSessionDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationSlackAppConfigSetArgs = {
  input: SlackAppConfigInput;
};

export type MutationSlackOauthRedirectArgs = {
  slackEnvironment: InputMaybe<SlackEnvironment>;
};

export type MutationSpaceCreateArgs = {
  input: SpaceInput;
};

export type MutationSpaceDeleteArgs = {
  space: Scalars["ID"]["input"];
};

export type MutationSpaceUpdateArgs = {
  input: SpaceInput;
  space: Scalars["ID"]["input"];
};

export type MutationStackConfigAddArgs = {
  config: ConfigInput;
  stack: Scalars["ID"]["input"];
};

export type MutationStackConfigDeleteArgs = {
  id: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackCreateArgs = {
  input: StackInput;
  manageState: Scalars["Boolean"]["input"];
  slug: InputMaybe<Scalars["String"]["input"]>;
  stackObjectID: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationStackCreateFromIntentArgs = {
  importState: InputMaybe<Scalars["Boolean"]["input"]>;
  project: Scalars["ID"]["input"];
  stackName: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationStackDeleteArgs = {
  destroyResources: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationStackDependenciesAddReferenceArgs = {
  reference: StackDependencyReferenceInput;
  stackDependencyID: Scalars["ID"]["input"];
};

export type MutationStackDependenciesAddReferencesArgs = {
  references: Array<StackDependencyReferenceInput>;
  stackDependencyID: Scalars["ID"]["input"];
};

export type MutationStackDependenciesCreateInBatchArgs = {
  input: StackDependencyBatchInput;
};

export type MutationStackDependenciesDeleteReferenceArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackDependenciesDeleteReferencesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationStackDependenciesUpdateReferenceArgs = {
  reference: StackDependencyReferenceUpdateInput;
};

export type MutationStackDependenciesUpdateReferencesArgs = {
  references: Array<StackDependencyReferenceUpdateInput>;
};

export type MutationStackDependencyCreateArgs = {
  input: StackDependencyInput;
};

export type MutationStackDependencyDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackDependencyUpdateArgs = {
  input: StackDependencyUpdateInput;
};

export type MutationStackDisableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackEnableArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackIntegrationAwsCreateArgs = {
  durationSeconds: InputMaybe<Scalars["Int"]["input"]>;
  externalID: InputMaybe<Scalars["String"]["input"]>;
  generateCredentialsInWorker: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
  region: InputMaybe<Scalars["String"]["input"]>;
  roleArn: Scalars["String"]["input"];
};

export type MutationStackIntegrationAwsDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackIntegrationDriftDetectionCreateArgs = {
  input: DriftDetectionIntegrationInput;
  stack: Scalars["ID"]["input"];
};

export type MutationStackIntegrationDriftDetectionDeleteArgs = {
  stack: Scalars["ID"]["input"];
};

export type MutationStackIntegrationDriftDetectionUpdateArgs = {
  input: DriftDetectionIntegrationInput;
  stack: Scalars["ID"]["input"];
};

export type MutationStackIntegrationGcpCreateArgs = {
  id: Scalars["ID"]["input"];
  tokenScopes: Array<Scalars["String"]["input"]>;
};

export type MutationStackIntegrationGcpDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackLockArgs = {
  id: Scalars["ID"]["input"];
  note: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationStackManagedStateImportArgs = {
  stackId: Scalars["ID"]["input"];
  state: Scalars["String"]["input"];
};

export type MutationStackManagedStateRollbackArgs = {
  managedStateVersionId: Scalars["String"]["input"];
  stackId: Scalars["ID"]["input"];
};

export type MutationStackMigrateVendorArgs = {
  config: InputMaybe<StackVendorMigrationInput>;
  id: Scalars["ID"]["input"];
  targetVendor: StackVendor;
};

export type MutationStackMigrateVendorAllArgs = {
  config: InputMaybe<StackVendorMigrationInput>;
  targetVendor: StackVendor;
};

export type MutationStackReslugArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackRoleBindingBatchCreateArgs = {
  input: StackRoleBindingBatchInput;
};

export type MutationStackRoleBindingCreateArgs = {
  input: StackRoleBindingInput;
};

export type MutationStackRoleBindingDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackRoleBindingUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: StackRoleBindingUpdateInput;
};

export type MutationStackScheduledDeleteCreateArgs = {
  input: ScheduledDeleteInput;
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledDeleteDeleteArgs = {
  scheduledDelete: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledDeleteUpdateArgs = {
  input: ScheduledDeleteInput;
  scheduledDelete: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledRunCreateArgs = {
  input: ScheduledRunInput;
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledRunDeleteArgs = {
  scheduledRun: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledRunUpdateArgs = {
  input: ScheduledRunInput;
  scheduledRun: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledTaskCreateArgs = {
  input: ScheduledTaskInput;
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledTaskDeleteArgs = {
  scheduledTask: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackScheduledTaskUpdateArgs = {
  input: ScheduledTaskInput;
  scheduledTask: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationStackSetCurrentCommitArgs = {
  id: Scalars["ID"]["input"];
  sha: Scalars["String"]["input"];
};

export type MutationStackSyncCommitArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackUnlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationStackUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: StackInput;
};

export type MutationStarSetArgs = {
  id: Scalars["ID"]["input"];
  star: Scalars["Boolean"]["input"];
};

export type MutationStateDownloadUrlArgs = {
  input: StateDownloadUrlInput;
};

export type MutationTaskCreateArgs = {
  command: Scalars["String"]["input"];
  skipInitialization: InputMaybe<Scalars["Boolean"]["input"]>;
  stack: Scalars["ID"]["input"];
};

export type MutationTemplateCreateArgs = {
  input: TemplateCreateInput;
};

export type MutationTemplateDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTemplateDeploymentCreateArgs = {
  id: Scalars["ID"]["input"];
  input: TemplateDeploymentCreateInput;
};

export type MutationTemplateDeploymentDeleteArgs = {
  id: Scalars["ID"]["input"];
  skipStackDeletion: InputMaybe<Scalars["Boolean"]["input"]>;
  templateID: Scalars["ID"]["input"];
};

export type MutationTemplateDeploymentRollbackArgs = {
  changeRecordID: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
  templateID: Scalars["ID"]["input"];
};

export type MutationTemplateDeploymentUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: TemplateDeploymentUpdateInput;
  templateID: Scalars["ID"]["input"];
};

export type MutationTemplateUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: TemplateUpdateInput;
};

export type MutationTemplateVersionCreateArgs = {
  input: TemplateVersionCreateInput;
};

export type MutationTemplateVersionDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTemplateVersionDeprecateArgs = {
  id: Scalars["ID"]["input"];
  input: InputMaybe<TemplateVersionDeprecateInput>;
};

export type MutationTemplateVersionParseTemplateArgs = {
  template: Scalars["String"]["input"];
};

export type MutationTemplateVersionUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: TemplateVersionUpdateInput;
};

export type MutationTerraformProviderCreateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  space: Scalars["ID"]["input"];
  type: Scalars["ID"]["input"];
};

export type MutationTerraformProviderDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTerraformProviderSetVisibilityArgs = {
  id: Scalars["ID"]["input"];
  public: Scalars["Boolean"]["input"];
};

export type MutationTerraformProviderUpdateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  space: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionCreateArgs = {
  input: TerraformProviderVersionInput;
  provider: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionDeleteArgs = {
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionPublishArgs = {
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionRegisterPlatformArgs = {
  input: TerraformProviderVersionPlatformInput;
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionRegisterPlatformV2Args = {
  input: TerraformProviderVersionPlatformInput;
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionRevokeArgs = {
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionUpdateArgs = {
  description: Scalars["String"]["input"];
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionUploadDocsArgs = {
  archive: Scalars["String"]["input"];
  version: Scalars["ID"]["input"];
};

export type MutationTerraformProviderVersionVerifyArgs = {
  version: Scalars["ID"]["input"];
};

export type MutationTofuWorkspaceUnlockArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTofuWorkspaceUnlockAllArgs = {
  stack: Scalars["ID"]["input"];
};

export type MutationTrackUserEventArgs = {
  context: InputMaybe<Scalars["String"]["input"]>;
  name: InputMaybe<Scalars["String"]["input"]>;
  properties: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUiConfigStoreArgs = {
  input: Scalars["String"]["input"];
};

export type MutationUploadLocalWorkspaceArgs = {
  stack: Scalars["ID"]["input"];
};

export type MutationUserGroupRoleBindingBatchCreateArgs = {
  input: UserGroupRoleBindingBatchInput;
};

export type MutationUserGroupRoleBindingCreateArgs = {
  input: UserGroupRoleBindingInput;
};

export type MutationUserGroupRoleBindingDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUserGroupRoleBindingUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: UserGroupRoleBindingInput;
};

export type MutationUserGuideCertificationCreateArgs = {
  displayName: Scalars["String"]["input"];
  groupID: Scalars["String"]["input"];
};

export type MutationUserGuideCertificationUpdateArgs = {
  displayName: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationUserGuideRestartArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUserGuideStartArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUserRoleBindingBatchCreateArgs = {
  input: UserRoleBindingBatchInput;
};

export type MutationUserRoleBindingCreateArgs = {
  input: UserRoleBindingInput;
};

export type MutationUserRoleBindingDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUserRoleBindingUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: UserRoleBindingInput;
};

export type MutationVcsAgentPoolCreateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type MutationVcsAgentPoolDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationVcsAgentPoolResetArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationVcsAgentPoolUpdateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationVersionAnnotateArgs = {
  id: Scalars["ID"]["input"];
  module: Scalars["ID"]["input"];
  notes: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationVersionCreateArgs = {
  commitSha: InputMaybe<Scalars["String"]["input"]>;
  module: Scalars["ID"]["input"];
  version: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationVersionDeleteArgs = {
  id: Scalars["ID"]["input"];
  module: Scalars["ID"]["input"];
};

export type MutationVersionProposeLocalWorkspaceArgs = {
  module: Scalars["ID"]["input"];
  testIds: InputMaybe<Array<Scalars["String"]["input"]>>;
  workspace: Scalars["ID"]["input"];
};

export type MutationVersionPushArgs = {
  commitMessage: Scalars["String"]["input"];
  commitSha: Scalars["String"]["input"];
  module: Scalars["ID"]["input"];
  tarballURL: Scalars["String"]["input"];
  version: Scalars["String"]["input"];
};

export type MutationVersionTriggerArgs = {
  id: Scalars["ID"]["input"];
  module: Scalars["ID"]["input"];
};

export type MutationVersionYankArgs = {
  id: Scalars["ID"]["input"];
  module: Scalars["ID"]["input"];
  note: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationWebhooksIntegrationCreateArgs = {
  input: WebhooksIntegrationInput;
  stack: Scalars["ID"]["input"];
};

export type MutationWebhooksIntegrationDeleteArgs = {
  id: Scalars["ID"]["input"];
  stack: Scalars["ID"]["input"];
};

export type MutationWebhooksIntegrationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: WebhooksIntegrationInput;
  stack: Scalars["ID"]["input"];
};

export type MutationWorkerDrainSetArgs = {
  drain: Scalars["Boolean"]["input"];
  id: Scalars["ID"]["input"];
  workerPool: Scalars["ID"]["input"];
};

export type MutationWorkerPoolCreateArgs = {
  certificateSigningRequest: Scalars["String"]["input"];
  description: InputMaybe<Scalars["String"]["input"]>;
  driftDetectionRunLimit: InputMaybe<Scalars["Int"]["input"]>;
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  preparingTimeoutSeconds: InputMaybe<Scalars["Int"]["input"]>;
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationWorkerPoolCycleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationWorkerPoolDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationWorkerPoolResetArgs = {
  certificateSigningRequest: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationWorkerPoolUpdateArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
  driftDetectionRunLimit: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["ID"]["input"];
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
  preparingTimeoutSeconds: InputMaybe<Scalars["Int"]["input"]>;
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type NamedWebhookHeaderInput = {
  entries: Array<KeyValuePair>;
};

/** A NamedWebhooksIntegration is a webhooks integration attached to a space with a name that can be referenced via notification policies. Each space can have one or more integration, allowing notification policies to route notifications to different webhook endpoints. */
export type NamedWebhooksIntegration = {
  __typename?: "NamedWebhooksIntegration";
  /** CreatedAt is unix timestamp (in seconds) at which the webhook was created */
  createdAt: Scalars["Int"]["output"];
  /** Indicates whether the integration has been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /**
   * Paginated list of deliveries from this integration. The optional opaque
   * token is used for pagination and should be copied from the previous
   * WebhookDeliveries response.
   */
  deliveries: Maybe<WebhookDeliveries>;
  /** Extended details of a single delivery. */
  deliveryDetails: Maybe<WebhookDeliveryDetails>;
  /** Enable or disable sending webhooks */
  enabled: Scalars["Boolean"]["output"];
  /** User provided endpoint to send webhooks to */
  endpoint: Scalars["String"]["output"];
  /** Named Webhooks Integration ID */
  id: Scalars["ID"]["output"];
  /** Labels associated with the endpoint. This can be used for matching in notification policies. */
  labels: Array<Scalars["String"]["output"]>;
  /** Name of the webhooks endpoint */
  name: Scalars["String"]["output"];
  /**
   * Plugin that is managing the webhook.
   * Used to indicate that modifications are restricted by a plugin action.
   */
  plugin: Maybe<Plugin>;
  retryOnFailure: Scalars["Boolean"]["output"];
  /**
   * Secret to be hashed and sent with payload
   * @deprecated This property is no longer used.
   */
  secret: Scalars["String"]["output"];
  /**
   * Secret headers is a list of header keys which are set for this webhook.
   * Only the keys are returned as values potentially have sensitive data.
   */
  secretHeaders: Array<Scalars["String"]["output"]>;
  /** Space to which this integration belongs. */
  space: Space;
};

/** A NamedWebhooksIntegration is a webhooks integration attached to a space with a name that can be referenced via notification policies. Each space can have one or more integration, allowing notification policies to route notifications to different webhook endpoints. */
export type NamedWebhooksIntegrationDeliveriesArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

/** A NamedWebhooksIntegration is a webhooks integration attached to a space with a name that can be referenced via notification policies. Each space can have one or more integration, allowing notification policies to route notifications to different webhook endpoints. */
export type NamedWebhooksIntegrationDeliveryDetailsArgs = {
  key: Scalars["String"]["input"];
};

export type NamedWebhooksIntegrationConnection = {
  __typename?: "NamedWebhooksIntegrationConnection";
  cursor: Scalars["String"]["output"];
  node: NamedWebhooksIntegration;
};

export type NamedWebhooksIntegrationInput = {
  /** Enable or disable sending webhooks */
  enabled: Scalars["Boolean"]["input"];
  /** User endpoint to send webhooks */
  endpoint: Scalars["String"]["input"];
  /** Labels for the integration */
  labels: Array<Scalars["String"]["input"]>;
  /** Name for the endpoint */
  name: Scalars["String"]["input"];
  retryOnFailure: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Secret to be hashed and sent with payload */
  secret: InputMaybe<Scalars["String"]["input"]>;
  /** Space to use for this integration */
  space: Scalars["ID"]["input"];
};

/** A newly created version of a managed Terraform provider. */
export type NewTerraformProviderVersion = {
  __typename?: "NewTerraformProviderVersion";
  /**
   * Upload Headers for the SHA256SUMS.sig file, that should be send with the presign request.
   * Only populated when creating the version.
   */
  sha256SumsSigUploadHeaders: Maybe<StringMap>;
  /**
   * Upload URL for the SHA256SUMS.sig file. Only populated when creating the
   * version.
   */
  sha256SumsSigUploadURL: Scalars["String"]["output"];
  /**
   * Upload Headersfor the SHA256SUMS file that should be send with the presign request.
   * Only populated when creating the version.
   */
  sha256SumsUploadHeaders: Maybe<StringMap>;
  /**
   * Upload URL for the SHA256SUMS file. Only populated when creating the
   * version.
   */
  sha256SumsUploadURL: Scalars["String"]["output"];
  /** Newly created version. */
  version: Maybe<TerraformProviderVersion>;
};

export type Notifiable = {
  notificationCount: Scalars["Int"]["output"];
};

/** Notification represents a single notification. */
export type Notification = {
  __typename?: "Notification";
  /** Body of the notification. */
  body: Scalars["String"]["output"];
  /** Dismissed indicates whether a user dismissed a notification. */
  dismissed: Scalars["Boolean"]["output"];
  /** GroupingKey is for marking the same issues. */
  groupingKey: Scalars["ID"]["output"];
  /** Globally unique ID of the notification. */
  id: Scalars["ID"]["output"];
  /** Unix timestamp representing the last occurrence of the notification. */
  lastOccurrenceAt: Scalars["Int"]["output"];
  /** Number of occurrences of the notification. */
  occurrencesCount: Scalars["Int"]["output"];
  /** Notification severity. */
  severity: NotificationSeverity;
  /** Entity to which notification is attached. */
  target: Scalars["ID"]["output"];
  /** Unix timestamp representing Notification creation. */
  timestamp: Scalars["Int"]["output"];
  /** Title of the notification. */
  title: Scalars["String"]["output"];
  /** Type of the notification. */
  type: NotificationType;
};

/** NotificationConnection represents a single notification in a page of results. */
export type NotificationConnection = {
  __typename?: "NotificationConnection";
  cursor: Scalars["String"]["output"];
  node: Notification;
};

export enum NotificationSeverity {
  Error = "ERROR",
  Info = "INFO",
  Warning = "WARNING",
}

export enum NotificationType {
  Account = "ACCOUNT",
  AwsIntegration = "AWS_INTEGRATION",
  Module = "MODULE",
  Policy = "POLICY",
  Stack = "STACK",
  WorkerPool = "WORKER_POOL",
}

/** OAuthRedirect is a response to an OAuth redirect query. */
export type OAuthRedirect = {
  __typename?: "OAuthRedirect";
  /**
   * enabled indicates whether logging in via the OAuth redirect is enabled or not. It
   * can be disabled for Self-Hosted accounts where no SSO configuration has been setup yet.
   */
  enabled: Scalars["Boolean"]["output"];
  /** Full URL to the identity provider (GitHub or Slack). */
  providerUrl: Scalars["String"]["output"];
  /** Temporary token to be persisted in the browser. */
  temporaryToken: Scalars["String"]["output"];
};

/** OIDCSettings represent account's OIDC settings */
export type OidcSettings = {
  __typename?: "OIDCSettings";
  /**
   * Login of the user who always gets an administrative access to the account.
   * This is meant to prevent locking yourself out of the account if the settings
   * are incorrect.
   */
  adminLogin: Maybe<Scalars["String"]["output"]>;
  /** contains custom claims mapping */
  claimMapping: ClaimMapping;
  /**  client id authorized by Identity Provider to initialize Oauth 2.0 authorization flow */
  clientId: Scalars["String"]["output"];
  /** address of the Identity Provider to initialize Oauth 2.0 authorization flow (e.g. https://accounts.google.com) */
  identityProviderHost: Scalars["String"]["output"];
};

export type OidcUpdateInput = {
  claimMapping: InputMaybe<ClaimMappingInput>;
};

/**
 * ObservabilityProcessingStatus says how far a run's observability data got
 * through the pipeline that produces it.
 */
export enum ObservabilityProcessingStatus {
  /** AVAILABLE means the data is stored and can be read. */
  Available = "AVAILABLE",
  /** NOT_ELIGIBLE means the run will never produce this data. */
  NotEligible = "NOT_ELIGIBLE",
  /**
   * NOT_ELIGIBLE_TERRAFORM_VENDOR is a subtype of NOT_ELIGIBLE: the run uses
   * the Terraform vendor, which captures nothing.
   */
  NotEligibleTerraformVendor = "NOT_ELIGIBLE_TERRAFORM_VENDOR",
  /**
   * PARTIAL_DATA_AVAILABLE means the run has not finished, but it already
   * produced some data that can be shown to the user.
   */
  PartialDataAvailable = "PARTIAL_DATA_AVAILABLE",
  /**
   * PROCESSING means the data has not landed yet, and is expected. The run
   * has not finished just yet, or it finished recently and the pipeline still
   * has work to do on it.
   */
  Processing = "PROCESSING",
  /**
   * UNAVAILABLE means the data should be there and we cannot find it. Usually
   * the processing window has passed, so something went wrong: the pipeline
   * failed somewhere, or the run never uploaded anything.
   */
  Unavailable = "UNAVAILABLE",
}

/** Certificate earned by a user */
export type OnboardingCertificate = {
  __typename?: "OnboardingCertificate";
  /** Name of the course for which the certificate was issued */
  courseName: Scalars["String"]["output"];
  /** Unique identifier (ULID) */
  id: Scalars["ID"]["output"];
  /** Unix timestamp of when the certificate was issued */
  issuedAt: Scalars["Int"]["output"];
};

/** Mission group associated with a user's onboarding progress */
export type OnboardingMission = {
  __typename?: "OnboardingMission";
  /** ID of the user guide group */
  groupID: Scalars["String"]["output"];
};

/** Onboarding progress for a single user */
export type OnboardingProgress = {
  __typename?: "OnboardingProgress";
  /** Certificates earned by the user */
  certificates: Maybe<Array<OnboardingCertificate>>;
  /** Mission groups the user has completed */
  completedMissions: Maybe<Array<OnboardingMission>>;
  /** Mission groups the user has in progress */
  inProgressMissions: Maybe<Array<OnboardingMission>>;
  /** Percentage of completed objectives out of all objectives */
  percentage: Scalars["Int"]["output"];
  /** Login of the user */
  userLogin: Scalars["String"]["output"];
};

/** A feature that an OpenTofu version may support. */
export enum OpenTofuFeature {
  Concise = "CONCISE",
  ConcisePlan = "CONCISE_PLAN",
  CpuProfiling = "CPU_PROFILING",
  EphemeralResources = "EPHEMERAL_RESOURCES",
  JsonInto = "JSON_INTO",
  OtelTracing = "OTEL_TRACING",
  StateEncryption = "STATE_ENCRYPTION",
}

/** Reports whether a specific OpenTofu feature is supported for a given version. */
export type OpenTofuFeatureCheck = {
  __typename?: "OpenTofuFeatureCheck";
  /** The feature being checked. */
  feature: OpenTofuFeature;
  /** The minimum OpenTofu version required for this feature. Null when supported. */
  requiredVersion: Maybe<Scalars["String"]["output"]>;
  /** Whether the feature is supported. */
  supported: Scalars["Boolean"]["output"];
};

/** Result of an openTofuMigrate enqueue call. */
export type OpenTofuMigrateResult = {
  __typename?: "OpenTofuMigrateResult";
  /** Number of stacks enqueued for migration/rollback in this call. */
  queued: Scalars["Int"]["output"];
};

/**
 * Headline counters for the Terraform -> OpenTofu migration. Account-wide: these
 * ignore any predicates the queue view has applied, so a filtered list will not
 * add up to them. Per-state counts that follow the filter come from
 * openTofuMigrationQueueSearchSuggestions instead.
 */
export type OpenTofuMigrationCounts = {
  __typename?: "OpenTofuMigrationCounts";
  /**
   * Stacks eligible for migration that are not queued right now — exactly what
   * openTofuMigrate(target: OpenTofu) with no predicates would enqueue, and the
   * same cohort openTofuMigrateSearch(target: OpenTofu) lists. Covers stacks
   * with no queue entry as well as ones whose last attempt ended in a terminal
   * ROLLEDBACK or FAILED state, since those can be re-driven.
   */
  eligibleToMigrate: Scalars["Int"]["output"];
  /**
   * Queue entries in state FAILED: the migration or rollback errored, see the
   * entry's note. A failed *migration* is normally also counted in
   * eligibleToMigrate, since re-issuing openTofuMigrate re-drives it. A failed
   * *rollback* is not: the stack still has vendor OpenTofu, so it belongs to
   * the rollback cohort, not the migration one. FAILED is a single state for
   * both directions, so this counter and eligibleToMigrate never have to move
   * together.
   */
  failed: Scalars["Int"]["output"];
  /**
   * Queue entries in state MIGRATED: successfully migrated to native OpenTofu
   * and not rolled back since.
   */
  migrated: Scalars["Int"]["output"];
  /** Queue entries in state TO_MIGRATE: picked up, not yet processed. */
  queuedToMigrate: Scalars["Int"]["output"];
  /** Queue entries in state TO_ROLLBACK: rollback requested, not yet processed. */
  queuedToRollback: Scalars["Int"]["output"];
  /**
   * Queue entries in state ROLLEDBACK: rolled back to the legacy Terraform
   * shape. Normally also counted in eligibleToMigrate, since a rolled-back
   * stack can be migrated again.
   */
  rolledBack: Scalars["Int"]["output"];
};

/** Result of an openTofuMigrationQueueClean call. */
export type OpenTofuMigrationQueueCleanResult = {
  __typename?: "OpenTofuMigrationQueueCleanResult";
  /** Number of pending entries removed from the queue. */
  removed: Scalars["Int"]["output"];
};

/** A single row in opentofu_migration_stacks exposed to the API. */
export type OpenTofuMigrationQueueEntry = {
  __typename?: "OpenTofuMigrationQueueEntry";
  /** Unix timestamp (seconds) when the queue entry was created. */
  createdAt: Scalars["Int"]["output"];
  /** Migration queue entry ID. */
  id: Scalars["ID"]["output"];
  /** Optional human-readable note. Set by the drain when migration fails. */
  note: Maybe<Scalars["String"]["output"]>;
  /** The stack being migrated. */
  stack: Stack;
  /** Current state of the migration request. */
  state: OpenTofuMigrationState;
  /** Unix timestamp (seconds) when the state was last updated. */
  updatedAt: Scalars["Int"]["output"];
};

export type OpenTofuMigrationQueueEntryConnection = {
  __typename?: "OpenTofuMigrationQueueEntryConnection";
  cursor: Scalars["String"]["output"];
  node: OpenTofuMigrationQueueEntry;
};

/** Paginated search output for the OpenTofu migration queue. */
export type OpenTofuMigrationQueueSearchOutput = {
  __typename?: "OpenTofuMigrationQueueSearchOutput";
  edges: Array<OpenTofuMigrationQueueEntryConnection>;
  pageInfo: PageInfo;
};

/** Current state of a row in the OpenTofu migration queue. */
export enum OpenTofuMigrationState {
  /**
   * Migration or rollback failed. See note for details. Resume by re-issuing
   * openTofuMigrate that matches this stack.
   */
  Failed = "FAILED",
  /** Successfully migrated to native OpenTofu vendor. */
  Migrated = "MIGRATED",
  /** Successfully rolled back to legacy Terraform vendor. */
  Rolledback = "ROLLEDBACK",
  /** Queued for migration to native OpenTofu vendor. */
  ToMigrate = "TO_MIGRATE",
  /** Queued for rollback to legacy Terraform vendor. */
  ToRollback = "TO_ROLLBACK",
}

export type OpenTofuRuntimeConfig = {
  __typename?: "OpenTofuRuntimeConfig";
  /**
   * When enabled, Spacelift passes -concise to tofu plan/apply/refresh to suppress "Refreshing state..." progress output.
   * Requires OpenTofu 1.7+ at runtime; the flag is silently omitted on older versions.
   * If you're running OpenTofu 1.10+, concise flag will be also used in apply.
   */
  concise: Scalars["Boolean"]["output"];
  /**
   * When enabled, Spacelift captures CPU profiles from OpenTofu init, plan, and apply phases.
   * Requires OpenTofu 1.11+ at runtime; silently omitted on older versions.
   */
  enableCPUProfiling: Scalars["Boolean"]["output"];
  /** Whether external state access is enabled. */
  externalStateAccessEnabled: Scalars["Boolean"]["output"];
  /** Whether smart sanitization is enabled. */
  useSmartSanitization: Scalars["Boolean"]["output"];
  /**
   * The version of OpenTofu used.
   * If the tool is CUSTOM, it's not defined.
   */
  version: Maybe<Scalars["String"]["output"]>;
  /** Defines the tool that will be used to execute the workflow. */
  workflowTool: OpenTofuWorkflowTool;
};

export enum OpenTofuWorkflowTool {
  /** A custom workflow tool. */
  Custom = "CUSTOM",
  /** OpenTofu. */
  Opentofu = "OPENTOFU",
}

/**
 * OriginIntegration shows the built-in Origin (Cursor) integration details. Origin
 * is a singleton per account (always default, root space), backed by a global
 * Spacelift-owned app, so there are no host/credential fields.
 */
export type OriginIntegration = {
  __typename?: "OriginIntegration";
  /** Slug of the Origin namespace (owner) the app is installed on. Null when unknown. */
  installationTarget: Maybe<Scalars["String"]["output"]>;
  /** Repository selection mode granted at install time ("all" or "selected"). */
  repoSelectionMode: Maybe<Scalars["String"]["output"]>;
  /** Scopes granted to the Origin app installation. */
  scopes: Array<Scalars["String"]["output"]>;
  /** When true, run source is fetched via git checkout rather than an archive download. */
  useGitCheckout: Scalars["Boolean"]["output"];
  /** Additional options tuning VCS check reporting behavior. */
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  /** How VCS checks are reported back to Origin (individual per stack or aggregated). */
  vcsChecks: VcsCheck;
};

export type PageInfo = {
  __typename?: "PageInfo";
  /** Cursor of the last item in the list */
  endCursor: Scalars["String"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** Cursor of the first item in the list */
  startCursor: Scalars["String"]["output"];
};

export type PersonalApiKeyInput = {
  description: InputMaybe<Scalars["String"]["input"]>;
  expiresAt: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The outcome of a collection of plan policies for a Run. */
export type PlanPoliciesOutcome = {
  __typename?: "PlanPoliciesOutcome";
  /** Unix timestamp representing plan policy evaluation time. */
  createdAt: Scalars["Int"]["output"];
  /** List of deny messages. */
  deny: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** List of warning messages. */
  warn: Array<Scalars["String"]["output"]>;
};

/**
 * Plugin represents a reusable component that can be attached to various entities
 * to extend functionality within Spacelift.
 */
export type Plugin = {
  __typename?: "Plugin";
  /** Unix timestamp representing the plugin creation. */
  createdAt: Scalars["Int"]["output"];
  /** Description of the plugin. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of the plugin. */
  id: Scalars["ID"]["output"];
  /** Label-based identifier for the plugin. */
  labelIdentifier: Scalars["String"]["output"];
  /** Arbitrary labels set by the user. */
  labels: Array<Scalars["String"]["output"]>;
  /** Plugin manifest containing configuration and metadata. */
  manifest: Scalars["String"]["output"];
  /** Human-readable name of the plugin. */
  name: Scalars["String"]["output"];
  /** Original plugin template used to create the plugin */
  pluginTemplateDetails: Maybe<PluginTemplate>;
  /** URL-safe slug for the plugin. */
  slug: Scalars["String"]["output"];
  /** Details of the space this Plugin belongs to. */
  spaceDetails: Space;
  /** Unix timestamp representing the plugin last update. */
  updatedAt: Scalars["Int"]["output"];
};

/** All arguments to install a Plugin. */
export type PluginInstallInput = {
  /** Label-based identifier for the plugin. */
  labelIdentifier: Scalars["String"]["input"];
  /** User-defined labels for the Plugin. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the plugin. */
  name: Scalars["String"]["input"];
  /** Plugin parameters with values */
  parameters: InputMaybe<Array<PluginInstallParameterInput>>;
  /** Plugin template used to install the plugin */
  pluginTemplateID: Scalars["ID"]["input"];
  /** ID of the space this Plugin will belong to. */
  space: Scalars["ID"]["input"];
};

/** Plugin template parameter input. */
export type PluginInstallParameterInput = {
  /** Unique identifier */
  id: Scalars["String"]["input"];
  /** Value of the parameter */
  value: Scalars["String"]["input"];
};

export type PluginLogsResponse = {
  __typename?: "PluginLogsResponse";
  message: LogMessage;
  pluginName: Scalars["String"]["output"];
};

/**
 * Plugin template represents a reusable plugin configuration that can be used
 * to create plugin instances.
 */
export type PluginTemplate = {
  __typename?: "PluginTemplate";
  /** Unix timestamp representing the plugin template creation. */
  createdAt: Scalars["Int"]["output"];
  /** Description of the plugin template. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of the plugin template. */
  id: Scalars["ID"]["output"];
  /** Global plugins are native to Spacelift and cannot be removed */
  isGlobal: Scalars["Boolean"]["output"];
  /** Arbitrary labels set by the user. */
  labels: Array<Scalars["String"]["output"]>;
  /** Plugin template manifest containing configuration and metadata. */
  manifest: Scalars["String"]["output"];
  /** Human-readable name of the plugin template. */
  name: Scalars["String"]["output"];
  /** Template parameters as JSON */
  parameters: Array<PluginTemplateParameter>;
  /** URL-safe slug for the plugin template. */
  slug: Scalars["String"]["output"];
  /** Unix timestamp representing the plugin template last update. */
  updatedAt: Scalars["Int"]["output"];
};

/** All arguments to create a Plugin Template. */
export type PluginTemplateCreateInput = {
  /** Description of the plugin template. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** User-defined labels for the Plugin Template. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Plugin template manifest containing configuration and metadata. */
  manifest: Scalars["String"]["input"];
  /** Name of the plugin template. */
  name: Scalars["String"]["input"];
};

/** Plugin template parameter configuration */
export type PluginTemplateParameter = {
  __typename?: "PluginTemplateParameter";
  /** The default value for the parameter */
  default: Maybe<Scalars["String"]["output"]>;
  /** Parameter description */
  description: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier */
  id: Scalars["String"]["output"];
  /** Parameter name */
  name: Scalars["String"]["output"];
  /** Whether the parameter is required */
  required: Scalars["Boolean"]["output"];
  /** Whether the parameter contains sensitive data */
  sensitive: Scalars["Boolean"]["output"];
  /** Parameter type */
  type: PluginTemplateParameterType;
};

export enum PluginTemplateParameterType {
  Boolean = "BOOLEAN",
  None = "NONE",
  Number = "NUMBER",
  String = "STRING",
}

/** All arguments to update a Plugin. */
export type PluginUpdateInput = {
  /** Description of the plugin. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** User-defined labels for the Plugin. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the plugin. */
  name: Scalars["String"]["input"];
};

/**
 * Policy is a rule or collection of rules that allow injecting custom logic into
 * Spacelift's decision points.
 */
export type Policy = Notifiable & {
  __typename?: "Policy";
  /** List of intent projects attached to this Policy */
  attachedIntentProjects: Array<PolicyIntentProjectAttachment>;
  /** Single stack attachment for this Policy. */
  attachedStack: Maybe<PolicyStackAttachment>;
  /** List of Stacks attached to this Policy. */
  attachedStacks: Array<PolicyStackAttachment>;
  /** Body of the policy. */
  body: Scalars["String"]["output"];
  /** Unix timestamp representing the policy creation. */
  createdAt: Scalars["Int"]["output"];
  /** Description of the policy. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Type of policy engine that will be used to evaluate this policy */
  engineType: PolicyEngineType;
  /**
   * List of all the policy evaluation records available in the account,
   * associated with this policy.
   */
  evaluationRecords: Array<PolicyEvaluationRecord>;
  /** Returns a single policy evaluation sample. */
  evaluationSample: Maybe<PolicyEvaluationSample>;
  /** Indicates whether any intent projects are attached to this policy */
  hasAttachedIntentProjects: Scalars["Boolean"]["output"];
  /** Indicates whether any stacks are attached to this policy, either directly or via auto-attachment. */
  hasAttachedStacks: Scalars["Boolean"]["output"];
  /** Unique (within a single organization), immutable name of the policy. */
  id: Scalars["ID"]["output"];
  /** User-defined labels set on the Policy. */
  labels: Array<Scalars["String"]["output"]>;
  /** Name of the policy. */
  name: Scalars["String"]["output"];
  /** Number of the new policy notifications. */
  notificationCount: Scalars["Int"]["output"];
  /**
   * Plugin that is managing the policy.
   * Used to indicate that modifications are restricted to plugin actions.
   */
  plugin: Maybe<Plugin>;
  sampleCount: Scalars["Int"]["output"];
  searchEvaluationRecordSuggestions: SearchSuggestionsOutput;
  searchEvaluationRecords: SearchPolicyEvaluationRecordOutput;
  /** ID of the space this Policy belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this Policy belongs to. */
  spaceDetails: Space;
  /** Type of the policy. */
  type: PolicyType;
  /** Unix timestamp of the last policy update. */
  updatedAt: Scalars["Int"]["output"];
};

/**
 * Policy is a rule or collection of rules that allow injecting custom logic into
 * Spacelift's decision points.
 */
export type PolicyAttachedStackArgs = {
  id: Scalars["ID"]["input"];
};

/**
 * Policy is a rule or collection of rules that allow injecting custom logic into
 * Spacelift's decision points.
 */
export type PolicyEvaluationSampleArgs = {
  key: Scalars["String"]["input"];
};

/**
 * Policy is a rule or collection of rules that allow injecting custom logic into
 * Spacelift's decision points.
 */
export type PolicySearchEvaluationRecordSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/**
 * Policy is a rule or collection of rules that allow injecting custom logic into
 * Spacelift's decision points.
 */
export type PolicySearchEvaluationRecordsArgs = {
  input: SearchInput;
};

export type PolicyConnection = {
  __typename?: "PolicyConnection";
  cursor: Scalars["String"]["output"];
  node: Policy;
};

/** All arguments to create an individual Policy. */
export type PolicyCreateInput = {
  /** Body of the policy. */
  body: Scalars["String"]["input"];
  /** Description of the policy. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Engine type of the policy. */
  engineType: InputMaybe<PolicyEngineType>;
  /** User-defined labels for the Policy. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the policy. */
  name: Scalars["String"]["input"];
  /** Optional ULID of a template that is used to create the policy. */
  policyTemplateULID: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the space this Policy will belong to. */
  space: InputMaybe<Scalars["ID"]["input"]>;
  /** Type of the policy. */
  type: PolicyType;
};

/** PolicyEngineType represents a type of policy engine that will be used to evaluate policy */
export enum PolicyEngineType {
  RegoV0 = "REGO_V0",
  RegoV1 = "REGO_V1",
}

/**
 * PolicyEvaluationRecord is a record of policy evaluation. It contains a key,
 * which can be separately used to retrieve the associated
 * PolicyEvaluationSample.
 */
export type PolicyEvaluationRecord = {
  __typename?: "PolicyEvaluationRecord";
  /** Key of the policy input. */
  key: Scalars["String"]["output"];
  /** Outcome of evaluating policy. */
  outcome: Scalars["String"]["output"];
  /** Unix timestamp of policy evaluation. */
  timestamp: Scalars["Int"]["output"];
};

export type PolicyEvaluationRecordConnection = {
  __typename?: "PolicyEvaluationRecordConnection";
  cursor: Scalars["String"]["output"];
  node: PolicyEvaluationRecord;
};

/** PolicyEvaluationSample represents a single instance of policy evaluation. */
export type PolicyEvaluationSample = {
  __typename?: "PolicyEvaluationSample";
  /** Body of the original policy. */
  body: Scalars["String"]["output"];
  /** Error of the policy evaluation. */
  error: Scalars["String"]["output"];
  /** Input to the original policy evaluation. */
  input: Scalars["String"]["output"];
  /** List of libraries used while evaluating the policy. */
  libraries: Array<SampledPolicyLibrary>;
  /** Synthetic (single-word) representation of the policy outcome. */
  outcome: Scalars["String"]["output"];
  /** String representation of Rego/OPA policy evaluation results. */
  results: Scalars["String"]["output"];
};

/** A real policy input stored for people writing policies, without the values the policy contract marks as sensitive. */
export type PolicyInputCapture = {
  __typename?: "PolicyInputCapture";
  /** Unix timestamp of the capture. */
  capturedAt: Scalars["Int"]["output"];
  /** An opaque id to pass to policyInputCapture. */
  id: Scalars["ID"]["output"];
  /** The input as a JSON document. Null when a newer capture replaced it in the meantime. */
  input: Maybe<Scalars["String"]["output"]>;
  kind: PolicyInputCaptureKind;
};

/** The event that produced a captured policy input. Every policy type has one kind, except trigger, which has one per event. */
export enum PolicyInputCaptureKind {
  Access = "ACCESS",
  Approval = "APPROVAL",
  GitPush = "GIT_PUSH",
  Login = "LOGIN",
  Notification = "NOTIFICATION",
  Plan = "PLAN",
  Task = "TASK",
  TriggerModuleVersion = "TRIGGER_MODULE_VERSION",
  TriggerRunFinish = "TRIGGER_RUN_FINISH",
}

/** A captured policy input as listed, without its content. */
export type PolicyInputCaptureSummary = {
  __typename?: "PolicyInputCaptureSummary";
  /** Unix timestamp of the capture. */
  capturedAt: Scalars["Int"]["output"];
  /** An opaque id to pass to policyInputCapture. */
  id: Scalars["ID"]["output"];
  kind: PolicyInputCaptureKind;
};

export type PolicyIntentProjectAttachment = {
  __typename?: "PolicyIntentProjectAttachment";
  /** Globally unique policy attachment identifier */
  id: Scalars["ID"]["output"];
  /** True if the policy was attached via an `autoattach:` label match instead of an explicit attachment. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** Intent policy unique identifier */
  policyID: Scalars["ID"]["output"];
  /** Intent policy name */
  policyName: Scalars["String"]["output"];
  /** Intent project unique identifier */
  projectID: Scalars["ID"]["output"];
  /** Intent project name */
  projectName: Scalars["String"]["output"];
  projectSpaceDetails: Space;
};

/**
 * PolicyLibrariesInput is the input containing policy libraries used to
 * evaluate the main policy body.
 */
export type PolicyLibrariesInput = {
  libraries: Array<PolicyLibraryInput>;
};

/**
 * PolicyLibraryInput is the input type containing the data for a single policy
 * library used to evaluate the main policy body.
 */
export type PolicyLibraryInput = {
  /** The body of the library. */
  body: Scalars["String"]["input"];
  /** The name of the library. */
  name: Scalars["String"]["input"];
};

/** PolicyRuntimeDetails represents the versions of the policy runtime used */
export type PolicyRuntimeDetails = {
  __typename?: "PolicyRuntimeDetails";
  /** The version of open-policy-agent used to evaluate policies */
  openPolicyAgentVersion: Scalars["String"]["output"];
};

/** All arguments to simulate a Policy. */
export type PolicySimulateInput = {
  /** Body of the policy. */
  body: Scalars["String"]["input"];
  /** Engine type of the policy. */
  engineType: InputMaybe<PolicyEngineType>;
  /** Type of the policy. */
  input: Scalars["String"]["input"];
  /** Libraries used */
  libraries: InputMaybe<PolicyLibrariesInput>;
  /** Type of the policy. */
  type: PolicyType;
};

/** PolicyStackAttachment is the policy-stack attachment viewed from the Policy. */
export type PolicyStackAttachment = {
  __typename?: "PolicyStackAttachment";
  /** Globally unique policy attachment identifier. */
  id: Scalars["ID"]["output"];
  /** True if the policy is autoattached. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** True if the attached stack is type of Module. */
  isModule: Scalars["Boolean"]["output"];
  /** Slug of the attached stack. */
  stackId: Scalars["ID"]["output"];
  /** Name of the attached stack. */
  stackName: Scalars["String"]["output"];
  stackSpaceDetails: Space;
};

export type PolicyTemplate = {
  __typename?: "PolicyTemplate";
  /** Body of the policy template. */
  body: Scalars["String"]["output"];
  /** Description of the policy template. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Unique ID of the policy template. */
  id: Scalars["ID"]["output"];
  /** Labels of the policy template. */
  labels: Array<Scalars["String"]["output"]>;
  /** Name of the policy template. */
  name: Scalars["String"]["output"];
  /** Slug of the policy template. */
  slug: Scalars["String"]["output"];
  /** Type of the policy template. */
  type: PolicyType;
};

export type PolicyTemplateConnection = {
  __typename?: "PolicyTemplateConnection";
  cursor: Scalars["String"]["output"];
  node: PolicyTemplate;
};

/** PolicyType represents a type of Spacelift policy. */
export enum PolicyType {
  /** Access policy - stack or module level RBAC. */
  Access = "ACCESS",
  /** Approval policy, allows approving or rejecting runs and tasks. */
  Approval = "APPROVAL",
  /** Git push policy - customizing Spacelift's reaction to VCS events. */
  GitPush = "GIT_PUSH",
  /** Initialization policy - allows blocking runs from executing. */
  Initialization = "INITIALIZATION",
  /** Intent policy - allow/deny operations on resources */
  Intent = "INTENT",
  /** Login policy - account-level RBAC. */
  Login = "LOGIN",
  /** Notification policy, allows to configure notifications and how they're sent. */
  Notification = "NOTIFICATION",
  /** Plan policy - introspects Terraform changes for hard or soft violations. */
  Plan = "PLAN",
  /** @deprecated Use ACCESS instead. */
  StackAccess = "STACK_ACCESS",
  /** Task policy - allows blocking tasks from executing. */
  Task = "TASK",
  /** @deprecated Use TASK instead. */
  TaskRun = "TASK_RUN",
  /** @deprecated Use PLAN instead. */
  TerraformPlan = "TERRAFORM_PLAN",
  /** Trigger policy, allows creating event-driven workflows between stacks. */
  Trigger = "TRIGGER",
}

/** All arguments to update an individual Policy. */
export type PolicyUpdateInput = {
  /** Body of the policy. */
  body: Scalars["String"]["input"];
  /** Description of the policy. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Engine type of the policy. */
  engineType: InputMaybe<PolicyEngineType>;
  /** User-defined labels for the Policy. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the policy. */
  name: Scalars["String"]["input"];
  /** ID of the space this Policy will belong to. */
  space: InputMaybe<Scalars["ID"]["input"]>;
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPool = {
  __typename?: "PublicWorkerPool";
  /**
   * Number of currently executing runs on the public worker pool for this account.
   * @deprecated Use busyWorkers fields instead.
   */
  activeRuns: Scalars["Int"]["output"];
  /** Number of currently busy workers in the public worker pool for this account. */
  busyWorkers: Scalars["Int"]["output"];
  /** List of intent projects using public WorkerPool for this account. */
  intentProjects: Array<IntentProjectReference>;
  /** Count of intent projects using public WorkerPool for this account. */
  intentProjectsCount: Scalars["Int"]["output"];
  /** Maximum number of simultaneously executing runs on the public worker pool for account. */
  parallelism: Scalars["Int"]["output"];
  /** Number of runs on the public worker ready for processing for this account. */
  pendingRuns: Scalars["Int"]["output"];
  /**
   * Count of queued runs on the public worker pool workers for this account.
   * @deprecated Use 'schedulableRunsCount' instead.
   */
  queuedRunsCount: Scalars["Int"]["output"];
  /** Count of schedulable runs on the public worker pool workers for this account. */
  schedulableRunsCount: Scalars["Int"]["output"];
  /** Search intent projects using public WorkerPool for this account. */
  searchIntentProjects: SearchIntentProjectReferencesOutput;
  /** Search intent projects suggestions using public WorkerPool for this account. */
  searchIntentProjectsSuggestions: SearchSuggestionsOutput;
  /** Search Runs for this WorkerPool. */
  searchSchedulableRuns: Maybe<SearchSchedulableRunsOutput>;
  /** Search Runs Suggestions for this WorkerPool. */
  searchSchedulableRunsSuggestions: Maybe<SearchSuggestionsOutput>;
  /** Search stacks/modules using this WorkerPool. */
  searchUsers: SearchWorkerPoolUsersOutput;
  /** Search stacks/modules suggestions using this WorkerPool. */
  searchUsersSuggestions: SearchSuggestionsOutput;
  /** Count of users on the public worker pool workers for this account. */
  usersCount: Scalars["Int"]["output"];
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPoolSearchIntentProjectsArgs = {
  input: SearchInput;
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPoolSearchIntentProjectsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPoolSearchSchedulableRunsArgs = {
  input: SearchInput;
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPoolSearchSchedulableRunsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPoolSearchUsersArgs = {
  input: SearchInput;
};

/** PublicWorkerPool contains details of public worker pool for account. */
export type PublicWorkerPoolSearchUsersSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** PullRequest is Spacelift's representation of Pull Request on GitHub. */
export type PullRequest = {
  __typename?: "PullRequest";
  /** GitHub username of the PullRequest creator. */
  authorLogin: Scalars["String"]["output"];
  /** Unix timestamp representing Run creation. */
  createdAt: Scalars["Int"]["output"];
  /** Draft status of the PullRequest. */
  draft: Scalars["Boolean"]["output"];
  /** Immutable name of the branch from which the Pull Request is created. */
  headBranch: Scalars["String"]["output"];
  /** Web URL of the branch from which the Pull Request is created. */
  headBranchURL: Scalars["String"]["output"];
  /** Git commit SHA of the latest commit to the branch. */
  headSHA: Scalars["String"]["output"];
  /**
   * Locally (within the scope of a Stack) unique identifier of the PullRequest,
   * given by GitHub.
   */
  id: Scalars["ID"]["output"];
  /**
   * Most recent Run on the Pull Request.
   * @deprecated Use runs instead.
   */
  run: Run;
  /** Most recent Runs on the Pull Request. */
  runs: Array<Run>;
  /** Current title of the Pull Request. */
  title: Scalars["String"]["output"];
  /** Unix timestamp of the last update. */
  updatedAt: Scalars["Int"]["output"];
  /** Immutable URL of the Pull Request on GitHub. */
  url: Scalars["String"]["output"];
};

/** Possible Pulumi entity types. */
export type PulumiEntity = PulumiOutput | PulumiResource | PulumiStack;

/** Metadata for a Pulumi output. */
export type PulumiOutput = {
  __typename?: "PulumiOutput";
  /** Hash of the value, always available. */
  hash: Scalars["String"]["output"];
  /** If the output is marked as sensitive. */
  sensitive: Scalars["Boolean"]["output"];
  /** Value of the output. Only available if it's not marked as sensitive, we don't store it otherwise. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Metadata for a Pulumi resource. */
export type PulumiResource = {
  __typename?: "PulumiResource";
  /** Pulumi ID of resource. */
  id: Scalars["String"]["output"];
  /** Property values. As a JSON-encoded string. */
  outputs: Scalars["String"]["output"];
  /** Parent object of the resource. */
  parent: Scalars["String"]["output"];
  /** Provider the resource stems from. */
  provider: Scalars["String"]["output"];
  /** Pulumi URN of resource. */
  urn: Scalars["String"]["output"];
};

/** Metadata for a Pulumi stack. */
export type PulumiStack = {
  __typename?: "PulumiStack";
  /**
   * This field exists solely for the purpose of adhering to the GraphQL spec,
   * which requires presence of at least one field in a type.
   */
  phantom: Scalars["Boolean"]["output"];
};

export type Query = {
  __typename?: "Query";
  /** @deprecated Use spaceliftIntelligenceTermsAccepted instead. */
  acceptedTermsAndConditionsAI: Scalars["Boolean"]["output"];
  /** Whether the grace period of deletion has ended and account can be deleted */
  accountCanBeDeleted: Scalars["Boolean"]["output"];
  /** Timestamp when the account can be deleted. */
  accountCanBeDeletedAt: Maybe<Scalars["Int"]["output"]>;
  /** Get the currently active user guide progress for the user */
  activeUserGuideProgress: Maybe<UserGuideProgress>;
  /** Returns all AI integrations for the current account. */
  aiIntegration: Maybe<AiIntegration>;
  /** Returns all AI integrations for the current account. */
  aiIntegrations: Array<AiIntegration>;
  /** Account-level setting indicating if non-root admins can create subspaces. */
  allowNonRootAdminSpaceCreation: Scalars["Boolean"]["output"];
  /** Individual AnsibleHost by ID. */
  ansibleHost: Maybe<AnsibleHost>;
  /** Returns a list of related Ansible Hosts. */
  ansibleHosts: Array<AnsibleHost>;
  /** Returns a list of related Ansible Tasks. */
  ansibleTasks: Array<AnsibleTask>;
  apiKey: ApiKey;
  apiKeyRoleBinding: ApiKeyRoleBinding;
  /**
   * Lists API keys currently holding access to a space through live
   * sessions. The login-policy counterpart of apiKeysWithAccessToSpace:
   * returns an empty page for MANAGED_USERS accounts. Requires space admin.
   */
  apiKeySessionsWithAccessToSpace: ApiKeySessionsWithAccessToSpaceOutput;
  /**
   * Returns the available search fields and their possible values for
   * apiKeySessionsWithAccessToSpace.
   */
  apiKeySessionsWithAccessToSpaceSuggestions: SearchSuggestionsOutput;
  /** List of all API keys for the account. */
  apiKeys: Array<ApiKey>;
  /** Account-level setting indicating non-human sessions (API keys, Admin Stacks) can manage API keys. */
  apiKeysManageableByNonHumans: Scalars["Boolean"]["output"];
  /**
   * Account-level setting indicating if API keys can be managed by non-root
   * admins.
   */
  apiKeysManagedByNonRootAdmins: Scalars["Boolean"]["output"];
  /** Returns API keys with RBAC access to the space, directly or via an ancestor space, searchable by name. */
  apiKeysWithAccessToSpace: ApiKeysWithAccessToSpaceOutput;
  /** Returns the available search fields and their possible values for apiKeysWithAccessToSpace. */
  apiKeysWithAccessToSpaceSuggestions: SearchSuggestionsOutput;
  /** List of aws integrations that can be attached Stacks/Modules in given space. */
  attachableAwsIntegrationsInSpace: Array<AwsIntegration>;
  /** List of azure integrations that can be attached Stacks/Modules in given space. */
  attachableAzureIntegrationsInSpace: Array<AzureIntegration>;
  /** List of contexts that can be attached Stacks/Modules in given space. */
  attachableContextsInSpace: Array<Context>;
  attachableExternalIntegrationInSpace: Array<ExternalIntegration>;
  /** List of policies that can be attached to Stacks/Modules in given space. */
  attachablePoliciesInSpace: Array<Policy>;
  /** List of VCS integrations that can be attached Stacks/Modules in given space. */
  attachableVCSIntegrationsForProviderInSpace: Array<VcsIntegration>;
  /** List of worker pools that can be attached Stacks/Modules in given space. */
  attachableWorkerPoolsInSpace: Array<WorkerPool>;
  /** How many days built-in audit trails are stored */
  auditTrailRetentionDays: Scalars["Int"]["output"];
  /** Show details of AuditTrailWebhook. */
  auditTrailWebhook: Maybe<AuditTrailWebhook>;
  /** Authorization scheme for the account */
  authorizationScheme: AuthorizationScheme;
  /**
   * Given the space and the labels, returns the list of autoattachment targets.
   * The list is not exhaustive, it only contains the 100 most recently updated
   * targets.
   */
  autoattachmentForLabels: AutoattachmentTargets;
  /**
   * Returns the live list of models available for the given (possibly unsaved)
   * AI integration configuration, used to populate the model picker before the
   * integration is saved.
   *   API-key providers (OpenAI/Anthropic/Google): pass provider + apiKey and,
   *     for self-hosted gateways, baseURL. Requires admin on the given space.
   *   Bedrock: pass provider + providerIntegrationId (the AWS integration) +
   *     providerConfig.bedrock.region.
   */
  availableAIModels: Array<AiModel>;
  /**
   * Returns available AI providers. If provider is specified, returns models for that provider only.
   * If provider is not specified, returns all providers with their available models.
   */
  availableAIProviders: Array<AiProvider>;
  /** availableBillingAddons returns the list of available billing addons. */
  availableBillingAddons: Array<BillingAddon>;
  /** availableSelfServicePlans returns the list of billing plans that can be bought via self-service. */
  availableSelfServicePlans: Array<BillingPlan>;
  /** Returns all user groups that are reported by the identity provider when users log in to Spacelift. */
  availableUserGroups: Array<Scalars["String"]["output"]>;
  awarenessSourceSurvey: Maybe<AwarenessSourceSurvey>;
  /** Details of a single AWS integration. */
  awsIntegration: Maybe<AwsIntegration>;
  /** Details of a single AWS integration looked up by the integration name. */
  awsIntegrationByName: Maybe<AwsIntegration>;
  /**
   * Lists any AWS integrations connected to the account. By default this excludes any integrations
   * that were created via the stackIntegrationAwsCreate mutation. You can return all integrations
   * by setting includeLegacy to true.
   */
  awsIntegrations: Array<AwsIntegration>;
  /** Indicates whether the managed AWS integration functionality is enabled. */
  awsIntegrationsEnabled: Scalars["Boolean"]["output"];
  /** Shows Azure DevOps Repos integration details. */
  azureDevOpsRepoIntegration: Maybe<AzureDevOpsRepoIntegration>;
  /** Endpoint for incoming Azure DevOps webhooks. */
  azureDevOpsWebhooksEndpoint: Scalars["String"]["output"];
  /**
   * Details of a single Azure integration. If the id is not provided, it will return
   * the default Azure Integration.
   */
  azureIntegration: Maybe<AzureIntegration>;
  /** Details of a single Azure integration looked up by the integration name. */
  azureIntegrationByName: Maybe<AzureIntegration>;
  /** Lists any Azure integrations connected to the account. */
  azureIntegrations: Array<AzureIntegration>;
  /** Indicates whether the managed Azure integration functionality is enabled. */
  azureIntegrationsEnabled: Scalars["Boolean"]["output"];
  /**
   * Returns live Bedrock inference profiles for the given AWS integration.
   * Each entry's id is the inference profile ID; name is the AWS-provided profile name.
   * @deprecated Use availableAIModels with the Bedrock provider, providerIntegrationId and providerConfig.bedrock.region instead.
   */
  bedrockInferenceProfiles: Array<AiModel>;
  /** Whether the account is billed externally (not through Stripe) */
  billedExternally: Scalars["Boolean"]["output"];
  /** Shows Stripe Billing subscription details */
  billingSubscription: Maybe<BillingSubscription>;
  /** Shows Bitbucket Cloud integration details. */
  bitbucketCloudIntegration: Maybe<BitbucketCloudIntegration>;
  /** Endpoint for incoming Bitbucket Cloud webhooks. */
  bitbucketCloudWebhooksEndpoint: Scalars["String"]["output"];
  /** Shows Bitbucket Datacenter integration details. */
  bitbucketDatacenterIntegration: Maybe<BitbucketDatacenterIntegration>;
  /** Endpoint for incoming Bitbucket Datacenter webhooks. */
  bitbucketDatacenterWebhooksEndpoint: Scalars["String"]["output"];
  /** Shows Blob Storage integration details. */
  blobStorageIntegration: Maybe<BlobStorageIntegration>;
  /** Returns a single blueprint. */
  blueprint: Maybe<Blueprint>;
  /**
   * Details of a single BlueprintDeployment.
   * @deprecated Use templateDeployment instead
   */
  blueprintDeployment: Maybe<BlueprintDeployment>;
  /** The json schema of a blueprint. */
  blueprintSchema: Scalars["String"]["output"];
  /**
   * The json schema of a blueprint v2.
   * @deprecated Use templateSchema instead
   */
  blueprintV2Schema: Scalars["String"]["output"];
  /**
   * Returns a single blueprint group details.
   * @deprecated Use template instead
   */
  blueprintVersionedGroup: Maybe<BlueprintVersionedGroup>;
  /** List of branches for a given repository. */
  branches: Array<Scalars["String"]["output"]>;
  /** Retrieve all completed guides for the user */
  completedUserGuides: Array<UserGuideProgress>;
  /** Details of a single Context. */
  context: Maybe<Context>;
  /** List of all the contexts in the account. */
  contexts: Array<Context>;
  /** Info about git build related data, self-hosted licence. Not valid in SaaS. */
  debugInfo: DebugInfo;
  /** Return default private worker pool runner image for the account */
  defaultPrivateWorkerPoolRunnerImage: Scalars["String"]["output"];
  /** Return default public worker pool runner image for the account */
  defaultPublicWorkerPoolRunnerImage: Scalars["String"]["output"];
  /** EnforceMFA determines whether MFA is required for all users in the account. */
  enforceMFA: Scalars["Boolean"]["output"];
  /**
   * evaluateFeatureFlags returns the current value of the specified feature flags. This API is
   * only available on Self-Hosted installations, and trying to use it on Spacelift SaaS
   * will result in an empty array being returned.
   */
  evaluateFeatureFlags: Array<FeatureFlagEvaluationResult>;
  externalIntegration: ExternalIntegration;
  externalIntegrations: Array<ExternalIntegration>;
  /** Returns all configured Flows instances available for linking. */
  flowsInstances: Array<FlowsInstance>;
  /** Returns the Flows integration for the current account, if linked. */
  flowsIntegration: Maybe<FlowsIntegration>;
  /**
   * Returns the projects of the linked Flows organization, each with the Space
   * role bindings currently assigned to it. Empty when no Flows org is linked.
   */
  flowsProjects: Array<FlowsProject>;
  /** Returns a list of available generic forms */
  genericFormsList: Array<GenericFormDescription>;
  /**
   * GitHub Enterprise Integration settings. If the id is not provided, it will return
   * the default GitHub Enterprise Integration.
   */
  githubEnterpriseIntegration: Maybe<GithubEnterpriseIntegration>;
  /** The webhooks endpoint to use in your GitHub Enterprise App */
  githubEnterpriseWebhooksEndpoint: Scalars["String"]["output"];
  /** Build-in GitHub Integration settings. */
  githubIntegration: Maybe<GithubIntegration>;
  /**
   * Shows Gitlab integration details. If the id is not provided, it will return
   * the default Gitlab Integration.
   */
  gitlabIntegration: Maybe<GitlabIntegration>;
  /** Endpoint for incoming Gitlab webhooks. */
  gitlabWebhooksEndpoint: Scalars["String"]["output"];
  /** List the GPG keys used to sign binaries. */
  gpgKeys: Array<GpgKey>;
  /** True if the account has at least one Ansible stack */
  hasAnsibleStacks: Scalars["Boolean"]["output"];
  /** Returns true if the account has SSO enabled. */
  hasSSO: Scalars["Boolean"]["output"];
  /** ID of the account. */
  id: Scalars["ID"]["output"];
  /** InfraAssistantBuildModeEnabled determines whether Infra Assistant build mode is enabled. */
  infraAssistantBuildModeEnabled: Scalars["Boolean"]["output"];
  /** InfraAssistantEnabled determines whether Infra Assistant is enabled. */
  infraAssistantEnabled: Scalars["Boolean"]["output"];
  /** ID of the GitHub App installation linked to the current account. */
  installationId: Maybe<Scalars["String"]["output"]>;
  /** Returns counts of different types of integrations in the account. */
  integrationsCount: IntegrationsCount;
  intentChatConversation: Maybe<IntentChatConversation>;
  intentChatConversations: Array<IntentChatConversation>;
  /**
   * Returns the underlying terraform-managed resources for a spacelift/module
   * intent resource by walking its terraform state. Data sources are excluded.
   * Cursor-paginated with first/after; at most 50 resources per page.
   */
  intentModuleResources: IntentModuleResourcesOutput;
  /** Returns the input schema that intent policies receive for evaluation. */
  intentPolicyInputSchema: Scalars["String"]["output"];
  intentProject: Maybe<IntentProject>;
  intentProjectActive: Maybe<IntentProject>;
  intentProjects: Array<IntentProject>;
  /** Returns true if the generic form is completed */
  isGenericFormCompleted: Scalars["Boolean"]["output"];
  /** List of all supported kubectl versions. */
  kubectlVersions: Array<Scalars["String"]["output"]>;
  /** @deprecated Use spaceliftIntelligenceTermsLatestVersion instead. */
  latestTermsAndConditionsVersionAI: Maybe<TermsAndConditionsVersion>;
  /** Details about a single managed user. */
  managedUser: ManagedUser;
  /** Details about a single user group. */
  managedUserGroup: ManagedUserGroup;
  /** Managed user group integration specified by id. */
  managedUserGroupIntegration: ManagedUserGroupIntegration;
  /** List of managed user group integrations. Allows for optional integrationType parameter to get integrations of specific type only. */
  managedUserGroupIntegrations: Array<ManagedUserGroupIntegration>;
  /** List of user groups in this account. */
  managedUserGroups: Array<ManagedUserGroup>;
  /** List of users that were invited or logged into the account. */
  managedUsers: Array<ManagedUser>;
  /** Tells if the account is marked for deletion. */
  markedForDeletion: Scalars["Boolean"]["output"];
  /**
   * MessageQueueStats returns the current size of every message queue the
   * backend is configured to use. Only available on Self-Hosted instances and
   * can only be fetched by admins.
   */
  messageQueueStats: Array<MessageQueueStats>;
  /** Return the current value for a given metric. */
  metrics: Maybe<SpaceliftMetrics>;
  /** Return the values for a given metric in a given range. */
  metricsRange: Maybe<SpaceliftMetrics>;
  /** Details of a single Module. */
  module: Maybe<Module>;
  /** List of all the Modules managed by this account. */
  modules: Array<Module>;
  /** Name of the account. */
  name: Maybe<Scalars["String"]["output"]>;
  namedWebhooksIntegration: NamedWebhooksIntegration;
  /** Total number of new Notifications. */
  notificationCount: Scalars["Int"]["output"];
  /** Returns the account's custom OAuth2 redirect host allowlist */
  oauthRedirectAllowedHosts: Array<Scalars["String"]["output"]>;
  /** OIDC settings, if the account is using OIDC-based SSO. */
  oidcSettings: Maybe<OidcSettings>;
  /** Return the OIDC subject template for the account */
  oidcSubjectTemplate: Maybe<Scalars["String"]["output"]>;
  /** If the account is on the trial period, this indicates the end of it. */
  onTrialUntil: Maybe<Scalars["Int"]["output"]>;
  /** Onboarding progress for all users on the account */
  onboardingProgress: Array<OnboardingProgress>;
  /** Given version constraints, calculate the latest version that satisfies it. */
  openTofuEffectiveVersion: Scalars["String"]["output"];
  /** Returns all OpenTofu features and whether they are supported for the given version constraint. */
  openTofuFeatures: Array<OpenTofuFeatureCheck>;
  /**
   * Returns a paginated list of stacks eligible for OpenTofu vendor migration or
   * rollback. This is the "preview" counterpart to openTofuMigrate: same eligible
   * cohort and same predicate surface, but returns the matching stacks instead of
   * enqueueing them.
   */
  openTofuMigrateSearch: SearchStacksOutput;
  /**
   * Returns search suggestions (predicate fields and possible values) for stacks
   * eligible for OpenTofu vendor migration or rollback. Same surface as
   * searchStacksSuggestions but scoped to the migration cohort selected by target:
   *
   * - target=OpenTofu: legacy Terraform stacks with terraform_workflow_tool=OPEN_TOFU
   *   (forward migration candidates).
   * - target=Terraform: native OpenTofu stacks previously migrated by this flow
   *   (rollback candidates).
   */
  openTofuMigrateSuggestions: SearchSuggestionsOutput;
  /**
   * Returns the headline counters for the Terraform -> OpenTofu migration, for
   * every stack in the account the caller can see. Meant for the migration
   * dashboard: one call instead of four counting searches.
   */
  openTofuMigrationCounts: OpenTofuMigrationCounts;
  /**
   * Searches the OpenTofu migration queue (opentofu_migration_stacks table). Powers
   * the dashboard widget, per-stack migration status checks, and the in-progress UI.
   * Uses the same SearchInput envelope as other search queries; predicates apply to
   * the queue row fields (state, createdAt, updatedAt) and to the migrated stack
   * (stackName, stackSlug, space, label).
   */
  openTofuMigrationQueueSearch: OpenTofuMigrationQueueSearchOutput;
  /**
   * Returns search suggestions (predicate fields and possible values) for the
   * OpenTofu migration queue. The suggestions counterpart of
   * openTofuMigrationQueueSearch: same rows, same predicate surface (state,
   * createdAt, updatedAt, stackName, stackSlug, space, label).
   */
  openTofuMigrationQueueSearchSuggestions: SearchSuggestionsOutput;
  /** List of all supported OpenTofu versions. */
  openTofuVersions: Array<Scalars["String"]["output"]>;
  /**
   * Built-in Origin (Cursor) integration settings. Null when the Origin app is
   * not installed on the account.
   */
  originIntegration: Maybe<OriginIntegration>;
  /** List of Spacelift's outgoing addresses. */
  outgoingIPAddresses: Array<Scalars["String"]["output"]>;
  /** List of all personal API keys for the account with their owners. Root admins only. */
  personalApiKeys: Array<ApiKey>;
  /** Number of personal API keys on the account that are not disabled. Space admins only. */
  personalApiKeysCount: Scalars["Int"]["output"];
  /** Account-level setting indicating whether users may create personal API keys. */
  personalApiKeysEnabled: Scalars["Boolean"]["output"];
  /** Details of a single Plugin. */
  plugin: Maybe<Plugin>;
  /** Details of a single Plugin Template. */
  pluginTemplate: Maybe<PluginTemplate>;
  /** List of all the plugin templates in the account. */
  pluginTemplates: Array<PluginTemplate>;
  /** List of all the plugins in the account. */
  plugins: Array<Plugin>;
  /** List of all the polices in the account. */
  policies: Array<Policy>;
  /** Details of a single Policy. */
  policy: Maybe<Policy>;
  /** One captured policy input, by an id from policyInputCaptures. */
  policyInputCapture: Maybe<PolicyInputCapture>;
  /** Policy inputs captured in the space for the policy type, newest first. Login inputs are listed under the root space. */
  policyInputCaptures: Array<PolicyInputCaptureSummary>;
  /** List Policy Runtime Details */
  policyRuntime: PolicyRuntimeDetails;
  policyTemplate: Maybe<PolicyTemplate>;
  /** List of all the VCS providers available in the account. */
  providers: Array<VcsProvider>;
  /** List of all the VCS providers available in a specific space. */
  providersInSpace: Array<VcsProvider>;
  /** Shows public worker pool details */
  publicWorkerPool: Maybe<PublicWorkerPool>;
  /** Get a single Repo by ID */
  repo: Maybe<Repo>;
  /** Get a Repo commit by repo ID and SHA (returns latest if SHA not provided) */
  repoCommit: Maybe<RepoCommit>;
  /** Get the commit history of a specific file in a Repo */
  repoFileHistory: RepoFileHistoryOutput;
  /** List all Repos in a space */
  repos: ReposOutput;
  /**
   * List of repositories available to the account.
   * Optional filter param can be applied for the results returned from VCS.
   */
  repositories: Array<Repository>;
  /**
   * Get a revision by repo ID and SHA (returns latest if SHA not provided)
   * @deprecated Use repoCommit instead.
   */
  revision: Maybe<Revision>;
  role: Role;
  /** Returns all roles for the account that are accessible by the requester. */
  roles: Array<Role>;
  /** Details of a single Run by ID, without needing to know the stack. */
  run: Maybe<Run>;
  /** Amount of days that run logs will be retained for */
  runLogRetentionDays: Scalars["Int"]["output"];
  /**
   * Run-minutes over a window of completed UTC days, served from the
   * run_minutes_by_day rollup on both SaaS and self-hosted.
   */
  runMinutesUsage: RunMinutesUsage;
  /** Return the stack the run belongs to. */
  runStack: Maybe<Stack>;
  /** SAML settings, if the account is using SAML-based SSO. */
  samlSettings: Maybe<SamlSettings>;
  /** Details of a single saved filter */
  savedFilter: Maybe<SavedFilter>;
  /** List of saved filters */
  savedFilters: Array<SavedFilter>;
  /** Details of a single Scan. */
  scan: Scan;
  /**
   * Providers a Scan can target, with the versions and resource types available
   * for each. Anything absent here cannot be scanned. Pass a provider to get just
   * that one.
   */
  scanProviderSchemas: Array<ScanProviderSchema>;
  /** Details of a single ScanRun. */
  scanRun: ScanRun;
  /** SCIM settings, if the account has SCIM provisioning configured. */
  scimSettings: Maybe<ScimOauthClient>;
  /** searchAnsibleHosts allows to search ansibleHosts. */
  searchAnsibleHosts: Maybe<SearchAnsibleHostsOutput>;
  /** Information about fields available for searching AnsibleHosts. */
  searchAnsibleHostsSuggestions: Maybe<SearchSuggestionsOutput>;
  /** searchAnsibleTasks allows to search AnsibleTasks. */
  searchAnsibleTasks: Maybe<SearchAnsibleTasksOutput>;
  /** Information about fields available for searching AnsibleTasks. */
  searchAnsibleTasksSuggestions: Maybe<SearchSuggestionsOutput>;
  /** Searches for audit trail entries. */
  searchAuditTrailEntries: SearchAuditTrailEntriesOutput;
  /** Information about fields available for searching audit trail entries. */
  searchAuditTrailEntriesSuggestions: SearchSuggestionsOutput;
  /** @deprecated Use searchTemplateDeployments instead */
  searchBlueprintDeployments: SearchBlueprintDeploymentsOutput;
  /** @deprecated Use searchTemplates instead */
  searchBlueprintVersionedGroups: SearchBlueprintVersionedGroupsOutput;
  /** @deprecated Use searchTemplatesSuggestions instead */
  searchBlueprintVersionedGroupsSuggestions: SearchSuggestionsOutput;
  searchBlueprints: SearchBlueprintsOutput;
  searchBlueprintsSuggestions: SearchSuggestionsOutput;
  searchContexts: SearchContextsOutput;
  searchContextsSuggestions: SearchSuggestionsOutput;
  searchIntentProjects: SearchIntentProjectsOutput;
  searchIntentProjectsSuggestions: SearchSuggestionsOutput;
  searchIntentResources: SearchIntentResourcesOutput;
  searchIntentResourcesOperations: SearchIntentResourcesOperationsOutput;
  searchIntentResourcesOperationsSuggestions: SearchSuggestionsOutput;
  searchIntentResourcesSuggestions: SearchSuggestionsOutput;
  /** Search managed entities with a set of predicates, ordering and paging. */
  searchManagedEntities: SearchManagedEntitiesOutput;
  /** Search managed entities grouped by providers with a set of predicates, ordering and paging. */
  searchManagedEntitiesGroupByProviders: SearchManagedEntitiesGroupedByProvidersOutput;
  /** Search managed entities grouped by stacks with a set of predicates, ordering and paging. */
  searchManagedEntitiesGroupByStacks: SearchManagedEntitiesGroupedByStacksOutput;
  /** Search managed entities grouped by types with a set of predicates, ordering and paging. */
  searchManagedEntitiesGroupByTypes: SearchManagedEntitiesGroupedByTypesOutput;
  /** Information about fields available for searching managed entities. */
  searchManagedEntitiesSuggestions: SearchSuggestionsOutput;
  /** Search Modules with a set of predicates, ordering and paging. */
  searchModules: SearchModulesOutput;
  /** Information about fields available for searching Modules. */
  searchModulesSuggestions: SearchSuggestionsOutput;
  searchNamedWebhooksIntegrations: SearchNamedWebhooksIntegrationOutput;
  searchNamedWebhooksIntegrationsSuggestions: SearchSuggestionsOutput;
  /** Search Notifications with a set of predicates, ordering and paging. */
  searchNotifications: SearchNotificationsOutput;
  /** Information about fields available for searching Notifications. */
  searchNotificationsSuggestions: SearchSuggestionsOutput;
  searchPolicies: SearchPoliciesOutput;
  searchPoliciesSuggestions: SearchSuggestionsOutput;
  searchPolicyTemplates: SearchPolicyTemplatesOutput;
  searchPolicyTemplatesSuggestions: SearchSuggestionsOutput;
  /** Search Repo commits with filtering, ordering, and pagination */
  searchRepoCommits: SearchRepoCommitsOutput;
  /** Get field suggestions for Repo commit search */
  searchRepoCommitsSuggestions: SearchSuggestionsOutput;
  /** Search Repo files with filtering, ordering, and pagination */
  searchRepoFiles: SearchRepoFilesOutput;
  /** Get field suggestions for Repo file search */
  searchRepoFilesSuggestions: SearchSuggestionsOutput;
  /** Search Repos with filtering and ordering */
  searchRepos: SearchReposOutput;
  /** Get field suggestions for Repo search */
  searchReposSuggestions: SearchSuggestionsOutput;
  /**
   * Search Revisions with filtering, ordering, and pagination
   * @deprecated Use searchRepoCommits instead.
   */
  searchRevisions: SearchRevisionsOutput;
  /**
   * Get field suggestions for Revision search
   * @deprecated Use searchRepoCommitsSuggestions instead.
   */
  searchRevisionsSuggestions: SearchSuggestionsOutput;
  /**
   * Paginated, account-wide run history ordered newest-first.
   * Scope the window with a TimeInRange predicate on the `createdAt` field.
   *
   * Orderable by `createdAt`, `triggeredBy` and `state`. Ordering by `state`
   * follows the internal state ordinal, so equal states group together but the
   * sequence is not alphabetical.
   *
   * `command` is only set on Tasks. It returns no possible values, so match it
   * with `fullTextSearch` or a `stringMatches` predicate.
   *
   * Paginate with either input.after (keyset cursor, sequential) or offset
   * (random-access, for loading pages concurrently), not both. offset skips
   * that many rows in the ordered result; use input.first as the page size and
   * SearchRunsOutput.total to compute the page count.
   *
   * Offset paging trades keyset's stability for random access, so pages can
   * skip or repeat rows if runs are created or deleted mid-scan.
   */
  searchRuns: SearchRunsOutput;
  /**
   * searchRunsSuggestions returns the filterable fields and their possible
   * values for the searchRuns query.
   */
  searchRunsSuggestions: SearchSuggestionsOutput;
  /** Search Scans with a set of predicates, ordering and paging. */
  searchScans: SearchScansOutput;
  /** Information about fields available for searching Scans. */
  searchScansSuggestions: SearchSuggestionsOutput;
  searchSpaceContexts: SearchSpaceContextsOutput;
  /** Filter-dropdown suggestions scoped to the given space's contexts. */
  searchSpaceContextsSuggestions: SearchSuggestionsOutput;
  /** Paginated policies created in or inherited by the given space. */
  searchSpacePolicies: SearchSpacePoliciesOutput;
  /** Filter-dropdown suggestions scoped to the given space's policies. */
  searchSpacePoliciesSuggestions: SearchSuggestionsOutput;
  /** Search Spaces with a set of predicates, ordering and paging. */
  searchSpaces: SearchSpacesOutput;
  /** Information about fields available for searching Spaces. */
  searchSpacesSuggestions: SearchSuggestionsOutput;
  /** Search Stacks with a set of predicates, ordering and paging. */
  searchStacks: SearchStacksOutput;
  /** Information about fields available for searching Stacks. */
  searchStacksSuggestions: SearchSuggestionsOutput;
  searchTemplateDeployments: SearchTemplateDeploymentsOutput;
  searchTemplates: SearchTemplatesOutput;
  searchTemplatesSuggestions: SearchSuggestionsOutput;
  searchTofuWorkspaces: SearchTofuWorkspacesOutput;
  searchTofuWorkspacesSuggestions: SearchSuggestionsOutput;
  searchVCSIntegrations: SearchVcsIntegrationsOutput;
  searchVCSIntegrationsSuggestions: SearchSuggestionsOutput;
  searchWorkerPools: SearchWorkerPoolsOutput;
  searchWorkerPoolsSuggestions: SearchSuggestionsOutput;
  /** Returns the seat limits and the number of in-use seats. */
  seats: Seats;
  /** Returns security email for the account */
  securityEmail: Scalars["String"]["output"];
  /** Returns list of the security keys in the account. */
  securityKeys: Array<SecurityKey>;
  /**
   * List of all the active sessions in the account. NOTE: this functionality is not available in the Starter
   * tier. An empty array will be returned for Starter tier accounts.
   */
  sessions: Array<Session>;
  /**
   * List of all the Modules shared with this account.
   * @deprecated Use sharedModulesV2 field instead.
   */
  sharedModules: Array<SharedModule>;
  /** List of all the Modules shared with this account or with spaces inside the account. */
  sharedModulesV2: Array<ModuleShare>;
  /**
   * Returns the instance-wide Slack App config information for a Self-Hosted instance. This is used by
   * the Spacelift Slack integration to integrate with your Slack workspace. Always returns null on SaaS.
   */
  slackAppConfig: Maybe<SlackAppConfig>;
  /**
   * Returns the app manifest that should be used when creating a Slack App to integrate
   * Spacelift with Slack. This is only useful on Self-Hosted instances. Always returns empty on SaaS.
   */
  slackAppManifest: Scalars["String"]["output"];
  /** Shows the details of the integration between your Slack workspace and your Spacelift account. */
  slackIntegration: Maybe<SlackIntegration>;
  /** Details of a single Space. */
  space: Maybe<Space>;
  /**
   * Returns the AWS account used by Spacelift during role assumption. This can be used for
   * generating AssumeRole policies.
   */
  spaceliftAwsAccountId: Scalars["String"]["output"];
  /** SpaceliftIntelligenceEnabled determines whether Spacelift Intelligence is enabled for the account (true if any sub-feature is on). */
  spaceliftIntelligenceEnabled: Scalars["Boolean"]["output"];
  /** SpaceliftIntelligenceTermsAccepted informs if the account has accepted the Spacelift Intelligence terms and conditions. */
  spaceliftIntelligenceTermsAccepted: Scalars["Boolean"]["output"];
  /** SpaceliftIntelligenceTermsLatestVersion returns the latest version of the Spacelift Intelligence terms and conditions. */
  spaceliftIntelligenceTermsLatestVersion: Maybe<TermsAndConditionsVersion>;
  /** Details of all the spaces in the Account accessible for the user. */
  spaces: Array<Space>;
  /** Details of a single Stack. */
  stack: Maybe<Stack>;
  stackRoleBinding: StackRoleBinding;
  /** List of all the stacks in the account. */
  stacks: Array<Stack>;
  /**
   * Returns stacks that can act in the space. RESIDING lists the space's own stacks;
   * ALL_WITH_ACCESS additionally lists every stack whose self-read or explicit role
   * binding reaches the space, whether that is on the space itself, an ancestor
   * (propagates down), or an inheriting descendant (read propagates up).
   */
  stacksWithAccessToSpace: StacksWithAccessToSpaceOutput;
  /** Returns the available search fields and their possible values for stacksWithAccessToSpace. */
  stacksWithAccessToSpaceSuggestions: SearchSuggestionsOutput;
  /** Returns a single template details. */
  template: Maybe<Template>;
  /** Details of a single TemplateDeployment. */
  templateDeployment: Maybe<TemplateDeployment>;
  /** The json schema of a template. */
  templateSchema: Scalars["String"]["output"];
  /** Parse a template and return its inputs and any validation errors. */
  templateVersionParseTemplate: BlueprintParseResult;
  /** Given version constraints, calculate the latest version that satisfies it. */
  terraformEffectiveVersion: Scalars["String"]["output"];
  /** Details of a single Terraform provider. */
  terraformProvider: Maybe<TerraformProvider>;
  /** List of all Terraform providers managed by this account. */
  terraformProviders: Array<TerraformProvider>;
  /** List of all supported Terraform versions. */
  terraformVersions: Array<Scalars["String"]["output"]>;
  /**
   * Given version constraints, calculate the latest version that satisfies it. NOTE: the only
   * valid values for the "tool" parameter are TERRAFORM_FOSS or OPEN_TOFU, and when no tool
   * is specified it defaults to TERRAFORM_FOSS.
   */
  terragruntEffectiveVersion: EffectiveTerragruntVersionResult;
  /** List of all supported Terragrunt versions. */
  terragruntVersions: Array<Scalars["String"]["output"]>;
  /** Billing tier of the account. */
  tier: BillingTier;
  /** The list of features available based on the billing tier of the account. */
  tierFeatures: Array<BillingTierFeature>;
  /** Type of the GitHub account. */
  type: Maybe<AccountType>;
  /**
   * Get the stored UI configuration for the user.
   * If no configuration is stored, empty string will be returned.
   */
  uiConfigGet: Scalars["String"]["output"];
  /** Usage for the last 30 days. */
  usage: Usage;
  userGroupRoleBinding: UserGroupRoleBinding;
  /** Returns IdP groups with RBAC access to the space, directly or via an ancestor space, searchable by group name. */
  userGroupsWithAccessToSpace: UserGroupsWithAccessToSpaceOutput;
  /** Returns the available search fields and their possible values for userGroupsWithAccessToSpace. */
  userGroupsWithAccessToSpaceSuggestions: SearchSuggestionsOutput;
  /** Retrieve a single user guide by ID */
  userGuide: Maybe<UserGuide>;
  /** List all certificates for the account */
  userGuideCertificationList: Array<UserGuideCertification>;
  /** Retrieve a single user guide chapter by ID */
  userGuideChapter: Maybe<UserGuideChapter>;
  /** List all user guide chapters */
  userGuideChapters: Array<UserGuideChapter>;
  /** Retrieve a single user guide group by ID */
  userGuideGroup: Maybe<UserGuideGroup>;
  /** List all user guide groups */
  userGuideGroups: Array<UserGuideGroup>;
  /** List all available user guides */
  userGuides: Array<UserGuide>;
  userRoleBinding: UserRoleBinding;
  /**
   * Lists the users currently holding access to a space through live
   * sessions. The login-policy counterpart of usersWithAccessToSpace:
   * returns an empty page for MANAGED_USERS accounts. Requires space admin.
   */
  userSessionsWithAccessToSpace: UserSessionsWithAccessToSpaceOutput;
  /**
   * Returns the available search fields and their possible values for
   * userSessionsWithAccessToSpace.
   */
  userSessionsWithAccessToSpaceSuggestions: SearchSuggestionsOutput;
  /** Returns users with RBAC access to the space, directly or via an ancestor space, searchable by username. */
  usersWithAccessToSpace: UsersWithAccessToSpaceOutput;
  /** Returns the available search fields and their possible values for usersWithAccessToSpace. */
  usersWithAccessToSpaceSuggestions: SearchSuggestionsOutput;
  /** Details of a single VCSAgentPool. */
  vcsAgentPool: Maybe<VcsAgentPool>;
  /** List of all the VCSAgentPools in the account. */
  vcsAgentPools: Array<VcsAgentPool>;
  /** Maximum number of runs triggered by a VCS event for this account. */
  vcsEventTriggeredRunsLimit: Maybe<Scalars["Int"]["output"]>;
  /** Get VCS integrations by provider and id */
  vcsIntegration: Maybe<VcsIntegration>;
  /** Runs a test to check whether the VCS integration is configured correctly */
  vcsIntegrationTest: VcsIntegrationTestResult;
  /** List of all VCS integrations available in the account. */
  vcsIntegrations: Array<VcsIntegration>;
  /** Current user, if any. */
  viewer: Maybe<User>;
  /** Details of a single WorkerPool. */
  workerPool: Maybe<WorkerPool>;
  /** List of all the WorkerPools in the account. */
  workerPools: Array<WorkerPool>;
  /**
   * Private worker usage for a billing cycle. Omit `input` to select the
   * current cycle.
   */
  workerUsage: WorkerUsage;
};

export type QueryAiIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAnsibleHostArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAnsibleHostsArgs = {
  input: InputMaybe<RunOrStackArgs>;
};

export type QueryAnsibleTasksArgs = {
  input: InputMaybe<RunOrStackArgs>;
};

export type QueryApiKeyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryApiKeyRoleBindingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryApiKeySessionsWithAccessToSpaceArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QueryApiKeySessionsWithAccessToSpaceSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QueryApiKeysWithAccessToSpaceArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QueryApiKeysWithAccessToSpaceSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QueryAttachableAwsIntegrationsInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAttachableAzureIntegrationsInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAttachableContextsInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAttachableExternalIntegrationInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAttachablePoliciesInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAttachableVcsIntegrationsForProviderInSpaceArgs = {
  id: Scalars["ID"]["input"];
  provider: VcsProvider;
};

export type QueryAttachableWorkerPoolsInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAutoattachmentForLabelsArgs = {
  labels: Array<Scalars["String"]["input"]>;
  space: Scalars["ID"]["input"];
};

export type QueryAvailableAiModelsArgs = {
  apiKey: InputMaybe<Scalars["String"]["input"]>;
  baseURL: InputMaybe<Scalars["String"]["input"]>;
  provider: Scalars["String"]["input"];
  providerConfig: InputMaybe<AiProviderConfigInput>;
  providerIntegrationId: InputMaybe<Scalars["ID"]["input"]>;
  space: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryAvailableAiProvidersArgs = {
  provider: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAwsIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAwsIntegrationByNameArgs = {
  name: Scalars["String"]["input"];
};

export type QueryAwsIntegrationsArgs = {
  includeLegacy: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAzureDevOpsRepoIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryAzureIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAzureIntegrationByNameArgs = {
  name: Scalars["String"]["input"];
};

export type QueryBedrockInferenceProfilesArgs = {
  awsIntegration: Scalars["ID"]["input"];
  config: AwsBedrockConfigInput;
};

export type QueryBitbucketCloudIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryBitbucketDatacenterIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryBlobStorageIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryBlueprintArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryBlueprintDeploymentArgs = {
  blueprintID: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
};

export type QueryBlueprintVersionedGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryBranchesArgs = {
  namespace: Scalars["String"]["input"];
  provider: VcsProvider;
  repository: Scalars["String"]["input"];
  repositoryURL: InputMaybe<Scalars["String"]["input"]>;
  vcsIntegrationID: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryContextArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryEvaluateFeatureFlagsArgs = {
  input: FeatureFlagEvaluationInput;
};

export type QueryExternalIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGithubEnterpriseIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGithubEnterpriseWebhooksEndpointArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGitlabIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryIntentChatConversationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryIntentChatConversationsArgs = {
  page: InputMaybe<Scalars["Int"]["input"]>;
  perPage: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryIntentModuleResourcesArgs = {
  after: InputMaybe<Scalars["String"]["input"]>;
  first: InputMaybe<Scalars["Int"]["input"]>;
  intentProjectID: Scalars["ID"]["input"];
  resourceID: Scalars["ID"]["input"];
};

export type QueryIntentProjectArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryIsGenericFormCompletedArgs = {
  name: Scalars["String"]["input"];
};

export type QueryManagedUserArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryManagedUserGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryManagedUserGroupIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryManagedUserGroupIntegrationsArgs = {
  integrationType: InputMaybe<ManagedUserGroupIntegrationType>;
};

export type QueryMetricsRangeArgs = {
  input: InputMaybe<MetricsInput>;
};

export type QueryModuleArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryNamedWebhooksIntegrationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOpenTofuEffectiveVersionArgs = {
  constraints: Scalars["String"]["input"];
};

export type QueryOpenTofuFeaturesArgs = {
  version: Scalars["String"]["input"];
};

export type QueryOpenTofuMigrateSearchArgs = {
  input: SearchInput;
  target: StackVendor;
};

export type QueryOpenTofuMigrateSuggestionsArgs = {
  input: SearchSuggestionsInput;
  target: StackVendor;
};

export type QueryOpenTofuMigrationQueueSearchArgs = {
  input: SearchInput;
};

export type QueryOpenTofuMigrationQueueSearchSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QueryPluginArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPluginTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPolicyArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPolicyInputCaptureArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPolicyInputCapturesArgs = {
  space: Scalars["ID"]["input"];
  type: PolicyType;
};

export type QueryPolicyTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryProvidersInSpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRepoArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRepoCommitArgs = {
  repoID: Scalars["ID"]["input"];
  sha: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRepoFileHistoryArgs = {
  after: InputMaybe<Scalars["String"]["input"]>;
  filePath: Scalars["String"]["input"];
  first: InputMaybe<Scalars["Int"]["input"]>;
  repoID: Scalars["ID"]["input"];
};

export type QueryReposArgs = {
  after: InputMaybe<Scalars["String"]["input"]>;
  first: InputMaybe<Scalars["Int"]["input"]>;
  spaceID: Scalars["ID"]["input"];
};

export type QueryRepositoriesArgs = {
  filter: InputMaybe<Scalars["String"]["input"]>;
  provider: InputMaybe<VcsProvider>;
  vcsIntegrationID: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryRevisionArgs = {
  repoID: Scalars["ID"]["input"];
  sha: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRoleArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRunArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRunMinutesUsageArgs = {
  input: RunMinutesUsageInput;
};

export type QueryRunStackArgs = {
  runId: Scalars["ID"]["input"];
};

export type QuerySavedFilterArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySavedFiltersArgs = {
  type: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryScanArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryScanProviderSchemasArgs = {
  provider: InputMaybe<ScanProvider>;
};

export type QueryScanRunArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySearchAnsibleHostsArgs = {
  input: SearchInput;
};

export type QuerySearchAnsibleHostsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchAnsibleTasksArgs = {
  input: SearchInput;
};

export type QuerySearchAnsibleTasksSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchAuditTrailEntriesArgs = {
  input: SearchInput;
};

export type QuerySearchAuditTrailEntriesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchBlueprintDeploymentsArgs = {
  input: SearchInput;
};

export type QuerySearchBlueprintVersionedGroupsArgs = {
  input: SearchInput;
};

export type QuerySearchBlueprintVersionedGroupsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchBlueprintsArgs = {
  input: SearchInput;
};

export type QuerySearchBlueprintsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchContextsArgs = {
  input: SearchInput;
};

export type QuerySearchContextsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchIntentProjectsArgs = {
  input: SearchInput;
};

export type QuerySearchIntentProjectsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchIntentResourcesArgs = {
  input: SearchInput;
};

export type QuerySearchIntentResourcesOperationsArgs = {
  input: SearchInput;
};

export type QuerySearchIntentResourcesOperationsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchIntentResourcesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchManagedEntitiesArgs = {
  input: SearchInput;
};

export type QuerySearchManagedEntitiesGroupByProvidersArgs = {
  input: SearchInput;
};

export type QuerySearchManagedEntitiesGroupByStacksArgs = {
  input: SearchInput;
};

export type QuerySearchManagedEntitiesGroupByTypesArgs = {
  input: SearchInput;
};

export type QuerySearchManagedEntitiesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchModulesArgs = {
  input: SearchInput;
  returnModuleSharing: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySearchModulesSuggestionsArgs = {
  input: SearchSuggestionsInput;
  returnModuleSharing: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySearchNamedWebhooksIntegrationsArgs = {
  input: SearchInput;
};

export type QuerySearchNamedWebhooksIntegrationsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchNotificationsArgs = {
  input: SearchInput;
};

export type QuerySearchNotificationsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchPoliciesArgs = {
  input: SearchInput;
};

export type QuerySearchPoliciesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchPolicyTemplatesArgs = {
  input: SearchInput;
};

export type QuerySearchPolicyTemplatesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchRepoCommitsArgs = {
  input: SearchInput;
  repoID: Scalars["ID"]["input"];
};

export type QuerySearchRepoCommitsSuggestionsArgs = {
  input: SearchSuggestionsInput;
  repoID: Scalars["ID"]["input"];
};

export type QuerySearchRepoFilesArgs = {
  commit: InputMaybe<Scalars["String"]["input"]>;
  input: SearchInput;
  repoID: Scalars["ID"]["input"];
};

export type QuerySearchRepoFilesSuggestionsArgs = {
  commit: InputMaybe<Scalars["String"]["input"]>;
  input: SearchSuggestionsInput;
  repoID: Scalars["ID"]["input"];
};

export type QuerySearchReposArgs = {
  input: SearchInput;
};

export type QuerySearchReposSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchRevisionsArgs = {
  input: SearchInput;
  repoID: Scalars["ID"]["input"];
};

export type QuerySearchRevisionsSuggestionsArgs = {
  input: SearchSuggestionsInput;
  repoID: Scalars["ID"]["input"];
};

export type QuerySearchRunsArgs = {
  input: SearchInput;
  offset: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySearchRunsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchScansArgs = {
  input: SearchInput;
};

export type QuerySearchScansSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchSpaceContextsArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QuerySearchSpaceContextsSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QuerySearchSpacePoliciesArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QuerySearchSpacePoliciesSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QuerySearchSpacesArgs = {
  input: SearchInput;
};

export type QuerySearchSpacesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchStacksArgs = {
  input: SearchInput;
};

export type QuerySearchStacksSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchTemplateDeploymentsArgs = {
  input: SearchInput;
};

export type QuerySearchTemplatesArgs = {
  input: SearchInput;
};

export type QuerySearchTemplatesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchTofuWorkspacesArgs = {
  input: SearchInput;
};

export type QuerySearchTofuWorkspacesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchVcsIntegrationsArgs = {
  input: SearchInput;
};

export type QuerySearchVcsIntegrationsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySearchWorkerPoolsArgs = {
  input: SearchInput;
};

export type QuerySearchWorkerPoolsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type QuerySpaceArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySpacesArgs = {
  input: InputMaybe<SearchSpacesInput>;
};

export type QueryStackArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryStackRoleBindingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryStacksWithAccessToSpaceArgs = {
  input: SearchInput;
  mode?: StackAccessMode;
  space: Scalars["ID"]["input"];
};

export type QueryStacksWithAccessToSpaceSuggestionsArgs = {
  input: SearchSuggestionsInput;
  mode?: StackAccessMode;
  space: Scalars["ID"]["input"];
};

export type QueryTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTemplateDeploymentArgs = {
  id: Scalars["ID"]["input"];
  templateID: Scalars["ID"]["input"];
};

export type QueryTemplateVersionParseTemplateArgs = {
  template: Scalars["String"]["input"];
};

export type QueryTerraformEffectiveVersionArgs = {
  constraints: Scalars["String"]["input"];
};

export type QueryTerraformProviderArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTerragruntEffectiveVersionArgs = {
  terraformConstraints: Scalars["String"]["input"];
  terragruntConstraints: Scalars["String"]["input"];
  tool: InputMaybe<TerragruntTool>;
};

export type QueryUserGroupRoleBindingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUserGroupsWithAccessToSpaceArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QueryUserGroupsWithAccessToSpaceSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QueryUserGuideArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUserGuideChapterArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUserGuideGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUserRoleBindingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUserSessionsWithAccessToSpaceArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QueryUserSessionsWithAccessToSpaceSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QueryUsersWithAccessToSpaceArgs = {
  input: SearchInput;
  space: Scalars["ID"]["input"];
};

export type QueryUsersWithAccessToSpaceSuggestionsArgs = {
  input: SearchSuggestionsInput;
  space: Scalars["ID"]["input"];
};

export type QueryVcsAgentPoolArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVcsIntegrationArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
  provider: VcsProvider;
};

export type QueryVcsIntegrationTestArgs = {
  id: Scalars["ID"]["input"];
  provider: VcsProvider;
};

export type QueryWorkerPoolArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryWorkerUsageArgs = {
  input: InputMaybe<WorkerUsageInput>;
};

/**
 * Repo represents a Spacelift-native VCS provider that stores
 * files directly in PostgreSQL with encryption support and linear commit history.
 */
export type Repo = {
  __typename?: "Repo";
  /** List of commits in this repo */
  commits: RepoCommitsOutput;
  createdAt: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  /** List of module IDs attached to this repo */
  modules: Array<Scalars["ID"]["output"]>;
  name: Scalars["String"]["output"];
  /**
   * List of revisions in this repo
   * @deprecated Use commits instead.
   */
  revisions: RevisionsOutput;
  slug: Scalars["String"]["output"];
  space: Maybe<Space>;
  /** List of stack IDs attached to this repo */
  stacks: Array<Scalars["ID"]["output"]>;
  updatedAt: Scalars["Int"]["output"];
  vcsCheckOptions: Maybe<VcsCheckOptions>;
  vcsChecks: VcsCheck;
};

/**
 * Repo represents a Spacelift-native VCS provider that stores
 * files directly in PostgreSQL with encryption support and linear commit history.
 */
export type RepoCommitsArgs = {
  after: InputMaybe<Scalars["String"]["input"]>;
  first: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Repo represents a Spacelift-native VCS provider that stores
 * files directly in PostgreSQL with encryption support and linear commit history.
 */
export type RepoRevisionsArgs = {
  after: InputMaybe<Scalars["String"]["input"]>;
  first: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * RepoCommit represents an immutable commit in the linear history
 * of a Repo.
 */
export type RepoCommit = {
  __typename?: "RepoCommit";
  authorEmail: Maybe<Scalars["String"]["output"]>;
  authorName: Scalars["String"]["output"];
  createdAt: Scalars["Int"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  /** Files in this commit */
  files: Array<RepoFile>;
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  /** Parent commit in the linear history (null for first commit) */
  parentCommit: Maybe<RepoCommit>;
  sha: Scalars["String"]["output"];
};

export type RepoCommitConnection = {
  __typename?: "RepoCommitConnection";
  cursor: Scalars["String"]["output"];
  node: RepoCommit;
};

/** Input for creating a commit in a Repo */
export type RepoCommitCreateInput = {
  /** Author email (optional) */
  authorEmail: InputMaybe<Scalars["String"]["input"]>;
  /** Author name */
  authorName: Scalars["String"]["input"];
  /** Optional extended description for the commit */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Files to commit */
  files: Array<RepoCommitFileInput>;
  /** Commit message */
  message: Scalars["String"]["input"];
  /** The Repo ID */
  repoID: Scalars["ID"]["input"];
};

/** Action to perform on a file in a commit */
export enum RepoCommitFileAction {
  /** Create a new file (returns error if the file already exists) */
  Create = "CREATE",
  /** Delete a file (no-op if the file doesn't exist; idempotent) */
  Delete = "DELETE",
  /** Update an existing file or create if it doesn't exist (default) */
  Update = "UPDATE",
}

/** Input for a single file in a commit */
export type RepoCommitFileInput = {
  /** Action to perform on the file (default: UPDATE) */
  action: InputMaybe<RepoCommitFileAction>;
  /** Base64-encoded file content (null for deletion when action is UPDATE) */
  content: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to encrypt this file at rest (default: false) */
  encrypt: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * File permissions in octal format (e.g., "0600", "0755")
   * Default: 0644 for regular files
   */
  fileMode: InputMaybe<Scalars["String"]["input"]>;
  /** File path (relative, no leading /) */
  path: Scalars["String"]["input"];
};

/** RepoCommitsOutput is a paginated list of RepoCommits. */
export type RepoCommitsOutput = {
  __typename?: "RepoCommitsOutput";
  edges: Array<RepoCommitConnection>;
  pageInfo: PageInfo;
};

export type RepoConnection = {
  __typename?: "RepoConnection";
  cursor: Scalars["String"]["output"];
  node: Repo;
};

/** Input for creating a new Repo */
export type RepoCreateInput = {
  /** Free-form description of the repo */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this is the default VCS integration for the space */
  isDefault: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Labels for categorization and filtering */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The name of the repo (slug will be auto-generated from this) */
  name: Scalars["String"]["input"];
  /** The space this Repo belongs to */
  spaceID: Scalars["ID"]["input"];
  /** Additional options for configuring VCS check behavior. */
  vcsCheckOptions: InputMaybe<VcsCheckOptionsInput>;
  /** VCS checks configuration */
  vcsChecks: InputMaybe<VcsCheck>;
};

/**
 * RepoFile represents a file at a specific commit,
 * including support for file deletion.
 */
export type RepoFile = {
  __typename?: "RepoFile";
  /**
   * Octal file permissions (e.g., "0644", "0755"), null if default
   * Commit that introduced this file version
   */
  commit: RepoCommit;
  /** File content (null if deleted) */
  content: Maybe<RepoFileContent>;
  fileMode: Maybe<Scalars["String"]["output"]>;
  /** No ID field - file versions identified by filePath within commit context */
  filePath: Scalars["String"]["output"];
  isDeleted: Scalars["Boolean"]["output"];
  /**
   * Revision that introduced this file version
   * @deprecated Use commit instead.
   */
  revision: Revision;
  sizeBytes: Maybe<Scalars["Int"]["output"]>;
};

export type RepoFileConnection = {
  __typename?: "RepoFileConnection";
  cursor: Scalars["String"]["output"];
  node: RepoFile;
};

/**
 * RepoFileContent represents deduplicated file content
 * with optional encryption.
 */
export type RepoFileContent = {
  __typename?: "RepoFileContent";
  content: Maybe<Scalars["String"]["output"]>;
  isEncrypted: Scalars["Boolean"]["output"];
  sha256Hash: Scalars["String"]["output"];
  /** Base64-encoded for non-encrypted files, null for encrypted files */
  sizeBytes: Scalars["Int"]["output"];
};

/** RepoFileHistoryOutput is the output type for repoFileHistory query. */
export type RepoFileHistoryOutput = {
  __typename?: "RepoFileHistoryOutput";
  edges: Array<RepoFileConnection>;
  pageInfo: PageInfo;
};

/** Input for updating an existing Repo */
export type RepoUpdateInput = {
  /** Free-form description of the repo */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Whether this is the default VCS integration for the space */
  isDefault: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Labels for categorization and filtering */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The name of the repo */
  name: InputMaybe<Scalars["String"]["input"]>;
  /** Additional options for configuring VCS check behavior. */
  vcsCheckOptions: InputMaybe<VcsCheckOptionsInput>;
  /** VCS checks configuration */
  vcsChecks: InputMaybe<VcsCheck>;
};

/** ReposOutput is a paginated list of Repos. */
export type ReposOutput = {
  __typename?: "ReposOutput";
  edges: Array<RepoConnection>;
  pageInfo: PageInfo;
};

/** GitHub repository with branches. */
export type Repository = {
  __typename?: "Repository";
  /** Name of the repository. */
  id: Scalars["ID"]["output"];
  /** Repository namespace. */
  namespace: Scalars["String"]["output"];
};

export type ResourceChange = {
  __typename?: "ResourceChange";
  resources: Array<EntityChangeV3>;
};

/**
 * Revision represents an immutable commit in the linear history
 * of a Repo. Superseded by RepoCommit.
 */
export type Revision = {
  __typename?: "Revision";
  authorEmail: Maybe<Scalars["String"]["output"]>;
  authorName: Scalars["String"]["output"];
  createdAt: Scalars["Int"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  /** Files in this revision */
  files: Array<RepoFile>;
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  /**
   * Parent revision in the linear history (null for first revision)
   * @deprecated Use RepoCommit.parentCommit instead.
   */
  parentRevision: Maybe<Revision>;
  sha: Scalars["String"]["output"];
};

export type RevisionConnection = {
  __typename?: "RevisionConnection";
  cursor: Scalars["String"]["output"];
  node: Revision;
};

/** Input for creating a revision (committing files) in a Repo */
export type RevisionCreateInput = {
  /** Author email (optional) */
  authorEmail: InputMaybe<Scalars["String"]["input"]>;
  /** Author name */
  authorName: Scalars["String"]["input"];
  /** Optional extended description for the commit */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Files to commit */
  files: Array<RevisionFileInput>;
  /** Commit message */
  message: Scalars["String"]["input"];
  /** The Repo ID */
  repoID: Scalars["ID"]["input"];
};

/** Action to perform on a file in a revision. Superseded by RepoCommitFileAction. */
export enum RevisionFileAction {
  /** Create a new file (returns error if the file already exists) */
  Create = "CREATE",
  /** Delete a file (no-op if the file doesn't exist; idempotent) */
  Delete = "DELETE",
  /** Update an existing file or create if it doesn't exist (default) */
  Update = "UPDATE",
}

/** Input for a single file in a revision */
export type RevisionFileInput = {
  /** Action to perform on the file (default: UPDATE) */
  action: InputMaybe<RevisionFileAction>;
  /** Base64-encoded file content (null for deletion when action is UPDATE) */
  content: InputMaybe<Scalars["String"]["input"]>;
  /** Whether to encrypt this file at rest (default: false) */
  encrypt: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * File permissions in octal format (e.g., "0600", "0755")
   * Default: 0644 for regular files
   */
  fileMode: InputMaybe<Scalars["String"]["input"]>;
  /** File path (relative, no leading /) */
  path: Scalars["String"]["input"];
};

/** RevisionsOutput is a paginated list of Revisions. */
export type RevisionsOutput = {
  __typename?: "RevisionsOutput";
  edges: Array<RevisionConnection>;
  pageInfo: PageInfo;
};

export type Role = {
  __typename?: "Role";
  actions: Array<Action>;
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isSystem: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  roleBindings: Array<RoleBinding>;
  roleBindingsCount: Scalars["Int"]["output"];
  slug: Scalars["String"]["output"];
};

export type RoleBinding =
  | ApiKeyRoleBinding
  | StackRoleBinding
  | UserGroupRoleBinding
  | UserRoleBinding;

export type RoleBindingInput = {
  /** ID of the role. */
  roleID: Scalars["ID"]["input"];
  /** ID of the space. */
  spaceID: Scalars["ID"]["input"];
};

export type RoleInput = {
  /** Permissions associated with the role. */
  actions: Array<Action>;
  /** Human-readable, free-form description. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Human-readable, free-form name. */
  name: Scalars["String"]["input"];
};

export type RoleUpdateInput = {
  /** Permissions associated with the role. */
  Actions: InputMaybe<Array<Action>>;
  /** Human-readable, free-form description. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Human-readable, free-form name. */
  name: InputMaybe<Scalars["String"]["input"]>;
};

/** Run represents the main concept in Spacelift. */
export type Run = {
  __typename?: "Run";
  /** Name of the branch for which this Run has been created. */
  branch: Scalars["String"]["output"];
  /** Checks if a run can be confirmed. */
  canConfirm: Scalars["Boolean"]["output"];
  /** Checks if a proposed run can be promoted to a tracked one. */
  canPromote: Scalars["Boolean"]["output"];
  /** Checks if a run can be retried. */
  canRetry: Scalars["Boolean"]["output"];
  /** Entities changed by this Run. */
  changesV2: Maybe<EntityChangesV2>;
  /**
   * Entities changed by this Run. If phase is not passed, the changes for latest phase are returned.
   * Only available for Terraform, OpenTofu and Terragrunt stacks. Returns an error
   * for other vendors, use changesV2 instead.
   */
  changesV3: Array<ResourceChange>;
  /** Command - only useful for Tasks. */
  command: Maybe<Scalars["String"]["output"]>;
  /** Comments on the Run, if any. */
  comments: Array<RunComment>;
  /**
   * Commit representing the HEAD of the branch at the time of triggering
   * the Run.
   */
  commit: Commit;
  /**
   * SHAs of every commit bundled into this Run, including its head commit
   * More than one when the Run was triggered by a push that batched several commits.
   */
  commits: Array<Scalars["String"]["output"]>;
  /** Returns a message explaining why a run cannot be confirmed. */
  confirmBlocker: Maybe<Scalars["String"]["output"]>;
  /**
   * A download URL for the CPU profile (.pprof) captured while the run was in
   * the given state. The profile merges every OpenTofu command of that state;
   * the "spacelift.command" sample label tells them apart.
   */
  cpuProfileDownloadURL: Maybe<LogsDownloadUrl>;
  /** Unix timestamp representing Run creation. */
  createdAt: Scalars["Int"]["output"];
  /** Customer provided runtime configuration for this Run. */
  customRuntimeConfig: Maybe<RuntimeConfig>;
  /**
   * Change in resources tracked by the Stack's state that will be caused
   * by this Run.
   */
  delta: Maybe<Delta>;
  /** The run that this run depends on. */
  dependsOn: Array<RunDependency>;
  /** Indicates whether this run belongs to a drift detection workflow. */
  driftDetection: Scalars["Boolean"]["output"];
  /**
   * If the run is a module test case, is the test case expected to fail? This
   * field will be null for non-module runs.
   */
  expectFailure: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Expired run is one that's been waiting for user approval for long enough to
   * have its pending plan file garbage-collected.
   */
  expired: Scalars["Boolean"]["output"];
  /** any external dependencies that this run has */
  externalDependencies: Array<RunExternalDependency>;
  /** Convenience helper, allowing a quick check on whether the Run has finished. */
  finished: Scalars["Boolean"]["output"];
  /**
   * Controls whether this run will force apply even when delta is zero.
   * Null means normal behavior. SINGLE: force apply this run only. CASCADE: force apply and propagate to dependents.
   */
  forceApplyMode: Maybe<ForceApplyMode>;
  /** Run history as a list of state transitions. */
  history: Array<RunStateTransition>;
  /** Globally unique ID (ULID) of the Run. */
  id: Scalars["ID"]["output"];
  /** The runs that depend on this run. */
  isDependedOnBy: Array<RunDependency>;
  /**
   * Indicates whether the run is the most recent one its current Stack - ie. it
   * is the one that has last changed the stack state.
   */
  isMostRecent: Scalars["Boolean"]["output"];
  /**
   * Indicates whether the run has been prioritized.
   * Equivalent to priorityPreset being high.
   * @deprecated Use priorityPreset instead.
   */
  isPrioritized: Scalars["Boolean"]["output"];
  /**
   * Paginated slice of Run logs associated with one of the current Run's
   * (past or present) states. Set sanitize to strip ANSI codes, timestamps
   * and noise lines - useful when feeding logs to an LLM.
   */
  logs: Maybe<LogsResponse>;
  /** A download URL for the logs of a run state */
  logsDownloadURL: Maybe<LogsDownloadUrl>;
  /** Indicates whether the Run needs approval before it can proceed. */
  needsApproval: Scalars["Boolean"]["output"];
  /**
   * Next run, if any. Next indicates a run of the same type, on the same branch,
   * created right after the current one.
   */
  next: Maybe<Run>;
  /**
   * How far the run's observability data got through the pipeline that
   * produces it. Null when the status could not be read.
   */
  observabilityStatus: Maybe<RunObservabilityStatus>;
  /**
   * A download URL for the run's captured OTEL trace as a single Jaeger JSON
   * document.
   */
  otelTraceForJaegerDownloadURL: Maybe<LogsDownloadUrl>;
  /** List of outcomes for policies evaluated against this runs plan. */
  planPoliciesOutcomes: Array<PlanPoliciesOutcome>;
  /** The logs associated with the plugins of a run. */
  pluginLogs: Array<PluginLogsResponse>;
  /** A download URL for the logs of a plugin. */
  pluginLogsDownloadURL: Maybe<LogsDownloadUrl>;
  /** Policy evaluation sample for a given key, if available. */
  policyReceiptSample: Maybe<PolicyEvaluationSample>;
  /** List of policy evaluations events that affected this run. */
  policyReceipts: Array<RunPolicyReceipt>;
  /**
   * Previous run, if any. Previous indicates a run of the same type, on the same
   * branch, created right before the current one.
   */
  previous: Maybe<Run>;
  /**
   * The scheduling tier of the run within its worker pool queue.
   * High runs are scheduled before all others, low runs after all others, and normal runs are ordered by run type.
   */
  priorityPreset: RunPriorityPreset;
  /** Reason why the run cannot be promoted, if any. */
  promoteBlocker: Maybe<Scalars["String"]["output"]>;
  /** Reason why the run cannot be retried. */
  retryBlocker: Maybe<Scalars["String"]["output"]>;
  /** List of reviews for this run. */
  reviews: Array<RunReview>;
  /** Individual runtime configuration for this Run. */
  runtimeConfig: Maybe<RuntimeConfig>;
  /**
   * searchEntityChanges allows to search changes of a run.
   * Only available for Terraform, OpenTofu and Terragrunt stacks. Returns an error
   * for other vendors, use changesV2 instead.
   */
  searchEntityChanges: SearchEntityChangeOutput;
  /**
   * searchEntityChangesSuggestions returns search suggestions for run changes.
   * Only available for Terraform, OpenTofu and Terragrunt stacks. Returns an error
   * for other vendors.
   */
  searchEntityChangesSuggestions: SearchSuggestionsOutput;
  /** The ID (slug) of the Stack this Run belongs to. */
  stackId: Scalars["ID"]["output"];
  /** Current state of the Run. */
  state: RunState;
  /** Indicates whether the run supports detailed resources. */
  supportsDetailedResources: Scalars["Boolean"]["output"];
  /** Title of the Run for UI consumption. */
  title: Scalars["String"]["output"];
  /** The user who manually triggered this Run, if any. */
  triggeredBy: Maybe<Scalars["String"]["output"]>;
  /**
   * Runs on dependent stacks that were triggered as a result of this run finishing.
   * Does not include runs in the Skipped state.
   */
  triggeredRuns: Array<RunDependency>;
  /** Type of the Run. */
  type: RunType;
  /** Unix timestamp of the last update. */
  updatedAt: Scalars["Int"]["output"];
  /** Observations about this run. Null until the run has ended. */
  workerFindings: Maybe<RunWorkerFindings>;
  /**
   * Metrics the workers reported while executing this run, next to the
   * same metrics across finished tracked runs of the same stack that
   * measured an apply, created within `comparisonWindowDays` before this
   * run. Null unless `observabilityStatus.metrics` is AVAILABLE, and when
   * the metrics could not be read.
   */
  workerMetrics: Maybe<RunWorkerMetrics>;
  /**
   * ID (ULID) of the workflow this Run belongs to. All Runs triggered as part
   * of the same chain (stack-dependency fan-out, trigger policies, promotion)
   * share this value, so it can be used to group a run chain without walking
   * the dependency graph. A standalone Run's workflowId is its own id.
   */
  workflowId: Scalars["ID"]["output"];
};

/** Run represents the main concept in Spacelift. */
export type RunChangesV2Args = {
  input: EntityChangeCollectionInputV2;
};

/** Run represents the main concept in Spacelift. */
export type RunChangesV3Args = {
  input: EntityChangesInputV3;
};

/** Run represents the main concept in Spacelift. */
export type RunCpuProfileDownloadUrlArgs = {
  state: RunState;
};

/** Run represents the main concept in Spacelift. */
export type RunLogsArgs = {
  sanitize: InputMaybe<Scalars["Boolean"]["input"]>;
  state: RunState;
  stateVersion: InputMaybe<Scalars["Int"]["input"]>;
  token: InputMaybe<Scalars["String"]["input"]>;
};

/** Run represents the main concept in Spacelift. */
export type RunLogsDownloadUrlArgs = {
  state: RunState;
  stateVersion: InputMaybe<Scalars["Int"]["input"]>;
};

/** Run represents the main concept in Spacelift. */
export type RunPluginLogsDownloadUrlArgs = {
  pluginName: Scalars["String"]["input"];
};

/** Run represents the main concept in Spacelift. */
export type RunPolicyReceiptSampleArgs = {
  id: Scalars["ID"]["input"];
};

/** Run represents the main concept in Spacelift. */
export type RunSearchEntityChangesArgs = {
  changePhase: InputMaybe<Scalars["String"]["input"]>;
  input: SearchInput;
};

/** Run represents the main concept in Spacelift. */
export type RunSearchEntityChangesSuggestionsArgs = {
  changePhase: InputMaybe<Scalars["String"]["input"]>;
  input: SearchSuggestionsInput;
};

/** Run represents the main concept in Spacelift. */
export type RunWorkerMetricsArgs = {
  input: InputMaybe<RunWorkerMetricsInput>;
};

/** RunComment represents a single comment on a Run. */
export type RunComment = {
  __typename?: "RunComment";
  /** Body of the comment, supports Markdown. */
  body: Scalars["String"]["output"];
  /** Comment creation timestamp. */
  createdAt: Scalars["Int"]["output"];
  /** Username of the commenter. */
  username: Scalars["String"]["output"];
};

/** RunConnection represents a single run in a page of searchRuns results. */
export type RunConnection = {
  __typename?: "RunConnection";
  cursor: Scalars["String"]["output"];
  node: RunWithStack;
};

export type RunDependency = {
  __typename?: "RunDependency";
  /** Identifier of the run dependency. */
  id: Scalars["ID"]["output"];
  /** The ID of the run. */
  runId: Scalars["ID"]["output"];
  /** Unix timestamp of the last run update. */
  runUpdatedAt: Scalars["Int"]["output"];
  /** The stack id of the run. */
  stackId: Scalars["ID"]["output"];
  /** The stack name of the run. */
  stackName: Scalars["String"]["output"];
  /** The state of the run. */
  state: RunState;
};

export type RunDiscardAll = {
  __typename?: "RunDiscardAll";
  discardedRuns: Array<Run>;
  failedDiscarding: Array<Scalars["String"]["output"]>;
};

export type RunExternalDependency = {
  __typename?: "RunExternalDependency";
  /** when the dependency has been marked as completed. */
  completedAt: Maybe<Scalars["Int"]["output"]>;
  /** when the dependency has been created. */
  createdAt: Scalars["Int"]["output"];
  /** The identifier of the dependency. */
  id: Scalars["ID"]["output"];
  /** Status of the dependency. */
  status: RunExternalDependencyStatus;
};

/** Experimental: Response to marking a dependency as complete. */
export type RunExternalDependencyMarkAsCompletedResponse = {
  __typename?: "RunExternalDependencyMarkAsCompletedResponse";
  /** there needs to be at least one field */
  phantom: Scalars["Boolean"]["output"];
  status: RunExternalDependencyStatus;
};

export enum RunExternalDependencyStatus {
  Failed = "FAILED",
  Finished = "FINISHED",
  Pending = "PENDING",
  Skipped = "SKIPPED",
}

export type RunIgnoredTrigger = {
  __typename?: "RunIgnoredTrigger";
  commit: Commit;
  createdAt: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  policyAttachments: Array<RunIgnoredTriggerPolicyAttachments>;
  reasonType: RunIgnoredTriggerReasonType;
};

export type RunIgnoredTriggerPolicyAttachments = {
  __typename?: "RunIgnoredTriggerPolicyAttachments";
  policy: Maybe<Policy>;
  policyName: Maybe<Scalars["String"]["output"]>;
};

export enum RunIgnoredTriggerReasonType {
  CustomPolicy = "CUSTOM_POLICY",
  CustomPolicyNoTrigger = "CUSTOM_POLICY_NO_TRIGGER",
  DisabledByLabel = "DISABLED_BY_LABEL",
  NoAffectedFilesInProjectRoot = "NO_AFFECTED_FILES_IN_PROJECT_ROOT",
  TagsIgnoredByDefault = "TAGS_IGNORED_BY_DEFAULT",
}

export type RunIgnoredTriggersConnection = {
  __typename?: "RunIgnoredTriggersConnection";
  cursor: Scalars["String"]["output"];
  node: RunIgnoredTrigger;
};

export type RunMinutesDailyByRunState = {
  __typename?: "RunMinutesDailyByRunState";
  /** Unix seconds at midnight UTC. */
  day: Scalars["Int"]["output"];
  minutes: Scalars["Float"]["output"];
  runState: RunState;
};

export type RunMinutesDailyByRunType = {
  __typename?: "RunMinutesDailyByRunType";
  /** Unix seconds at midnight UTC. */
  day: Scalars["Int"]["output"];
  minutes: Scalars["Float"]["output"];
  runType: RunType;
};

/**
 * Minutes that ran on a worker, split by whether that worker belonged to the
 * public (default) pool. Only executing run states count: a run waiting in the
 * queue has no worker assigned, so its minutes are recorded as private, and
 * counting them would report queue time as private worker time. That filter is
 * why these two numbers sum to less than dailyByRunType / dailyByRunState.
 */
export type RunMinutesTotals = {
  __typename?: "RunMinutesTotals";
  /** Minutes that ran on a private worker pool. */
  privateMinutes: Scalars["Float"]["output"];
  /** Minutes that ran on the public (default) worker pool. */
  publicMinutes: Scalars["Float"]["output"];
};

/**
 * Run-minutes are state durations - the time between consecutive run state
 * transitions - so a run contributes minutes to every state it passes through,
 * not just the ones that occupy a worker. A duration counts in full against the
 * day its state *started*; it is never split across day boundaries. A state
 * entered at 23:50 and left 20 minutes later puts all 20 minutes on the earlier
 * day, so a day's minutes can include time that elapsed later. Terminal states
 * never appear: they have no next transition, hence no duration.
 */
export type RunMinutesUsage = {
  __typename?: "RunMinutesUsage";
  /** Run-minutes per day, broken down by run state. */
  dailyByRunState: Array<RunMinutesDailyByRunState>;
  /**
   * Run-minutes per day, broken down by run type. One entry per (day, runType)
   * that has minutes; days with no runs are absent.
   */
  dailyByRunType: Array<RunMinutesDailyByRunType>;
  /**
   * Window totals split by worker-pool visibility. Counts executing run states
   * only, so these do not add up to the totals of the two series above - see
   * RunMinutesTotals.
   */
  totals: RunMinutesTotals;
  /**
   * The window this response actually covers: the requested startTime/endTime
   * after endTime was capped at the start of today. Read the series against
   * these bounds, not the ones you sent - they can differ.
   */
  window: RunMinutesUsageWindow;
};

/**
 * Window to report run-minutes over, half-open as [startTime, endTime). Both bounds
 * are unix seconds and must be midnight UTC - a whole multiple of 86400 - because the
 * rollup is per-UTC-day. A bound that is not midnight is rejected rather than rounded,
 * so being a few hours off cannot silently drop a day. The span may be at most 62 days.
 */
export type RunMinutesUsageInput = {
  /**
   * Exclusive upper bound, clamped to the start of today: the rollup only
   * covers days that have closed, so today is never reported. A window entirely
   * in the future is not an error - it reports an empty window and no data.
   */
  endTime: Scalars["Int"]["input"];
  /**
   * Inclusive lower bound. Days older than the rollup's retention horizon
   * (~183 days) hold no data and report zero.
   */
  startTime: Scalars["Int"]["input"];
};

export type RunMinutesUsageWindow = {
  __typename?: "RunMinutesUsageWindow";
  /** Unix seconds at midnight UTC, exclusive. */
  end: Scalars["Int"]["output"];
  /** Unix seconds at midnight UTC, inclusive. */
  start: Scalars["Int"]["output"];
};

/**
 * RunObservabilitySeverity says how much attention a run's observability data
 * reports needs.
 */
export enum RunObservabilitySeverity {
  /** Worth acting on. */
  Major = "MAJOR",
  /** Worth knowing about. */
  Minor = "MINOR",
  /** Nothing to act on. */
  None = "NONE",
}

export type RunObservabilityStatus = {
  __typename?: "RunObservabilityStatus";
  /**
   * The status of the metrics derived from those spans. A run that is still
   * going reports PARTIAL_DATA_AVAILABLE here once it stored its first metric
   * point, and AVAILABLE only after it reaches a terminal state.
   */
  metrics: ObservabilityProcessingStatus;
  /**
   * The status of the OTEL spans the run's workers captured. A phase's trace
   * is complete once that phase ends, so a run that is still going reports
   * PARTIAL_DATA_AVAILABLE here once it stored its first span.
   */
  traces: ObservabilityProcessingStatus;
};

export type RunOrStackArgs = {
  run: InputMaybe<Scalars["String"]["input"]>;
  stack: InputMaybe<Scalars["String"]["input"]>;
};

/** RunPolicyReceipt represents a single policy evaluation event that affected a Run. */
export type RunPolicyReceipt = {
  __typename?: "RunPolicyReceipt";
  /** Timestamp representing the moment of policy evaluation. */
  createdAt: Scalars["Int"]["output"];
  /** Type of policy engine that was used to evaluate this policy */
  engineType: PolicyEngineType;
  /** Flags generated by the policy evaluation, if any. */
  flags: Array<Scalars["String"]["output"]>;
  /** Globally unique ID of this policy receipt. */
  id: Scalars["ID"]["output"];
  /** Basic string representation of the policy's evaluation result. */
  outcome: Scalars["String"]["output"];
  /** Indicates whether the policy was deleted. */
  policyDeleted: Scalars["Boolean"]["output"];
  /** Name of the policy that affected the Run. */
  policyName: Scalars["String"]["output"];
  /** Slug of the policy that affected the Run. */
  policySlug: Maybe<Scalars["String"]["output"]>;
  /** Type of the evaluated policy. */
  policyType: PolicyType;
  /** Indicates whether sample has expired. */
  sampleExpired: Scalars["Boolean"]["output"];
  /** Indicates whether the policy evaluation was sampled. */
  sampled: Scalars["Boolean"]["output"];
};

/** RunPriorityPreset represents predefined priority levels for runs. */
export enum RunPriorityPreset {
  /** Highest priority - run will be scheduled before other runs. */
  High = "high",
  /**
   * Low priority - queued behind high and normal priority runs on the same worker pool,
   * except that low priority tracked and proposed runs still go ahead of drift detection runs.
   */
  Low = "low",
  /** Default priority based on run type (blocking, non-blocking, drift detection). */
  Normal = "normal",
}

/**
 * RunResourceState represents a state of the Run.
 * It's for Terraform-Provider, to allow spacelift run to read the state of another run.
 */
export type RunResourceState = {
  __typename?: "RunResourceState";
  /** Convenience helper, allowing a quick check on whether the Run has finished. */
  finished: Scalars["Boolean"]["output"];
  /** Globally unique ID (ULID) of the Run. */
  id: Scalars["ID"]["output"];
  /** Current state of the Run. */
  state: RunState;
};

/** RunReview represents a single Run review event. */
export type RunReview = {
  __typename?: "RunReview";
  /** Author of the review. */
  author: Scalars["String"]["output"];
  /** Decision made by the reviewer. */
  decision: RunReviewDecision;
  /** Unique ID of the run review. */
  id: Scalars["ID"]["output"];
  /** Optional note, if any. */
  note: Maybe<Scalars["String"]["output"]>;
  /** State of the Run at the time of the review. */
  state: RunState;
  /** StateVersion of the Run at the time of the review. */
  stateVersion: Scalars["Int"]["output"];
  /** Unix timestamp of the review. */
  timestamp: Scalars["Int"]["output"];
};

/** RunReviewDecision values represent available run review decision. */
export enum RunReviewDecision {
  /** The reviewer approved the Run. */
  Approve = "APPROVE",
  /** The reviewer rejected the Run. */
  Reject = "REJECT",
}

export type RunScheduledForTerminationTile = {
  __typename?: "RunScheduledForTerminationTile";
  runTile: RunTile;
  scheduledTerminationAt: Scalars["Int"]["output"];
};

/** RunState represents a discrete state of a Run. */
export enum RunState {
  /** A worker is currently applying the run's changes. */
  Applying = "APPLYING",
  /** The run has been canceled by the user. */
  Canceled = "CANCELED",
  /**
   * The run's plan has been confirmed by the user. The run is now waiting for
   * the worker to pick it up and start processing.
   */
  Confirmed = "CONFIRMED",
  /**
   * The worker is currently performing a destroy operation on the managed
   * resources.
   */
  Destroying = "DESTROYING",
  /** The run's plan has been rejected by the user. */
  Discarded = "DISCARDED",
  /** The run has failed. */
  Failed = "FAILED",
  /** The run or task has finished successfully. */
  Finished = "FINISHED",
  /** The run's workspace is currently initializing on the worker. */
  Initializing = "INITIALIZING",
  /** @deprecated This state is no longer used. */
  Pending = "PENDING",
  /** The proposed run is waiting for post-planning approval policy sign-off. */
  PendingReview = "PENDING_REVIEW",
  /** The worker is currently performing the task requested by the user. */
  Performing = "PERFORMING",
  /** The worker is planning the run. */
  Planning = "PLANNING",
  /** The workspace is currently being prepared for the run. */
  Preparing = "PREPARING",
  /** The workspace is currently being prepared for the change deployment. */
  PreparingApply = "PREPARING_APPLY",
  /** The run is being prepared to be replanned. */
  PreparingReplan = "PREPARING_REPLAN",
  /**
   * The run is queued and is either waiting for an available worker or for the
   * stack lock to be released by another run.
   */
  Queued = "QUEUED",
  /** The run is ready to be started. */
  Ready = "READY",
  /** The run is pending a replan and should get picked up by the scheduler. */
  ReplanRequested = "REPLAN_REQUESTED",
  /** The run was skipped. */
  Skipped = "SKIPPED",
  /** The run has been stopped by the user. */
  Stopped = "STOPPED",
  /**
   * The run has planned successfully, it reports changes and is waiting for the
   * user to review those.
   */
  Unconfirmed = "UNCONFIRMED",
  /** An invalid "zero-value" for the run state. */
  Unknown = "UNKNOWN",
}

/** Change in the Run state, along with its metadata. */
export type RunStateTransition = {
  __typename?: "RunStateTransition";
  /** Indicates whether the state transition has logs. */
  hasLogs: Scalars["Boolean"]["output"];
  /** Optional note about the state transition. */
  note: Maybe<Scalars["String"]["output"]>;
  /** New state of the Run. */
  state: RunState;
  /**
   * New state version of the Run.
   * Old runs are not guaranteed to have this value set,
   * but backend will accept `null` as input where this value is needed.
   */
  stateVersion: Maybe<Scalars["Int"]["output"]>;
  /** Whether the transition finishes the run. */
  terminal: Scalars["Boolean"]["output"];
  /** Unix timestamp of the Run. */
  timestamp: Scalars["Int"]["output"];
  /** Unix timestamp of the subsequent state transition, if any. */
  until: Maybe<Scalars["Int"]["output"]>;
  /** GitHub username of the individual who caused the change, if any. */
  username: Maybe<Scalars["String"]["output"]>;
};

export type RunTile = {
  __typename?: "RunTile";
  createdAt: Scalars["Int"]["output"];
  /** ULID of the run. */
  id: Scalars["ID"]["output"];
  needsApproval: Scalars["Boolean"]["output"];
  stackTile: StackTile;
  state: RunState;
  title: Scalars["String"]["output"];
  type: RunType;
};

export type RunTileWithApproval = {
  __typename?: "RunTileWithApproval";
  approval: Scalars["Boolean"]["output"];
  runTile: RunTile;
};

export type RunTriggerBatchInput = {
  /**
   * Controls behavior when a run's plan shows zero changes.
   * SINGLE: force-apply this run only, do not propagate to dependents.
   * CASCADE: force-apply this run and all triggered dependents.
   * Null means normal behavior (runs with no changes stop at the plan stage).
   */
  forceApply: InputMaybe<ForceApplyMode>;
  /** The stacks to trigger runs for. */
  stacks: Array<RunTriggerBatchStackInput>;
};

export type RunTriggerBatchOutput = {
  __typename?: "RunTriggerBatchOutput";
  /**
   * The runs created by the batch trigger: one per requested stack plus any
   * dependency-triggered runs, in no particular order.
   */
  runs: Array<RunTriggerBatchRun>;
};

export type RunTriggerBatchRun = {
  __typename?: "RunTriggerBatchRun";
  /**
   * The created run. Only present when you have read access to the run's stack,
   * otherwise null. Dependency-triggered runs may land on stacks you cannot access.
   */
  run: Maybe<Run>;
  /** The ID of the created run. Always present, even for runs on stacks you cannot access. */
  runId: Scalars["ID"]["output"];
};

export type RunTriggerBatchStackInput = {
  /**
   * Commit SHA to use. Defaults to the commit currently tracked by the stack,
   * or to the HEAD of the tracked branch if the stack is not yet tracking any commit.
   * For tracked runs, the stack's tracked commit will be updated to this commit.
   */
  commitSha: InputMaybe<Scalars["String"]["input"]>;
  /** The stack (or module) slug. */
  stack: Scalars["ID"]["input"];
};

/** RunType is a type of the Run. */
export enum RunType {
  /** Resource destruction job. */
  Destroy = "DESTROY",
  /** Source code parsing job. */
  Parse = "PARSE",
  /** A run that's creating a change preview or drift detection. */
  Proposed = "PROPOSED",
  /** One-off run started by the user. */
  Task = "TASK",
  /** Test case for a module. */
  Testing = "TESTING",
  /** A deployment candidate. */
  Tracked = "TRACKED",
  /** An invalid "zero-value" for the run type. */
  Unknown = "UNKNOWN",
}

/** RunWithPosition is a wrapper for run with its position in the queue. */
export type RunWithPosition = {
  __typename?: "RunWithPosition";
  isModule: Scalars["Boolean"]["output"];
  position: Scalars["Int"]["output"];
  /** Provider of the stacks' repository. */
  provider: VcsProvider;
  run: Run;
  space: Space;
  stackId: Scalars["ID"]["output"];
  stackName: Scalars["String"]["output"];
  version: Maybe<Scalars["String"]["output"]>;
};

/** RunWithPositionConnection represents a single queued run in a page of results. */
export type RunWithPositionConnection = {
  __typename?: "RunWithPositionConnection";
  cursor: Scalars["String"]["output"];
  node: RunWithPosition;
};

/**
 * RunWithStack is a run together with the stack (or module) it belongs to, so
 * the account-wide runs view can render stack details without a separate
 * per-stack query.
 */
export type RunWithStack = {
  __typename?: "RunWithStack";
  /**
   * Whether the run belongs to a module. Surfaced here because the Stack type
   * does not expose it.
   */
  isModule: Scalars["Boolean"]["output"];
  run: Run;
  /** The stack (or module) the run belongs to. */
  stack: Stack;
};

export type RunWorkerFinding = {
  __typename?: "RunWorkerFinding";
  description: Maybe<Scalars["String"]["output"]>;
  recommendation: Maybe<Scalars["String"]["output"]>;
  severity: RunObservabilitySeverity;
  title: Scalars["String"]["output"];
  type: RunWorkerFindingType;
};

export enum RunWorkerFindingType {
  ProviderVersionChange = "ProviderVersionChange",
  ProviderVersionConflict = "ProviderVersionConflict",
  SlowProviderInstallCacheDisabled = "SlowProviderInstallCacheDisabled",
}

export type RunWorkerFindings = {
  __typename?: "RunWorkerFindings";
  /**
   * Observations excluding the outcome. Empty when evaluated with no findings;
   * null when not yet available or retrieval failed. Retrieval failures do not
   * produce GraphQL errors. Multiple findings may share a type; order is not
   * guaranteed.
   */
  findings: Maybe<Array<RunWorkerFinding>>;
  /**
   * Summary of how the run ended, available independently of findings.
   * Null if the summary could not be retrieved.
   */
  outcome: Maybe<RunWorkerOutcome>;
};

/**
 * A run's worker metrics grouped by what they describe, each measurement next
 * to the stack comparison it can be judged against. These are measurements
 * only: whether a value is slow is for the reader to decide, and whether the
 * metrics are complete is what `observabilityStatus.metrics` says.
 */
export type RunWorkerMetrics = {
  __typename?: "RunWorkerMetrics";
  /** The population the P95 values were drawn from. */
  comparison: RunWorkerMetricsComparison;
  /**
   * Wall-clock time the run spent on the worker: final for a finished run,
   * elapsed so far for one still going. Waits between worker executions
   * are not counted. The P95 is drawn from runs that applied and finished.
   */
  duration: RunWorkerMetricsDuration;
  failedResources: RunWorkerMetricsFailedResources;
  /**
   * The providers the run spent the most time installing, longest first. The
   * run only reports the slowest few providers. Being at the top is not a
   * verdict: the slowest provider of a fast run is not a slow provider.
   */
  slowestProviders: Array<RunWorkerMetricsProvider>;
  /**
   * One entry per run state that either this run or the comparison runs
   * measured, in execution order. A state the worker does not trace has no
   * entry.
   */
  states: Array<RunWorkerMetricsState>;
};

export type RunWorkerMetricsComparison = {
  __typename?: "RunWorkerMetricsComparison";
  /**
   * Number of comparison runs a p95 needs before it is published. Below it
   * every `p95Seconds` is null.
   */
  requiredRunCount: Scalars["Int"]["output"];
  /**
   * Number of comparison runs: the population a comparison could be drawn
   * from.
   */
  runCount: Scalars["Int"]["output"];
  /** Days before the run's creation that comparison runs were drawn from. */
  windowDays: Scalars["Int"]["output"];
};

/**
 * A measured duration next to its stack comparison. Either side can be missing
 * on its own: a run that has not measured yet has a P95 but no seconds, a stack
 * with too few readings of this measurement has seconds but no P95.
 */
export type RunWorkerMetricsDuration = {
  __typename?: "RunWorkerMetricsDuration";
  /**
   * Ratio of this run's seconds to the p95Seconds. Null whenever either
   * seconds or p95Seconds is null.
   */
  p95Ratio: Maybe<Scalars["Float"]["output"]>;
  /**
   * 95th percentile of the same reading across the comparison runs. Null
   * unless there are at least `RunWorkerMetricsComparison.requiredRunCount`
   * data points.
   */
  p95Seconds: Maybe<Scalars["Float"]["output"]>;
  /**
   * Severity of the duration. Judged on `p95Ratio`. Null whenever
   * `p95Ratio` is null.
   */
  p95Severity: Maybe<RunObservabilitySeverity>;
  /** This run's reading. */
  seconds: Maybe<Scalars["Float"]["output"]>;
};

export type RunWorkerMetricsFailedResourceGroup = {
  __typename?: "RunWorkerMetricsFailedResourceGroup";
  count: Scalars["Int"]["output"];
  /** Resource type as the workflow tool names it, such as `aws_s3_bucket`. */
  resourceType: Scalars["String"]["output"];
  /**
   * The run state the resources failed in, one of the values
   * `RunWorkerMetricsState.runState` takes.
   */
  runState: RunState;
};

export type RunWorkerMetricsFailedResources = {
  __typename?: "RunWorkerMetricsFailedResources";
  /**
   * The same count by run state and resource type, in execution order then
   * by type.
   */
  breakdown: Array<RunWorkerMetricsFailedResourceGroup>;
  /**
   * Resources that failed, summed over every run state and resource type. A
   * resource counts once per state it failed in, however many times it
   * failed there.
   */
  count: Scalars["Int"]["output"];
};

export type RunWorkerMetricsHook = {
  __typename?: "RunWorkerMetricsHook";
  /**
   * The hook's command line as the worker reports it, such as `./seed.sh`.
   * A hook can be a whole inline script, so a long command line is cut.
   */
  command: Scalars["String"]["output"];
  /**
   * Time the state spent on this hook, summed over every time the state ran
   * it in this phase.
   */
  durationSeconds: Scalars["Float"]["output"];
  /**
   * `before` or `after`, saying whether the hook ran before or after the
   * command of its run state.
   */
  phase: Scalars["String"]["output"];
};

/** Selects the comparison window for `Run.workerMetrics`. */
export type RunWorkerMetricsInput = {
  /**
   * Days before the run's creation that comparison runs are drawn from, 1
   * through 90. Defaults to 30.
   */
  comparisonWindowDays: InputMaybe<Scalars["Int"]["input"]>;
};

export type RunWorkerMetricsProvider = {
  __typename?: "RunWorkerMetricsProvider";
  /**
   * Provider source address as the workflow tool reports it, such as
   * `registry.opentofu.org/hashicorp/aws`.
   */
  address: Scalars["String"]["output"];
  /**
   * Time spent installing the provider, summed over every run state that
   * installed it.
   */
  installDurationSeconds: Scalars["Float"]["output"];
};

export type RunWorkerMetricsResource = {
  __typename?: "RunWorkerMetricsResource";
  /**
   * Resource instance address as the workflow tool reports it, such as
   * `aws_s3_bucket.main` or `module.web.aws_instance.this[0]`.
   */
  address: Scalars["String"]["output"];
  /**
   * Time the state spent on this instance, summed over every operation it
   * performed on it. A plan state that both reads and refreshes an instance
   * reports the two together.
   */
  durationSeconds: Scalars["Float"]["output"];
  /** Whether this resource reported an error for this instance. */
  failed: Scalars["Boolean"]["output"];
  /** Resource type as the workflow tool names it, such as `aws_s3_bucket`. */
  resourceType: Scalars["String"]["output"];
};

export type RunWorkerMetricsState = {
  __typename?: "RunWorkerMetricsState";
  duration: RunWorkerMetricsDuration;
  /**
   * Error details for this failed state, in the order the worker reported
   * them. Empty when the state did not fail or no details were captured.
   */
  errors: Array<RunWorkerMetricsStateError>;
  /**
   * Whether this run ended in FAILED after an error occurred while executing
   * this state.
   */
  failed: Scalars["Boolean"]["output"];
  /**
   * One of INITIALIZING, PLANNING, APPLYING, DESTROYING and PERFORMING, the
   * run states the worker traces.
   */
  runState: RunState;
  /**
   * The user hooks this state spent the most time on, longest first. The
   * state only reports the slowest few hooks. Null for a state that never
   * runs hooks. Empty for a state that can, but reported none.
   */
  slowestHooks: Maybe<Array<RunWorkerMetricsHook>>;
  /**
   * The resource instances this state spent the most time on, longest first.
   * The state only reports the slowest few resources. Being at the top is
   * not a judgement: the slowest instance of a fast state is not a slow
   * resource. Null for a state that never works on resources, such as
   * INITIALIZING. Empty for a state that can, but reported none.
   */
  slowestResources: Maybe<Array<RunWorkerMetricsResource>>;
};

export type RunWorkerMetricsStateError = {
  __typename?: "RunWorkerMetricsStateError";
  /** The exception message, as the worker redacted it. */
  message: Scalars["String"]["output"];
  /**
   * Resource instance address the error came from, such as `aws_s3_bucket.main`
   * or `module.web.aws_instance.this[0]`. Null when the error is not tied to a
   * single resource.
   */
  resourceAddress: Maybe<Scalars["String"]["output"]>;
};

export type RunWorkerOutcome = {
  __typename?: "RunWorkerOutcome";
  /**
   * How well the run did. Null for a finished run until
   * `observabilityStatus.metrics` is AVAILABLE.
   */
  category: Maybe<RunWorkerOutcomeCategory>;
  /**
   * The note on the run's final state transition, such as the reason it
   * failed. Null when there is no note.
   */
  description: Maybe<Scalars["String"]["output"]>;
  /**
   * How the run ended, in a few words: "Finished", "Stopped", "Failed
   * during planning".
   */
  title: Scalars["String"]["output"];
};

/** The categories go from best to worst. */
export enum RunWorkerOutcomeCategory {
  /** The run ended in FAILED, no matter which state it failed in. */
  Failed = "Failed",
  /**
   * The run finished with a normal duration and has at least one finding,
   * so there is something to improve.
   */
  Finished = "Finished",
  /**
   * The run finished with a normal duration and has no findings. There is
   * nothing to do.
   */
  Healthy = "Healthy",
  /**
   * The run ended before it could finish or fail: it was stopped, canceled,
   * discarded or skipped.
   */
  Interrupted = "Interrupted",
  /**
   * The run finished, but took much longer than the stack's P95, in total
   * or in one of its states. This is the same rule that gives a duration
   * the MAJOR severity.
   */
  Slow = "Slow",
}

export type RunsScheduledForTerminationTile = {
  __typename?: "RunsScheduledForTerminationTile";
  /** The oldest runs in the warning window, capped at a fixed page size. */
  runs: Array<RunScheduledForTerminationTile>;
  /** How many runs the warning window holds in total, ignoring the cap on runs. */
  totalCount: Scalars["Int"]["output"];
};

/**
 * RuntimeConfig is the runtime configuration pulled from GitHub for each
 * Run separately.
 */
export type RuntimeConfig = {
  __typename?: "RuntimeConfig";
  /** List of after-apply scripts. */
  afterApply: Array<Scalars["String"]["output"]>;
  /** List of after-destroy scripts. */
  afterDestroy: Array<Scalars["String"]["output"]>;
  /** List of after-init scripts. */
  afterInit: Array<Scalars["String"]["output"]>;
  /** List of after-perform scripts. */
  afterPerform: Array<Scalars["String"]["output"]>;
  /** List of after-plan scripts. */
  afterPlan: Array<Scalars["String"]["output"]>;
  /** List of after-run scripts. */
  afterRun: Array<Scalars["String"]["output"]>;
  /** List of before-apply scripts. */
  beforeApply: Array<Scalars["String"]["output"]>;
  /** List of before-destroy scripts. */
  beforeDestroy: Array<Scalars["String"]["output"]>;
  /** List of before-init scripts. */
  beforeInit: Array<Scalars["String"]["output"]>;
  /** List of before-perform scripts. */
  beforePerform: Array<Scalars["String"]["output"]>;
  /** List of before-plan scripts. */
  beforePlan: Array<Scalars["String"]["output"]>;
  /** Environment variables */
  environment: Array<EnvVar>;
  /** List of paths to include in a git sparse checkout. */
  gitSparseCheckoutPaths: Array<Scalars["String"]["output"]>;
  /** Contains any OpenTofu-specific configuration options used by the run. */
  opentofu: Maybe<OpenTofuRuntimeConfig>;
  /** Indicates where the root of the Terraform project is. */
  projectRoot: Scalars["String"]["output"];
  /** Name of the Docker image used to process the Run. */
  runnerImage: Scalars["String"]["output"];
  /** Contains any Terraform-specific configuration options used by the run. */
  terraform: Maybe<TerraformRuntimeConfig>;
  /** Terraform version used to process the Run. */
  terraformVersion: Scalars["String"]["output"];
  /**
   * Terraform workflow tool used to process the Run.
   * TODO: ideally we'd make this field optional because it doesn't make sense for non-TF stacks. Same with the version.
   */
  terraformWorkflowTool: TerraformWorkflowTool;
  /**
   * Contains any Terragrunt-specific configuration options used by the run. This field
   * may not be populated for older runs created before the Terragrunt runtime config began being
   * stored.
   */
  terragrunt: Maybe<TerragruntRuntimeConfig>;
  /** runtime configuration in YAML format */
  yaml: Scalars["String"]["output"];
};

export type RuntimeConfigInput = {
  /** List of after-apply scripts. */
  afterApply: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of after-destroy scripts. */
  afterDestroy: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of after-init scripts. */
  afterInit: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of after-perform scripts. */
  afterPerform: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of after-plan scripts. */
  afterPlan: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of after-run scripts. */
  afterRun: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of before-apply scripts. */
  beforeApply: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of before-destroy scripts. */
  beforeDestroy: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of before-init scripts. */
  beforeInit: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of before-perform scripts. */
  beforePerform: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** List of before-plan scripts. */
  beforePlan: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Environment variables */
  environment: InputMaybe<Array<EnvVarInput>>;
  /** List of paths for git sparse checkout. */
  gitSparseCheckoutPaths: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Indicates where the root of the Terraform project is. */
  projectRoot: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the Docker image used to process the Run. */
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Runtime configuration in YAML format.
   * The yaml property, or the other properties must be set, but not both.
   */
  yaml: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * SAMLNameIDFormat is the format for the NameID to use when making requests to the SAML
 * identity provider.
 */
export enum SamlNameIdFormat {
  /** An email address. */
  EmailAddress = "EMAIL_ADDRESS",
  /** An opaque identifier that remains the same between logins. */
  Persistent = "PERSISTENT",
  /** An opaque identifier that does not remain the same between logins. */
  Transient = "TRANSIENT",
}

/** SAMLSettings represent account's SAML settings */
export type SamlSettings = {
  __typename?: "SAMLSettings";
  /**
   * Login of the user who always gets an administrative access to the account.
   * This is meant to prevent locking yourself out of the account if the settings
   * are incorrect.
   */
  adminLogin: Maybe<Scalars["String"]["output"]>;
  /** contains custom claims mapping */
  claimMapping: ClaimMapping;
  /** Identity provider metadata, if statically provided. */
  idpMetadata: Maybe<Scalars["String"]["output"]>;
  /** Identity provider metadata URL, if the provider supports dynamic metadata retrieval. */
  idpMetadataURL: Maybe<Scalars["String"]["output"]>;
  /** The format used when requesting the NameID (user/login name) from the identity provider. */
  nameIDFormat: SamlNameIdFormat;
};

export type SamlUpdateInput = {
  claimMapping: InputMaybe<ClaimMappingInput>;
};

export type ScimGroupMetadata = {
  __typename?: "SCIMGroupMetadata";
  /** External ID assigned by the SCIM identity provider */
  externalId: Scalars["String"]["output"];
};

export type ScimUserMetadata = {
  __typename?: "SCIMUserMetadata";
  /** Display name from the SCIM identity provider (RFC 7643 §4.1.1) */
  displayName: Scalars["String"]["output"];
  /** Email address from the SCIM identity provider */
  email: Scalars["String"]["output"];
  /** External ID assigned by the SCIM identity provider */
  externalId: Scalars["String"]["output"];
  /** Family (last) name from the SCIM identity provider */
  familyName: Scalars["String"]["output"];
  /** Formatted full name from the SCIM identity provider */
  formattedName: Scalars["String"]["output"];
  /** Given (first) name from the SCIM identity provider */
  givenName: Scalars["String"]["output"];
  /** Unix timestamp (seconds) at which the user was provisioned via SCIM */
  provisionedAt: Scalars["Int"]["output"];
};

/**
 * SampledPolicyLibrary represents a single policy library captured as part of a
 * policy evaluation sample.
 */
export type SampledPolicyLibrary = {
  __typename?: "SampledPolicyLibrary";
  /** Body of the sampled library. */
  Body: Scalars["String"]["output"];
  /** Name of the sampled library. */
  Name: Scalars["String"]["output"];
};

export type SavedFilter = {
  __typename?: "SavedFilter";
  /** Login of the user who created the saved filter */
  createdBy: Scalars["String"]["output"];
  /** Data is the JSON representation of the filter data */
  data: Scalars["String"]["output"];
  /** Globally unique ID of the saved filter */
  id: Scalars["ID"]["output"];
  /** Toggle whether the filter is public or not */
  isPublic: Scalars["Boolean"]["output"];
  /** Name of the saved filter */
  name: Scalars["String"]["output"];
  /** Type describes the type of the filter. It is used to determine which view the filter is for */
  type: Scalars["String"]["output"];
};

export type SavedFilterInput = {
  /** Data is the JSON representation of the filter data */
  data: Scalars["String"]["input"];
  /** Toggle whether the filter is public or not */
  isPublic: Scalars["Boolean"]["input"];
  /** Name of the saved filter */
  name: Scalars["String"]["input"];
  /** Type describes the type of the filter. It is used to determine which view the filter is for */
  type: Scalars["String"]["input"];
};

/**
 * A Scan describes a cloud-resource discovery configuration. Each scan can be
 * executed many times via ScanRuns.
 */
export type Scan = {
  __typename?: "Scan";
  /** CreatedAt is the unix timestamp (in seconds) at which the scan was created. */
  createdAt: Scalars["Int"]["output"];
  /** Indicates whether the scan has been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /** Free-form description. */
  description: Scalars["String"]["output"];
  /** Scan identifier (slug). */
  id: Scalars["ID"]["output"];
  /** Labels for filtering / grouping. */
  labels: Array<Scalars["String"]["output"]>;
  /**
   * The scan's most recent run, in whatever state it is in. Null until the
   * scan has run for the first time.
   */
  latestRun: Maybe<ScanRun>;
  /** Display name. */
  name: Scalars["String"]["output"];
  /**
   * Provider configurations the scan targets, one per configuration: several AWS
   * regions are several entries.
   */
  providerConfigs: Array<ScanProviderConfig>;
  /** Optional custom runner image the scan's runs are executed with. */
  runnerImage: Maybe<Scalars["String"]["output"]>;
  /** Resources to discover and their per-resource filters. */
  scope: Array<ScanScope>;
  /** The scan's runs, with a set of predicates, ordering and paging. */
  searchRuns: SearchScanRunsOutput;
  /** Information about fields available for searching this scan's runs. */
  searchRunsSuggestions: SearchSuggestionsOutput;
  /** Space this scan belongs to. */
  space: Space;
  /** UpdatedAt is the unix timestamp (in seconds) at which the scan was last modified. */
  updatedAt: Scalars["Int"]["output"];
  /** Worker pool used to dispatch scan runs. Must be a discovery-type pool. */
  workerPool: Scalars["ID"]["output"];
  /**
   * Name of that worker pool, so a list of scans need not look each one up.
   * Null only if the pool is gone for good.
   */
  workerPoolName: Maybe<Scalars["String"]["output"]>;
};

/**
 * A Scan describes a cloud-resource discovery configuration. Each scan can be
 * executed many times via ScanRuns.
 */
export type ScanSearchRunsArgs = {
  input: SearchInput;
};

/**
 * A Scan describes a cloud-resource discovery configuration. Each scan can be
 * executed many times via ScanRuns.
 */
export type ScanSearchRunsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type ScanAttribute = {
  __typename?: "ScanAttribute";
  name: Scalars["String"]["output"];
  /** The attribute's type, which decides how a filter addresses it. */
  type: ScanAttributeType;
};

export enum ScanAttributeType {
  /** A plain string, addressed by the attribute name alone. */
  String = "STRING",
  /**
   * A map of string to string, such as tags. Addressed by the attribute name
   * plus a key.
   */
  StringMap = "STRING_MAP",
}

export type ScanConnection = {
  __typename?: "ScanConnection";
  cursor: Scalars["String"]["output"];
  node: Scan;
};

export type ScanInput = {
  /** Free-form description (use an empty string for none). */
  description: Scalars["String"]["input"];
  /** Labels for filtering / grouping. */
  labels: Array<Scalars["String"]["input"]>;
  /** Display name. */
  name: Scalars["String"]["input"];
  /** Provider configurations the scan targets, at least one. */
  providerConfigs: Array<ScanProviderConfigInput>;
  /** RunnerImage is an optional string used to set a customer runner image */
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  /** Resources to discover and their per-resource filters. */
  scope: Array<ScanScopeInput>;
  /** Space the scan belongs to. */
  space: Scalars["ID"]["input"];
  /** Worker pool ULID. Must be a discovery-type pool. */
  workerPool: Scalars["ID"]["input"];
};

export type ScanListParameter = {
  __typename?: "ScanListParameter";
  name: Scalars["String"]["output"];
  /**
   * A required parameter identifies a parent resource, so we autodetect it from
   * the parent listing rather than asking the user for a value. Setting one
   * through ScanScopeInput.parameters is an error.
   */
  required: Scalars["Boolean"]["output"];
  /**
   * What the list call accepts here. A value is always written as a string and
   * converted against this.
   */
  type: ScanParameterType;
};

export enum ScanParameterType {
  Bool = "BOOL",
  /** Written as a decimal string. */
  Number = "NUMBER",
  /**
   * The list call takes a value no single string can spell, so none can be set
   * through the API.
   */
  Other = "OTHER",
  String = "STRING",
}

/** ScanProvider is the cloud provider a Scan targets. */
export enum ScanProvider {
  Aws = "AWS",
}

/** ScanProviderConfig is one provider configuration a Scan targets. */
export type ScanProviderConfig = {
  __typename?: "ScanProviderConfig";
  config: ScanProviderSettings;
  /**
   * ULID of the integration supplying the credentials this configuration runs
   * with. Two cloud accounts in one scan are two configurations.
   */
  integration: Scalars["ID"]["output"];
  /**
   * Name of that integration, so a list of scans need not look each one up.
   * Null if the integration has since been deleted.
   */
  integrationName: Maybe<Scalars["String"]["output"]>;
  /** How long the scan waits between list calls, as a Go duration string. */
  throttleInterval: Maybe<Scalars["String"]["output"]>;
  type: ScanProvider;
  version: Scalars["String"]["output"];
};

/**
 * ScanProviderConfigInput is one provider configuration. Exactly one provider
 * member must be set, and it decides which provider the entry configures.
 */
export type ScanProviderConfigInput = {
  /** Set if AWS is the provider. */
  aws: InputMaybe<AwsScanSettingsInput>;
  /**
   * ULID of the integration supplying the credentials this configuration runs
   * with. Two cloud accounts in one scan are two configurations.
   */
  integration: Scalars["ID"]["input"];
  /**
   * How long to wait between list calls, as a Go duration string ("100ms",
   * "1.5s", "30s"), between 1ms and 1m. Defaults to 5s.
   */
  throttleInterval: InputMaybe<Scalars["String"]["input"]>;
  /** Provider major to pin the scan to, one of ScanProviderSchema.majorVersions. */
  version: Scalars["String"]["input"];
};

/**
 * ScanProviderConfigSchema is the discriminated union of what each provider's own
 * configuration can be set to.
 */
export type ScanProviderConfigSchema = AwsScanConfigSchema;

/**
 * ScanProviderSchema is what one provider can be asked to discover, read from the
 * provider release's own schemas.
 */
export type ScanProviderSchema = {
  __typename?: "ScanProviderSchema";
  /** The provider's own configuration options, mirroring ScanProviderSettings. */
  configSchema: ScanProviderConfigSchema;
  /**
   * Provider versions a Scan may pin. Majors only: we hold one release per major
   * and that is the granularity a scan selects at.
   */
  majorVersions: Array<Scalars["String"]["output"]>;
  /**
   * Every resource type this provider can be asked to scan. A type it cannot
   * list is absent.
   */
  resourceTypes: Array<ScanResourceType>;
  type: ScanProvider;
};

/**
 * ScanProviderSettings is the discriminated union of the providers' own
 * configurations.
 */
export type ScanProviderSettings = AwsScanSettings;

/** A ScanResource is one cloud resource a ScanRun discovered. */
export type ScanResource = {
  __typename?: "ScanResource";
  /** CreatedAt is the unix timestamp (in seconds) at which the resource was recorded. */
  createdAt: Scalars["Int"]["output"];
  /** Opaque resource identifier, unique to the run that discovered it. */
  id: Scalars["ID"]["output"];
  /**
   * The provider's resource identity as a raw JSON string. Values the row has
   * no column for - the region, the account, the ARN - live in here.
   */
  identity: Scalars["String"]["output"];
  /** Hash of the identity, used to compare and deduplicate resources. */
  identityHash: Scalars["String"]["output"];
  /** Version of the identity schema the provider reported. */
  identitySchemaVersion: Maybe<Scalars["Int"]["output"]>;
  /** Whether a stack's state holds an entity with the same resource identity. */
  isManaged: Scalars["Boolean"]["output"];
  /** The provider's label for the resource, not guaranteed unique. */
  name: Scalars["String"]["output"];
  /** How the provider was configured when the run found this resource. */
  providerConfig: Maybe<ScanProviderConfig>;
  /** The Scan that discovered the resource. */
  scan: Scan;
  /** The provider's type name, e.g. aws_s3_bucket. */
  type: Scalars["String"]["output"];
};

export type ScanResourceConnection = {
  __typename?: "ScanResourceConnection";
  cursor: Scalars["String"]["output"];
  node: ScanResource;
};

/**
 * ScanResourceType is one resource type a provider can be asked to scan: what
 * its list call accepts, and what a filter on the listed resources can name.
 */
export type ScanResourceType = {
  __typename?: "ScanResourceType";
  /**
   * Attributes a filter on this type can be written against. Filters are
   * matched once a resource has been listed, so these are the resource's own
   * attributes rather than anything the list call accepts.
   */
  attributes: Array<ScanAttribute>;
  /**
   * Attributes of the list call itself, which narrow what gets listed at all.
   * Only the ones a scan can act on: settable, or autodetected from a parent.
   */
  parameters: Array<ScanListParameter>;
  /**
   * The provider docs subcategory, e.g. "VPC (Virtual Private Cloud)". The
   * registry groups resource types by it.
   */
  subcategory: Scalars["String"]["output"];
  /** The resource type, matching ScanScope.type. */
  type: Scalars["String"]["output"];
};

/** A ScanRun is one execution of a Scan. */
export type ScanRun = {
  __typename?: "ScanRun";
  /** CreatedAt is the unix timestamp (in seconds) at which the run was queued. */
  createdAt: Scalars["Int"]["output"];
  /**
   * How long the worker has had the run, in seconds. Counted from when the
   * worker reported picking it up until the run finished, or until now if it
   * hasn't. Zero before the worker reports.
   */
  duration: Scalars["Int"]["output"];
  /** Problems that didn't stop the run. */
  failures: Array<ScanRunFailure>;
  failuresCount: Scalars["Int"]["output"];
  /** ScanRun identifier (ULID). */
  id: Scalars["ID"]["output"];
  /**
   * Free-form text describing the run outcome, e.g. why it failed or the note
   * whoever canceled it left.
   */
  note: Maybe<Scalars["String"]["output"]>;
  /** Provider configurations snapshotted from the Scan at trigger time. */
  providerConfigs: Array<ScanProviderConfig>;
  /** How many resources this run recorded. */
  resourceCount: Scalars["Int"]["output"];
  /** The run's resources split by whether a stack already manages them. */
  resourceStats: ScanRunResourceStats;
  /** The Scan this run belongs to. */
  scan: Scan;
  /** Resources to discover, snapshotted from the Scan at trigger time. */
  scope: Array<ScanScope>;
  /**
   * The resources this run discovered, with a set of predicates, ordering and
   * paging.
   */
  searchResources: SearchScanResourcesOutput;
  /** Information about fields available for searching this run's resources. */
  searchResourcesSuggestions: SearchSuggestionsOutput;
  /** Lifecycle state. */
  state: ScanRunState;
  /**
   * StateChangedAt is the unix timestamp (in seconds) at which the run entered
   * its current state. For a terminal state, that is when the run finished.
   */
  stateChangedAt: Scalars["Int"]["output"];
  /** ULID of the worker that picked up this run, if any. */
  workerUlid: Maybe<Scalars["String"]["output"]>;
};

/** A ScanRun is one execution of a Scan. */
export type ScanRunSearchResourcesArgs = {
  input: SearchInput;
};

/** A ScanRun is one execution of a Scan. */
export type ScanRunSearchResourcesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type ScanRunConnection = {
  __typename?: "ScanRunConnection";
  cursor: Scalars["String"]["output"];
  node: ScanRun;
};

/** ScanRunFailure is a problem a run hit while scanning. */
export type ScanRunFailure = {
  __typename?: "ScanRunFailure";
  message: Scalars["String"]["output"];
  /** How the provider was configured when the run hit the failure. */
  providerConfig: ScanProviderConfig;
  /**
   * The resource type that couldn't be listed. Null when the whole provider
   * configuration failed.
   */
  resourceType: Maybe<Scalars["String"]["output"]>;
};

/**
 * ScanRunResourceStats splits a run's resources by whether a stack manages them.
 * Counted off the stored resources, so it goes to zero once retention drops them.
 */
export type ScanRunResourceStats = {
  __typename?: "ScanRunResourceStats";
  /** Resources whose identity matches an entity in some stack's state. */
  managed: Scalars["Int"]["output"];
  /** Resources no stack's state accounts for. */
  unmanaged: Scalars["Int"]["output"];
};

/** ScanRunState is the lifecycle state of a ScanRun. */
export enum ScanRunState {
  Canceled = "CANCELED",
  Failed = "FAILED",
  Finished = "FINISHED",
  FinishedWithErrors = "FINISHED_WITH_ERRORS",
  Queued = "QUEUED",
  Scanning = "SCANNING",
  Stopped = "STOPPED",
}

/**
 * ScanScope describes one resource type the worker should list, and which of the
 * listed resources to keep.
 */
export type ScanScope = {
  __typename?: "ScanScope";
  /** Null keeps every resource of this type. */
  filter: Maybe<ScanScopeFilter>;
  /** Values for the list call itself, which narrow what is listed at all. */
  parameters: Array<ScanScopeParameter>;
  type: Scalars["String"]["output"];
};

/**
 * ScanScopeCondition tests one attribute of a listed resource. It holds when the
 * attribute matches any of its values. See ScanScopeConditionInput for the rules
 * each field follows.
 */
export type ScanScopeCondition = {
  __typename?: "ScanScopeCondition";
  attribute: Scalars["String"]["output"];
  /** The key of a STRING_MAP attribute, null for a STRING one. */
  key: Maybe<Scalars["String"]["output"]>;
  /** Inverts this condition, not the filter. */
  negate: Scalars["Boolean"]["output"];
  operator: ScanScopeOperator;
  /** Empty for EXISTS. */
  values: Array<Scalars["String"]["output"]>;
};

export type ScanScopeConditionInput = {
  /** One of ScanResourceType.attributes for the scope's type. */
  attribute: Scalars["String"]["input"];
  /**
   * Which key of a STRING_MAP attribute to test - "Environment" in tags. Such
   * an attribute is matched one named key at a time, never as a whole, so this
   * is required for a STRING_MAP attribute and must be omitted for a STRING one.
   */
  key: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Inverts this condition, not the filter. A condition on an attribute the
   * resource does not have is false before negation, so negating
   * "tags.Environment EQUALS prod" keeps a resource with no tags at all.
   */
  negate: InputMaybe<Scalars["Boolean"]["input"]>;
  operator: ScanScopeOperator;
  /**
   * The condition holds when the attribute matches any of these. Omit for
   * EXISTS, pass 1 to 50 non-empty values for every other operator.
   */
  values: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** ScanScopeFilter keeps a resource only when every one of its conditions holds. */
export type ScanScopeFilter = {
  __typename?: "ScanScopeFilter";
  conditions: Array<ScanScopeCondition>;
};

export type ScanScopeFilterInput = {
  /** At least one, at most 20. */
  conditions: Array<ScanScopeConditionInput>;
};

export type ScanScopeInput = {
  /** Omit to keep every resource of this type. */
  filter: InputMaybe<ScanScopeFilterInput>;
  /**
   * Values for the list call itself, which narrow what is listed at all. Unlike
   * a filter these are applied before any resource is read.
   */
  parameters: InputMaybe<Array<ScanScopeParameterInput>>;
  type: Scalars["String"]["input"];
};

/**
 * ScanScopeOperator is how a condition compares an attribute to its values. The
 * matching operators are case-sensitive.
 */
export enum ScanScopeOperator {
  Contains = "CONTAINS",
  EndsWith = "ENDS_WITH",
  Equals = "EQUALS",
  /**
   * Takes no values, and asks only whether the attribute, or the key within it,
   * is set.
   */
  Exists = "EXISTS",
  StartsWith = "STARTS_WITH",
}

/** ScanScopeParameter is one value passed to the list call of a scope's type. */
export type ScanScopeParameter = {
  __typename?: "ScanScopeParameter";
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type ScanScopeParameterInput = {
  /**
   * One of ScanResourceType.parameters for the scope's type, and not one marked
   * required there.
   */
  name: Scalars["String"]["input"];
  /**
   * Always a string, converted against the parameter's ScanParameterType. A
   * parameter of type OTHER takes no value at all.
   */
  value: Scalars["String"]["input"];
};

export type ScheduledDelete = {
  __typename?: "ScheduledDelete";
  /**
   * Apply will be scheduled according to this cron schedule expression if specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  cronSchedule: Maybe<Array<Scalars["String"]["output"]>>;
  /** Globally unique schedule identifier. */
  id: Scalars["ID"]["output"];
  /**
   * When the next detection run will be scheduled.
   * Null if done or is in progress.
   */
  nextSchedule: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether this job should delete stack resources as well */
  shouldDeleteResources: Scalars["Boolean"]["output"];
  /** Stack that the schedule will be run against */
  stack: Scalars["ID"]["output"];
  /**
   * Apply will be scheduled at this timestamp specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  timestampSchedule: Maybe<Scalars["Float"]["output"]>;
  /** Cron schedule expressions will apply for this timezone. */
  timezone: Maybe<Scalars["String"]["output"]>;
};

export type ScheduledDeleteInput = {
  cronSchedule: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Indicates whether this job should delete stack resources as well */
  shouldDeleteResources: Scalars["Boolean"]["input"];
  /**
   * Apply will be scheduled at this timestamp specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  timestampSchedule: InputMaybe<Scalars["Int"]["input"]>;
  timezone: InputMaybe<Scalars["String"]["input"]>;
};

export type ScheduledRun = {
  __typename?: "ScheduledRun";
  /**
   * Apply will be scheduled according to this cron schedule expression if specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  cronSchedule: Maybe<Array<Scalars["String"]["output"]>>;
  /** Customer provided runtime configuration for this scheduled run. */
  customRuntimeConfig: Maybe<RuntimeConfig>;
  /** Globally unique schedule identifier. */
  id: Scalars["ID"]["output"];
  /** Name of the scheduled run */
  name: Scalars["String"]["output"];
  /**
   * When the next detection run will be scheduled.
   * Null if done or is in progress.
   */
  nextSchedule: Maybe<Scalars["Int"]["output"]>;
  /**
   * Apply will be scheduled at this timestamp specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  timestampSchedule: Maybe<Scalars["Float"]["output"]>;
  /** Cron schedule expressions will apply for this timezone. */
  timezone: Maybe<Scalars["String"]["output"]>;
};

/** Arguments used to create and update an individual ScheduledRun configuration. */
export type ScheduledRunInput = {
  /**
   * Apply will be scheduled according to this cron schedule expression if specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  cronSchedule: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the scheduled run */
  name: Scalars["String"]["input"];
  /** Customer provided runtime configuration for this scheduled run. */
  runtimeConfig: InputMaybe<RuntimeConfigInput>;
  /**
   * Apply will be scheduled at this timestamp specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  timestampSchedule: InputMaybe<Scalars["Int"]["input"]>;
  /** Cron schedule expressions will apply for this timezone. */
  timezone: InputMaybe<Scalars["String"]["input"]>;
};

export type ScheduledTask = {
  __typename?: "ScheduledTask";
  /** Command to be run as a task */
  command: Scalars["String"]["output"];
  /**
   * Apply will be scheduled according to this cron schedule expression if specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  cronSchedule: Maybe<Array<Scalars["String"]["output"]>>;
  /** Globally unique schedule identifier. */
  id: Scalars["ID"]["output"];
  /**
   * When the next detection run will be scheduled.
   * Null if done or is in progress.
   */
  nextSchedule: Maybe<Scalars["Int"]["output"]>;
  /** Stack that the schedule will be run against */
  stack: Scalars["ID"]["output"];
  /**
   * Apply will be scheduled at this timestamp specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  timestampSchedule: Maybe<Scalars["Float"]["output"]>;
  /** Cron schedule expressions will apply for this timezone. */
  timezone: Maybe<Scalars["String"]["output"]>;
};

export type ScheduledTaskInput = {
  /** Command to be run as a task */
  command: Scalars["String"]["input"];
  /**
   * Apply will be scheduled according to this cron schedule expression if specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  cronSchedule: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Apply will be scheduled at this timestamp specified.
   * Either timestampSchedule or cronSchedule must not be empty.
   */
  timestampSchedule: InputMaybe<Scalars["Int"]["input"]>;
  /** Cron schedule expressions will apply for this timezone. */
  timezone: InputMaybe<Scalars["String"]["input"]>;
};

export type ScimOauthClient = {
  __typename?: "ScimOauthClient";
  /** The OAuth2 access token endpoint */
  accessTokenEndpoint: Scalars["String"]["output"];
  /** The OAuth2 client ID */
  clientID: Scalars["String"]["output"];
  /** The OAuth2 client secret, only returned on creation */
  clientSecret: Maybe<Scalars["String"]["output"]>;
  /** The SCIM connector base URL */
  connnectorBaseURL: Scalars["String"]["output"];
};

export type SearchAnsibleHostsOutput = {
  __typename?: "SearchAnsibleHostsOutput";
  edges: Array<AnsibleHostsConnection>;
  pageInfo: PageInfo;
};

export type SearchAnsibleTaskExecutionsOutput = {
  __typename?: "SearchAnsibleTaskExecutionsOutput";
  edges: Array<AnsibleTaskExecutionsConnection>;
  pageInfo: PageInfo;
};

export type SearchAnsibleTasksOutput = {
  __typename?: "SearchAnsibleTasksOutput";
  edges: Array<AnsibleTasksConnection>;
  pageInfo: PageInfo;
};

export type SearchAuditTrailEntriesOutput = {
  __typename?: "SearchAuditTrailEntriesOutput";
  edges: Array<AuditTrailEntriesConnection>;
  pageInfo: PageInfo;
};

export type SearchBlueprintDeploymentChangeHistoryOutput = {
  __typename?: "SearchBlueprintDeploymentChangeHistoryOutput";
  edges: Array<BlueprintDeploymentChangeRecordConnection>;
  pageInfo: PageInfo;
};

export type SearchBlueprintDeploymentsOutput = {
  __typename?: "SearchBlueprintDeploymentsOutput";
  edges: Array<BlueprintDeploymentConnection>;
  pageInfo: PageInfo;
};

export type SearchBlueprintVersionedGroupsOutput = {
  __typename?: "SearchBlueprintVersionedGroupsOutput";
  edges: Array<BlueprintVersionedGroupsConnection>;
  pageInfo: PageInfo;
};

export type SearchBlueprintsOutput = {
  __typename?: "SearchBlueprintsOutput";
  edges: Array<BlueprintsConnection>;
  pageInfo: PageInfo;
};

export type SearchContextsOutput = {
  __typename?: "SearchContextsOutput";
  edges: Array<ContextsConnection>;
  pageInfo: PageInfo;
};

export type SearchEntityChangeOutput = {
  __typename?: "SearchEntityChangeOutput";
  edges: Array<EntityChangeConnection>;
  pageInfo: PageInfo;
};

export type SearchInput = {
  /**
   * List the entity changes after this ID
   * When paginating the PageInfo.endCursor returned contains the next cursor value
   */
  after: InputMaybe<Scalars["String"]["input"]>;
  /** List the first * items */
  first: InputMaybe<Scalars["Int"]["input"]>;
  /** A full text search phrase. */
  fullTextSearch: InputMaybe<Scalars["String"]["input"]>;
  /** Ordering is unimplemented right now. */
  orderBy: InputMaybe<Array<SearchQueryOrder>>;
  /** The list of field predicates to match. */
  predicates: InputMaybe<Array<SearchQueryPredicate>>;
  /** Which page to return. */
  requestedPage: InputMaybe<SearchQueryRequestedPage>;
};

export type SearchIntentProjectReferencesOutput = {
  __typename?: "SearchIntentProjectReferencesOutput";
  edges: Array<IntentProjectReferencesConnection>;
  pageInfo: PageInfo;
};

export type SearchIntentProjectsOutput = {
  __typename?: "SearchIntentProjectsOutput";
  edges: Array<IntentProjectsConnection>;
  pageInfo: PageInfo;
};

export type SearchIntentResourcesOperationsOutput = {
  __typename?: "SearchIntentResourcesOperationsOutput";
  edges: Array<IntentResourcesOperationConnection>;
  pageInfo: PageInfo;
};

export type SearchIntentResourcesOutput = {
  __typename?: "SearchIntentResourcesOutput";
  edges: Array<IntentResourceConnection>;
  pageInfo: PageInfo;
};

export type SearchManagedEntitiesGroupedByProvidersOutput = {
  __typename?: "SearchManagedEntitiesGroupedByProvidersOutput";
  edges: Array<ManagedEntitiesGroupedByProvidersConnection>;
  pageInfo: PageInfo;
};

export type SearchManagedEntitiesGroupedByStacksOutput = {
  __typename?: "SearchManagedEntitiesGroupedByStacksOutput";
  edges: Array<ManagedEntitiesGroupedByStacksConnection>;
  pageInfo: PageInfo;
};

export type SearchManagedEntitiesGroupedByTypesOutput = {
  __typename?: "SearchManagedEntitiesGroupedByTypesOutput";
  edges: Array<ManagedEntitiesGroupedByTypesConnection>;
  pageInfo: PageInfo;
};

export type SearchManagedEntitiesOutput = {
  __typename?: "SearchManagedEntitiesOutput";
  edges: Array<ManagedEntitiesConnection>;
  pageInfo: PageInfo;
};

/** SearchModulesOutput is a page of Modules. */
export type SearchModulesOutput = {
  __typename?: "SearchModulesOutput";
  edges: Array<ModuleConnection>;
  pageInfo: PageInfo;
};

export type SearchNamedWebhooksIntegrationOutput = {
  __typename?: "SearchNamedWebhooksIntegrationOutput";
  edges: Array<NamedWebhooksIntegrationConnection>;
  pageInfo: PageInfo;
};

/** SearchNotificationsOutput is a page of Notifications. */
export type SearchNotificationsOutput = {
  __typename?: "SearchNotificationsOutput";
  edges: Array<NotificationConnection>;
  pageInfo: PageInfo;
};

export type SearchPoliciesOutput = {
  __typename?: "SearchPoliciesOutput";
  edges: Array<PolicyConnection>;
  pageInfo: PageInfo;
};

export type SearchPolicyEvaluationRecordOutput = {
  __typename?: "SearchPolicyEvaluationRecordOutput";
  edges: Array<PolicyEvaluationRecordConnection>;
  pageInfo: PageInfo;
};

export type SearchPolicyTemplatesOutput = {
  __typename?: "SearchPolicyTemplatesOutput";
  edges: Array<PolicyTemplateConnection>;
  pageInfo: PageInfo;
};

/** SearchQueryFieldConstraint constraints the values of a field. */
export type SearchQueryFieldConstraint = {
  /** booleanEquals constraints the field to be equal to one of the given values. */
  booleanEquals: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  /** enumEquals constraints the field to be equal to one of the given values. */
  enumEquals: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** hierarchyNode constraints the field to be contained in one of the given values. */
  hierarchyNode: InputMaybe<SearchQueryFieldConstraintHierarchyNodeList>;
  /**
   * hierarchyNodeValueEquals constraints the field to be contained in one of the given values
   * ID fields of SearchSuggestionsPossibleValuesHierarchyNode's are expected here
   */
  hierarchyNodeValueEquals: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * stringEquals constraints the field to be exactly equal to one of the given values.
   * Unlike stringMatches this is case-sensitive and supports no wildcards, but it can use an index
   * on the field, so prefer it whenever an exact value is known (e.g. a slug picked from suggestions).
   */
  stringEquals: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * stringMatches constraints the field to match one of the given values.
   * '*' wildcards can be used in the values to indicate arbitrary numbers of arbitrary characters.
   */
  stringMatches: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** timeInLast constrains the field to predefined time ranges. */
  timeInLast: InputMaybe<SearchQueryFieldConstraintTimeInLast>;
  /** timeInRange constraints the field to be within the time range. */
  timeInRange: InputMaybe<SearchQueryFieldConstraintTimeInRange>;
};

export type SearchQueryFieldConstraintHierarchyNode = {
  /** ID fields of SearchSuggestionsPossibleValuesHierarchyNode's are expected here as value. */
  equals: Scalars["String"]["input"];
  /** Should descendants be included in the search results. */
  includeDescendants: Scalars["Boolean"]["input"];
};

export type SearchQueryFieldConstraintHierarchyNodeList = {
  /** List of hierarchy node constraints */
  nodes: Array<SearchQueryFieldConstraintHierarchyNode>;
};

export enum SearchQueryFieldConstraintTimeInLast {
  Last1D = "LAST1D",
  Last1H = "LAST1H",
  Last4H = "LAST4H",
  Last7D = "LAST7D",
  Last14D = "LAST14D",
  Last15M = "LAST15M",
  Last30M = "LAST30M",
}

export type SearchQueryFieldConstraintTimeInRange = {
  /** End of the time range. */
  end: InputMaybe<Scalars["Int"]["input"]>;
  /** Start of the time range. */
  start: InputMaybe<Scalars["Int"]["input"]>;
};

/** SearchQueryOrder is used to order the results of a search query. */
export type SearchQueryOrder = {
  /** direction to order by, defaults to ASC */
  direction: InputMaybe<SearchQueryOrderDirection>;
  /** field name to order by */
  field: Scalars["String"]["input"];
};

/** SearchQueryOrderDirection is the direction of the ordering. */
export enum SearchQueryOrderDirection {
  Asc = "ASC",
  Desc = "DESC",
}

/** SearchQueryPredicate is used to filter the results of a search query. */
export type SearchQueryPredicate = {
  /** constraint is the constraint on the field value. */
  constraint: SearchQueryFieldConstraint;
  /** exclude indicates whether the predicate should exclude fields values matching the constraint. */
  exclude: InputMaybe<Scalars["Boolean"]["input"]>;
  /** field is the field name to constraint. */
  field: Scalars["String"]["input"];
};

export enum SearchQueryRequestedPage {
  /** The first page of results. */
  First = "FIRST",
  /** The last page of results. */
  Last = "LAST",
  /** The next page of results. */
  Next = "NEXT",
  /** The previous page of results. */
  Previous = "PREVIOUS",
}

/** SearchRepoCommitsOutput is the output type for searchRepoCommits query. */
export type SearchRepoCommitsOutput = {
  __typename?: "SearchRepoCommitsOutput";
  edges: Array<RepoCommitConnection>;
  pageInfo: PageInfo;
};

/** SearchRepoFilesOutput is the output type for searchRepoFiles query. */
export type SearchRepoFilesOutput = {
  __typename?: "SearchRepoFilesOutput";
  edges: Array<RepoFileConnection>;
  pageInfo: PageInfo;
};

/** SearchReposOutput is the output type for searchRepos query. */
export type SearchReposOutput = {
  __typename?: "SearchReposOutput";
  edges: Array<RepoConnection>;
  pageInfo: PageInfo;
};

/** SearchRevisionsOutput is the output type for searchRevisions query. */
export type SearchRevisionsOutput = {
  __typename?: "SearchRevisionsOutput";
  edges: Array<RevisionConnection>;
  pageInfo: PageInfo;
};

export type SearchRunIgnoredTriggersOutput = {
  __typename?: "SearchRunIgnoredTriggersOutput";
  edges: Array<RunIgnoredTriggersConnection>;
  pageInfo: PageInfo;
};

/** SearchRunsOutput is a page of account-wide runs returned by searchRuns. */
export type SearchRunsOutput = {
  __typename?: "SearchRunsOutput";
  edges: Array<RunConnection>;
  pageInfo: PageInfo;
  /**
   * Total number of runs matching the query, ignoring pagination.
   * Computed with a single COUNT query and resolved lazily, only select it when needed.
   */
  total: Scalars["Int"]["output"];
};

export type SearchScanResourcesOutput = {
  __typename?: "SearchScanResourcesOutput";
  edges: Array<ScanResourceConnection>;
  pageInfo: PageInfo;
};

export type SearchScanRunsOutput = {
  __typename?: "SearchScanRunsOutput";
  edges: Array<ScanRunConnection>;
  pageInfo: PageInfo;
};

export type SearchScansOutput = {
  __typename?: "SearchScansOutput";
  edges: Array<ScanConnection>;
  pageInfo: PageInfo;
};

export type SearchSchedulableRunsOutput = {
  __typename?: "SearchSchedulableRunsOutput";
  edges: Array<RunWithPositionConnection>;
  pageInfo: PageInfo;
};

export type SearchSpaceContextsOutput = {
  __typename?: "SearchSpaceContextsOutput";
  edges: Array<SpaceContextConnection>;
  pageInfo: PageInfo;
};

export type SearchSpacePoliciesOutput = {
  __typename?: "SearchSpacePoliciesOutput";
  edges: Array<SpacePolicyConnection>;
  pageInfo: PageInfo;
};

/** Arguments used to filter spaces. */
export type SearchSpacesInput = {
  /** Optional actions parameter filters spaces where the user can perform ALL specified actions. */
  actions: InputMaybe<Array<Action>>;
};

export type SearchSpacesOutput = {
  __typename?: "SearchSpacesOutput";
  edges: Array<SpaceConnection>;
  pageInfo: PageInfo;
};

/** SearchStacksOutput is a page of Stacks. */
export type SearchStacksOutput = {
  __typename?: "SearchStacksOutput";
  edges: Array<StackConnection>;
  pageInfo: PageInfo;
};

/** SearchSuggestionsField describes a field you can use for searching. */
export type SearchSuggestionsField = {
  __typename?: "SearchSuggestionsField";
  /** filterable indicates whether the field can be used for filtering. */
  filterable: Scalars["Boolean"]["output"];
  /** name of the field. */
  name: Scalars["String"]["output"];
  /** orderable indicates whether the field can be used for search result ordering. */
  orderable: Scalars["Boolean"]["output"];
  /** One of the below will be non-null if the field is filterable. */
  possibleValuesBoolean: Maybe<SearchSuggestionsPossibleValuesBoolean>;
  possibleValuesEnum: Maybe<SearchSuggestionsPossibleValuesEnum>;
  possibleValuesHierarchy: Maybe<SearchSuggestionsPossibleValuesHierarchy>;
  possibleValuesString: Maybe<SearchSuggestionsPossibleValuesString>;
  possibleValuesTime: Maybe<Scalars["Boolean"]["output"]>;
  /** type of the field, only available if the field is filterable. */
  type: Maybe<SearchSuggestionsFieldType>;
};

export enum SearchSuggestionsFieldType {
  Boolean = "BOOLEAN",
  Enum = "ENUM",
  Hierarchy = "HIERARCHY",
  String = "STRING",
  Time = "TIME",
}

export type SearchSuggestionsInput = {
  /**
   * An optional list of fields to get the possible values for.
   * If a specified field doesn't exist, it will be ignored.
   */
  fields: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** A full text search phrase. */
  fullTextSearch: InputMaybe<Scalars["String"]["input"]>;
  /** The list of field predicates to match. */
  predicates: InputMaybe<Array<SearchQueryPredicate>>;
};

/** SearchSuggestionsOutput describes fields you can use for searching. */
export type SearchSuggestionsOutput = {
  __typename?: "SearchSuggestionsOutput";
  fields: Array<SearchSuggestionsField>;
  filteredCount: Scalars["Int"]["output"];
};

/** SearchSuggestionsPossibleValuesBoolean describes possible boolean values of a field. */
export type SearchSuggestionsPossibleValuesBoolean = {
  __typename?: "SearchSuggestionsPossibleValuesBoolean";
  /** counts of the respective values in the current result set. */
  counts: Array<Scalars["Int"]["output"]>;
  /** directCounts is always null for non-hierarchical fields (kept for consistency with hierarchy type). */
  directCounts: Maybe<Array<Scalars["Int"]["output"]>>;
  /** values are the possible values of the field. */
  values: Array<Scalars["Boolean"]["output"]>;
};

/** SearchSuggestionsPossibleValuesEnum describes possible enum values of a field. */
export type SearchSuggestionsPossibleValuesEnum = {
  __typename?: "SearchSuggestionsPossibleValuesEnum";
  /** counts of the respective values in the current result set. */
  counts: Array<Scalars["Int"]["output"]>;
  /** directCounts is always null for non-hierarchical fields (kept for consistency with hierarchy type). */
  directCounts: Maybe<Array<Scalars["Int"]["output"]>>;
  /** values are the possible values of the field. */
  values: Array<Scalars["String"]["output"]>;
};

/** SearchSuggestionsPossibleValuesHierarchy describes possible values of a hierarchical field. */
export type SearchSuggestionsPossibleValuesHierarchy = {
  __typename?: "SearchSuggestionsPossibleValuesHierarchy";
  /**
   * counts of the respective values in the current result set.
   * For hierarchical fields, this includes unique IDs at this node AND all descendant nodes.
   */
  counts: Array<Scalars["Int"]["output"]>;
  /**
   * directCounts contains the count of unique IDs directly at each node (excluding descendants).
   * This allows frontends to calculate:
   * - Direct count: directCounts[i]
   * - Descendant count: counts[i] - directCounts[i]
   * Only populated for hierarchical fields; null for others.
   */
  directCounts: Maybe<Array<Scalars["Int"]["output"]>>;
  /** values are the possible values of the field. */
  values: Array<SearchSuggestionsPossibleValuesHierarchyNode>;
};

/** SearchSuggestionsPossibleValuesHierarchyNode describes a single possible value node of a hierarchical field. */
export type SearchSuggestionsPossibleValuesHierarchyNode = {
  __typename?: "SearchSuggestionsPossibleValuesHierarchyNode";
  /** the value that this single node represents in the context of the parent */
  displayValue: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** ID of the parent; null for the root node */
  parentId: Maybe<Scalars["ID"]["output"]>;
};

/** SearchSuggestionsPossibleValuesString describes possible string values of a field. */
export type SearchSuggestionsPossibleValuesString = {
  __typename?: "SearchSuggestionsPossibleValuesString";
  /** counts of the respective values in the current result set. */
  counts: Array<Scalars["Int"]["output"]>;
  /** directCounts is always null for non-hierarchical fields (kept for consistency with hierarchy type). */
  directCounts: Maybe<Array<Scalars["Int"]["output"]>>;
  /** values are the possible values of the field. */
  values: Array<Scalars["String"]["output"]>;
};

export type SearchTemplateDeploymentChangeHistoryOutput = {
  __typename?: "SearchTemplateDeploymentChangeHistoryOutput";
  edges: Array<TemplateDeploymentChangeRecordConnection>;
  pageInfo: PageInfo;
};

export type SearchTemplateDeploymentsOutput = {
  __typename?: "SearchTemplateDeploymentsOutput";
  edges: Array<TemplateDeploymentConnection>;
  pageInfo: PageInfo;
};

export type SearchTemplateVersionsOutput = {
  __typename?: "SearchTemplateVersionsOutput";
  edges: Array<TemplateVersionsConnection>;
  pageInfo: PageInfo;
};

export type SearchTemplatesOutput = {
  __typename?: "SearchTemplatesOutput";
  edges: Array<TemplatesConnection>;
  pageInfo: PageInfo;
};

export type SearchTofuWorkspacesOutput = {
  __typename?: "SearchTofuWorkspacesOutput";
  edges: Array<TofuWorkspacesConnection>;
  pageInfo: PageInfo;
};

export type SearchVcsIntegrationUsersOutput = {
  __typename?: "SearchVCSIntegrationUsersOutput";
  edges: Array<VcsIntegrationUserConnection>;
  pageInfo: PageInfo;
};

export type SearchVcsIntegrationsOutput = {
  __typename?: "SearchVCSIntegrationsOutput";
  edges: Array<VcsIntegrationsConnection>;
  pageInfo: PageInfo;
};

export type SearchVersionsOutput = {
  __typename?: "SearchVersionsOutput";
  edges: Array<VersionsConnection>;
  pageInfo: PageInfo;
};

export type SearchWorkerPoolUsersOutput = {
  __typename?: "SearchWorkerPoolUsersOutput";
  edges: Array<WorkerPoolUserConnection>;
  pageInfo: PageInfo;
};

export type SearchWorkerPoolsOutput = {
  __typename?: "SearchWorkerPoolsOutput";
  edges: Array<WorkerPoolConnection>;
  pageInfo: PageInfo;
};

export type SearchWorkersOutput = {
  __typename?: "SearchWorkersOutput";
  edges: Array<WorkerConnection>;
  pageInfo: PageInfo;
};

export type SeatLimit = {
  __typename?: "SeatLimit";
  /** The number of seats currently in use. */
  inUse: Scalars["Int"]["output"];
  /** The total number of seats available, -1 for unlimited. */
  limit: Scalars["Int"]["output"];
};

export type Seats = {
  __typename?: "Seats";
  /** API key seat limit. */
  apiKey: SeatLimit;
  /** User seat limit. */
  user: SeatLimit;
};

/** SecurityKey represents hardware device that supports the FIDO2 protocol. */
export type SecurityKey = {
  __typename?: "SecurityKey";
  /** Timestamp representing the security key registration. */
  createdAt: Scalars["Int"]["output"];
  /** currentOwner returns true if the current user is the owner of the security key. */
  currentOwner: Scalars["Boolean"]["output"];
  /** Unique ID of the security key. */
  id: Scalars["ID"]["output"];
  /** Name of the security key. */
  name: Scalars["String"]["output"];
  /** Owner of the security key. */
  owner: Scalars["String"]["output"];
};

export type SelfHostedLicence = {
  __typename?: "SelfHostedLicence";
  /** Describes the date range of the license. */
  validity: LicenseDateRange;
};

export type ServiceNowExtraDataInput = {
  /** Base URL for the ServiceNow instance */
  baseURL: Scalars["String"]["input"];
  /** Password for authentication */
  password: Scalars["String"]["input"];
  /** Username for authentication */
  username: Scalars["String"]["input"];
};

/** Session represents a single user session with a Spacelift account. */
export type Session = {
  __typename?: "Session";
  /** Admin means that the user is an admin of the organization. */
  admin: Scalars["Boolean"]["output"];
  /** Channel the session came through. */
  channel: SessionChannel;
  /** Time of the session creation. */
  createdAt: Scalars["Int"]["output"];
  /** Current indicates whether the session is the current one. */
  current: Scalars["Boolean"]["output"];
  /** Email of the session creator if applicable. */
  email: Scalars["String"]["output"];
  /** Time of the session expiration. */
  expiresAt: Scalars["Int"]["output"];
  /** Unique session ID, the same as JWT ID. */
  id: Scalars["ID"]["output"];
  /** IP address of the session creator. */
  ipAddress: Scalars["String"]["output"];
  /** Indicates whether the session is a machine user. */
  isMachineUser: Scalars["Boolean"]["output"];
  /** Login of the session creator. */
  login: Scalars["String"]["output"];
  /** Full name of the session creator. */
  name: Scalars["String"]["output"];
  /** Team names which the user has access to. */
  teams: Array<Scalars["String"]["output"]>;
  /** Type of the session */
  type: Scalars["String"]["output"];
};

/** SessionChannel is the login path a session came through. */
export enum SessionChannel {
  Spacectl = "SPACECTL",
  TerraformCli = "TERRAFORM_CLI",
  Unknown = "UNKNOWN",
  Web = "WEB",
}

/** How a session grant came to be. */
export enum SessionGrantOrigin {
  /**
   * Synthesized from the highest space_admin/space_write/space_read level
   * present in the session's precomputed space access.
   */
  AccessLevel = "ACCESS_LEVEL",
  /** The login policy assigned this role via its roles rule. */
  AssignedRole = "ASSIGNED_ROLE",
}

/**
 * A grant derived from a live session's precomputed space access. There is
 * no space field (always the queried space), no propagated/source field (the
 * snapshot is flattened at login), and no binding (nothing revocable except
 * the sessions themselves).
 */
export type SessionSpaceAccessRoleGrant = {
  __typename?: "SessionSpaceAccessRoleGrant";
  origin: SessionGrantOrigin;
  role: Role;
};

/**
 * SharedModule contains information about a module an account has access to that is shared
 * with it by another Spacelift account.
 */
export type SharedModule = {
  __typename?: "SharedModule";
  /** Current module version. */
  current: Maybe<SharedVersion>;
  /** Free-form module description for the users, supports Markdown. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Unique (within a single organization), immutable name of the Module. */
  id: Scalars["ID"]["output"];
  /** Labels applied to a Module. */
  labels: Array<Scalars["String"]["output"]>;
  /** Latest module version. */
  latest: Maybe<SharedVersion>;
  /** Provider-independent name of the Terraform module. */
  name: Scalars["String"]["output"];
  /**
   * Subdomain of the account owner - if the module is owned by another account
   * and just shared with the current one, this will be used to point the user
   * to the "canonical" location of the module.
   */
  ownerSubdomain: Scalars["String"]["output"];
  /** TerraformProvider represents Module's Terraform provider */
  terraformProvider: Scalars["String"]["output"];
  /** Retrieve a single Version by its ID. */
  version: Maybe<SharedVersion>;
  /**
   * Paginate through all Versions of the current Module. By default, only
   * ACTIVE and PENDING versions are shown, but setting includeFailed to true
   * will show all versions.
   */
  versions: Array<SharedVersion>;
};

/**
 * SharedModule contains information about a module an account has access to that is shared
 * with it by another Spacelift account.
 */
export type SharedModuleVersionArgs = {
  id: Scalars["ID"]["input"];
};

/**
 * SharedModule contains information about a module an account has access to that is shared
 * with it by another Spacelift account.
 */
export type SharedModuleVersionsArgs = {
  before: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * SharedVersion contains information about a module version that has been shared with this
 * account by another Spacelift account.
 */
export type SharedVersion = {
  __typename?: "SharedVersion";
  /** Unique ID of the Version. */
  id: Scalars["ID"]["output"];
  /**
   * String representation of the metadata generated by parsing the module
   * source code.
   */
  metadata: Maybe<ModuleRepositoryMetadata>;
  /** User-provided notes associated with the version. */
  notes: Maybe<Scalars["String"]["output"]>;
  /**
   * Number of the version conforming to the semantic versioning scheme
   * (major, minor, patch).
   */
  number: Scalars["String"]["output"];
  /** Current state of the Version. */
  state: VersionState;
  /** Note associated with the version when it was marked as "bad", if it has */
  yankNote: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the version has been marked as "bad". */
  yanked: Scalars["Boolean"]["output"];
  /** Login of the user who marked the version as "bad", if it has been marked */
  yankedBy: Maybe<Scalars["String"]["output"]>;
};

/** Returns information about the Slack App used to integrate Spacelift with Slack. */
export type SlackAppConfig = {
  __typename?: "SlackAppConfig";
  /** Indicates whether the Slack App configuration can be deleted via slackAppConfigDelete */
  canDelete: Scalars["Boolean"]["output"];
  /**
   * Indicates whether the Slack App configuration can be modified via slackAppConfigSet
   * and slackAppConfigDelete. This will return false if the Slack App config is provided
   * via environment variables.
   */
  canUpdate: Scalars["Boolean"]["output"];
  /** The client ID of the Slack App. Returns null when no Slack App is configured. */
  clientId: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether GovSlack credentials are configured, allowing connections to GovSlack workspaces. */
  isGovSlackAvailable: Scalars["Boolean"]["output"];
};

export type SlackAppConfigInput = {
  clientId: Scalars["String"]["input"];
  clientSecret: Scalars["String"]["input"];
  signingSecret: Scalars["String"]["input"];
};

/** SlackEnvironment indicates which Slack API environment an integration connects to. */
export enum SlackEnvironment {
  Commercial = "COMMERCIAL",
  Govslack = "GOVSLACK",
}

/** SlackIntegration represents account's Slack integration */
export type SlackIntegration = {
  __typename?: "SlackIntegration";
  /** Indicates whether this integration uses commercial Slack or GovSlack. */
  slackEnvironment: SlackEnvironment;
  /** ID of the Slack workspace */
  teamID: Scalars["String"]["output"];
  /** Name of the Slack workspace */
  teamName: Scalars["String"]["output"];
};

export type Space = {
  __typename?: "Space";
  /** This user's access level to this Space. */
  accessLevel: SpaceAccessLevel;
  /** Actions that the user can perform in this space */
  allowedActions: Array<Action>;
  /** Description of the space */
  description: Scalars["String"]["output"];
  /** Unique (within a single organization), immutable name of the space. */
  id: Scalars["ID"]["output"];
  /** Toggle whether the space should inherit entities from its parent space */
  inheritEntities: Scalars["Boolean"]["output"];
  /** Optional list of Space labels. */
  labels: Array<Scalars["String"]["output"]>;
  /** Fancy, mutable name of the Space to show in the UI. */
  name: Scalars["String"]["output"];
  /** Immutable identifier of the space that this space is child of */
  parentSpace: Maybe<Scalars["ID"]["output"]>;
};

/** UserRoleBinding = granted directly to the user; SpaceAccessGroup = granted through that group. */
export type SpaceAccessGrantVia = SpaceAccessGroup | UserRoleBinding;

/**
 * A group that a user belongs to, identifying the source of a group-derived grant.
 * Deliberately minimal: the access view only needs to name the group; full group
 * detail (members, counts, status) is available through the group queries.
 */
export type SpaceAccessGroup = {
  __typename?: "SpaceAccessGroup";
  description: Scalars["String"]["output"];
  groupName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

/** The level of access a user has to the given space. */
export enum SpaceAccessLevel {
  Admin = "ADMIN",
  None = "NONE",
  Read = "READ",
  Write = "WRITE",
}

export type SpaceAccessRule = {
  __typename?: "SpaceAccessRule";
  /** Slug of the space that this access rule affects. */
  space: Scalars["ID"]["output"];
  /** Access level to be granted within the space. */
  spaceAccessLevel: SpaceAccessLevel;
};

export type SpaceAccessRuleInput = {
  /** Slug of the space that this access rule affects. */
  space: Scalars["ID"]["input"];
  /** Access level to be granted within the space. */
  spaceAccessLevel: SpaceAccessLevel;
};

/**
 * A person with live sessions in a login-policy account. No ManagedUser row
 * exists for them; this is the grouping of their live sessions, keyed by
 * login.
 */
export type SpaceAccessSessionUser = {
  __typename?: "SpaceAccessSessionUser";
  email: Scalars["String"]["output"];
  /**
   * Unix timestamp of the most recent live session whose access reaches
   * the queried space (an even newer session that does not reach it is
   * not reflected here).
   */
  lastLoginAt: Scalars["Int"]["output"];
  login: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Number of live sessions whose access reaches the queried space. */
  sessionCount: Scalars["Int"]["output"];
};

/**
 * The narrow stack view returned by stacksWithAccessToSpace: just enough to
 * identify and label a stack in the access list, without pulling in the full
 * Stack type and the associations it depends on.
 */
export type SpaceAccessStack = {
  __typename?: "SpaceAccessStack";
  id: Scalars["ID"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  state: StackState;
};

/** SpaceActions define which actions are allowed in a space. */
export type SpaceActions = {
  __typename?: "SpaceActions";
  actions: Array<Action>;
  spaceID: Scalars["ID"]["output"];
};

export type SpaceConnection = {
  __typename?: "SpaceConnection";
  cursor: Scalars["String"]["output"];
  node: Space;
};

export type SpaceContextConnection = {
  __typename?: "SpaceContextConnection";
  cursor: Scalars["String"]["output"];
  inherited: Scalars["Boolean"]["output"];
  node: Context;
};

/** Arguments used to create and update an individual Space. */
export type SpaceInput = {
  /** Description of the space */
  description: Scalars["String"]["input"];
  /** Toggle whether the space should inherit entities from its parent space */
  inheritEntities: Scalars["Boolean"]["input"];
  /** Optional list of Space labels. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the space */
  name: Scalars["String"]["input"];
  /** Slug of the space that this space will be child of */
  parentSpace: Scalars["ID"]["input"];
};

export type SpacePolicyConnection = {
  __typename?: "SpacePolicyConnection";
  cursor: Scalars["String"]["output"];
  /** True when the policy lives in an ancestor space rather than the queried space. */
  inherited: Scalars["Boolean"]["output"];
  node: Policy;
};

export type SpaceTile = {
  __typename?: "SpaceTile";
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type SpaceliftMetrics = {
  __typename?: "SpaceliftMetrics";
  /**
   * DORA metrics
   * Average lead time for changes in seconds per day.
   */
  averageLeadTimeForChangesRange: Array<DataPoint>;
  /** Overall average lead time for changes in seconds for the entire time range. */
  averageLeadTimeForChangesValue: Array<DataPoint>;
  /**
   * Runs
   * Average run duration in nanoseconds
   */
  averageRunDuration: Array<DataPoint>;
  averageRunDurationRange: Array<DataPoint>;
  /** Average time to merge in seconds per day. */
  averageTimeToMergeRange: Array<DataPoint>;
  /** Average time to recovery in seconds per day. */
  averageTimeToRecoveryRange: Array<DataPoint>;
  /** Overall average time to recovery in seconds for the entire time range. */
  averageTimeToRecoveryValue: Array<DataPoint>;
  avgStackSizeByResourceCount: Array<DataPoint>;
  /** Change failure rate as ratio of failed to completed deployments per day. */
  changeFailureRateRange: Array<DataPoint>;
  /** Overall change failure rate as ratio of failed to completed deployments for the entire time range. */
  changeFailureRateValue: Array<DataPoint>;
  /** Deployment frequency rate in deployments per day. */
  deploymentFrequencyRateValue: Array<DataPoint>;
  driftDetectionCoverage: Array<DataPoint>;
  favouriteModules: Array<StackTile>;
  favouriteStacks: Array<StackTile>;
  hasRuns: Scalars["Boolean"]["output"];
  hasStacks: Scalars["Boolean"]["output"];
  largestStacks: Array<StackTileWithResources>;
  /** Stacks */
  maxStackSizeByResourceCount: Array<DataPoint>;
  /** Median lead time for changes in seconds per day. */
  medianLeadTimeForChangesRange: Array<DataPoint>;
  /** Overall median lead time for changes in seconds for the entire time range. */
  medianLeadTimeForChangesValue: Array<DataPoint>;
  medianRunDuration: Array<DataPoint>;
  medianRunDurationRange: Array<DataPoint>;
  /** Median time to merge in seconds per day. */
  medianTimeToMergeRange: Array<DataPoint>;
  /** Median time to recovery in seconds per day. */
  medianTimeToRecoveryRange: Array<DataPoint>;
  /** Overall median time to recovery in seconds for the entire time range. */
  medianTimeToRecoveryValue: Array<DataPoint>;
  needsApprovalRuns: Array<RunTile>;
  numberOfDeploymentsRange: Array<DataPoint>;
  recentDriftDetectionProposedRuns: Array<RunTile>;
  recentStacks: Array<StackTile>;
  resourcesCountByDrift: Array<DataPoint>;
  /** Resources */
  resourcesCountByVendor: Array<DataPoint>;
  resourcesCountRange: Array<DataPoint>;
  runsRecentlyApproved: Array<RunTileWithApproval>;
  runsRequiringAttention: Array<RunTile>;
  /**
   * Non-terminal runs approaching administrative termination. The warning window is the
   * period before scheduledTerminationAt during which customers can act on the run.
   * Runs already past scheduledTerminationAt are left out, since they are about to be
   * terminated and nothing can be done about them.
   */
  runsScheduledForTermination: RunsScheduledForTerminationTile;
  stackFailuresRange: Array<DataPoint>;
  stacksCountByState: Array<DataPoint>;
  stacksRequiringAttention: StacksAttentionTile;
  /** DriftDetection */
  upcomingDriftDetectionSchedules: Array<DriftDetectionIntegrationTile>;
};

export type SpaceliftMetricsRecentStacksArgs = {
  states: Array<StackState>;
};

/** Stack represents a single Spacelift project. */
export type Stack = Hookable &
  Notifiable & {
    __typename?: "Stack";
    /**
     * List of globs that when changed trigger a run.
     * It similar to projectRoot but instead of being a concrete path it is a
     * a list of paths defined using the glob pattern.
     */
    additionalProjectGlobs: Array<Scalars["String"]["output"]>;
    /** Administrative stacks can manage other Stacks at runtime. */
    administrative: Scalars["Boolean"]["output"];
    /**
     * List of after-apply scripts.
     * @deprecated Use hooks.afterApply instead.
     */
    afterApply: Array<Scalars["String"]["output"]>;
    /**
     * List of after-destroy scripts.
     * @deprecated Use hooks.afterDestroy instead.
     */
    afterDestroy: Array<Scalars["String"]["output"]>;
    /**
     * List of after-init scripts.
     * @deprecated Use hooks.afterInit instead.
     */
    afterInit: Array<Scalars["String"]["output"]>;
    /**
     * List of after-perform scripts.
     * @deprecated Use hooks.afterPerform instead.
     */
    afterPerform: Array<Scalars["String"]["output"]>;
    /**
     * List of after-plan scripts.
     * @deprecated Use hooks.afterPlan instead.
     */
    afterPlan: Array<Scalars["String"]["output"]>;
    /**
     * List of after-run scripts.
     * @deprecated Use hooks.afterRun instead.
     */
    afterRun: Array<Scalars["String"]["output"]>;
    /**
     * Per-action authorization the viewer holds on this Stack, covering the
     * granular STACK_SCHEDULED_* actions so scheduling controls can be gated on
     * explicit role grants rather than coarse space admin/write.
     */
    allowedActions: Array<Action>;
    /**
     * API host, useful for building links in the GUI. It may be empty if the
     * Stack's original VCS provider has been removed.
     */
    apiHost: Maybe<Scalars["String"]["output"]>;
    /** List of aws integrations that can be attached to this Stack. */
    attachableAwsIntegrations: Array<AwsIntegration>;
    /** List of azure integrations that can be attached to this Stack. */
    attachableAzureIntegrations: Array<AzureIntegration>;
    /** List of contexts that can be attached to this Stack. */
    attachableContexts: Array<Context>;
    /** List of policies that can be attached to this Stack. */
    attachablePolicies: Array<Policy>;
    /** List of worker pools that can be attached to this Stack. */
    attachableWorkerPools: Array<WorkerPool>;
    /** Any AWS integrations attached to this stack. */
    attachedAwsIntegrations: Array<StackAwsIntegrationAttachment>;
    /** Any Azure integrations attached to this stack. */
    attachedAzureIntegrations: Array<StackAzureIntegrationAttachment>;
    /** List of contexts attached to this Stack. */
    attachedContexts: Array<StackContextAttachment>;
    /** List of policies attached to this Stack. */
    attachedPolicies: Array<StackPolicyAttachment>;
    /** Will the stack automatically deploy successful plans. */
    autodeploy: Scalars["Boolean"]["output"];
    /** Will the stack automatically retry invalidated Pull Request Runs. */
    autoretry: Scalars["Boolean"]["output"];
    /**
     * List of before-apply scripts.
     * @deprecated Use hooks.beforeApply instead.
     */
    beforeApply: Array<Scalars["String"]["output"]>;
    /**
     * List of before-destroy scripts.
     * @deprecated Use hooks.beforeDestroy instead.
     */
    beforeDestroy: Array<Scalars["String"]["output"]>;
    /**
     * List of before-init scripts.
     * @deprecated Use hooks.beforeInit instead.
     */
    beforeInit: Array<Scalars["String"]["output"]>;
    /**
     * List of before-perform scripts.
     * @deprecated Use hooks.beforePerform instead.
     */
    beforePerform: Array<Scalars["String"]["output"]>;
    /**
     * List of before-plan scripts.
     * @deprecated Use hooks.beforePlan instead.
     */
    beforePlan: Array<Scalars["String"]["output"]>;
    /** Indicates whether the stack is currently blocked by a Run. */
    blocked: Scalars["Boolean"]["output"];
    /** The Run that's currently holding the stack lock, if any. */
    blocker: Maybe<Run>;
    /** Will point to a blueprint if the stack has been created using one. */
    blueprint: Maybe<Blueprint>;
    /**
     * Will point to a blueprint deployment if the stack has been created using one.
     * @deprecated Use templateDeployment instead
     */
    blueprintDeployment: Maybe<BlueprintDeployment>;
    /** Git branch of the repo that the Stack is tracking. */
    branch: Scalars["String"]["output"];
    /** Whether the user has read privileges for this Stack. */
    canRead: Scalars["Boolean"]["output"];
    /** Whether the user has write privileges for this Stack. */
    canWrite: Scalars["Boolean"]["output"];
    /** Full list of stack config elements. */
    config: Array<ConfigElement>;
    /** Single stack config element. */
    configElement: Maybe<ConfigElement>;
    /** Timestamp representing the stack creation. */
    createdAt: Scalars["Int"]["output"];
    /** Whether the stack has been deleted. */
    deleted: Scalars["Boolean"]["output"];
    /** Whether the stack is pending deletion. */
    deleting: Scalars["Boolean"]["output"];
    /**
     * Change in resources tracked by the Stack's state that will be caused
     * by an unconfirmed run that is blocking the stack.
     */
    delta: Maybe<Delta>;
    /**
     * All stack dependencies this stack depends on, or are depended on by,
     * including transitive dependencies.
     */
    dependenciesFullGraph: Array<StackDependency>;
    /** An individual stack dependency. */
    dependency: Maybe<StackDependency>;
    /** Dependencies of the stack. */
    dependsOn: Array<StackDependency>;
    /** Free-form stack description for the users, supports Markdown. */
    description: Maybe<Scalars["String"]["output"]>;
    /**
     * ULID of the run that detected drift on this stack.
     * Only set when isDrifted is true. Returns null otherwise.
     */
    driftDetectedBy: Maybe<Scalars["ID"]["output"]>;
    /**
     * When the Terraform version is a version range, this is the highest version
     * in the range that will be used for the next run. If the version is not a
     * range, or is not set, this field will be nil.
     */
    effectiveTerraformVersion: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether uploading sensitive outputs is enabled for this stack. */
    enableSensitiveOutputUpload: Scalars["Boolean"]["output"];
    /** Indicates whether the masking for secret is enabled for this stack. */
    enableWellKnownSecretMasking: Scalars["Boolean"]["output"];
    /** Entities managed by this stack. */
    entities: Array<ManagedEntity>;
    /** Individual entity managed by this stack (id is the address of the entity). */
    entity: Maybe<ManagedEntity>;
    /** Number of entities managed by this stack. */
    entityCount: Scalars["Int"]["output"];
    /**
     * The list of paths that are used for sparse checkout, if any. If empty sparse checkout is not used - whole repository is checked out.
     * Note: this field is only used if git checkout is enabled. See https://docs.spacelift.io/concepts/stack/stack-settings#labels
     */
    gitSparseCheckoutPaths: Maybe<Array<Scalars["String"]["output"]>>;
    /** Indicates whether the GitHub Checks "Deploy" action is enabled. */
    githubActionDeploy: Scalars["Boolean"]["output"];
    /** List of hooks extending this stack. */
    hooks: Hooks;
    /** Unique (within a single organization), immutable name of the stack. */
    id: Scalars["ID"]["output"];
    /** Integrations between a Stack and external systems. */
    integrations: Maybe<StackIntegrations>;
    /** Stacks that are depending on this stack. */
    isDependedOnBy: Array<StackDependency>;
    /** If stack is disabled, it will not be able to create any runs. */
    isDisabled: Scalars["Boolean"]["output"];
    /** If there are any entities in the stack that are drifted, this value will be true. */
    isDrifted: Scalars["Boolean"]["output"];
    /** Whether the Stack is read-only because it is managed by an active template deployment. */
    isLockedByTemplateDeployment: Scalars["Boolean"]["output"];
    /** Return true if the stack is currently using a rolled-back state */
    isStateRollback: Scalars["Boolean"]["output"];
    /** Labels applied to a Stack. */
    labels: Array<Scalars["String"]["output"]>;
    /** Timestamp of when the last 'apply' state started. */
    lastApplyAt: Maybe<Scalars["Int"]["output"]>;
    /** Whether triggering local workspace based Runs on this Stack is enabled. */
    localPreviewEnabled: Scalars["Boolean"]["output"];
    /** Note associated with the lock, if any. */
    lockNote: Maybe<Scalars["String"]["output"]>;
    /** Timestamp of the time when the stack was locked, if it is locked. */
    lockedAt: Maybe<Scalars["Int"]["output"]>;
    /** Username of the person who locked the Stack for their exclusive use. */
    lockedBy: Maybe<Scalars["String"]["output"]>;
    /** Is Spacelift responsible for managing the Terraform state file. */
    managesStateFile: Scalars["Boolean"]["output"];
    /** Versions of modules hosted on Spacelift the latest run on this Stack uses. */
    moduleVersionsUsed: Array<Version>;
    /** Fancy, mutable name of the Stack to show in the UI. */
    name: Scalars["String"]["output"];
    /** Repository namespace. */
    namespace: Scalars["String"]["output"];
    /** Indicates whether the Stack has a run that needs approval. */
    needsApproval: Scalars["Boolean"]["output"];
    /** Number of the new stack notifications. */
    notificationCount: Scalars["Int"]["output"];
    /** The list of stack outputs, if any. */
    outputs: Array<StackOutput>;
    /** Retrieve stack policy attachment by a known ID. */
    policyAttachment: Maybe<StackPolicyAttachment>;
    /**
     * Project root is the optional directory relative to the workspace root
     * containing the entrypoint to the Stack.
     */
    projectRoot: Maybe<Scalars["String"]["output"]>;
    /** Paginated list of proposed Runs. */
    proposedRuns: Array<Run>;
    /** Indicates whether deletion protection is currently "on" for the stack. */
    protectFromDeletion: Scalars["Boolean"]["output"];
    /** Provider of the repository */
    provider: VcsProvider;
    /**
     * List of up to 50 most recent open Pull Requests targeting Stack's tracked
     * branch.
     */
    pullRequests: Array<PullRequest>;
    /** GitHub repository tracked by this stack, as account/repo. */
    repository: Scalars["String"]["output"];
    /** A list of tags for the tracked repository. */
    repositoryTags: Array<Scalars["String"]["output"]>;
    /** Git repository URL tracked by this stack. */
    repositoryURL: Maybe<Scalars["String"]["output"]>;
    /** List of role bindings for this Stack. */
    roleBindings: Array<StackRoleBinding>;
    /** Individual Run (or task) by ID. */
    run: Maybe<Run>;
    runResourceState: Maybe<RunResourceState>;
    /** Optional runner image used to process the Run. */
    runnerImage: Maybe<Scalars["String"]["output"]>;
    /** Paginated list of Runs targeting the tracked branch. */
    runs: Array<Run>;
    /**
     * List of runs from a start timestamp inclusive to an end timestamp exclusive.
     * Caveat: It uses Ints serialized to Strings, because serializing Ints to JSON
     * is apparently really hard in JavaScript.
     * Also, note that the maximum supported range is 8 days (691,200 seconds).
     */
    runsInRange: Array<Run>;
    /**
     * Calculated runtime config containing elements coming from contexts,
     * stack and various integrations.
     */
    runtimeConfig: Array<ConfigElementWithSource>;
    /** Individual ScheduledDelete created for this stack */
    scheduledDelete: Maybe<ScheduledDelete>;
    /** Deletes that are scheduled for this stack */
    scheduledDeletes: Array<ScheduledDelete>;
    /** Individual ScheduledRun created for this stack */
    scheduledRun: Maybe<ScheduledRun>;
    /** Runs that are scheduled for this stack */
    scheduledRuns: Array<ScheduledRun>;
    /** Individual ScheduledTask created for this stack */
    scheduledTask: Maybe<ScheduledTask>;
    /** Tasks that are scheduled for this stack */
    scheduledTasks: Array<ScheduledTask>;
    /** Search managed entities with a set of predicates, ordering and paging. */
    searchManagedEntities: SearchManagedEntitiesOutput;
    /** Search managed entities grouped by providers with a set of predicates, ordering and paging. */
    searchManagedEntitiesGroupByProviders: SearchManagedEntitiesGroupedByProvidersOutput;
    /** Search managed entities grouped by stacks with a set of predicates, ordering and paging. */
    searchManagedEntitiesGroupByStacks: SearchManagedEntitiesGroupedByStacksOutput;
    /** Search managed entities grouped by types with a set of predicates, ordering and paging. */
    searchManagedEntitiesGroupByTypes: SearchManagedEntitiesGroupedByTypesOutput;
    /** Information about fields available for searching managed entities. */
    searchManagedEntitiesSuggestions: SearchSuggestionsOutput;
    /** Returns managed state versions */
    searchManagedStateVersions: Maybe<ManagedStateVersionOutput>;
    /**
     * Searches run ignored triggers. This query can only be fetched by admins.
     * Note: this is an experimental functionality.
     */
    searchRunIgnoredTriggers: Maybe<SearchRunIgnoredTriggersOutput>;
    /** Whether vendor binary downloads should be skipped during runs. */
    skipVendorBinaryDownload: Scalars["Boolean"]["output"];
    /** ID of the space this Stack belongs to. */
    space: Scalars["ID"]["output"];
    /** Details of the space this Stack belongs to. */
    spaceDetails: Space;
    /** Starred stack is showed first on the stack list */
    starred: Scalars["Boolean"]["output"];
    /** Current state of the Stack. */
    state: StackState;
    /** Is set to true when there are no ongoing runs. */
    stateIsTerminal: Scalars["Boolean"]["output"];
    /** Timestamp of the last change to the Stack state. */
    stateSetAt: Maybe<Scalars["Int"]["output"]>;
    /** ID of the last run that changed the Stack state. */
    stateSetBy: Maybe<Scalars["ID"]["output"]>;
    /** Paginated list of Tasks. */
    tasks: Array<Run>;
    /** Will point to a template deployment if the stack has been created using one. */
    templateDeployment: Maybe<TemplateDeployment>;
    /**
     * Terraform version set by the admin (can be a version range) or last used to
     * apply changes (always a version).
     */
    terraformVersion: Maybe<Scalars["String"]["output"]>;
    /** Current tracked branch head, if any. */
    trackedBranchHead: Maybe<Commit>;
    /**
     * Current commit tracked by the Stack - that is the latest commit pushed that
     * affects it.
     */
    trackedCommit: Maybe<Commit>;
    /** Note about who or what set the current tracked commit, if anything. */
    trackedCommitSetBy: Scalars["String"]["output"];
    /** VCSDetached indicates whether the stack's VCS integration has been deleted. */
    vcsDetached: Scalars["Boolean"]["output"];
    /**
     * The VCS integration used by this stack. This may either be a default integration,
     * or a space-level integration. If a space-level integration is being used by the stack,
     * and that integration is deleted, this property will be null. Additionally, if the
     * stack is using a default integration, and none exists, this property will be null.
     */
    vcsIntegration: Maybe<VcsIntegration>;
    /** Stack configuration which is specific to the vendor used. */
    vendorConfig: Maybe<StackConfigVendor>;
    /** Indicates whether this stack was migrated from Terraform to native Terragrunt. */
    wasMigratedFromTerraform: Scalars["Boolean"]["output"];
    /**
     * WorkerPool associated with the Stack, if any. If the Stack is associated
     * with the shared default worker pool, this field is empty.
     */
    workerPool: Maybe<WorkerPool>;
  };

/** Stack represents a single Spacelift project. */
export type StackConfigElementArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackDependencyArgs = {
  dependsOnStackId: InputMaybe<Scalars["ID"]["input"]>;
  id: InputMaybe<Scalars["ID"]["input"]>;
};

/** Stack represents a single Spacelift project. */
export type StackEntityArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackPolicyAttachmentArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackProposedRunsArgs = {
  before: InputMaybe<Scalars["ID"]["input"]>;
};

/** Stack represents a single Spacelift project. */
export type StackRunArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackRunResourceStateArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackRunsArgs = {
  before: InputMaybe<Scalars["ID"]["input"]>;
};

/** Stack represents a single Spacelift project. */
export type StackRunsInRangeArgs = {
  end: Scalars["String"]["input"];
  start: Scalars["String"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackScheduledDeleteArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackScheduledRunArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackScheduledTaskArgs = {
  id: Scalars["ID"]["input"];
};

/** Stack represents a single Spacelift project. */
export type StackSearchManagedEntitiesArgs = {
  input: SearchInput;
};

/** Stack represents a single Spacelift project. */
export type StackSearchManagedEntitiesGroupByProvidersArgs = {
  input: SearchInput;
};

/** Stack represents a single Spacelift project. */
export type StackSearchManagedEntitiesGroupByStacksArgs = {
  input: SearchInput;
};

/** Stack represents a single Spacelift project. */
export type StackSearchManagedEntitiesGroupByTypesArgs = {
  input: SearchInput;
};

/** Stack represents a single Spacelift project. */
export type StackSearchManagedEntitiesSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** Stack represents a single Spacelift project. */
export type StackSearchManagedStateVersionsArgs = {
  input: SearchInput;
};

/** Stack represents a single Spacelift project. */
export type StackSearchRunIgnoredTriggersArgs = {
  input: SearchInput;
};

/** Stack represents a single Spacelift project. */
export type StackTasksArgs = {
  before: InputMaybe<Scalars["ID"]["input"]>;
};

/** Selects which stacks stacksWithAccessToSpace returns. */
export enum StackAccessMode {
  /**
   * Every stack that can act in the queried space: residents, ancestor residents
   * (implicit self-read propagates down), inheriting-descendant residents (read
   * propagates up), and explicit binding holders.
   */
  AllWithAccess = "ALL_WITH_ACCESS",
  /** Only stacks whose home space is the queried space. */
  Residing = "RESIDING",
}

/** StackAwsIntegrationAttachment is the AWS integration attachment viewed from the Stack. */
export type StackAwsIntegrationAttachment = {
  __typename?: "StackAwsIntegrationAttachment";
  /** Duration in seconds for which the assumed role credentials should be valid. */
  durationSeconds: Scalars["Int"]["output"];
  /**
   * AWS external ID. This will contain your custom external ID when using role-assumption on the
   * worker, and otherwise will contain an external ID generated by Spacelift.
   */
  externalId: Scalars["String"]["output"];
  /** AWS credentials will be generated in the private worker. */
  generateCredentialsInWorker: Scalars["Boolean"]["output"];
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** ID of the attached integration. */
  integrationId: Scalars["ID"]["output"];
  /** Whether the context is autoattached to the stack. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** Labels of the attached integration. */
  labels: Array<Scalars["String"]["output"]>;
  /** Whether the integration is a legacy integration or not. */
  legacy: Scalars["Boolean"]["output"];
  /** The friendly name of the integration. */
  name: Scalars["String"]["output"];
  /** Whether the integration is used for read operations. */
  read: Scalars["Boolean"]["output"];
  /** AWS IAM role to assume. */
  roleArn: Scalars["String"]["output"];
  /** Whether the integration is used for write operations. */
  write: Scalars["Boolean"]["output"];
};

/** StackAzureIntegrationAttachment is the Azure integration attachment viewed from the Stack. */
export type StackAzureIntegrationAttachment = {
  __typename?: "StackAzureIntegrationAttachment";
  /** The default Azure subscription to use if none has been specified at the Stack level. */
  defaultSubscriptionId: Maybe<Scalars["String"]["output"]>;
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** The display name of the Azure AD application. */
  integrationDisplayName: Scalars["String"]["output"];
  /** ID of the attached integration. */
  integrationId: Scalars["ID"]["output"];
  /** Name of the attached integration. */
  integrationName: Scalars["String"]["output"];
  /** Whether the context is autoattached to the stack. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** Labels of the attached integration. */
  labels: Array<Scalars["String"]["output"]>;
  /** Whether the integration is used for read operations. */
  read: Scalars["Boolean"]["output"];
  /** The Azure subscription Id to use for this stack. Overrides the defaultSubscriptionId. */
  subscriptionId: Maybe<Scalars["String"]["output"]>;
  /** Whether the integration is used for write operations. */
  write: Scalars["Boolean"]["output"];
};

/** Configuration which varies depending on the used vendor. */
export type StackConfigVendor =
  | StackConfigVendorAnsible
  | StackConfigVendorCloudFormation
  | StackConfigVendorKubernetes
  | StackConfigVendorOpenTofu
  | StackConfigVendorPulumi
  | StackConfigVendorTerraform
  | StackConfigVendorTerragrunt;

/** Configuration specific to Ansible stacks. */
export type StackConfigVendorAnsible = {
  __typename?: "StackConfigVendorAnsible";
  /** The main Ansible playbook file. */
  playbook: Scalars["String"]["output"];
};

/** Configuration specific to Ansible stacks. */
export type StackConfigVendorAnsibleInput = {
  /** The main Ansible playbook file. */
  playbook: Scalars["String"]["input"];
};

/** Configuration specific to CloudFormation stacks. */
export type StackConfigVendorCloudFormation = {
  __typename?: "StackConfigVendorCloudFormation";
  /** The main CloudFormation template file, which gets to be the root stack. */
  entryTemplateFile: Scalars["String"]["output"];
  /** The region in which the CloudFormation stack should be. */
  region: Scalars["String"]["output"];
  /** CloudFormation root stack name. */
  stackName: Scalars["String"]["output"];
  /** The S3 Bucket CloudFormation should store its templates in. */
  templateBucket: Scalars["String"]["output"];
};

/** Configuration specific to CloudFormation stacks. */
export type StackConfigVendorCloudFormationInput = {
  /** The main CloudFormation template file, which gets to be the root stack. */
  entryTemplateFile: Scalars["String"]["input"];
  /** The region in which the CloudFormation stack should be. */
  region: Scalars["String"]["input"];
  /** CloudFormation root stack name. */
  stackName: Scalars["String"]["input"];
  /** The S3 Bucket CloudFormation should store its templates in. */
  templateBucket: Scalars["String"]["input"];
};

/**
 * Configuration which varies depending on the used vendor.
 * All but one field should be left empty.
 */
export type StackConfigVendorInput = {
  /** Set if Ansible is the Stack vendor. */
  ansible: InputMaybe<StackConfigVendorAnsibleInput>;
  /** Set if CloudFormation is the Stack vendor. */
  cloudFormation: InputMaybe<StackConfigVendorCloudFormationInput>;
  /** Set if Kubernetes is the Stack vendor. */
  kubernetes: InputMaybe<StackConfigVendorKubernetesInput>;
  /** Set if OpenTofu is the Stack vendor. */
  opentofu: InputMaybe<StackConfigVendorOpenTofuInput>;
  /** Set if Pulumi is the Stack vendor. */
  pulumi: InputMaybe<StackConfigVendorPulumiInput>;
  /** Set if Terraform is the Stack vendor. */
  terraform: InputMaybe<StackConfigVendorTerraformInput>;
  /** Set if Terragrunt is the Stack vendor. */
  terragrunt: InputMaybe<StackConfigVendorTerragruntInput>;
};

/** Configuration specific to Kubernetes stacks. */
export type StackConfigVendorKubernetes = {
  __typename?: "StackConfigVendorKubernetes";
  /** The version of kubectl to be used. */
  kubectlVersion: Scalars["String"]["output"];
  /** The tool used by the stack for executing workflow stages. */
  kubernetesWorkflowTool: KubernetesWorkflowTool;
  /** The namespace to run kubectl in. */
  namespace: Scalars["String"]["output"];
};

/** Configuration specific to Kubernetes stacks. */
export type StackConfigVendorKubernetesInput = {
  /** The version of kubectl to be used. */
  kubectlVersion: InputMaybe<Scalars["String"]["input"]>;
  /** Defines the tool that will be used to execute the workflow. */
  kubernetesWorkflowTool: InputMaybe<KubernetesWorkflowTool>;
  /** The Kubernetes namespace to run kubectl in. */
  namespace: Scalars["String"]["input"];
};

/** Configuration specific to OpenTofu stacks. */
export type StackConfigVendorOpenTofu = {
  __typename?: "StackConfigVendorOpenTofu";
  /**
   * When enabled, Spacelift passes -concise to tofu plan/apply/refresh to suppress "Refreshing state..." progress output.
   * Requires OpenTofu 1.7+. A stack on an older version cannot enable it.
   * If you're running OpenTofu 1.10+, concise flag will be also used in apply.
   */
  concise: Scalars["Boolean"]["output"];
  /**
   * When the version is a version range, this is the highest supported
   * version in the range that will be used for the next run. If the version
   * is not a range, or is not set, this field will be null.
   */
  effectiveVersion: Maybe<Scalars["String"]["output"]>;
  /**
   * When enabled, Spacelift captures CPU profiles from OpenTofu init, plan, and apply phases.
   * Requires OpenTofu 1.11+ at runtime; silently omitted on older versions.
   */
  enableCPUProfiling: Scalars["Boolean"]["output"];
  /** Indicates whether you can access the Stack state file from other stacks or outside of Spacelift. */
  externalStateAccessEnabled: Scalars["Boolean"]["output"];
  /** OpenTofu features supported by the configured version. */
  supportedFeatures: Array<OpenTofuFeatureCheck>;
  /**
   * If Smart sanitization should be used for sanitizing plans and resources.
   * Smart sanitization will only sanitize values that have been marked as sensitive.
   */
  useSmartSanitization: Scalars["Boolean"]["output"];
  /** OpenTofu version to use. */
  version: Maybe<Scalars["String"]["output"]>;
  /** The tool used by the stack for executing workflow stages. */
  workflowTool: OpenTofuWorkflowTool;
  /** OpenTofu workspace to select (not compatible with some backends). */
  workspace: Maybe<Scalars["String"]["output"]>;
};

/** Configuration specific to OpenTofu stacks. */
export type StackConfigVendorOpenTofuInput = {
  /**
   * When enabled, Spacelift passes -concise to tofu plan/apply/refresh to suppress "Refreshing state..." progress output.
   * Requires OpenTofu 1.7+. A stack on an older version cannot enable it.
   * If you're running OpenTofu 1.10+, concise flag will be also used in apply.
   * When unset on create, defaults to true on OpenTofu 1.7+ and to false on older versions.
   */
  concise: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * When enabled, Spacelift captures CPU profiles from OpenTofu init, plan, and apply phases.
   * Requires OpenTofu 1.11+ at runtime; silently omitted on older versions.
   * When unset on create, defaults to true on OpenTofu 1.11+ and to false on older versions.
   */
  enableCPUProfiling: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether you can access the Stack state file from other stacks or outside of Spacelift. */
  externalStateAccessEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * If Smart sanitization should be used for sanitizing plans and resources.
   * Smart sanitization will only sanitize values that have been marked as sensitive.
   */
  useSmartSanitization: InputMaybe<Scalars["Boolean"]["input"]>;
  /** OpenTofu version to use. */
  version: InputMaybe<Scalars["String"]["input"]>;
  /** Defines the tool that will be used to execute the workflow. */
  workflowTool: InputMaybe<OpenTofuWorkflowTool>;
  /** OpenTofu workspace to select (not compatible with some backends). */
  workspace: InputMaybe<Scalars["String"]["input"]>;
};

/** Configuration specific to Pulumi stacks. */
export type StackConfigVendorPulumi = {
  __typename?: "StackConfigVendorPulumi";
  /** The URL to log into. */
  loginURL: Scalars["String"]["output"];
  /** Root stack name. */
  stackName: Scalars["String"]["output"];
};

/** Configuration specific to Pulumi stacks. */
export type StackConfigVendorPulumiInput = {
  /** The URL to log into. */
  loginURL: Scalars["String"]["input"];
  /** Root stack name. */
  stackName: Scalars["String"]["input"];
};

/** Configuration specific to Terraform stacks. */
export type StackConfigVendorTerraform = {
  __typename?: "StackConfigVendorTerraform";
  /** Indicates whether you can access the Stack state file from other stacks or outside of Spacelift. */
  externalStateAccessEnabled: Scalars["Boolean"]["output"];
  /**
   * If Smart sanitization should be used for sanitizing terraform plans and resources.
   * Smart sanitization will only sanitize values that terraform has marked as sensitive.
   */
  useSmartSanitization: Scalars["Boolean"]["output"];
  /** Terraform version to use. */
  version: Maybe<Scalars["String"]["output"]>;
  /** The tool used by the stack for executing workflow stages. */
  workflowTool: TerraformWorkflowTool;
  /** Terraform workspace to select (not compatible with some backends). */
  workspace: Maybe<Scalars["String"]["output"]>;
};

/** Configuration specific to Terraform stacks. */
export type StackConfigVendorTerraformInput = {
  /** Indicates whether you can access the Stack state file from other stacks or outside of Spacelift. */
  externalStateAccessEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * If Smart sanitization should be used for sanitizing terraform plans and resources.
   * Smart sanitization will only sanitize values that terraform has marked as sensitive.
   */
  useSmartSanitization: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Terraform version to use. */
  version: InputMaybe<Scalars["String"]["input"]>;
  /** Defines the tool that will be used to execute the workflow. */
  workflowTool: InputMaybe<TerraformWorkflowTool>;
  /** Terraform workspace to select (not compatible with some backends). */
  workspace: InputMaybe<Scalars["String"]["input"]>;
};

/** Configuration specific to Terragrunt stacks. */
export type StackConfigVendorTerragrunt = {
  __typename?: "StackConfigVendorTerragrunt";
  /** Effective terragrunt and terraform versions */
  effectiveVersions: EffectiveTerragruntVersionResult;
  /**
   * Controls whether module names are prefixed to resource and output keys for non-run-all stacks.
   * Has no effect when useRunAll is enabled (always prefixes in that case).
   */
  prefixResourceNamesWithModuleName: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * If set to true, the apply phase will reuse the plan from the planning phase instead of
   * re-planning. Successor of skipReplanWhenRunAll, applies to both run-all and non-run-all stacks.
   *
   * WARNING: this means any mocked_outputs referenced during planning will be applied as-is.
   * Do not enable this together with mocked_outputs unless you fully understand the implications —
   * your apply may execute against mocked values rather than real ones.
   */
  skipReplan: Scalars["Boolean"]["output"];
  /**
   * If set to true, the apply phase will reuse the plan from the planning phase instead of
   * re-planning. Only applies when useRunAll is enabled.
   * Runs with disabled useRunAll reuse the plan by default.
   *
   * WARNING: this means any mocked_outputs referenced during planning will be applied as-is.
   * Do not enable this together with mocked_outputs unless you fully understand the implications —
   * your apply may execute against mocked values rather than real ones.
   *
   * DEPRECATED: use skipReplan instead, which works for both run-all and non-run-all stacks.
   * @deprecated Use skipReplan instead, which applies to both run-all and non-run-all stacks.
   */
  skipReplanWhenRunAll: Scalars["Boolean"]["output"];
  /** Terraform version to use. */
  terraformVersion: Maybe<Scalars["String"]["output"]>;
  /** Terragrunt version to use. */
  terragruntVersion: Maybe<Scalars["String"]["output"]>;
  /** TerragruntTool defines the underlying tool run by Terragrunt. */
  tool: TerragruntTool;
  /** If set to true, Terragrunt backend will execute commands in run-all mode. */
  useRunAll: Scalars["Boolean"]["output"];
  /**
   * If Smart sanitization should be used for sanitizing terraform plans and resources.
   * Smart sanitization will only sanitize values that terraform has marked as sensitive.
   */
  useSmartSanitization: Scalars["Boolean"]["output"];
  useStateManagement: Scalars["Boolean"]["output"];
};

export type StackConfigVendorTerragruntInput = {
  /**
   * Controls whether module names are prefixed to resource and output keys for non-run-all stacks.
   * Has no effect when useRunAll is enabled (always prefixes in that case).
   */
  prefixResourceNamesWithModuleName: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Whether to skip re-planning during apply by reusing the saved plan. Successor of
   * skipReplanWhenRunAll, applies to both run-all and non-run-all stacks.
   *
   * WARNING: this means any mocked_outputs referenced during planning will be applied as-is.
   * Do not enable this together with mocked_outputs unless you fully understand the implications —
   * your apply may execute against mocked values rather than real ones.
   */
  skipReplan: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Whether to skip re-planning during apply by reusing the saved plan. Only applies with useRunAll.
   * Runs with disabled useRunAll reuse the plan by default.
   *
   * WARNING: this means any mocked_outputs referenced during planning will be applied as-is.
   * Do not enable this together with mocked_outputs unless you fully understand the implications —
   * your apply may execute against mocked values rather than real ones.
   *
   * DEPRECATED: use skipReplan instead, which works for both run-all and non-run-all stacks.
   */
  skipReplanWhenRunAll: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Terraform version to use. */
  terraformVersion: InputMaybe<Scalars["String"]["input"]>;
  /** Terragrunt version to use. */
  terragruntVersion: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The IaC tool used by Terragrunt. When set to MANUALLY_PROVISIONED, an environment variable
   * called TERRAGRUNT_TFPATH must be available to runs to tell them where to find the tool.
   * Defaults to TERRAFORM_FOSS if not provided.
   */
  tool: InputMaybe<TerragruntTool>;
  /** If set to true, Terragrunt backend will execute commands in run-all mode. */
  useRunAll: Scalars["Boolean"]["input"];
  /**
   * If Smart sanitization should be used for sanitizing terraform plans and resources.
   * Smart sanitization will only sanitize values that terraform has marked as sensitive.
   */
  useSmartSanitization: Scalars["Boolean"]["input"];
  useStateManagement: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** StackConnection represents a single stack in a page of results. */
export type StackConnection = {
  __typename?: "StackConnection";
  cursor: Scalars["String"]["output"];
  node: Stack;
};

/** StackContextAttachment is the stack attachment viewed from the Stack. */
export type StackContextAttachment = {
  __typename?: "StackContextAttachment";
  /** Full list of stack config elements. */
  config: Array<ConfigElement>;
  /** Description of the attached context. */
  contextDescription: Maybe<Scalars["String"]["output"]>;
  /** Hooks of the attached context. */
  contextHooks: Hooks;
  /** ID of the attached context. */
  contextId: Scalars["ID"]["output"];
  /** Labels of the attached context. */
  contextLabels: Array<Scalars["String"]["output"]>;
  /** Name of the attached context. */
  contextName: Scalars["String"]["output"];
  /** Globally unique attachment identifier. */
  id: Scalars["ID"]["output"];
  /** Whether the context is autoattached to the stack. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** Context in question. */
  priority: Scalars["Int"]["output"];
};

/** Arguments used to create a Stack from Intent Project. */
export type StackCreateFromIntentInput = {
  /** Intent Project ID */
  project: Scalars["ID"]["input"];
  /** optional Stack name, if omited Intent Project name will be used */
  stackName: InputMaybe<Scalars["String"]["input"]>;
};

/** StackDependency represents a dependency between two stacks. */
export type StackDependency = {
  __typename?: "StackDependency";
  /** Details of the dependency stack. */
  dependsOnStack: StackDependencyDetail;
  /**
   * ID of the dependency.
   * @deprecated Use dependsOnStack field instead.
   */
  dependsOnStackId: Scalars["ID"]["output"];
  /** Slug of the dependency. Immutable. */
  id: Scalars["ID"]["output"];
  /** An individual stack dependency reference. */
  reference: Maybe<StackDependencyReference>;
  /** Number of references */
  referenceCount: Scalars["Int"]["output"];
  /** Output/Input references */
  references: Array<StackDependencyReference>;
  /** Details of the stack that has a dependency. */
  stack: StackDependencyDetail;
  /**
   * ID of the stack that has a dependency.
   * @deprecated Use stack field instead.
   */
  stackId: Scalars["ID"]["output"];
  /**
   * When true, triggers the downstream stack on every upstream run completion,
   * even if none of the dependency outputs have changed.
   */
  triggerAlways: Scalars["Boolean"]["output"];
};

/** StackDependency represents a dependency between two stacks. */
export type StackDependencyReferenceArgs = {
  id: InputMaybe<Scalars["ID"]["input"]>;
  inputName: InputMaybe<Scalars["String"]["input"]>;
};

export type StackDependencyBatchInput = {
  /** The list of dependencies to add. */
  dependencies: Array<StackDependencyInput>;
};

export type StackDependencyDetail = {
  __typename?: "StackDependencyDetail";
  /** ID of the stack. */
  id: Scalars["ID"]["output"];
  /**
   * Whether the stack is read-only because it is managed by an active template
   * deployment. Its dependencies cannot be edited from stack settings, it need to
   * changed on the template.
   */
  isLockedByTemplateDeployment: Scalars["Boolean"]["output"];
  /** Name of the stack. */
  name: Scalars["String"]["output"];
  /** Space of the stack. */
  space: Space;
  /** Stack configuration which is specific to the vendor used. */
  vendorConfig: Maybe<StackConfigVendor>;
};

export type StackDependencyInput = {
  /** ID of the dependency. */
  dependsOnStackId: Scalars["ID"]["input"];
  /** The Stack which has a dependency. */
  stackId: Scalars["ID"]["input"];
  /** When enabled, the downstream stack will be triggered even if none of the dependency outputs have changed. */
  triggerAlways: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StackDependencyReference = {
  __typename?: "StackDependencyReference";
  /** ID of the stack dependency reference */
  id: Scalars["ID"]["output"];
  /** Input name */
  inputName: Scalars["String"]["output"];
  /** Output name */
  outputName: Scalars["String"]["output"];
  /**
   * TriggerAlways
   * When enabled, downstream stacks will be triggered even if the value of the
   * output has not changed.
   */
  triggerAlways: Scalars["Boolean"]["output"];
  /** Type */
  type: ConfigType;
};

export type StackDependencyReferenceInput = {
  inputName: Scalars["String"]["input"];
  outputName: Scalars["String"]["input"];
  triggerAlways: InputMaybe<Scalars["Boolean"]["input"]>;
  type: InputMaybe<ConfigType>;
};

export type StackDependencyReferenceUpdateInput = {
  id: Scalars["ID"]["input"];
  inputName: Scalars["String"]["input"];
  outputName: Scalars["String"]["input"];
  triggerAlways: InputMaybe<Scalars["Boolean"]["input"]>;
  type: InputMaybe<ConfigType>;
};

export type StackDependencyUpdateInput = {
  /** ID of the stack dependency to update. */
  id: Scalars["ID"]["input"];
  /** When enabled, the downstream stack will be triggered even if none of the dependency outputs have changed. */
  triggerAlways: Scalars["Boolean"]["input"];
};

/** Arguments used to create and update an individual Stack. */
export type StackInput = {
  /**
   * AdditionalProjectGlobs is a list of globs that when changed trigger a run.
   * It similar to ProjectRoot but instead of being a concrete path it is a
   * a list of paths defined using the glob pattern.
   */
  additionalProjectGlobs: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Administrative stacks can manage other Stacks at runtime. */
  administrative: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional list of after-apply scripts. */
  afterApply: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of after-destroy scripts. */
  afterDestroy: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of after-init scripts. */
  afterInit: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of after-perform scripts. */
  afterPerform: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of after-plan scripts. */
  afterPlan: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of after-run scripts. */
  afterRun: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * When set to true, stack will automatically deploy successful plans to
   * tracked branches.
   */
  autodeploy: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When set to true, stack will automatically retry invalidated Pull Request Runs. */
  autoretry: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional list of before-apply scripts. */
  beforeApply: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of before-destroy scripts. */
  beforeDestroy: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of before-init scripts. */
  beforeInit: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of before-perform scripts. */
  beforePerform: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Optional list of before-plan scripts. */
  beforePlan: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Name of the branch to track. */
  branch: Scalars["String"]["input"];
  /** Optional free-form description of the Stack. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether runs on the stack will attempt to upload sensitive output potentially needed for stack dependencies */
  enableSensitiveOutputUpload: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether the masking for secret is enabled for this stack. */
  enableWellKnownSecretMasking: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * The list of paths that are used for sparse checkout, if any. If empty sparse checkout is not used - whole repository is checked out.
   * Note: this field is only used if git checkout is enabled. See https://docs.spacelift.io/concepts/stack/stack-settings#labels
   */
  gitSparseCheckoutPaths: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** When set to true, the "Deploy" action will be enabled on GitHub Checks Run (default: true). */
  githubActionDeploy: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When set to true, the stack will not be able to create runs. */
  isDisabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional list of Stack labels. */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Whether triggering local workspace based Runs on this Stack is enabled */
  localPreviewEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Human-friendly, mutable stack name. */
  name: Scalars["String"]["input"];
  /**
   * Namespace is the optional namespace which the repository belongs to. If not
   * provided, the name of the linked GitHub account is used.
   */
  namespace: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Project root is the optional directory relative to the workspace root
   * containing the entrypoint to the Stack.
   */
  projectRoot: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether deletion protection is currently "on" for the stack. */
  protectFromDeletion: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Provider is the optional VCS provider that provides access to the Git
   * repository linked to the Stack.
   */
  provider: InputMaybe<VcsProvider>;
  /** Name of the repository to track. */
  repository: Scalars["String"]["input"];
  /** Optional URL of the repository to track. */
  repositoryURL: InputMaybe<Scalars["String"]["input"]>;
  /** Optional runner image used to process the Run. */
  runnerImage: InputMaybe<Scalars["String"]["input"]>;
  /** Whether vendor binary downloads should be skipped during runs. */
  skipVendorBinaryDownload: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ID of the Space this Stack should be in. */
  space: InputMaybe<Scalars["ID"]["input"]>;
  /** Terraform version to use. NOTE: this takes precedence over vendorConfig.terraformVersion */
  terraformVersion: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The ID of the VCS integration used by this stack. This should only be provided if the default (account-level)
   * integration is not being used (i.e. a space-level integration is being used).
   */
  vcsIntegrationId: InputMaybe<Scalars["ID"]["input"]>;
  /** Stack configuration which is specific to the vendor used. */
  vendorConfig: InputMaybe<StackConfigVendorInput>;
  /** ID of the worker pool for the Stack to use. */
  workerPool: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * AWS integration - with that set up, a Stack can assume an arbitrary AWS IAM
 * role without setting up static credentials.
 */
export type StackIntegrationAws = {
  __typename?: "StackIntegrationAws";
  /**
   * Is this integration activated. If not, assumedRoleARN is expected to be
   * empty.
   */
  activated: Scalars["Boolean"]["output"];
  /** AWS IAM assume role creation link. */
  assumeRoleLink: Scalars["String"]["output"];
  /** AWS IAM assume role policy statement. */
  assumeRolePolicyStatement: Scalars["String"]["output"];
  /** AWS IAM role to assume, if set. */
  assumedRoleArn: Maybe<Scalars["String"]["output"]>;
  /** Duration in seconds for which the assumed role credentials should be valid. */
  durationSeconds: Maybe<Scalars["Int"]["output"]>;
  /** AWS external ID (works only for private workers). */
  externalID: Maybe<Scalars["String"]["output"]>;
  /** AWS credentials will be generated in the private worker. */
  generateCredentialsInWorker: Scalars["Boolean"]["output"];
  /** AWS region. */
  region: Maybe<Scalars["String"]["output"]>;
};

/**
 * GCP integration - with that set up, a Stack gets its dedicated GCP service
 * account and each run and tasks automatically gets its temporary credentials.
 */
export type StackIntegrationGcp = {
  __typename?: "StackIntegrationGcp";
  /**
   * Is this integration activated. If not, serviceAccountEmail and scopes are
   * expected to be empty.
   */
  activated: Scalars["Boolean"]["output"];
  /**
   * Email of the GCP service account created for this stack. Runs and tasks will
   * get temporary access token for this account.
   */
  serviceAccountEmail: Maybe<Scalars["String"]["output"]>;
  /**
   * List of scopes to request when generating temporary access token for the
   * service account. It's empty when the integration is not activated.
   */
  tokenScopes: Array<Scalars["String"]["output"]>;
};

/**
 * Slack integration - with that set up, a Stack or Module can send notifications
 * about various events to a number of Slack channels.
 */
export type StackIntegrationSlack = {
  __typename?: "StackIntegrationSlack";
  /**
   * Is this integration activated. If not, channelNames are expected to be
   * empty.
   */
  activated: Scalars["Boolean"]["output"];
  /**
   * List of names of Slack channels which are subscribed to events in this
   * Module or Stack.
   */
  channelNames: Array<Scalars["String"]["output"]>;
};

/** StackIntegrations represents external integrations for an individual Stack. */
export type StackIntegrations = {
  __typename?: "StackIntegrations";
  /** AWS integration. */
  aws: StackIntegrationAws;
  /** AWS integrations. */
  awsV2: Array<StackAwsIntegrationAttachment>;
  /** Azure integrations. */
  azure: Array<StackAzureIntegrationAttachment>;
  /** Drift detection configuration for the Stack, null if not enabled. */
  driftDetection: Maybe<DriftDetectionIntegration>;
  /**
   * GCP integration.
   * @deprecated Use OIDC integration instead.
   */
  gcp: StackIntegrationGcp;
  /** Slack integration. */
  slack: StackIntegrationSlack;
  /** Details of a single webhook integration. */
  webhook: Maybe<WebhooksIntegration>;
  /** List of webhooks integrations. */
  webhooks: Array<WebhooksIntegration>;
};

/** StackIntegrations represents external integrations for an individual Stack. */
export type StackIntegrationsWebhookArgs = {
  id: Scalars["ID"]["input"];
};

/** Result of a bulk vendor migration operation. */
export type StackMigrateVendorAllResult = {
  __typename?: "StackMigrateVendorAllResult";
  /** Number of eligible stacks that were not migrated (e.g. due to time limit). */
  left: Scalars["Int"]["output"];
  /** Number of stacks successfully migrated in this call. */
  migrated: Scalars["Int"]["output"];
};

/** StackOutput represents a single stack output field. */
export type StackOutput = {
  __typename?: "StackOutput";
  /** Brief explanation of output's purpose or value. */
  description: Maybe<Scalars["String"]["output"]>;
  /** ID (name) of the output. */
  id: Scalars["ID"]["output"];
  /**
   * Indicates whether the output is sensitive. For sensitive outputs, we do not
   * have the value, so we cannot display it.
   */
  sensitive: Scalars["Boolean"]["output"];
  /**
   * String representation of the value of the output. If the output is sensitive,
   * this field is empty.
   */
  value: Maybe<Scalars["String"]["output"]>;
};

/** StackPolicyAttachment is the stack policy attachment viewed from the Stack. */
export type StackPolicyAttachment = {
  __typename?: "StackPolicyAttachment";
  /**
   * List of all the policy evaluation records associated with this policy
   * attachment.
   */
  evaluationRecords: Array<PolicyEvaluationRecord>;
  /** Returns a single policy evaluation sample */
  evaluationSample: Maybe<PolicyEvaluationSample>;
  /** Globally unique Policy attachment identifier. */
  id: Scalars["ID"]["output"];
  /** True if the policy is autoattached. */
  isAutoattached: Scalars["Boolean"]["output"];
  /** Body of the attached Policy. */
  policyBody: Scalars["String"]["output"];
  /** ID of the attached Policy. */
  policyId: Scalars["ID"]["output"];
  /** Labels of the attached Policy. */
  policyLabels: Array<Scalars["String"]["output"]>;
  /** Name of the attached Policy. */
  policyName: Scalars["String"]["output"];
  /** Type of the attached Policy. */
  policyType: PolicyType;
};

/** StackPolicyAttachment is the stack policy attachment viewed from the Stack. */
export type StackPolicyAttachmentEvaluationSampleArgs = {
  key: Scalars["String"]["input"];
};

export type StackRoleBinding = {
  __typename?: "StackRoleBinding";
  id: Scalars["ID"]["output"];
  role: Role;
  space: Space;
  stackID: Scalars["ID"]["output"];
  stackName: Scalars["String"]["output"];
};

export type StackRoleBindingBatchInput = {
  /** List of stack role bindings to create. */
  bindings: Array<StackRoleBindingInput>;
};

export type StackRoleBindingInput = {
  /** ID of the role. */
  roleID: Scalars["ID"]["input"];
  /** ID of the space. */
  spaceID: Scalars["ID"]["input"];
  /** ID of the stack. */
  stackID: Scalars["ID"]["input"];
};

export type StackRoleBindingUpdateInput = {
  /** ID of the role. */
  roleID: Scalars["ID"]["input"];
  /** ID of the space. */
  spaceID: Scalars["ID"]["input"];
};

/** How a grant reaches the queried space, i.e. where its space sits relative to it. */
export enum StackSpaceAccessGrantSource {
  /**
   * The grant lives on a descendant space and reaches the queried space by
   * inheritance up the tree (the descendant chain has inherit_entities enabled).
   */
  Inherited = "INHERITED",
  /**
   * The grant lives on an ancestor space and reaches the queried space by
   * propagating down.
   */
  Propagated = "PROPAGATED",
  /** The grant lives on the queried space itself. */
  Resident = "RESIDENT",
}

/** A role grant giving a stack access to a space, either directly or through the space tree. */
export type StackSpaceAccessRoleGrant = {
  __typename?: "StackSpaceAccessRoleGrant";
  /**
   * The explicit binding backing this grant. Null for the implicit self-read
   * every stack has on its own home space. For INHERITED grants it names the
   * originating custom role and descendant space the read climbed from, so
   * binding.role intentionally differs from the effective role above.
   */
  binding: Maybe<StackRoleBinding>;
  /**
   * The role effective on the queried space. For INHERITED grants only read
   * climbs up an inherit_entities edge, so this is the synthetic "Space reader"
   * system role, which may differ from binding.role (the bound custom role).
   */
  role: Role;
  /** How this grant reaches the queried space (resident, propagated, or inherited). */
  source: StackSpaceAccessGrantSource;
  space: Space;
};

/**
 * StackState represents a discrete state of a Stack, which is also the state of
 * its most currently running Run.
 */
export enum StackState {
  /** The current tracked run is now applying. */
  Applying = "APPLYING",
  /** The current tracked run has been confirmed by the user. */
  Confirmed = "CONFIRMED",
  /** The current destroy job is now deleting all managed resources. */
  Destroying = "DESTROYING",
  /** The last tracked run has been discarded by the user. */
  Discarded = "DISCARDED",
  /** The last tracked run has failed. */
  Failed = "FAILED",
  /** The last tracked run has finished successfully. */
  Finished = "FINISHED",
  /** The current tracked run is now initializing. */
  Initializing = "INITIALIZING",
  /** No tracked run has been started yet, so the stack has no meaningful state. */
  None = "NONE",
  /** The current tracked run is now planning. */
  Planning = "PLANNING",
  /** The current tracked run is now preparing for execution. */
  Preparing = "PREPARING",
  /** The current tracked run is now preparing to apply the change. */
  PreparingApply = "PREPARING_APPLY",
  /** The current tracked run is being prepared to be replanned. */
  PreparingReplan = "PREPARING_REPLAN",
  /** The current tracked run is now ready for execution. */
  Ready = "READY",
  /** The current tracked run is pending a replan. */
  ReplanRequested = "REPLAN_REQUESTED",
  /** The last tracked run has been stopped. */
  Stopped = "STOPPED",
  /** The current tracked run is awaiting human confirmation. */
  Unconfirmed = "UNCONFIRMED",
}

export type StackTerragruntMigration = {
  __typename?: "StackTerragruntMigration";
  migrated: Scalars["Int"]["output"];
  readyToMigrate: Scalars["Int"]["output"];
};

export type StackTile = {
  __typename?: "StackTile";
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  spaceTile: SpaceTile;
  state: StackState;
};

export type StackTileWithResources = {
  __typename?: "StackTileWithResources";
  resourcesCount: Scalars["Int"]["output"];
  stackTile: StackTile;
};

export enum StackVendor {
  Ansible = "Ansible",
  CloudFormation = "CloudFormation",
  Kubernetes = "Kubernetes",
  OpenTofu = "OpenTofu",
  Pulumi = "Pulumi",
  Terraform = "Terraform",
  Terragrunt = "Terragrunt",
}

/** Configuration for vendor migration. Used when migrating stacks between vendor types */
export type StackVendorMigrationInput = {
  /** Labels to set on the stack after migration */
  labels: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Terragrunt-specific configuration */
  terragrunt: InputMaybe<TerragruntMigrationInput>;
};

export type StackWithAccessToSpaceEdge = {
  __typename?: "StackWithAccessToSpaceEdge";
  cursor: Scalars["String"]["output"];
  node: StackWithAccessToSpaceNode;
};

export type StackWithAccessToSpaceNode = {
  __typename?: "StackWithAccessToSpaceNode";
  /** Role grants that give this stack access to the queried space. Never empty. */
  roles: Array<StackSpaceAccessRoleGrant>;
  stack: SpaceAccessStack;
};

export type StacksAttentionTile = {
  __typename?: "StacksAttentionTile";
  stackTerragruntMigration: Maybe<StackTerragruntMigration>;
};

export type StacksWithAccessToSpaceOutput = {
  __typename?: "StacksWithAccessToSpaceOutput";
  edges: Array<StackWithAccessToSpaceEdge>;
  pageInfo: PageInfo;
};

/**
 * StateDownloadUrl represents a pre-signed URL that can be used to download
 * a stack's state file.
 */
export type StateDownloadUrl = {
  __typename?: "StateDownloadUrl";
  /** Pre-signed URL to use to download the state file. */
  url: Scalars["String"]["output"];
};

/**
 * StateDownloadUrlInput provides parameters for generating a pre-signed URL
 * to download a stack's state file.
 */
export type StateDownloadUrlInput = {
  /** ID of the stack to download state from. */
  stackId: Scalars["ID"]["input"];
  /**
   * Optional version of the state to download. When not provided, downloads
   * the latest state. Currently not supported - will return an error if provided.
   */
  version: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * StateUploadUrl represents a pre-signed URL that can be used to upload an
 * existing state file.
 */
export type StateUploadUrl = {
  __typename?: "StateUploadUrl";
  /** Temporary object ID to be passed when creating the Stack. */
  objectId: Scalars["String"]["output"];
  /** HTTP headers that should be sent with the upload request. */
  uploadHeaders: Maybe<StringMap>;
  /** Pre-signed URL to use to upload the file. */
  url: Scalars["String"]["output"];
};

export type StringMap = {
  __typename?: "StringMap";
  entries: Array<KeyValuePairType>;
};

export type StringMapInput = {
  entries: Array<KeyValuePair>;
};

/**
 * StripeSubscriptionStatus represents all states of a Stripe subscription.
 * https://docs.stripe.com/api/subscriptions/object#subscription_object-status
 * the convention of casing is kept to match the Stripe API.
 */
export enum StripeSubscriptionStatus {
  Active = "active",
  Cancelled = "cancelled",
  Incomplete = "incomplete",
  IncompleteExpired = "incomplete_expired",
  PastDue = "past_due",
  Unknown = "unknown",
  Unpaid = "unpaid",
}

export type SubscriptionInput = {
  /** Address visible on invoice */
  address: Scalars["String"]["input"];
  /** City visible on invoice */
  city: Scalars["String"]["input"];
  /** Company name */
  companyName: InputMaybe<Scalars["String"]["input"]>;
  /** ISO-3166-1 alpha-2 code of the country */
  country: Scalars["String"]["input"];
  /** Billing email */
  email: Scalars["String"]["input"];
  /** Full name of the representative */
  fullName: Scalars["String"]["input"];
  /** State name (US-only) */
  state: InputMaybe<Scalars["String"]["input"]>;
  /** Tax ID type (e.g., eu_vat, us_ein) */
  taxIDType: InputMaybe<Scalars["String"]["input"]>;
  /** Tax ID value */
  taxIDValue: InputMaybe<Scalars["String"]["input"]>;
  /** Zip code */
  zipCode: Scalars["String"]["input"];
};

export type SubscriptionUpdateV2Input = {
  /** addons that the subscription should have (can be ignored because it has not implemented yet). */
  addons: InputMaybe<Array<BillingAddonType>>;
  /** billing cycle interval the subscription should be changed to. */
  interval: InputMaybe<BillingCycleInterval>;
  /** billing tier the subscription should be changed to. */
  tier: BillingTier;
};

export type Template = {
  __typename?: "Template";
  /** Actions that the user can perform on this Template. */
  allowedActions: Array<Action>;
  /** Whether the template can be deleted (has no versions). */
  canDelete: Scalars["Boolean"]["output"];
  /**
   * Get template versions that are compatible upgrade targets from the specified version.
   * Returns only PUBLISHED versions that can be upgraded to from the given version.
   */
  compatibleVersions: Array<TemplateVersion>;
  /** CreatedAt is unix timestamp (in seconds) at which the template was created */
  createdAt: Scalars["Int"]["output"];
  /** Number of deployments for this template. */
  deploymentsCount: Scalars["Int"]["output"];
  /** Description of the template. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Template ID, used to identify a template by name (slug) */
  id: Scalars["ID"]["output"];
  /** Labels associated with the template. */
  labels: Array<Scalars["String"]["output"]>;
  /**
   * The highest published, non-deprecated template version, compared as semantic versions.
   * Based on creation time when version is not semver compliant.
   */
  latestVersion: Maybe<TemplateVersionSummary>;
  /** Name of the template */
  name: Scalars["String"]["output"];
  /** Search for template versions. */
  searchTemplateVersions: SearchTemplateVersionsOutput;
  /** Get search suggestions for template versions. */
  searchTemplateVersionsSuggestions: SearchSuggestionsOutput;
  /** Space to which this template belongs. */
  space: Space;
  /** Get a single template version by ID (slug or ULID). */
  templateVersion: Maybe<TemplateVersion>;
  /** Get a single template version by its version number. */
  templateVersionByNumber: Maybe<TemplateVersion>;
  /** Unique identifier of the template (ULID) */
  ulid: Scalars["String"]["output"];
  /** UpdatedAt is unix timestamp (in seconds) at which the template was updated */
  updatedAt: Scalars["Int"]["output"];
};

export type TemplateCompatibleVersionsArgs = {
  versionId: Scalars["ID"]["input"];
};

export type TemplateSearchTemplateVersionsArgs = {
  input: SearchInput;
};

export type TemplateSearchTemplateVersionsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type TemplateTemplateVersionArgs = {
  id: Scalars["ID"]["input"];
};

export type TemplateTemplateVersionByNumberArgs = {
  versionNumber: Scalars["String"]["input"];
};

export type TemplateCreateInput = {
  /** Template description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Initial version details */
  initialVersion: InputMaybe<InitialTemplateVersionInput>;
  /** Template labels */
  labels: Array<Scalars["String"]["input"]>;
  /** Template name */
  name: Scalars["String"]["input"];
  /** Space of the template. */
  space: Scalars["ID"]["input"];
};

export type TemplateDeployment = {
  __typename?: "TemplateDeployment";
  /** Actions that the user can perform on this TemplateDeployment. */
  allowedActions: Array<Action>;
  /** CreatedAt is unix timestamp (in seconds) at which the deployment was created */
  createdAt: Scalars["Int"]["output"];
  /** The type of deployment (REGULAR or TEST) */
  deploymentType: TemplateDeploymentType;
  /** Deployment description */
  description: Maybe<Scalars["String"]["output"]>;
  /** Deployment ID */
  id: Scalars["ID"]["output"];
  /** List of non-secret inputs used during deployment */
  inputs: Array<TemplateDeploymentInput>;
  /** Deployment name */
  name: Scalars["String"]["output"];
  /** Whether stacks will be deleted when the scheduled deletion fires (true by default) */
  scheduledDeleteStacks: Maybe<Scalars["Boolean"]["output"]>;
  /** The scheduled deletion timestamp for this deployment (unix seconds), if any */
  scheduledDeleteTimestamp: Maybe<Scalars["Int"]["output"]>;
  /** Search through the history of changes made to this deployment */
  searchChangeHistory: SearchTemplateDeploymentChangeHistoryOutput;
  /** The space where the deployment was created */
  space: Space;
  /** All stacks for this deployment */
  stacks: Array<TemplateDeploymentStack>;
  /** The state of the deployment that is calculated based on the state of the managed stacks in the deployment. */
  state: TemplateDeploymentState;
  /** The template used for deployment */
  template: TemplateDeploymentTemplate;
  /** The version number of the template used for deployment */
  templateVersion: TemplateDeploymentVersion;
};

export type TemplateDeploymentSearchChangeHistoryArgs = {
  input: SearchInput;
};

export type TemplateDeploymentChangeRecord = {
  __typename?: "TemplateDeploymentChangeRecord";
  /** Timestamp when this change was created */
  createdAt: Scalars["Int"]["output"];
  /** Change record ID (ULID) */
  id: Scalars["ID"]["output"];
  /** List of inputs at the time of this change */
  inputs: Array<TemplateDeploymentInput>;
  /** List of inputs before this change (null for the first change) */
  previousInputs: Maybe<Array<TemplateDeploymentInput>>;
  /** The template version before this change (null for the first change) */
  previousVersion: Maybe<TemplateDeploymentChangeRecordVersion>;
  /** The template version at the time of this change */
  version: TemplateDeploymentChangeRecordVersion;
};

export type TemplateDeploymentChangeRecordConnection = {
  __typename?: "TemplateDeploymentChangeRecordConnection";
  cursor: Scalars["String"]["output"];
  node: TemplateDeploymentChangeRecord;
};

export type TemplateDeploymentChangeRecordVersion = {
  __typename?: "TemplateDeploymentChangeRecordVersion";
  /** Template version ID */
  id: Scalars["ID"]["output"];
  /** Template version number */
  number: Maybe<Scalars["String"]["output"]>;
  /** Raw template of the template version */
  rawTemplate: Scalars["String"]["output"];
};

export type TemplateDeploymentConnection = {
  __typename?: "TemplateDeploymentConnection";
  cursor: Scalars["String"]["output"];
  node: TemplateDeployment;
};

export type TemplateDeploymentCreateInput = {
  /** Type of deployment. Defaults to REGULAR. TEST deployments allow deploying draft versions. */
  deploymentType: InputMaybe<TemplateDeploymentType>;
  /** Deployment description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Deployment inputs */
  inputs: Array<TemplateDeploymentCreateInputPair>;
  /** Deployment name */
  name: Scalars["String"]["input"];
  /** Space where the template will be deployed */
  space: Scalars["ID"]["input"];
};

export type TemplateDeploymentCreateInputPair = {
  id: Scalars["String"]["input"];
  value: InputMaybe<Scalars["String"]["input"]>;
};

export type TemplateDeploymentInput = {
  __typename?: "TemplateDeploymentInput";
  /** SHA256 checksum of the input value */
  checksum: Scalars["String"]["output"];
  /** Input ID */
  id: Scalars["ID"]["output"];
  /** Whether this is a secret input */
  secret: Scalars["Boolean"]["output"];
  /** Input value */
  value: Scalars["String"]["output"];
};

export type TemplateDeploymentStack = {
  __typename?: "TemplateDeploymentStack";
  /** Stack ID */
  id: Scalars["ID"]["output"];
  /** Stack name */
  name: Scalars["String"]["output"];
  /** Stack outputs */
  outputs: Array<StackOutput>;
  /** Stack state */
  state: StackState;
};

export enum TemplateDeploymentState {
  Destroying = "DESTROYING",
  DestroyingFailed = "DESTROYING_FAILED",
  Discarded = "DISCARDED",
  Failure = "FAILURE",
  Finished = "FINISHED",
  InProgress = "IN_PROGRESS",
  None = "NONE",
  Unconfirmed = "UNCONFIRMED",
}

export type TemplateDeploymentTemplate = {
  __typename?: "TemplateDeploymentTemplate";
  /** Template ID */
  id: Scalars["ID"]["output"];
};

export enum TemplateDeploymentType {
  Regular = "REGULAR",
  Test = "TEST",
}

export type TemplateDeploymentUpdateInput = {
  /** New description for the deployment */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Full replacement of deployment inputs. Empty array clears all inputs. */
  inputs: InputMaybe<Array<TemplateDeploymentUpdateInputPair>>;
  /** New name for the deployment (will not change the slug) */
  name: InputMaybe<Scalars["String"]["input"]>;
  /** The ID of the new template version to upgrade to */
  versionId: InputMaybe<Scalars["ID"]["input"]>;
};

export type TemplateDeploymentUpdateInputPair = {
  id: Scalars["String"]["input"];
  /**
   * If keepOldValue is set to true, the value will not be updated.
   * It's useful for secret values, where we don't want to overwrite the existing value.
   */
  keepOldValue: InputMaybe<Scalars["Boolean"]["input"]>;
  value: InputMaybe<Scalars["String"]["input"]>;
};

export type TemplateDeploymentUpgradeInput = {
  /** The ID of the new template version to upgrade to */
  versionId: Scalars["ID"]["input"];
};

export type TemplateDeploymentVersion = {
  __typename?: "TemplateDeploymentVersion";
  /** Template version ID */
  id: Scalars["ID"]["output"];
  /** Template version number */
  version: Maybe<Scalars["String"]["output"]>;
};

export type TemplateUpdateInput = {
  /** Template description */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** Template labels */
  labels: Array<Scalars["String"]["input"]>;
  /** Template name */
  name: Scalars["String"]["input"];
  /** Space of the template. */
  space: Scalars["ID"]["input"];
};

export type TemplateVersion = {
  __typename?: "TemplateVersion";
  /** Whether the template version can be deleted */
  canDelete: Scalars["Boolean"]["output"];
  /** CreatedAt is unix timestamp (in seconds) at which the template version was created */
  createdAt: Scalars["Int"]["output"];
  /** Indicates whether the template version has been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /** Number of deployments for this template version */
  deploymentsCount: Scalars["Int"]["output"];
  /** Unix timestamp (in seconds) at which this template version was deprecated, if at all. */
  deprecatedAt: Maybe<Scalars["Int"]["output"]>;
  /** Optional note explaining why this version was deprecated. */
  deprecationNote: Maybe<Scalars["String"]["output"]>;
  /** Template version ID, used to identify a template version by name (slug) */
  id: Scalars["ID"]["output"];
  /** Inputs of the template version. */
  inputs: Array<BlueprintInput>;
  /** Instructions for given template version. */
  instructions: Maybe<Scalars["String"]["output"]>;
  /** Labels associated with the template. */
  labels: Array<Scalars["String"]["output"]>;
  /** Name of the template */
  name: Scalars["String"]["output"];
  /** PublishedAt is unix timestamp (in seconds) at which the template version was published */
  publishedAt: Maybe<Scalars["Int"]["output"]>;
  /** RawTemplate of the template version. */
  rawTemplate: Scalars["String"]["output"];
  /** Space to which this template version belongs. */
  space: Space;
  /** List of keys that are used in the template. */
  stackKeys: Array<Scalars["String"]["output"]>;
  /** State of the template version. Published or Draft. */
  state: BlueprintState;
  /**
   * V2 template. For V1 templates, returns the migrated template with warnings.
   * For V2 templates, returns the raw template as-is with no warnings.
   */
  template: BlueprintTemplate;
  templateDetails: Template;
  /** Unique identifier of the template version (ULID) */
  ulid: Scalars["String"]["output"];
  /** UpdatedAt is unix timestamp (in seconds) at which the template version was updated */
  updatedAt: Scalars["Int"]["output"];
  version: Maybe<Scalars["String"]["output"]>;
};

export type TemplateVersionCreateInput = {
  /** Template version instructions. */
  instructions: InputMaybe<Scalars["String"]["input"]>;
  /** Labels associated with the template version. */
  labels: Array<Scalars["String"]["input"]>;
  /** Template version state (draft, published). */
  state: BlueprintState;
  /** Template body. */
  template: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the template this version belongs to. */
  templateID: Scalars["ID"]["input"];
  /** Version number. */
  versionNumber: Scalars["String"]["input"];
};

export type TemplateVersionDeprecateInput = {
  /** Optional note explaining why this version was deprecated. */
  note: InputMaybe<Scalars["String"]["input"]>;
};

/** Limited template version info returned for latest version queries. */
export type TemplateVersionSummary = {
  __typename?: "TemplateVersionSummary";
  /** Unix timestamp (in seconds) at which this template version was deprecated, if at all. */
  deprecatedAt: Maybe<Scalars["Int"]["output"]>;
  /** Optional note explaining why this version was deprecated. */
  deprecationNote: Maybe<Scalars["String"]["output"]>;
  /** Template version ID, used to identify a template version by name (slug) */
  id: Scalars["ID"]["output"];
  /** Unique identifier of the template version (ULID) */
  ulid: Scalars["String"]["output"];
  /** Version number of the template version */
  version: Maybe<Scalars["String"]["output"]>;
};

export type TemplateVersionUpdateInput = {
  /** Template version instructions. */
  instructions: InputMaybe<Scalars["String"]["input"]>;
  /** Labels associated with the template version. */
  labels: Array<Scalars["String"]["input"]>;
  /** Template version state (draft, published). */
  state: BlueprintState;
  /** Template body. */
  template: InputMaybe<Scalars["String"]["input"]>;
  /** Version number. */
  versionNumber: Scalars["String"]["input"];
};

export type TemplateVersionsConnection = {
  __typename?: "TemplateVersionsConnection";
  cursor: Scalars["String"]["output"];
  node: TemplateVersion;
};

export type TemplatesConnection = {
  __typename?: "TemplatesConnection";
  cursor: Scalars["String"]["output"];
  node: Template;
};

export type TermsAndConditionsVersion = {
  __typename?: "TermsAndConditionsVersion";
  content: Scalars["String"]["output"];
  version: Scalars["Int"]["output"];
};

/** Possible Terraform entity types. */
export type TerraformEntity = TerraformModule | TerraformOutput | TerraformResource;

/** Metadata for a Terraform module. */
export type TerraformModule = {
  __typename?: "TerraformModule";
  /**
   * This field exists solely for the purpose of adhering to the GraphQL spec,
   * which requires presence of at least one field in a type.
   */
  phantom: Scalars["Boolean"]["output"];
};

/** Metadata for a Terraform output. */
export type TerraformOutput = {
  __typename?: "TerraformOutput";
  /** Hash of the value, always available. */
  hash: Scalars["String"]["output"];
  /** If the output is marked as sensitive. */
  sensitive: Scalars["Boolean"]["output"];
  /** Value of the output. Only available if it's not marked as sensitive, we don't store it otherwise. */
  value: Maybe<Scalars["String"]["output"]>;
};

/**
 * TerraformProvider represents a Terraform provider managed using Spacelift's
 * Terraform provider registry.
 */
export type TerraformProvider = {
  __typename?: "TerraformProvider";
  /** Actions that the user can perform on this TerraformProvider. */
  allowedActions: Array<Action>;
  /** Creation timestamp of the provider. */
  createdAt: Scalars["Int"]["output"];
  /** Whether the provider has just been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /**
   * Human-readable description of the provider, if set by the user. Supports
   * Markdown.
   */
  description: Maybe<Scalars["String"]["output"]>;
  /** Immutable ID of the provider, unique within the scope of a single account. */
  id: Scalars["ID"]["output"];
  /** Set of labels attached to the provider. */
  labels: Array<Scalars["String"]["output"]>;
  /** The semver number of the last version of the provider that was published. */
  latestVersionNumber: Maybe<Scalars["String"]["output"]>;
  /** Whether the provider can be consumed outside of this account. */
  public: Scalars["Boolean"]["output"];
  /** ID of the space this provider belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this provider belongs to. */
  spaceDetails: Space;
  /** Last update timestamp of the provider. */
  updatedAt: Scalars["Int"]["output"];
  /** Get a particular version by its semver number. */
  version: Maybe<TerraformProviderVersion>;
  /** List of versions of the provider. */
  versions: Array<TerraformProviderVersion>;
};

/**
 * TerraformProvider represents a Terraform provider managed using Spacelift's
 * Terraform provider registry.
 */
export type TerraformProviderVersionArgs = {
  number: Scalars["String"]["input"];
};

/** Documentation file metadata */
export type TerraformProviderDoc = {
  __typename?: "TerraformProviderDoc";
  /** Filename of the documentation file */
  filename: Scalars["String"]["output"];
  /** Key (full path) of the documentation file */
  key: Scalars["String"]["output"];
  /** Type of documentation (guide, resource, data source) */
  type: TerraformProviderDocType;
};

/** Type of Terraform provider documentation */
export enum TerraformProviderDocType {
  /** Data source documentation */
  DataSource = "DATA_SOURCE",
  /** Provider overview documentation */
  Overview = "OVERVIEW",
  /** Resource documentation */
  Resource = "RESOURCE",
  /** Unknown/unclassified documentation */
  Unknown = "UNKNOWN",
}

/** Documentation for a Terraform provider version */
export type TerraformProviderDocs = {
  __typename?: "TerraformProviderDocs";
  /** Get content for a specific documentation file by key */
  content: Scalars["String"]["output"];
  /** All documentation files with metadata */
  files: Array<TerraformProviderDoc>;
  /**
   * Convenience field that returns the content of the overview documentation file.
   * Returns empty string if no overview doc exists or if there's an error fetching it.
   * This allows the frontend to always display other docs even if overview is unavailable.
   */
  overviewContent: Scalars["String"]["output"];
};

/** Documentation for a Terraform provider version */
export type TerraformProviderDocsContentArgs = {
  key: Scalars["String"]["input"];
};

/** Platform supported by Spacelift. */
export type TerraformProviderPlatform = {
  __typename?: "TerraformProviderPlatform";
  /** Architecture of the platform. */
  architecture: Scalars["String"]["output"];
  /** Operating system of the platform. */
  os: Scalars["String"]["output"];
};

/** A single version of a managed Terraform provider. */
export type TerraformProviderVersion = {
  __typename?: "TerraformProviderVersion";
  /** Actions that the user can perform on this TerraformProviderVersion. */
  allowedActions: Array<Action>;
  /** Temporary presigned URL for downloading the artifact. */
  artifactDownloadUrl: Scalars["String"]["output"];
  /** List of artifacts associated with this provider version. */
  artifacts: Array<TerraformProviderVersionArtifact>;
  /** Creation timestamp of the provider version. */
  createdAt: Scalars["Int"]["output"];
  /** Indicates whether the version is deleted. */
  deleted: Scalars["Boolean"]["output"];
  /**
   * Free-form, human-readable description of the provider version. Supports
   * Markdown. Can be used for info like release notes, changelog, warnings or
   * deprecations.
   */
  description: Maybe<Scalars["String"]["output"]>;
  /** Documentation for this provider version. */
  docs: TerraformProviderDocs;
  /** Immutable, globally unique ID of the provider version. */
  id: Scalars["ID"]["output"];
  /** Semantically versioned number. */
  number: Scalars["String"]["output"];
  /** List of platforms for which the provider was built. */
  platforms: Array<TerraformProviderPlatform>;
  /**
   * List of Terraform plugin protocol versions supported by the provider
   * binaries.
   */
  protocolVersions: Array<Scalars["String"]["output"]>;
  /** ID of the GPG key used to sign provider binaries. */
  signingKeyId: Scalars["ID"]["output"];
  /** Current status of the Terraform provider version. */
  status: TerraformProviderVersionStatus;
  /** Last update timestamp of the provider version. */
  updatedAt: Scalars["Int"]["output"];
  /**
   * Failure message from the last failed verification attempt.
   * Null means no verification has been attempted yet, or the last attempt succeeded
   * (if verifiedAt is set).
   */
  verificationFailure: Maybe<Scalars["String"]["output"]>;
  /**
   * Timestamp at which the artifacts were verified (GPG signature + checksums).
   * Null means the version has not been verified yet.
   */
  verifiedAt: Maybe<Scalars["Int"]["output"]>;
};

/** A single version of a managed Terraform provider. */
export type TerraformProviderVersionArtifactDownloadUrlArgs = {
  filename: Scalars["String"]["input"];
};

/** A single artifact associated with a Terraform provider version. */
export type TerraformProviderVersionArtifact = {
  __typename?: "TerraformProviderVersionArtifact";
  /** Name of the artifact. */
  filename: Scalars["String"]["output"];
  /** Artifact size in bytes. */
  sizeBytes: Scalars["Int"]["output"];
};

export type TerraformProviderVersionInput = {
  /** Semantically versioned number, unique for this provider. */
  number: Scalars["String"]["input"];
  /**
   * List of Terraform plugin protocol versions supported by the provider
   * binaries. These must correspond to whatever is supported by Terraform, and
   * Spacelift does not validate these; Terraform will. You can learn more about
   * Terraform plugin protocol versions at https://developer.hashicorp.com/terraform/plugin/how-terraform-works#terraform-plugin-protocol
   */
  protocolVersions: Array<Scalars["String"]["input"]>;
  /** Hex-encoded SHA 256 checksum of the checksums file. */
  shaSumsFileSHA: Scalars["String"]["input"];
  /** Hex-encoded SHA 256 checksum of the checksums signature file. */
  signatureFileSHA: Scalars["String"]["input"];
  /**
   * ID of the GPG key used to sign the provider binaries. This key must be
   * registered with the Spacelift account, and may not be revoked.
   */
  signingKeyId: Scalars["ID"]["input"];
};

export type TerraformProviderVersionPlatformInput = {
  /**
   * CPU architecture for which the provider binary is built. Note that Spacelift
   * does not validate the correctness of the reported architecture; Terraform
   * will do it.
   */
  architecture: Scalars["String"]["input"];
  /** Hex-encoded SHA 256 checksum of the zip archive. */
  archiveChecksum: Scalars["String"]["input"];
  /** Hex-encoded SHA 256 checksum of the archived binary. */
  binaryChecksum: Scalars["String"]["input"];
  /**
   * Operating system for which the provider binary is built. Note that Spacelift
   * does not validate the correctness of the reported operating system;
   * Terraform will do it.
   */
  os: Scalars["String"]["input"];
};

export type TerraformProviderVersionRegisterPlatformV2Output = {
  __typename?: "TerraformProviderVersionRegisterPlatformV2Output";
  uploadHeaders: Maybe<StringMap>;
  uploadUrl: Scalars["String"]["output"];
};

/** Current status of the Terraform provider version. */
export enum TerraformProviderVersionStatus {
  /** The version currently being built. */
  Draft = "DRAFT",
  /** The version is published, and ready to be used. */
  Published = "PUBLISHED",
  /** The version has been revoked and can no longer be used. */
  Revoked = "REVOKED",
}

/** Metadata for a Terraform resource. */
export type TerraformResource = {
  __typename?: "TerraformResource";
  /** Address in module. */
  address: Scalars["String"]["output"];
  /** Mode of resource. */
  mode: Scalars["String"]["output"];
  /** Module the resource is in. */
  module: Scalars["String"]["output"];
  /** Provider the resource stems from. */
  provider: Scalars["String"]["output"];
  /** Taint status. */
  tainted: Scalars["Boolean"]["output"];
  /** Property values. As a JSON-encoded string. */
  values: Scalars["String"]["output"];
};

export type TerraformRuntimeConfig = {
  __typename?: "TerraformRuntimeConfig";
  /**
   * The version of the tool used (e.g. OpenTofu or Terraform)
   * If the tool is CUSTOM, it's not defined.
   */
  version: Maybe<Scalars["String"]["output"]>;
  /** Defines the tool that will be used to execute the workflow. */
  workflowTool: TerraformWorkflowTool;
};

export enum TerraformWorkflowTool {
  /** A custom workflow tool. */
  Custom = "CUSTOM",
  /** OpenTofu. */
  OpenTofu = "OPEN_TOFU",
  /** The open source licensed version of Terraform. */
  TerraformFoss = "TERRAFORM_FOSS",
}

/** Configuration options specific to Terragrunt vendor migration. */
export type TerragruntMigrationInput = {
  terragruntVersion: InputMaybe<Scalars["String"]["input"]>;
};

export type TerragruntRuntimeConfig = {
  __typename?: "TerragruntRuntimeConfig";
  /**
   * Controls whether module names are prefixed to resource and output keys for non-run-all stacks.
   * Has no effect when useRunAll is enabled (always prefixes in that case).
   */
  prefixResourceNamesWithModuleName: Maybe<Scalars["Boolean"]["output"]>;
  /** The version of the tool used by Terragrunt (e.g. OpenTofu or Terraform). */
  terraformVersion: Maybe<Scalars["String"]["output"]>;
  /** The Terragrunt version used. */
  terragruntVersion: Scalars["String"]["output"];
  /** The underlying tool executed by Terragrunt for the run. */
  tool: TerragruntTool;
  /** Indicates whether the run used Terragrunt run-all. */
  useRunAll: Scalars["Boolean"]["output"];
  /** Indicates whether smart-sanitization was enabled for the run. */
  useSmartSanitization: Scalars["Boolean"]["output"];
  useStateManagement: Scalars["Boolean"]["output"];
};

/** TerragruntTool defines the underlying tool run by Terragrunt. */
export enum TerragruntTool {
  /**
   * Indicates that no tool will automatically be downloaded or configured, and that users are
   * reponsible for manually provisioning the tool themselves, for example via a custom runner
   * image or a pre-init hook.
   */
  ManuallyProvisioned = "MANUALLY_PROVISIONED",
  /** OpenTofu. */
  OpenTofu = "OPEN_TOFU",
  /** The open source licensed version of Terraform. */
  TerraformFoss = "TERRAFORM_FOSS",
}

/** Represents a Tofu/Terraform workspace used for local development. */
export type TofuWorkspace = {
  __typename?: "TofuWorkspace";
  /** Unix timestamp when the workspace was created. */
  createdAt: Scalars["Int"]["output"];
  /** Unique identifier of the workspace. */
  id: Scalars["ID"]["output"];
  /** Whether the workspace is currently locked. */
  isLocked: Scalars["Boolean"]["output"];
  /** User who locked the workspace, if locked. */
  lockedBy: Maybe<Scalars["String"]["output"]>;
  /** Name of the workspace. */
  name: Scalars["String"]["output"];
};

/** Response type for unlocking all Tofu workspaces in a stack. */
export type TofuWorkspaceUnlockAllResponse = {
  __typename?: "TofuWorkspaceUnlockAllResponse";
  /** List of workspaces that were successfully unlocked. */
  unlockedWorkspaces: Array<TofuWorkspace>;
};

export type TofuWorkspacesConnection = {
  __typename?: "TofuWorkspacesConnection";
  cursor: Scalars["String"]["output"];
  node: TofuWorkspace;
};

export type Usage = {
  __typename?: "Usage";
  /** Number of minutes that can be used within the billing period. */
  allowedMinutes: Scalars["Int"]["output"];
  /** Number of users who can log in within the billing period. */
  allowedSeats: Scalars["Int"]["output"];
  /** The end date of the current billing period. */
  billingPeriodEnd: Maybe<Scalars["Int"]["output"]>;
  /** The start date of the current billing period. */
  billingPeriodStart: Maybe<Scalars["Int"]["output"]>;
  /** Logins of users who logged in to any of the stack */
  logins: Array<UserLogin>;
  /** The unit amount (in cents) to be charged per run-minute. */
  pricePerRunMinute: Maybe<Scalars["Int"]["output"]>;
  /** The unit amount (in cents) to be charged per seat monthly */
  pricePerSeat: Maybe<Scalars["Int"]["output"]>;
  /** The unit amount (in cents) to be charged per worker monthly */
  pricePerWorker: Maybe<Scalars["Int"]["output"]>;
  /** The unit amount (in cents) to be monthly charged for the subscription */
  subscriptionPrice: Maybe<Scalars["Int"]["output"]>;
  /** Cost forecast of the upcoming invoice. */
  upcomingInvoiceTotalAmount: Scalars["Int"]["output"];
  /** Number of minutes used within the current billing period. */
  usedMinutes: Scalars["Int"]["output"];
  /** Number of private minutes used within the current billing period. */
  usedPrivateMinutes: Scalars["Int"]["output"];
  /** Number of public minutes used within the current billing period. */
  usedPublicMinutes: Scalars["Int"]["output"];
  /** Number of users who last logged in during current billing period. */
  usedSeats: Scalars["Int"]["output"];
  /** Maximum number of concurrent self-hosted workers in the current billing period. */
  usedWorkers: Scalars["Int"]["output"];
};

/** Spacelift user. */
export type User = {
  __typename?: "User";
  /** actions that the user can perform in spaces. */
  actions: Array<SpaceActions>;
  /** Whether the user has org-wide admin privileges. */
  admin: Scalars["Boolean"]["output"];
  /** List of API keys created by the user. */
  apiKeys: Array<ApiKey>;
  /** URL of the user avatar. */
  avatarURL: Scalars["String"]["output"];
  /**
   * Whether the current user may create a personal API key right now. Runs the
   * same checks as personalApiKeyCreate.
   */
  canCreatePersonalApiKey: Scalars["Boolean"]["output"];
  /** Whether the access policies can be evaluated for this user. */
  cannotEvaluateAccessPolicies: Scalars["Boolean"]["output"];
  /** Email of the user, may be empty. */
  email: Scalars["String"]["output"];
  /** Username. */
  id: Scalars["ID"]["output"];
  /** V2 identity for the current user, if available. */
  identity: Maybe<Identity>;
  /** Identity provider. */
  identityProvider: Scalars["String"]["output"];
  /** Indicates whether the user is the first to log in for this account. Is guaranteed to be true only for the first user to log in and before any other user has logged in. */
  isFirstUser: Scalars["Boolean"]["output"];
  /** Temporary access token as a string. */
  jwt: Scalars["String"]["output"];
  /** Full name of the GitHub user. */
  name: Scalars["String"]["output"];
  /**
   * List of personal API keys owned by the user. Unlike apiKeys, this does not
   * depend on the account allowing non-root API keys.
   */
  ownedApiKeys: Array<ApiKey>;
  /** Returns list of the security keys for the current user. */
  securityKeys: Array<SecurityKey>;
  /** Timestamp of the first login, only populated for human users. */
  since: Maybe<Scalars["Int"]["output"]>;
  /** Team names which the user has access to. */
  teams: Array<Scalars["String"]["output"]>;
  /** Unix timestamp of token validity expiration. */
  validUntil: Scalars["Int"]["output"];
};

export type UserGroupRoleBinding = {
  __typename?: "UserGroupRoleBinding";
  id: Scalars["ID"]["output"];
  roleID: Scalars["ID"]["output"];
  space: Space;
  /** @deprecated Use space field instead. */
  spaceID: Scalars["ID"]["output"];
  userGroup: ManagedUserGroup;
  /** @deprecated Use userGroup field instead. */
  userGroupID: Scalars["ID"]["output"];
};

export type UserGroupRoleBindingBatchInput = {
  /** List of user group role bindings to create. */
  bindings: Array<UserGroupRoleBindingInput>;
};

export type UserGroupRoleBindingInput = {
  /** ID of the role. */
  roleID: Scalars["ID"]["input"];
  /** ID of the space. */
  spaceID: Scalars["ID"]["input"];
  /** ID of the user group. */
  userGroupID: Scalars["ID"]["input"];
};

/**
 * A role grant giving a group access to a space. Always a direct binding on
 * the group, there is no grantedVia union like UserSpaceAccessRoleGrant.
 */
export type UserGroupSpaceAccessRoleGrant = {
  __typename?: "UserGroupSpaceAccessRoleGrant";
  /** True when the grant lives on an ancestor space rather than the queried space. */
  propagated: Scalars["Boolean"]["output"];
  role: Role;
  space: Space;
};

export enum UserGroupStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type UserGroupWithAccessToSpaceEdge = {
  __typename?: "UserGroupWithAccessToSpaceEdge";
  cursor: Scalars["String"]["output"];
  node: UserGroupWithAccessToSpaceNode;
};

export type UserGroupWithAccessToSpaceNode = {
  __typename?: "UserGroupWithAccessToSpaceNode";
  roles: Array<UserGroupSpaceAccessRoleGrant>;
  userGroup: ManagedUserGroup;
};

export type UserGroupsWithAccessToSpaceOutput = {
  __typename?: "UserGroupsWithAccessToSpaceOutput";
  edges: Array<UserGroupWithAccessToSpaceEdge>;
  pageInfo: PageInfo;
};

/** UserGuide represents a user guide with steps */
export type UserGuide = {
  __typename?: "UserGuide";
  /** The chapter this guide belongs to */
  chapter: UserGuideChapter;
  /** Completion information for the guide */
  completion: UserGuideCompletion;
  /** ID of the group this guide belongs to (for navigation back to the group) */
  groupId: Scalars["ID"]["output"];
  /** Unique identifier for the guide */
  id: Scalars["ID"]["output"];
  /** Metadata about the guide */
  metadata: UserGuideMetadata;
  /** Order of the guide in the chapter */
  order: Scalars["Int"]["output"];
  /** Detailed prerequisite guide information with completion status */
  prerequisiteGuides: UserGuidePrerequisites;
  /** URL-friendly slug for the guide */
  slug: Scalars["String"]["output"];
  /** Steps in the guide */
  steps: Array<UserGuideStep>;
};

/** UserGuideCertification represents a certificate with full details */
export type UserGuideCertification = {
  __typename?: "UserGuideCertification";
  /** The course for which the certificate was issued */
  course: Scalars["String"]["output"];
  /** Description of the user guide group associated with the certificate */
  description: Maybe<Scalars["String"]["output"]>;
  /** Name shown on the certificate */
  displayName: Scalars["String"]["output"];
  /** ID of the user guide group associated with the certificate */
  groupID: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier (ULID) */
  id: Scalars["ID"]["output"];
  /** Unix timestamp of when the certificate was issued */
  issuedAt: Scalars["Int"]["output"];
  /** Login of the user who claimed the certificate */
  userLogin: Scalars["String"]["output"];
};

/** UserGuideChapter represents a chapter within a user guide group */
export type UserGuideChapter = {
  __typename?: "UserGuideChapter";
  /** Description of the chapter */
  description: Scalars["String"]["output"];
  /** List of guides in this chapter */
  guides: Array<UserGuide>;
  /** Unique identifier for the chapter */
  id: Scalars["ID"]["output"];
  /** Name of the chapter */
  name: Scalars["String"]["output"];
  /** Order of the chapter in the group */
  order: Scalars["Int"]["output"];
};

/** UserGuideCompletion contains completion information */
export type UserGuideCompletion = {
  __typename?: "UserGuideCompletion";
  /** List of recommended guide IDs to show next */
  recommendedGuideIds: Array<Scalars["ID"]["output"]>;
  /** Success message shown on completion */
  successMessage: Scalars["String"]["output"];
};

/** UserGuideDoc represents a documentation link */
export type UserGuideDoc = {
  __typename?: "UserGuideDoc";
  /** Title of the documentation */
  title: Scalars["String"]["output"];
  /** URL of the documentation */
  url: Scalars["String"]["output"];
};

/** UserGuideGroup represents a grouping of user guides */
export type UserGuideGroup = {
  __typename?: "UserGuideGroup";
  /** List of chapters in this group */
  chapters: Array<UserGuideChapter>;
  /** Description of the group */
  description: Scalars["String"]["output"];
  /** Unique identifier for the group */
  id: Scalars["ID"]["output"];
  /** Name of the group */
  name: Scalars["String"]["output"];
  /** Order of the group in the list */
  order: Scalars["Int"]["output"];
  /**
   * Entitlements the account must have to access every guide in this
   * group. An empty list means the group is available to every
   * account. The frontend can intersect this with the account's
   * tierFeatures to decide whether the group should be gated.
   */
  requiredEntitlements: Array<BillingTierFeature>;
  /** The skill level of the guide group */
  skillLevel: Maybe<UserGuideGroupSkillLevel>;
};

/** UserGuideGroupSkillLevel represents the difficulty/skill level of a user guide group */
export enum UserGuideGroupSkillLevel {
  Beginner = "BEGINNER",
  Commander = "COMMANDER",
  Enabler = "ENABLER",
  Guardian = "GUARDIAN",
}

/** UserGuideMetadata contains guide metadata */
export type UserGuideMetadata = {
  __typename?: "UserGuideMetadata";
  /** Description of the guide */
  description: Scalars["String"]["output"];
  /** Difficulty level of the guide */
  difficulty: Scalars["String"]["output"];
  /** Labels of the guide */
  labels: Array<Scalars["String"]["output"]>;
  /** Estimated time to complete the guide in minutes */
  minutesToComplete: Scalars["Int"]["output"];
  /** Prerequisites for the guide */
  prerequisites: Array<Scalars["String"]["output"]>;
  /** Title of the guide */
  title: Scalars["String"]["output"];
};

/** UserGuidePrerequisites contains prerequisite completion status */
export type UserGuidePrerequisites = {
  __typename?: "UserGuidePrerequisites";
  /** All prerequisite guides required for this guide */
  all: Array<UserGuide>;
  /** Prerequisite guides that have been completed by the user */
  completed: Array<UserGuide>;
  /** Prerequisite guides that have not yet been completed */
  uncompleted: Array<UserGuide>;
};

/** UserGuideProgress tracks user progress through a guide */
export type UserGuideProgress = {
  __typename?: "UserGuideProgress";
  /** Timestamp when the guide was completed */
  completedAt: Maybe<Scalars["Int"]["output"]>;
  /** Steps completed so far */
  completedSteps: Array<UserGuideStep>;
  /** Current step index */
  currentStep: Scalars["Int"]["output"];
  /** The guide being tracked */
  guide: UserGuide;
  /** Progress percentage (0-100) */
  progressPercent: Scalars["Float"]["output"];
  /** Timestamp when the guide was started */
  startedAt: Maybe<Scalars["Int"]["output"]>;
  /** Current status of the guide progress */
  status: UserGuideStatus;
};

/** UserGuideStatus represents the status of a user guide */
export enum UserGuideStatus {
  Abandoned = "ABANDONED",
  Completed = "COMPLETED",
  Invalid = "INVALID",
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
}

/** UserGuideStep represents a single step in a guide */
export type UserGuideStep = {
  __typename?: "UserGuideStep";
  /** Documentation links for the step */
  docs: Array<UserGuideDoc>;
  /** Optional hint for the step */
  hint: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier for the step */
  id: Scalars["ID"]["output"];
  /** Instruction for the step */
  instruction: Scalars["String"]["output"];
  /** Order of the step in the guide */
  order: Scalars["Int"]["output"];
  /** Title of the step */
  title: Scalars["String"]["output"];
};

/** UserLogin represents the last login attempt for a single GitHub user. */
export type UserLogin = {
  __typename?: "UserLogin";
  /** Last login timestamp. */
  timestamp: Scalars["Int"]["output"];
  /** GitHub username of the user. */
  username: Scalars["String"]["output"];
};

export enum UserRole {
  Admin = "ADMIN",
  Owner = "OWNER",
  User = "USER",
}

export type UserRoleBinding = {
  __typename?: "UserRoleBinding";
  id: Scalars["ID"]["output"];
  role: Role;
  roleID: Scalars["ID"]["output"];
  space: Space;
  /** @deprecated Use space field instead. */
  spaceID: Scalars["ID"]["output"];
  user: ManagedUser;
  userID: Scalars["ID"]["output"];
};

export type UserRoleBindingBatchInput = {
  /** List of user role bindings to create. */
  bindings: Array<UserRoleBindingInput>;
};

export type UserRoleBindingInput = {
  /** ID of the role. */
  roleID: Scalars["ID"]["input"];
  /** ID of the space. */
  spaceID: Scalars["ID"]["input"];
  /** ID of the user. */
  userID: Scalars["ID"]["input"];
};

export type UserSessionsWithAccessToSpaceEdge = {
  __typename?: "UserSessionsWithAccessToSpaceEdge";
  cursor: Scalars["String"]["output"];
  node: UserSessionsWithAccessToSpaceNode;
};

export type UserSessionsWithAccessToSpaceNode = {
  __typename?: "UserSessionsWithAccessToSpaceNode";
  roles: Array<SessionSpaceAccessRoleGrant>;
  user: SpaceAccessSessionUser;
};

export type UserSessionsWithAccessToSpaceOutput = {
  __typename?: "UserSessionsWithAccessToSpaceOutput";
  edges: Array<UserSessionsWithAccessToSpaceEdge>;
  pageInfo: PageInfo;
};

/** A role grant giving a user access to a space, either directly or via a group they belong to. */
export type UserSpaceAccessRoleGrant = {
  __typename?: "UserSpaceAccessRoleGrant";
  grantedVia: SpaceAccessGrantVia;
  /** True when the grant lives on an ancestor space rather than the queried space. */
  propagated: Scalars["Boolean"]["output"];
  role: Role;
  space: Space;
};

export enum UserStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Queued = "QUEUED",
}

export type UsersWithAccessToSpaceEdge = {
  __typename?: "UsersWithAccessToSpaceEdge";
  cursor: Scalars["String"]["output"];
  node: UsersWithAccessToSpaceNode;
};

export type UsersWithAccessToSpaceNode = {
  __typename?: "UsersWithAccessToSpaceNode";
  roles: Array<UserSpaceAccessRoleGrant>;
  user: ManagedUser;
};

export type UsersWithAccessToSpaceOutput = {
  __typename?: "UsersWithAccessToSpaceOutput";
  edges: Array<UsersWithAccessToSpaceEdge>;
  pageInfo: PageInfo;
};

/** VCSAgentConnection represents a single connection from a VCS Agent. */
export type VcsAgentConnection = {
  __typename?: "VCSAgentConnection";
  /** Globally unique, immutable ID of the agent connection. */
  id: Scalars["ID"]["output"];
  /** Metadata associated with the agent connection. */
  metadata: Maybe<Scalars["String"]["output"]>;
};

export type VcsAgentPool = {
  __typename?: "VCSAgentPool";
  /** List of agent connections belonging to this VCSAgentPool. */
  agentConnections: Array<VcsAgentConnection>;
  /**
   * Config represents a configuration for the agents that must be passed to the agents.
   * Only available right after creation or reset.
   */
  config: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the VCSAgentPool has just been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /** Optional description of the VCSAgentPool, supports markdown. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Globally unique, immutable ID of the VCSAgentPool. */
  id: Scalars["ID"]["output"];
  /** Mutable name of the VCSAgentPool, unique within the scope of a single account. */
  name: Scalars["String"]["output"];
};

export enum VcsCheck {
  /** a single VCS check aggregating all the stacks checks */
  Aggregated = "AGGREGATED",
  /** INDIVIDUAL and AGGREGATED checks */
  All = "ALL",
  /** a VCS check for each stack */
  Individual = "INDIVIDUAL",
}

/** Additional options for configuring VCS check behavior. */
export type VcsCheckOptions = {
  __typename?: "VCSCheckOptions";
  /** When true, individual check runs are only sent when a run reaches a non-success terminal state. */
  individualFailuresOnly: Scalars["Boolean"]["output"];
  /** When true, individual check runs are only sent for runs that plan changes; runs with no changes are skipped (failures are still sent). */
  individualSkipUnchanged: Scalars["Boolean"]["output"];
};

/** Input for configuring additional VCS check options. */
export type VcsCheckOptionsInput = {
  /** When true, individual check runs are only sent when a run reaches a non-success terminal state. */
  individualFailuresOnly: InputMaybe<Scalars["Boolean"]["input"]>;
  /** When true, individual check runs are only sent for runs that plan changes; runs with no changes are skipped (failures are still sent). */
  individualSkipUnchanged: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VcsIntegration = {
  __typename?: "VCSIntegration";
  /** CreatedAt is unix timestamp (in seconds) at which the blueprint was created */
  createdAt: Scalars["Int"]["output"];
  /** Free-form description of the integration. */
  description: Scalars["String"]["output"];
  /** Provider-specific data is available only with admin access. */
  details: Maybe<VcsIntegrationDetails>;
  /**
   * The ID of the integration. Unique per Spacelift account and VCS type. NOTE: this
   * field will not be populated for the managed GitHub provider (`GITHUB`), but will
   * be populated for all other provider types.
   */
  id: Scalars["ID"]["output"];
  /**
   * Whether the integration is the default integration for the VCS provider type. Only
   * one default integration may exist per account and VCS type.
   */
  isDefault: Scalars["Boolean"]["output"];
  /** Any labels attached to the integration. */
  labels: Array<Scalars["String"]["output"]>;
  /** The name of the integration. */
  name: Scalars["String"]["output"];
  /** The VCS provider that this integration supports. */
  provider: VcsProvider;
  /** Search stacks/modules using this VCS integration. */
  searchUsers: SearchVcsIntegrationUsersOutput;
  /** Search stacks/modules suggestions using this VCS integration. */
  searchUsersSuggestions: SearchSuggestionsOutput;
  /**
   * The space this VCS integration belongs to. Default integrations always belong to the
   * root space.
   */
  space: Space;
  /** UpdatedAt is unix timestamp (in seconds) at which the integration was updated */
  updatedAt: Scalars["Int"]["output"];
};

export type VcsIntegrationSearchUsersArgs = {
  input: SearchInput;
};

export type VcsIntegrationSearchUsersSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

export type VcsIntegrationCheck = {
  __typename?: "VCSIntegrationCheck";
  metadata: Maybe<VcsIntegrationTestResultMetadata>;
  status: VcsIntegrationTestStatus;
  type: VcsIntegrationTestType;
};

export type VcsIntegrationDetails =
  | AzureDevOpsRepoIntegration
  | BitbucketCloudIntegration
  | BitbucketDatacenterIntegration
  | BlobStorageIntegration
  | GithubEnterpriseIntegration
  | GithubIntegration
  | GitlabIntegration
  | OriginIntegration;

export type VcsIntegrationTestResult = {
  __typename?: "VCSIntegrationTestResult";
  checks: Array<VcsIntegrationCheck>;
  status: VcsIntegrationTestStatus;
};

export type VcsIntegrationTestResultMetadata = {
  __typename?: "VCSIntegrationTestResultMetadata";
  githubAppEvents: Array<Scalars["String"]["output"]>;
  permissions: Array<Scalars["String"]["output"]>;
  reason: Maybe<Scalars["String"]["output"]>;
  webHooks: Maybe<VcsIntegrationTestResultMetadataWebhooks>;
};

export type VcsIntegrationTestResultMetadataWebhooks = {
  __typename?: "VCSIntegrationTestResultMetadataWebhooks";
  actual: Scalars["String"]["output"];
  expected: Scalars["String"]["output"];
};

export enum VcsIntegrationTestStatus {
  Fail = "FAIL",
  Success = "SUCCESS",
}

export enum VcsIntegrationTestType {
  Connection = "CONNECTION",
  GithubAppEvents = "GITHUB_APP_EVENTS",
  Permissions = "PERMISSIONS",
  Webhook = "WEBHOOK",
}

/** VCSIntegrationUser represents a user (module or stacks) of the VCS integration. */
export type VcsIntegrationUser = {
  __typename?: "VCSIntegrationUser";
  /** True if the attached project is a module. */
  isModule: Scalars["Boolean"]["output"];
  /** Space details of the attached stack or module. */
  spaceDetails: Space;
  /** Slug of the attached stack or module. */
  stackId: Scalars["ID"]["output"];
  /** Name of the attached stack or module. */
  stackName: Scalars["String"]["output"];
};

/** VCSIntegrationUserConnection represents a single stack/module in a page of results for a VCS integration. */
export type VcsIntegrationUserConnection = {
  __typename?: "VCSIntegrationUserConnection";
  cursor: Scalars["String"]["output"];
  node: VcsIntegrationUser;
};

export type VcsIntegrationsConnection = {
  __typename?: "VCSIntegrationsConnection";
  cursor: Scalars["String"]["output"];
  node: VcsIntegration;
};

/** VCSProvider is the type of VCS provider. */
export enum VcsProvider {
  /** Azure DevOps. */
  AzureDevops = "AZURE_DEVOPS",
  /** Bitbucket Cloud (bitbucket.org). */
  BitbucketCloud = "BITBUCKET_CLOUD",
  /** Self-hosted Bitbucket Datacenter. */
  BitbucketDatacenter = "BITBUCKET_DATACENTER",
  /** Blob Storage VCS provider reading commit archives from an object store. */
  Blob = "BLOB",
  /** Git link VCS provider. */
  Git = "GIT",
  /** Managed GitHub (github.com). */
  Github = "GITHUB",
  /**
   * GitHub Enterprise - either self-hosted or as an extra organization on
   * github.com.
   */
  GithubEnterprise = "GITHUB_ENTERPRISE",
  /** GitLab - either self-hosted or managed (gitlab.com). */
  Gitlab = "GITLAB",
  /** Origin - Cursor's git platform, integrated via a global Spacelift-owned app. */
  Origin = "ORIGIN",
  /** Spacelift-managed virtual VCS provider used for onboarding new users. */
  Showcase = "SHOWCASE",
  /** Spacelift-native VCS provider with files stored in database. */
  Spacelift = "SPACELIFT",
}

/** Version represents a single version of the Module. */
export type Version = {
  __typename?: "Version";
  /** Commit which triggered this version. */
  commit: Commit;
  /** Number of stacks, regardless of account, using this module version. */
  consumerCount: Scalars["Int"]["output"];
  /** Stacks in your account which use this module version. */
  consumers: Array<Stack>;
  /** CreatedAt is unix timestamp (in seconds) at which the version was created */
  createdAt: Scalars["Int"]["output"];
  /**
   * Link to the source code to download the version. Will only work for ACTIVE
   * versions.
   */
  downloadLink: Maybe<Scalars["String"]["output"]>;
  /** Unique ID of the Version. */
  id: Scalars["ID"]["output"];
  /**
   * LastPulledAt is unix timestamp (in seconds) at which this version was most recently
   * downloaded. Null if the version has never been pulled. For shared or public modules
   * this timestamp reflects usage across all consumers, not just the requesting account.
   */
  lastPulledAt: Maybe<Scalars["Int"]["output"]>;
  /**
   * String representation of the metadata generated by parsing the module
   * source code.
   */
  metadata: Maybe<ModuleRepositoryMetadata>;
  /**
   * Run parsing the module source code to generate the metadata. This will
   * only be populated if we're parsing the module source on the worker.
   */
  metadataParsingRun: Maybe<Run>;
  /** Module to which this version belongs. */
  module: VersionModuleInfo;
  /** User-provided notes associated with the version. */
  notes: Maybe<Scalars["String"]["output"]>;
  /**
   * Number of the version conforming to the semantic versioning scheme
   * (major, minor, patch).
   */
  number: Scalars["String"]["output"];
  /** List of runs */
  runs: Array<Run>;
  /** Link to the source code from which the version was built. */
  sourceURL: Scalars["String"]["output"];
  /** Current state of the Version. */
  state: VersionState;
  /** The user who manually triggered this Version, if any. */
  triggeredBy: Maybe<Scalars["String"]["output"]>;
  /** Terraform versions tested for this version. */
  versionCount: Scalars["Int"]["output"];
  /** Note associated with the version when it was marked as "bad", if it has */
  yankNote: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the version has been marked as "bad". */
  yanked: Scalars["Boolean"]["output"];
  /** Login of the user who marked the version as "bad", if it has been marked */
  yankedBy: Maybe<Scalars["String"]["output"]>;
};

/** Contains information about the module that a version was created from. */
export type VersionModuleInfo = {
  __typename?: "VersionModuleInfo";
  /** The module's ID. */
  id: Scalars["ID"]["output"];
  /** Provider-independent name of the Terraform module. */
  name: Scalars["String"]["output"];
  /** The name of the module owner. */
  owner: Scalars["String"]["output"];
};

/** VersionState represents the current state of the Version. */
export enum VersionState {
  /** The version is active and can be used. */
  Active = "ACTIVE",
  /** Testing the version failed. */
  Failed = "FAILED",
  /** The version is currently being tested. */
  Pending = "PENDING",
}

export type VersionsConnection = {
  __typename?: "VersionsConnection";
  cursor: Scalars["String"]["output"];
  node: Version;
};

/** WebhookDeliveries represents a paginated list of webhook deliveries. */
export type WebhookDeliveries = {
  __typename?: "WebhookDeliveries";
  /**
   * Token to use to fetch the next batch of webhook deliveries. If the token is
   * empty, the end of the list has been reached.
   */
  nextToken: Maybe<Scalars["String"]["output"]>;
  /** Next batch of webhook deliveries. */
  nodes: Array<WebhookDelivery>;
};

/** WebhookDelivery represents a single webhook or audit trail delivery. */
export type WebhookDelivery = {
  __typename?: "WebhookDelivery";
  /** Unique ID of the delivery. */
  id: Scalars["ID"]["output"];
  /** HTTP status of the delivery, 0 if the delivery failed. */
  status: Scalars["Int"]["output"];
  /** Unix timestamp of the delivery. */
  timestamp: Scalars["Int"]["output"];
};

/** WebhookDeliveryDetails represents extended details for a single webhook delivery. */
export type WebhookDeliveryDetails = {
  __typename?: "WebhookDeliveryDetails";
  /** Body of the request. */
  requestBody: Scalars["String"]["output"];
  /** A list of headers from the request. */
  requestHeaders: Array<WebhookDeliveryHeader>;
  /** Body of the response. */
  responseBody: Scalars["String"]["output"];
  /**
   * Response error, if any. Response error means that the payload was not
   * delivered.
   */
  responseError: Maybe<Scalars["String"]["output"]>;
  /** A list of headers from the response. */
  responseHeaders: Array<WebhookDeliveryHeader>;
};

/**
 * WebhookDeliveryHeader represents a single header (request or response) in a
 * webhook delivery.
 */
export type WebhookDeliveryHeader = {
  __typename?: "WebhookDeliveryHeader";
  /** Name of the header. */
  name: Scalars["String"]["output"];
  /** Values of the header. */
  values: Array<Scalars["String"]["output"]>;
};

/** Webhooks integration info to send webhooks for stack */
export type WebhooksIntegration = {
  __typename?: "WebhooksIntegration";
  /** Deleted boolean */
  deleted: Scalars["Boolean"]["output"];
  /**
   * Paginated list of deliveries from this integration. The optional opaque
   * token is used for pagination and should be copied from the previous
   * WebhookDeliveries response.
   */
  deliveries: Maybe<WebhookDeliveries>;
  /** Extended details of a single delivery. */
  deliveryDetails: Maybe<WebhookDeliveryDetails>;
  /** Enable or disable sending webhooks */
  enabled: Scalars["Boolean"]["output"];
  /** User endpoint to send webhooks */
  endpoint: Scalars["String"]["output"];
  /** WebhooksIntegration ID */
  id: Scalars["ID"]["output"];
  retryOnFailure: Scalars["Boolean"]["output"];
  /**
   * Secret to count SHA1
   * @deprecated This property is no longer used.
   */
  secret: Scalars["String"]["output"];
};

/** Webhooks integration info to send webhooks for stack */
export type WebhooksIntegrationDeliveriesArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

/** Webhooks integration info to send webhooks for stack */
export type WebhooksIntegrationDeliveryDetailsArgs = {
  key: Scalars["String"]["input"];
};

export type WebhooksIntegrationInput = {
  /** Enable or disable sending webhooks */
  enabled: Scalars["Boolean"]["input"];
  /** User endpoint to send webhooks */
  endpoint: Scalars["String"]["input"];
  retryOnFailure: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Secret to count SHA1 */
  secret: InputMaybe<Scalars["String"]["input"]>;
};

/** Worker represents a single worker in the WorkerPool. */
export type Worker = {
  __typename?: "Worker";
  /**
   * Unix timestamp when the worker last became available (idle).
   * Used by autoscalers to determine idle-time for scale-down decisions.
   */
  availableAt: Maybe<Scalars["Int"]["output"]>;
  /** Busy indicates whether the Worker is currently processing work (a run or an Intent task). */
  busy: Scalars["Boolean"]["output"];
  /** Unix timestamp representing the worker creation. */
  createdAt: Scalars["Int"]["output"];
  /** Drained indicates that the worker is not accepting new work. */
  drained: Scalars["Boolean"]["output"];
  /** Globally unique, immutable ID of the Worker. */
  id: Scalars["ID"]["output"];
  /** Metadata associated with the worker. */
  metadata: Maybe<Scalars["String"]["output"]>;
  /**
   * Indicates whether the worker is running an outdated version and should be updated.
   * @deprecated This property is no longer used.
   */
  shouldUpdate: Maybe<Scalars["Boolean"]["output"]>;
  /** Status indicates the status of the worker */
  status: WorkerStatus;
};

/** WorkerConnection represents a single worker in a page of results. */
export type WorkerConnection = {
  __typename?: "WorkerConnection";
  cursor: Scalars["String"]["output"];
  node: Worker;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPool = Notifiable & {
  __typename?: "WorkerPool";
  /**
   * Number of runs currently being processed by this WorkerPool.
   * @deprecated Use busyWorkers fields instead.
   */
  activeRuns: Scalars["Int"]["output"];
  /** Actions that the user can perform on this WorkerPool. */
  allowedActions: Array<Action>;
  /** Number of currently busy workers in this worker pool. */
  busyWorkers: Scalars["Int"]["output"];
  /** Config represents a configuration for the workers that must be passed to the workers. */
  config: Scalars["String"]["output"];
  /** CreatedAt is unix timestamp (in seconds) at which the worker pool was created. */
  createdAt: Scalars["Int"]["output"];
  /** Indicates whether the WorkerPool has just been deleted. */
  deleted: Scalars["Boolean"]["output"];
  /** Optional description of the WorkerPool, supports markdown. */
  description: Maybe<Scalars["String"]["output"]>;
  /**
   * Maximum number of drift detection runs that can be scheduled on this worker pool.
   * If null or set to negative value, there is no limit.
   */
  driftDetectionRunLimit: Maybe<Scalars["Int"]["output"]>;
  /** Globally unique, immutable ID of the WorkerPool. */
  id: Scalars["ID"]["output"];
  /**
   * List of intent projects using this WorkerPool.
   * It will return an empty result for the public worker pool.
   */
  intentProjects: Array<IntentProjectReference>;
  /** Count of intent projects using this WorkerPool. */
  intentProjectsCount: Scalars["Int"]["output"];
  /** Labels applied to a WorkerPool. */
  labels: Array<Scalars["String"]["output"]>;
  /**
   * Indicates that this pool is managed by the Kubernetes WorkerPool controller. If a pool
   * is managed by the controller, any updates from other clients (e.g. the Spacelift UI) will
   * be blocked. Deletion of the pool by other clients is still allowed to allow a situation
   * where the Spacelift API and Kubernetes API become out of sync.
   */
  managedByK8sController: Scalars["Boolean"]["output"];
  /** Mutable name of the WorkerPool, unique within the scope of a single account. */
  name: Scalars["String"]["output"];
  /** Number of the new worker pool notifications. */
  notificationCount: Scalars["Int"]["output"];
  /** Number of runs ready for processing by this WorkerPool. */
  pendingRuns: Scalars["Int"]["output"];
  /**
   * The effective Preparing-phase timeout in seconds: the pool's override, or the platform
   * default when the pool has no override. When raising this, also raise
   * SPACELIFT_LAUNCHER_WORKSPACE_INIT_TIMEOUT on the pool's workers, otherwise the worker
   * stops downloading source before this deadline is reached.
   */
  preparingTimeoutSeconds: Maybe<Scalars["Int"]["output"]>;
  /**
   * Count of queued runs on the public worker pool workers for this account.
   * @deprecated Use 'schedulableRunsCount' instead.
   */
  queuedRunsCount: Scalars["Int"]["output"];
  /** List of scans using this WorkerPool. */
  scans: Array<WorkerPoolScanReference>;
  /** Count of scans using this WorkerPool. */
  scansCount: Scalars["Int"]["output"];
  /** Count of schedulable runs on the worker pool workers for this account. */
  schedulableRunsCount: Scalars["Int"]["output"];
  /** Search intent projects using this WorkerPool. */
  searchIntentProjects: SearchIntentProjectReferencesOutput;
  /** Search intent projects suggestions using this WorkerPool. */
  searchIntentProjectsSuggestions: SearchSuggestionsOutput;
  /** Search Runs for this WorkerPool. */
  searchSchedulableRuns: Maybe<SearchSchedulableRunsOutput>;
  /** Search Runs Suggestions for this WorkerPool. */
  searchSchedulableRunsSuggestions: Maybe<SearchSuggestionsOutput>;
  /** Search stacks/modules using this WorkerPool. */
  searchUsers: SearchWorkerPoolUsersOutput;
  /** Search stacks/modules suggestions using this WorkerPool. */
  searchUsersSuggestions: SearchSuggestionsOutput;
  /** Search workers belonging to this WorkerPool. */
  searchWorkers: Maybe<SearchWorkersOutput>;
  /** Search workers suggestions belonging to this WorkerPool. */
  searchWorkersSuggestions: Maybe<SearchSuggestionsOutput>;
  /** ID of the space this WorkerPool belongs to. */
  space: Scalars["ID"]["output"];
  /** Details of the space this WorkerPool belongs to. */
  spaceDetails: Space;
  /** UpdatedAt is unix timestamp (in seconds) at which the worker pool was updated. */
  updatedAt: Scalars["Int"]["output"];
  /**
   * List of users (modules or stacks) of this WorkerPool.
   * It will return an empty result for the public worker pool.
   */
  users: Array<WorkerPoolUser>;
  /** Count of users on the public worker pool workers for this account. */
  usersCount: Scalars["Int"]["output"];
  /** Compatibility */
  workerPool: WorkerPool;
  /** List of workers belonging to this WorkerPool. */
  workers: Array<Worker>;
  /** Count of workers. */
  workersCount: Scalars["Int"]["output"];
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchIntentProjectsArgs = {
  input: SearchInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchIntentProjectsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchSchedulableRunsArgs = {
  input: SearchInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchSchedulableRunsSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchUsersArgs = {
  input: SearchInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchUsersSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchWorkersArgs = {
  input: SearchInput;
};

/** WorkerPool represents a single WorkerPool. */
export type WorkerPoolSearchWorkersSuggestionsArgs = {
  input: SearchSuggestionsInput;
};

/** WorkerPoolConnection represents a single worker pool in a page of results. */
export type WorkerPoolConnection = {
  __typename?: "WorkerPoolConnection";
  cursor: Scalars["String"]["output"];
  node: WorkerPool;
};

/** WorkerPoolScanReference is a scan using the worker pool, viewed from the worker pool. */
export type WorkerPoolScanReference = {
  __typename?: "WorkerPoolScanReference";
  /** Slug of the scan. */
  id: Scalars["ID"]["output"];
  /** Name of the scan. */
  name: Scalars["String"]["output"];
  /** Details of the space the scan belongs to. */
  spaceDetails: Space;
};

/** WorkerPoolUser represents a user (module or stacks) of the worker pool. */
export type WorkerPoolUser = {
  __typename?: "WorkerPoolUser";
  /** True if the attached project is a module. */
  isModule: Scalars["Boolean"]["output"];
  /**
   * Space details of the attached stack or module.
   * It will return a useless result for the public worker pool.
   */
  spaceDetails: Space;
  /** Slug of the attached stack or module. */
  stackId: Scalars["ID"]["output"];
  /** Name of the attached stack or module. */
  stackName: Scalars["String"]["output"];
};

/** WorkerPoolUserConnection represents a single stack/module in a page of results for a worker pool. */
export type WorkerPoolUserConnection = {
  __typename?: "WorkerPoolUserConnection";
  cursor: Scalars["String"]["output"];
  node: WorkerPoolUser;
};

export enum WorkerStatus {
  /** Worker is currently processing a worker. */
  Busy = "BUSY",
  /** Worker is not accepting new work. */
  Drained = "DRAINED",
  Idle = "IDLE",
}

export type WorkerUsage = {
  __typename?: "WorkerUsage";
  /** Null unless the contract has both a limit and a percentile. */
  burst: Maybe<WorkerUsageBurst>;
  /**
   * Concurrency at the percentile the contract bills on (contractedPercentile).
   * Null when there is no contract or the contract has no percentile, matching
   * contractedPercentile.
   */
  concurrencyAtContractedPercentile: Maybe<Scalars["Int"]["output"]>;
  /**
   * Private worker concurrency at each requested percentile. The current
   * cycle covers elapsed time; a past cycle covers its full duration. Results
   * preserve request order. Each value must be between 0 and 100, and a query
   * may request up to 5 values.
   */
  concurrencyPercentiles: Array<WorkerUsagePercentile>;
  /**
   * Worker concurrency limit in the current contract. Null when the account
   * has no contract or no limit. Past cycles also use this current value,
   * which may differ from the limit in effect during that cycle.
   */
  contractedLimit: Maybe<Scalars["Int"]["output"]>;
  /**
   * Billed percentile in the current contract, such as 95. Null when the
   * account has no contract. Past cycles also use this current value.
   */
  contractedPercentile: Maybe<Scalars["Int"]["output"]>;
  /** Billing cycle selected by `cyclesAgo`. An omitted value selects 0. */
  cycle: WorkerUsageCycle;
  /**
   * One point per day in the selected cycle. The current cycle runs through
   * today; a past cycle includes every day. Days without activity return zero.
   * Pass `percentiles` to populate `concurrencyAtPercentilesToDate`. Each value
   * must be between 0 and 100, and a query may request up to 5 values. Omit
   * `percentiles` to skip those calculations.
   */
  daily: Array<WorkerUsageDailyPoint>;
  /**
   * True when contractedLimit is not specific to this account: other accounts
   * draw on the same limit, so this account's usage is only part of what counts
   * against it.
   */
  multiAccountContract: Scalars["Boolean"]["output"];
  /**
   * Every cycle `cyclesAgo` can select right now, newest first, starting with
   * the current cycle. The list stops at the oldest retained cycle or at the
   * cycle the account was created or the contract started in, whichever is
   * newer. Past dates are extrapolated from the current contract, and the list
   * shifts by one when a new cycle starts.
   */
  selectableCycles: Array<WorkerUsageCycle>;
};

export type WorkerUsageConcurrencyPercentilesArgs = {
  percentiles?: Array<Scalars["Int"]["input"]>;
};

export type WorkerUsageDailyArgs = {
  percentiles: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

/**
 * Uses the current contract's limit and percentile, including for past cycles.
 * `budgetMinutes` applies the current billed percentile to the selected cycle's
 * duration.
 */
export type WorkerUsageBurst = {
  __typename?: "WorkerUsageBurst";
  /** How many minutes of the full cycle may exceed the contracted worker limit. */
  budgetMinutes: Scalars["Int"]["output"];
  /** budget - used (may be negative when over). */
  remainingMinutes: Scalars["Int"]["output"];
  /**
   * Minutes above the current contracted limit. The current cycle counts time
   * elapsed so far; a past cycle counts its full duration. Each minute counts
   * once, regardless of how far concurrency exceeded the limit.
   */
  usedMinutes: Scalars["Int"]["output"];
};

export type WorkerUsageCycle = {
  __typename?: "WorkerUsageCycle";
  /** The `cyclesAgo` value that selects this cycle. */
  cyclesAgo: Scalars["Int"]["output"];
  /** Unix seconds, exclusive on the minute timeline. */
  end: Scalars["Int"]["output"];
  /** Unix seconds, inclusive. */
  start: Scalars["Int"]["output"];
};

export type WorkerUsageDailyPoint = {
  __typename?: "WorkerUsageDailyPoint";
  /**
   * Minutes of THIS day, not cumulative, in which worker concurrency exceeded
   * contractedLimit. Summed over the cycle this equals burst.usedMinutes. Null
   * exactly when contractedLimit is null; 0 means the day stayed within the
   * limit. Excludes the live tail, like the percentile above.
   */
  burstMinutesUsed: Maybe<Scalars["Int"]["output"]>;
  /**
   * Concurrency at contractedPercentile computed cumulatively from the cycle
   * start through the END of this day, so the last point equals
   * concurrencyAtContractedPercentile. Null exactly when contractedPercentile
   * is null. Unlike max, this excludes the live tail, so on the current day it
   * can lag by a couple of minutes.
   */
  concurrencyAtContractedPercentileToDate: Maybe<Scalars["Int"]["output"]>;
  /**
   * Concurrency at each percentile requested via daily(percentiles:), computed
   * cumulatively from the cycle start through the END of this day - so the last
   * point matches concurrencyPercentiles for the same input. Returns exactly the
   * requested percentiles, in request order; empty when none were requested.
   * Like concurrencyAtContractedPercentileToDate, this excludes the live tail.
   */
  concurrencyAtPercentilesToDate: Array<WorkerUsagePercentile>;
  /** Unix seconds at midnight UTC. */
  day: Scalars["Int"]["output"];
  /** Peak concurrent workers that day. */
  max: Scalars["Int"]["output"];
};

/**
 * Selects the billing cycle returned by `workerUsage`. Omitting `input`, passing
 * an empty input, omitting `cyclesAgo`, and setting `cyclesAgo` to 0 all select
 * the current cycle.
 */
export type WorkerUsageInput = {
  /**
   * Number of billing cycles before the current cycle. Null means 0. 0 selects
   * the current cycle to date; 1 selects the most recent completed cycle.
   * Valid values range from 0 through 5.
   *
   * The rollup retains the current monthly partition and the six preceding
   * partitions. An anniversary-based billing cycle can span two partitions,
   * so selecting cycle 6 could read a dropped partition as zero.
   *
   * A past cycle that ends before the account was created, or before the contract
   * or subscription started, returns an error. The cycle those dates fall in stays
   * selectable. The current cycle is never checked. A valid cycle older than the
   * rollup returns zeros, which is indistinguishable from no usage.
   */
  cyclesAgo: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkerUsagePercentile = {
  __typename?: "WorkerUsagePercentile";
  /** Which percentile this is, e.g. 95 */
  percentile: Scalars["Int"]["output"];
  /** Concurrent workers at that percentile */
  value: Scalars["Int"]["output"];
};

export type _Service = {
  __typename?: "_Service";
  sdl: Scalars["String"]["output"];
};
